/* eslint-disable */
/* tslint:disable */
// @ts-nocheck
/* prettier-ignore-start */

/** @jsxRuntime classic */
/** @jsx createPlasmicElementProxy */
/** @jsxFrag React.Fragment */

// This class is auto-generated by Plasmic; please do not edit!
// Plasmic Project: bvRZj1oZhhFBeMnkX2LkQu
// Component: XTAvGJPchvtf

import * as React from "react";

import Head from "next/head";
import Link, { LinkProps } from "next/link";
import { useRouter } from "next/router";

import {
  Flex as Flex__,
  MultiChoiceArg,
  PlasmicDataSourceContextProvider as PlasmicDataSourceContextProvider__,
  PlasmicIcon as PlasmicIcon__,
  PlasmicImg as PlasmicImg__,
  PlasmicLink as PlasmicLink__,
  PlasmicPageGuard as PlasmicPageGuard__,
  SingleBooleanChoiceArg,
  SingleChoiceArg,
  Stack as Stack__,
  StrictProps,
  Trans as Trans__,
  classNames,
  createPlasmicElementProxy,
  deriveRenderOpts,
  ensureGlobalVariants,
  generateOnMutateForSpec,
  generateStateOnChangeProp,
  generateStateOnChangePropForCodeComponents,
  generateStateValueProp,
  get as $stateGet,
  hasVariant,
  initializeCodeComponentStates,
  initializePlasmicStates,
  makeFragment,
  omit,
  pick,
  renderPlasmicSlot,
  set as $stateSet,
  useCurrentUser,
  useDollarState,
  usePlasmicTranslator,
  useTrigger,
  wrapWithClassName
} from "@plasmicapp/react-web";
import {
  DataCtxReader as DataCtxReader__,
  useDataEnv,
  useGlobalActions
} from "@plasmicapp/react-web/lib/host";

import { DataProvider } from "@plasmicpkgs/plasmic-basic-components";
import Logo from "../../Logo"; // plasmic-import: 2Sac1UHK8925/component
import { AntdTabs } from "@plasmicpkgs/antd5/skinny/registerTabs";
import { AntdTabItem } from "@plasmicpkgs/antd5/skinny/registerTabs";
import { _useGlobalVariants } from "./plasmic"; // plasmic-import: bvRZj1oZhhFBeMnkX2LkQu/projectModule
import { _useStyleTokens } from "./PlasmicStyleTokensProvider"; // plasmic-import: bvRZj1oZhhFBeMnkX2LkQu/styleTokensProvider

import "@plasmicapp/react-web/lib/plasmic.css";

import sty from "./PlasmicHomeProductsSection.module.css"; // plasmic-import: XTAvGJPchvtf/css

import G782Icon from "./icons/PlasmicIcon__G782"; // plasmic-import: MMRz7C213ZtM/icon
import Path842Icon from "./icons/PlasmicIcon__Path842"; // plasmic-import: if2ZBI6-mCRt/icon
import G942Icon from "./icons/PlasmicIcon__G942"; // plasmic-import: qQqra4akk1UG/icon
import G902Icon from "./icons/PlasmicIcon__G902"; // plasmic-import: NIASMtAHey5J/icon
import Xmlid6613Icon from "./icons/PlasmicIcon__Xmlid6613"; // plasmic-import: KfBLqrnqkh7K/icon
import Xmlid7308Icon from "./icons/PlasmicIcon__Xmlid7308"; // plasmic-import: Rc8q4cS6TRtw/icon
import Xmlid6615Icon from "./icons/PlasmicIcon__Xmlid6615"; // plasmic-import: 0tD2p8PYECMq/icon
import Xmlid7443Icon from "./icons/PlasmicIcon__Xmlid7443"; // plasmic-import: iF8_3kA9Wb9q/icon
import Xmlid6614Icon from "./icons/PlasmicIcon__Xmlid6614"; // plasmic-import: NrjMSUE48Q7-/icon
import Xmlid7347Icon from "./icons/PlasmicIcon__Xmlid7347"; // plasmic-import: H5UzqZGnQ6c9/icon
import Xmlid7207Icon from "./icons/PlasmicIcon__Xmlid7207"; // plasmic-import: DpRijowJYOcb/icon
import Icon91Icon from "./icons/PlasmicIcon__Icon91"; // plasmic-import: Eto7rfXCGRus/icon
import Icon84Icon from "./icons/PlasmicIcon__Icon84"; // plasmic-import: FiW4QWmFBSGC/icon
import Group15Icon from "./icons/PlasmicIcon__Group15"; // plasmic-import: sngXPatVLZFN/icon
import VectorIcon from "./icons/PlasmicIcon__Vector"; // plasmic-import: p59FhsiOKrqv/icon
import Group17Icon from "./icons/PlasmicIcon__Group17"; // plasmic-import: it9muy_gitMY/icon
import Icon87Icon from "./icons/PlasmicIcon__Icon87"; // plasmic-import: kRk_Xh2G2HnQ/icon
import Wave1Icon from "./icons/PlasmicIcon__Wave1"; // plasmic-import: 3mJHowbx7rSQ/icon
import Wave41Icon from "./icons/PlasmicIcon__Wave41"; // plasmic-import: DIg8uO9h9sg6/icon
import Icon83Icon from "./icons/PlasmicIcon__Icon83"; // plasmic-import: xO0x_ObqZEpK/icon
import Tri5Icon from "./icons/PlasmicIcon__Tri5"; // plasmic-import: Nl74VmqXyNEG/icon
import Tri6Icon from "./icons/PlasmicIcon__Tri6"; // plasmic-import: MkW1tH1QWQLl/icon
import Tri7Icon from "./icons/PlasmicIcon__Tri7"; // plasmic-import: NpK22MIvdvQk/icon
import Tri8Icon from "./icons/PlasmicIcon__Tri8"; // plasmic-import: mTQQpvznsa4w/icon
import Tri9Icon from "./icons/PlasmicIcon__Tri9"; // plasmic-import: SWTR22lK0L3m/icon
import Guides3Icon from "./icons/PlasmicIcon__Guides3"; // plasmic-import: XHpccnyExBri/icon
import Poly5Icon from "./icons/PlasmicIcon__Poly5"; // plasmic-import: -U7MgB01MQbT/icon
import Poly6Icon from "./icons/PlasmicIcon__Poly6"; // plasmic-import: F5gR-O_HyT9n/icon
import Tri10Icon from "./icons/PlasmicIcon__Tri10"; // plasmic-import: ExkocK1wu2kG/icon
import Guides4Icon from "./icons/PlasmicIcon__Guides4"; // plasmic-import: YjFmU2IsLZ0F/icon
import Poly7Icon from "./icons/PlasmicIcon__Poly7"; // plasmic-import: u1nAugzbBEpp/icon
import Poly8Icon from "./icons/PlasmicIcon__Poly8"; // plasmic-import: 1y0n4jZNi909/icon
import IconXSmall12Envelope2Icon from "./icons/PlasmicIcon__IconXSmall12Envelope2"; // plasmic-import: -PxiOO79NRy6/icon
import Group18Icon from "./icons/PlasmicIcon__Group18"; // plasmic-import: UM0p2Azo0z2-/icon
import Group19Icon from "./icons/PlasmicIcon__Group19"; // plasmic-import: EVjj3YlsW_9I/icon
import Vector2Icon from "./icons/PlasmicIcon__Vector2"; // plasmic-import: 3L1yEtJBOS3y/icon

createPlasmicElementProxy;

export type PlasmicHomeProductsSection__VariantMembers = {};
export type PlasmicHomeProductsSection__VariantsArgs = {};
type VariantPropType = keyof PlasmicHomeProductsSection__VariantsArgs;
export const PlasmicHomeProductsSection__VariantProps =
  new Array<VariantPropType>();

export type PlasmicHomeProductsSection__ArgsType = {};
type ArgPropType = keyof PlasmicHomeProductsSection__ArgsType;
export const PlasmicHomeProductsSection__ArgProps = new Array<ArgPropType>();

export type PlasmicHomeProductsSection__OverridesType = {
  productsSection?: Flex__<"section">;
  productsProvider?: Flex__<typeof DataProvider>;
  desktopWrapper?: Flex__<"div">;
  intro2?: Flex__<"div">;
  header9?: Flex__<"div">;
  top3?: Flex__<"div">;
  subtitle?: Flex__<"div">;
  title?: Flex__<"div">;
  body6?: Flex__<"div">;
  col4?: Flex__<"div">;
  nav?: Flex__<"div">;
  img2?: Flex__<"div">;
  logoIcon?: Flex__<"div">;
  logo7?: Flex__<typeof Logo>;
  logo2?: Flex__<typeof Logo>;
  logo3?: Flex__<typeof Logo>;
  productTabs?: Flex__<typeof AntdTabs>;
  content?: Flex__<"div">;
  placeholder?: Flex__<"div">;
  intro?: Flex__<"div">;
  col?: Flex__<"div">;
  logo?: Flex__<typeof Logo>;
  text53?: Flex__<"div">;
  title23?: Flex__<"div">;
  desc?: Flex__<"div">;
  img?: Flex__<"div">;
  areas?: Flex__<"div">;
  header10?: Flex__<"div">;
  title11?: Flex__<"div">;
  body7?: Flex__<"div">;
  frame22?: Flex__<"div">;
  item17?: Flex__<"div">;
  title12?: Flex__<"div">;
  desc7?: Flex__<"div">;
  item18?: Flex__<"div">;
  title13?: Flex__<"div">;
  desc2?: Flex__<"div">;
  item19?: Flex__<"div">;
  title14?: Flex__<"div">;
  desc3?: Flex__<"div">;
  item20?: Flex__<"div">;
  title15?: Flex__<"div">;
  desc4?: Flex__<"div">;
  item21?: Flex__<"div">;
  title16?: Flex__<"div">;
  desc5?: Flex__<"div">;
  item22?: Flex__<"div">;
  title17?: Flex__<"div">;
  desc6?: Flex__<"div">;
  footnote?: Flex__<"div">;
  bodyWrapper6?: Flex__<"div">;
  intro4?: Flex__<"div">;
  col7?: Flex__<"div">;
  logo9?: Flex__<typeof Logo>;
  text44?: Flex__<"div">;
  title27?: Flex__<"div">;
  desc9?: Flex__<"div">;
  img4?: Flex__<"div">;
  bg3?: Flex__<"div">;
  xmlid7457?: Flex__<"div">;
  xmlid6776?: Flex__<"div">;
  xmlid7433?: Flex__<"div">;
  xmlid7339?: Flex__<"div">;
  alert3?: Flex__<"div">;
  icon20?: Flex__<"div">;
  content3?: Flex__<"div">;
  text45?: Flex__<"div">;
  icon21?: Flex__<"div">;
  credits?: Flex__<"div">;
  header20?: Flex__<"div">;
  subtitle5?: Flex__<"div">;
  title28?: Flex__<"div">;
  main6?: Flex__<"div">;
  mockupCmeCredits?: Flex__<"div">;
  table?: Flex__<"div">;
  col8?: Flex__<"div">;
  mockupTableCellText?: Flex__<"div">;
  text46?: Flex__<"div">;
  mockupTableCellAvatar?: Flex__<"div">;
  mockupTableCellAvatar2?: Flex__<"div">;
  mockupTableCellAvatar3?: Flex__<"div">;
  col9?: Flex__<"div">;
  mockupTableCellText2?: Flex__<"div">;
  text47?: Flex__<"div">;
  mockupTableCellText3?: Flex__<"div">;
  text48?: Flex__<"div">;
  mockupTableCellText4?: Flex__<"div">;
  text49?: Flex__<"div">;
  mockupTableCellText5?: Flex__<"div">;
  text50?: Flex__<"div">;
  col10?: Flex__<"div">;
  mockupTableCellText6?: Flex__<"div">;
  text51?: Flex__<"div">;
  mockupTableCellText7?: Flex__<"div">;
  text52?: Flex__<"div">;
  mockupTableCellText8?: Flex__<"div">;
  text57?: Flex__<"div">;
  mockupTableCellText9?: Flex__<"div">;
  text58?: Flex__<"div">;
  col11?: Flex__<"div">;
  mockupTableCellText10?: Flex__<"div">;
  text59?: Flex__<"div">;
  mockupTableCellText11?: Flex__<"div">;
  text60?: Flex__<"div">;
  mockupTableCellText12?: Flex__<"div">;
  text70?: Flex__<"div">;
  mockupTableCellText13?: Flex__<"div">;
  text71?: Flex__<"div">;
  mockupButton7?: Flex__<"div">;
  link10?: Flex__<"div">;
  certificate?: Flex__<"div">;
  top5?: Flex__<"div">;
  mockupCertificateIcon?: Flex__<"div">;
  bg4?: Flex__<"div">;
  group1?: Flex__<"div">;
  paper1?: Flex__<"div">;
  paper2?: Flex__<"div">;
  cert?: Flex__<"div">;
  award491?: Flex__<"div">;
  overlay?: Flex__<"div">;
  title29?: Flex__<"div">;
  mockupTextPlaceholder?: Flex__<"div">;
  mockupTextPlaceholderParagraph?: Flex__<"div">;
  mockupTextPlaceholderLine?: Flex__<"div">;
  mockupTextPlaceholderContent37?: Flex__<"div">;
  placeholder38?: Flex__<"div">;
  mockupTextPlaceholderLine2?: Flex__<"div">;
  mockupTextPlaceholderContent38?: Flex__<"div">;
  placeholder39?: Flex__<"div">;
  mockupTextPlaceholderLine3?: Flex__<"div">;
  mockupTextPlaceholderContent39?: Flex__<"div">;
  placeholder40?: Flex__<"div">;
  mockupTextPlaceholderLine4?: Flex__<"div">;
  mockupTextPlaceholderContent40?: Flex__<"div">;
  placeholder41?: Flex__<"div">;
  mockupTextPlaceholderLine5?: Flex__<"div">;
  mockupTextPlaceholderContent41?: Flex__<"div">;
  placeholder42?: Flex__<"div">;
  mockupTextPlaceholderParagraph2?: Flex__<"div">;
  mockupTextPlaceholderLine6?: Flex__<"div">;
  mockupTextPlaceholderContent42?: Flex__<"div">;
  placeholder43?: Flex__<"div">;
  mockupTextPlaceholderLine7?: Flex__<"div">;
  mockupTextPlaceholderContent43?: Flex__<"div">;
  placeholder44?: Flex__<"div">;
  mockupTextPlaceholderLine8?: Flex__<"div">;
  mockupTextPlaceholderContent44?: Flex__<"div">;
  placeholder45?: Flex__<"div">;
  mockupTextPlaceholderLine9?: Flex__<"div">;
  mockupTextPlaceholderContent45?: Flex__<"div">;
  placeholder46?: Flex__<"div">;
  mockupTextPlaceholderLine10?: Flex__<"div">;
  mockupTextPlaceholderContent46?: Flex__<"div">;
  placeholder47?: Flex__<"div">;
  mockupTextPlaceholderLine11?: Flex__<"div">;
  mockupTextPlaceholderContent47?: Flex__<"div">;
  placeholder48?: Flex__<"div">;
  mockupTextPlaceholderLine12?: Flex__<"div">;
  mockupTextPlaceholderContent48?: Flex__<"div">;
  placeholder49?: Flex__<"div">;
  mockupTextPlaceholderLine13?: Flex__<"div">;
  mockupTextPlaceholderContent49?: Flex__<"div">;
  placeholder50?: Flex__<"div">;
  mockupTextPlaceholderParagraph3?: Flex__<"div">;
  mockupTextPlaceholderLine14?: Flex__<"div">;
  mockupTextPlaceholderContent50?: Flex__<"div">;
  placeholder51?: Flex__<"div">;
  mockupTextPlaceholderLine15?: Flex__<"div">;
  mockupTextPlaceholderContent15?: Flex__<"div">;
  placeholder52?: Flex__<"div">;
  mockupTextPlaceholderLine16?: Flex__<"div">;
  mockupTextPlaceholderContent16?: Flex__<"div">;
  placeholder53?: Flex__<"div">;
  mockupTextPlaceholderLine17?: Flex__<"div">;
  mockupTextPlaceholderContent17?: Flex__<"div">;
  placeholder54?: Flex__<"div">;
  mockupTextPlaceholderLine18?: Flex__<"div">;
  mockupTextPlaceholderContent18?: Flex__<"div">;
  placeholder55?: Flex__<"div">;
  mockupTextPlaceholderParagraph4?: Flex__<"div">;
  mockupTextPlaceholderLine19?: Flex__<"div">;
  mockupTextPlaceholderContent19?: Flex__<"div">;
  placeholder19?: Flex__<"div">;
  mockupTextPlaceholderLine20?: Flex__<"div">;
  mockupTextPlaceholderContent20?: Flex__<"div">;
  placeholder20?: Flex__<"div">;
  mockupTextPlaceholderLine21?: Flex__<"div">;
  mockupTextPlaceholderContent21?: Flex__<"div">;
  placeholder21?: Flex__<"div">;
  mockupTextPlaceholderLine22?: Flex__<"div">;
  mockupTextPlaceholderContent22?: Flex__<"div">;
  placeholder22?: Flex__<"div">;
  mockupTextPlaceholderLine23?: Flex__<"div">;
  mockupTextPlaceholderContent23?: Flex__<"div">;
  placeholder23?: Flex__<"div">;
  mockupTextPlaceholderLine24?: Flex__<"div">;
  mockupTextPlaceholderContent24?: Flex__<"div">;
  placeholder24?: Flex__<"div">;
  mockupTextPlaceholderLine25?: Flex__<"div">;
  mockupTextPlaceholderContent25?: Flex__<"div">;
  placeholder25?: Flex__<"div">;
  mockupTextPlaceholderLine26?: Flex__<"div">;
  mockupTextPlaceholderContent26?: Flex__<"div">;
  placeholder26?: Flex__<"div">;
  mockupButton8?: Flex__<"div">;
  link11?: Flex__<"div">;
  alert2?: Flex__<"div">;
  icon22?: Flex__<"div">;
  check2?: Flex__<"div">;
  content4?: Flex__<"div">;
  report?: Flex__<"div">;
  bill?: Flex__<"div">;
  header21?: Flex__<"div">;
  subtitle9?: Flex__<"div">;
  title30?: Flex__<"div">;
  main7?: Flex__<"div">;
  placeholder27?: Flex__<"div">;
  header22?: Flex__<"div">;
  title31?: Flex__<"div">;
  date?: Flex__<"div">;
  section?: Flex__<"div">;
  head?: Flex__<"div">;
  mockupTextPlaceholderParagraph5?: Flex__<"div">;
  mockupTextPlaceholderLine27?: Flex__<"div">;
  mockupTextPlaceholderContent27?: Flex__<"div">;
  placeholder28?: Flex__<"div">;
  mockupTextPlaceholderLine28?: Flex__<"div">;
  mockupTextPlaceholderContent28?: Flex__<"div">;
  placeholder29?: Flex__<"div">;
  mockupTextPlaceholderLine29?: Flex__<"div">;
  mockupTextPlaceholderContent29?: Flex__<"div">;
  placeholder30?: Flex__<"div">;
  mockupTextPlaceholderLine30?: Flex__<"div">;
  mockupTextPlaceholderContent30?: Flex__<"div">;
  placeholder31?: Flex__<"div">;
  mockupTextPlaceholderLine31?: Flex__<"div">;
  mockupTextPlaceholderContent31?: Flex__<"div">;
  placeholder32?: Flex__<"div">;
  total?: Flex__<"div">;
  title32?: Flex__<"div">;
  val6?: Flex__<"div">;
  section2?: Flex__<"div">;
  head2?: Flex__<"div">;
  mockupTextPlaceholderParagraph6?: Flex__<"div">;
  mockupTextPlaceholderLine32?: Flex__<"div">;
  mockupTextPlaceholderContent32?: Flex__<"div">;
  placeholder33?: Flex__<"div">;
  mockupTextPlaceholderLine33?: Flex__<"div">;
  mockupTextPlaceholderContent33?: Flex__<"div">;
  placeholder34?: Flex__<"div">;
  mockupTextPlaceholderLine34?: Flex__<"div">;
  mockupTextPlaceholderContent34?: Flex__<"div">;
  placeholder35?: Flex__<"div">;
  mockupTextPlaceholderLine35?: Flex__<"div">;
  mockupTextPlaceholderContent35?: Flex__<"div">;
  placeholder36?: Flex__<"div">;
  mockupTextPlaceholderLine36?: Flex__<"div">;
  mockupTextPlaceholderContent36?: Flex__<"div">;
  placeholder37?: Flex__<"div">;
  total2?: Flex__<"div">;
  title34?: Flex__<"div">;
  val7?: Flex__<"div">;
  edge?: Flex__<"div">;
  tri?: Flex__<"div">;
  rect?: Flex__<"div">;
  tri2?: Flex__<"div">;
  rect2?: Flex__<"div">;
  tri3?: Flex__<"div">;
  rect3?: Flex__<"div">;
  tri4?: Flex__<"div">;
  rect4?: Flex__<"div">;
  tri5?: Flex__<"div">;
  rect5?: Flex__<"div">;
  tri6?: Flex__<"div">;
  rect6?: Flex__<"div">;
  tri7?: Flex__<"div">;
  rect7?: Flex__<"div">;
  tri8?: Flex__<"div">;
  rect8?: Flex__<"div">;
  tri9?: Flex__<"div">;
  rect9?: Flex__<"div">;
  tri10?: Flex__<"div">;
  rect10?: Flex__<"div">;
  tri11?: Flex__<"div">;
  rect11?: Flex__<"div">;
  tri12?: Flex__<"div">;
  rect12?: Flex__<"div">;
  tri13?: Flex__<"div">;
  rect13?: Flex__<"div">;
  tri14?: Flex__<"div">;
  rect14?: Flex__<"div">;
  tri15?: Flex__<"div">;
  rect15?: Flex__<"div">;
  tri16?: Flex__<"div">;
  rect16?: Flex__<"div">;
  tri17?: Flex__<"div">;
  rect17?: Flex__<"div">;
  tri18?: Flex__<"div">;
  rect18?: Flex__<"div">;
  tri19?: Flex__<"div">;
  rect19?: Flex__<"div">;
  tri20?: Flex__<"div">;
  rect20?: Flex__<"div">;
  tri21?: Flex__<"div">;
  rect21?: Flex__<"div">;
  tri22?: Flex__<"div">;
  rect22?: Flex__<"div">;
  tri23?: Flex__<"div">;
  rect23?: Flex__<"div">;
  tri24?: Flex__<"div">;
  rect24?: Flex__<"div">;
  tri25?: Flex__<"div">;
  rect25?: Flex__<"div">;
  tri26?: Flex__<"div">;
  rect26?: Flex__<"div">;
  tri27?: Flex__<"div">;
  rect27?: Flex__<"div">;
  tri28?: Flex__<"div">;
  rect28?: Flex__<"div">;
  tri29?: Flex__<"div">;
  rect29?: Flex__<"div">;
  tri30?: Flex__<"div">;
  rect30?: Flex__<"div">;
  tri31?: Flex__<"div">;
  rect31?: Flex__<"div">;
  tri32?: Flex__<"div">;
  rect32?: Flex__<"div">;
  shade3?: Flex__<"div">;
  features3?: Flex__<"div">;
  title33?: Flex__<"div">;
  figmaPaste2?: Flex__<"div">;
  contentsItem10?: Flex__<"div">;
  icon23?: Flex__<"div">;
  text61?: Flex__<"div">;
  contentsItem11?: Flex__<"div">;
  icon24?: Flex__<"div">;
  text62?: Flex__<"div">;
  contentsItem12?: Flex__<"div">;
  icon25?: Flex__<"div">;
  text63?: Flex__<"div">;
  contentsItem13?: Flex__<"div">;
  icon26?: Flex__<"div">;
  text64?: Flex__<"div">;
  contentsItem14?: Flex__<"div">;
  icon27?: Flex__<"div">;
  text65?: Flex__<"div">;
  contentsItem15?: Flex__<"div">;
  icon28?: Flex__<"div">;
  text66?: Flex__<"div">;
  contentsItem16?: Flex__<"div">;
  icon29?: Flex__<"div">;
  text67?: Flex__<"div">;
  contentsItem17?: Flex__<"div">;
  icon30?: Flex__<"div">;
  text68?: Flex__<"div">;
  bodyWrapper5?: Flex__<"div">;
  intro3?: Flex__<"div">;
  col5?: Flex__<"div">;
  logo8?: Flex__<typeof Logo>;
  text?: Flex__<"div">;
  title18?: Flex__<"div">;
  desc8?: Flex__<"div">;
  img3?: Flex__<"div">;
  bg2?: Flex__<"div">;
  reimbursement?: Flex__<"div">;
  header11?: Flex__<"div">;
  subtitle4?: Flex__<"div">;
  title19?: Flex__<"div">;
  main4?: Flex__<"div">;
  placeholder16?: Flex__<"div">;
  row?: Flex__<"div">;
  prop?: Flex__<"div">;
  label10?: Flex__<"div">;
  val?: Flex__<"div">;
  prop2?: Flex__<"div">;
  label11?: Flex__<"div">;
  val2?: Flex__<"div">;
  mockupProgressBarWithTitle?: Flex__<"div">;
  header12?: Flex__<"div">;
  title20?: Flex__<"div">;
  val3?: Flex__<"div">;
  bar?: Flex__<"div">;
  value?: Flex__<"div">;
  demographics?: Flex__<"div">;
  demographics2?: Flex__<"div">;
  header13?: Flex__<"div">;
  subtitle7?: Flex__<"div">;
  title4?: Flex__<"div">;
  main5?: Flex__<"div">;
  placeholder17?: Flex__<"div">;
  row2?: Flex__<"div">;
  header14?: Flex__<"div">;
  name6?: Flex__<"div">;
  error?: Flex__<"div">;
  tip?: Flex__<"div">;
  label3?: Flex__<"div">;
  link6?: Flex__<"div">;
  row6?: Flex__<"div">;
  header15?: Flex__<"div">;
  name7?: Flex__<"div">;
  error2?: Flex__<"div">;
  tip2?: Flex__<"div">;
  label4?: Flex__<"div">;
  link7?: Flex__<"div">;
  row7?: Flex__<"div">;
  header16?: Flex__<"div">;
  name8?: Flex__<"div">;
  error3?: Flex__<"div">;
  tip3?: Flex__<"div">;
  label5?: Flex__<"div">;
  link8?: Flex__<"div">;
  shade2?: Flex__<"div">;
  cap?: Flex__<"div">;
  header17?: Flex__<"div">;
  subtitle8?: Flex__<"div">;
  title21?: Flex__<"div">;
  main3?: Flex__<"div">;
  placeholder18?: Flex__<"div">;
  field?: Flex__<"div">;
  label6?: Flex__<"div">;
  select?: Flex__<"div">;
  input?: Flex__<"div">;
  leftIcon?: Flex__<"div">;
  text25?: Flex__<"div">;
  rightIcon?: Flex__<"div">;
  row5?: Flex__<"div">;
  prop3?: Flex__<"div">;
  label7?: Flex__<"div">;
  val4?: Flex__<"div">;
  prop4?: Flex__<"div">;
  label8?: Flex__<"div">;
  val5?: Flex__<"div">;
  profile3?: Flex__<"div">;
  av3?: Flex__<"div">;
  col6?: Flex__<"div">;
  top4?: Flex__<"div">;
  header18?: Flex__<"div">;
  name9?: Flex__<"div">;
  status3?: Flex__<"div">;
  label9?: Flex__<"div">;
  body8?: Flex__<"div">;
  year3?: Flex__<"div">;
  name5?: Flex__<"div">;
  actions3?: Flex__<"div">;
  mockupButton5?: Flex__<"div">;
  link9?: Flex__<"div">;
  mockupButton6?: Flex__<"div">;
  link5?: Flex__<"div">;
  menu2?: Flex__<"div">;
  header19?: Flex__<"div">;
  title22?: Flex__<"div">;
  icon8?: Flex__<"div">;
  list?: Flex__<"div">;
  item23?: Flex__<"div">;
  text26?: Flex__<"div">;
  item24?: Flex__<"div">;
  text4?: Flex__<"div">;
  item25?: Flex__<"div">;
  text27?: Flex__<"div">;
  item26?: Flex__<"div">;
  text28?: Flex__<"div">;
  item27?: Flex__<"div">;
  text29?: Flex__<"div">;
  item28?: Flex__<"div">;
  text30?: Flex__<"div">;
  item29?: Flex__<"div">;
  text31?: Flex__<"div">;
  item30?: Flex__<"div">;
  text32?: Flex__<"div">;
  item31?: Flex__<"div">;
  text33?: Flex__<"div">;
  item32?: Flex__<"div">;
  text34?: Flex__<"div">;
  alert?: Flex__<"div">;
  icon9?: Flex__<"div">;
  content2?: Flex__<"div">;
  text35?: Flex__<"div">;
  icon10?: Flex__<"div">;
  features?: Flex__<"div">;
  title5?: Flex__<"div">;
  figmaPaste?: Flex__<"div">;
  contentsItem?: Flex__<"div">;
  icon11?: Flex__<"div">;
  text36?: Flex__<"div">;
  contentsItem2?: Flex__<"div">;
  icon12?: Flex__<"div">;
  text37?: Flex__<"div">;
  contentsItem3?: Flex__<"div">;
  icon13?: Flex__<"div">;
  text38?: Flex__<"div">;
  contentsItem4?: Flex__<"div">;
  icon14?: Flex__<"div">;
  text39?: Flex__<"div">;
  contentsItem5?: Flex__<"div">;
  icon15?: Flex__<"div">;
  text5?: Flex__<"div">;
  contentsItem6?: Flex__<"div">;
  icon16?: Flex__<"div">;
  text40?: Flex__<"div">;
  contentsItem7?: Flex__<"div">;
  icon17?: Flex__<"div">;
  text41?: Flex__<"div">;
  contentsItem8?: Flex__<"div">;
  icon18?: Flex__<"div">;
  text42?: Flex__<"div">;
  contentsItem9?: Flex__<"div">;
  icon19?: Flex__<"div">;
  text43?: Flex__<"div">;
  mobileWrapper?: Flex__<"div">;
  header?: Flex__<"div">;
  top?: Flex__<"div">;
  subtitle2?: Flex__<"div">;
  title2?: Flex__<"div">;
  body?: Flex__<"div">;
  tabs?: Flex__<typeof AntdTabs>;
  content8?: Flex__<"div">;
  placeholder83?: Flex__<"div">;
  intro5?: Flex__<"div">;
  img5?: Flex__<"div">;
  bg?: Flex__<"div">;
  compWrap?: Flex__<"div">;
  perf?: Flex__<"div">;
  header6?: Flex__<"div">;
  subtitle3?: Flex__<"div">;
  title24?: Flex__<"div">;
  main?: Flex__<"div">;
  mockupCompetencies?: Flex__<"div">;
  graph?: Flex__<"div">;
  labels?: Flex__<"div">;
  series2?: Flex__<"div">;
  rectangle1?: Flex__<"div">;
  rectangle2?: Flex__<"div">;
  rectangle3?: Flex__<"div">;
  rectangle4?: Flex__<"div">;
  rectangle5?: Flex__<"div">;
  rectangle6?: Flex__<"div">;
  series3?: Flex__<"div">;
  rectangle7?: Flex__<"div">;
  rectangle8?: Flex__<"div">;
  rectangle9?: Flex__<"div">;
  rectangle10?: Flex__<"div">;
  rectangle11?: Flex__<"div">;
  rectangle12?: Flex__<"div">;
  scores?: Flex__<"div">;
  graphScore?: Flex__<"div">;
  num?: Flex__<"div">;
  graphScore2?: Flex__<"div">;
  num2?: Flex__<"div">;
  graphScore3?: Flex__<"div">;
  num3?: Flex__<"div">;
  smallerGraph?: Flex__<"div">;
  inner?: Flex__<"div">;
  labels2?: Flex__<"div">;
  series22?: Flex__<"div">;
  rectangle13?: Flex__<"div">;
  rectangle14?: Flex__<"div">;
  rectangle15?: Flex__<"div">;
  rectangle16?: Flex__<"div">;
  rectangle17?: Flex__<"div">;
  rectangle18?: Flex__<"div">;
  series32?: Flex__<"div">;
  rectangle19?: Flex__<"div">;
  rectangle20?: Flex__<"div">;
  rectangle21?: Flex__<"div">;
  rectangle22?: Flex__<"div">;
  rectangle23?: Flex__<"div">;
  rectangle24?: Flex__<"div">;
  scores2?: Flex__<"div">;
  graphScore4?: Flex__<"div">;
  num4?: Flex__<"div">;
  graphScore5?: Flex__<"div">;
  num5?: Flex__<"div">;
  graphScore6?: Flex__<"div">;
  num6?: Flex__<"div">;
  list6?: Flex__<"div">;
  item?: Flex__<"div">;
  icon?: Flex__<"div">;
  abbr?: Flex__<"div">;
  title25?: Flex__<"div">;
  item2?: Flex__<"div">;
  icon2?: Flex__<"div">;
  abbr2?: Flex__<"div">;
  title3?: Flex__<"div">;
  item3?: Flex__<"div">;
  icon3?: Flex__<"div">;
  abbr3?: Flex__<"div">;
  title41?: Flex__<"div">;
  item4?: Flex__<"div">;
  icon4?: Flex__<"div">;
  abbr4?: Flex__<"div">;
  title43?: Flex__<"div">;
  item5?: Flex__<"div">;
  icon5?: Flex__<"div">;
  abbr5?: Flex__<"div">;
  title6?: Flex__<"div">;
  item6?: Flex__<"div">;
  icon6?: Flex__<"div">;
  abbr6?: Flex__<"div">;
  title7?: Flex__<"div">;
  shade?: Flex__<"div">;
  nav2?: Flex__<"div">;
  btn?: Flex__<"div">;
  text55?: Flex__<"div">;
  btn2?: Flex__<"div">;
  text2?: Flex__<"div">;
  btn3?: Flex__<"div">;
  text3?: Flex__<"div">;
  btn4?: Flex__<"div">;
  text56?: Flex__<"div">;
  mockupButtonBarItem?: Flex__<"div">;
  text69?: Flex__<"div">;
  btn5?: Flex__<"div">;
  text6?: Flex__<"div">;
  btn6?: Flex__<"div">;
  text7?: Flex__<"div">;
  btn7?: Flex__<"div">;
  text8?: Flex__<"div">;
  btn8?: Flex__<"div">;
  text9?: Flex__<"div">;
  btn9?: Flex__<"div">;
  text10?: Flex__<"div">;
  profile?: Flex__<"div">;
  av?: Flex__<"div">;
  col12?: Flex__<"div">;
  top2?: Flex__<"div">;
  header2?: Flex__<"div">;
  name?: Flex__<"div">;
  status?: Flex__<"div">;
  label?: Flex__<"div">;
  line?: Flex__<"div">;
  mockupTextPlaceholderContent?: Flex__<"div">;
  placeholder2?: Flex__<"div">;
  body3?: Flex__<"div">;
  year?: Flex__<"div">;
  name2?: Flex__<"div">;
  line2?: Flex__<"div">;
  mockupTextPlaceholderContent2?: Flex__<"div">;
  placeholder3?: Flex__<"div">;
  actions?: Flex__<"div">;
  mockupButton?: Flex__<"div">;
  link?: Flex__<"div">;
  mockupButton2?: Flex__<"div">;
  link2?: Flex__<"div">;
  text11?: Flex__<"div">;
  title8?: Flex__<"div">;
  desc13?: Flex__<"div">;
  areas2?: Flex__<"div">;
  header3?: Flex__<"div">;
  title49?: Flex__<"div">;
  body2?: Flex__<"div">;
  frame23?: Flex__<"div">;
  item7?: Flex__<"div">;
  title50?: Flex__<"div">;
  desc17?: Flex__<"div">;
  item8?: Flex__<"div">;
  title51?: Flex__<"div">;
  desc18?: Flex__<"div">;
  item9?: Flex__<"div">;
  title52?: Flex__<"div">;
  desc19?: Flex__<"div">;
  item10?: Flex__<"div">;
  title53?: Flex__<"div">;
  desc20?: Flex__<"div">;
  item11?: Flex__<"div">;
  title54?: Flex__<"div">;
  desc21?: Flex__<"div">;
  item12?: Flex__<"div">;
  title55?: Flex__<"div">;
  desc10?: Flex__<"div">;
  footnote2?: Flex__<"div">;
  content5?: Flex__<"div">;
  placeholder56?: Flex__<"div">;
  intro6?: Flex__<"div">;
  img6?: Flex__<"div">;
  bg5?: Flex__<"div">;
  xmlid74572?: Flex__<"div">;
  xmlid67762?: Flex__<"div">;
  xmlid74332?: Flex__<"div">;
  xmlid73392?: Flex__<"div">;
  certificate2?: Flex__<"div">;
  top6?: Flex__<"div">;
  mockupCertificateIcon2?: Flex__<"div">;
  bg6?: Flex__<"div">;
  group2?: Flex__<"div">;
  paper3?: Flex__<"div">;
  paper4?: Flex__<"div">;
  cert2?: Flex__<"div">;
  award492?: Flex__<"div">;
  overlay2?: Flex__<"div">;
  title26?: Flex__<"div">;
  mockupTextPlaceholder2?: Flex__<"div">;
  mockupTextPlaceholderParagraph7?: Flex__<"div">;
  mockupTextPlaceholderLine37?: Flex__<"div">;
  mockupTextPlaceholderContent51?: Flex__<"div">;
  placeholder57?: Flex__<"div">;
  mockupTextPlaceholderLine38?: Flex__<"div">;
  mockupTextPlaceholderContent52?: Flex__<"div">;
  placeholder58?: Flex__<"div">;
  mockupTextPlaceholderLine39?: Flex__<"div">;
  mockupTextPlaceholderContent3?: Flex__<"div">;
  placeholder4?: Flex__<"div">;
  mockupTextPlaceholderLine40?: Flex__<"div">;
  mockupTextPlaceholderContent4?: Flex__<"div">;
  placeholder5?: Flex__<"div">;
  mockupTextPlaceholderLine41?: Flex__<"div">;
  mockupTextPlaceholderContent5?: Flex__<"div">;
  placeholder6?: Flex__<"div">;
  mockupTextPlaceholderParagraph8?: Flex__<"div">;
  mockupTextPlaceholderLine42?: Flex__<"div">;
  mockupTextPlaceholderContent6?: Flex__<"div">;
  placeholder7?: Flex__<"div">;
  mockupTextPlaceholderLine43?: Flex__<"div">;
  mockupTextPlaceholderContent7?: Flex__<"div">;
  placeholder8?: Flex__<"div">;
  mockupTextPlaceholderLine44?: Flex__<"div">;
  mockupTextPlaceholderContent8?: Flex__<"div">;
  placeholder9?: Flex__<"div">;
  mockupTextPlaceholderLine45?: Flex__<"div">;
  mockupTextPlaceholderContent9?: Flex__<"div">;
  placeholder10?: Flex__<"div">;
  mockupTextPlaceholderLine46?: Flex__<"div">;
  mockupTextPlaceholderContent10?: Flex__<"div">;
  placeholder11?: Flex__<"div">;
  mockupTextPlaceholderLine47?: Flex__<"div">;
  mockupTextPlaceholderContent11?: Flex__<"div">;
  placeholder12?: Flex__<"div">;
  mockupTextPlaceholderLine48?: Flex__<"div">;
  mockupTextPlaceholderContent12?: Flex__<"div">;
  placeholder13?: Flex__<"div">;
  mockupTextPlaceholderLine49?: Flex__<"div">;
  mockupTextPlaceholderContent13?: Flex__<"div">;
  placeholder14?: Flex__<"div">;
  mockupTextPlaceholderParagraph9?: Flex__<"div">;
  mockupTextPlaceholderLine50?: Flex__<"div">;
  mockupTextPlaceholderContent14?: Flex__<"div">;
  placeholder15?: Flex__<"div">;
  mockupTextPlaceholderLine51?: Flex__<"div">;
  mockupTextPlaceholderContent53?: Flex__<"div">;
  placeholder59?: Flex__<"div">;
  mockupTextPlaceholderLine52?: Flex__<"div">;
  mockupTextPlaceholderContent54?: Flex__<"div">;
  placeholder60?: Flex__<"div">;
  mockupTextPlaceholderLine53?: Flex__<"div">;
  mockupTextPlaceholderContent55?: Flex__<"div">;
  placeholder61?: Flex__<"div">;
  mockupTextPlaceholderLine54?: Flex__<"div">;
  mockupTextPlaceholderContent56?: Flex__<"div">;
  placeholder62?: Flex__<"div">;
  mockupTextPlaceholderParagraph10?: Flex__<"div">;
  mockupTextPlaceholderLine55?: Flex__<"div">;
  mockupTextPlaceholderContent57?: Flex__<"div">;
  placeholder63?: Flex__<"div">;
  mockupTextPlaceholderLine56?: Flex__<"div">;
  mockupTextPlaceholderContent58?: Flex__<"div">;
  placeholder64?: Flex__<"div">;
  mockupTextPlaceholderLine57?: Flex__<"div">;
  mockupTextPlaceholderContent59?: Flex__<"div">;
  placeholder65?: Flex__<"div">;
  mockupTextPlaceholderLine58?: Flex__<"div">;
  mockupTextPlaceholderContent60?: Flex__<"div">;
  placeholder66?: Flex__<"div">;
  mockupTextPlaceholderLine59?: Flex__<"div">;
  mockupTextPlaceholderContent61?: Flex__<"div">;
  placeholder67?: Flex__<"div">;
  mockupTextPlaceholderLine60?: Flex__<"div">;
  mockupTextPlaceholderContent62?: Flex__<"div">;
  placeholder68?: Flex__<"div">;
  mockupTextPlaceholderLine61?: Flex__<"div">;
  mockupTextPlaceholderContent63?: Flex__<"div">;
  placeholder69?: Flex__<"div">;
  mockupTextPlaceholderLine62?: Flex__<"div">;
  mockupTextPlaceholderContent64?: Flex__<"div">;
  placeholder70?: Flex__<"div">;
  mockupButton3?: Flex__<"div">;
  link3?: Flex__<"div">;
  bill3?: Flex__<"div">;
  bill2?: Flex__<"div">;
  header4?: Flex__<"div">;
  subtitle6?: Flex__<"div">;
  title35?: Flex__<"div">;
  main2?: Flex__<"div">;
  placeholder71?: Flex__<"div">;
  header5?: Flex__<"div">;
  title36?: Flex__<"div">;
  date2?: Flex__<"div">;
  section3?: Flex__<"div">;
  head3?: Flex__<"div">;
  mockupTextPlaceholderParagraph11?: Flex__<"div">;
  mockupTextPlaceholderLine63?: Flex__<"div">;
  mockupTextPlaceholderContent65?: Flex__<"div">;
  placeholder72?: Flex__<"div">;
  mockupTextPlaceholderLine64?: Flex__<"div">;
  mockupTextPlaceholderContent66?: Flex__<"div">;
  placeholder73?: Flex__<"div">;
  mockupTextPlaceholderLine65?: Flex__<"div">;
  mockupTextPlaceholderContent67?: Flex__<"div">;
  placeholder74?: Flex__<"div">;
  mockupTextPlaceholderLine66?: Flex__<"div">;
  mockupTextPlaceholderContent68?: Flex__<"div">;
  placeholder75?: Flex__<"div">;
  mockupTextPlaceholderLine67?: Flex__<"div">;
  mockupTextPlaceholderContent69?: Flex__<"div">;
  placeholder76?: Flex__<"div">;
  total3?: Flex__<"div">;
  title37?: Flex__<"div">;
  val8?: Flex__<"div">;
  section4?: Flex__<"div">;
  head4?: Flex__<"div">;
  mockupTextPlaceholderParagraph12?: Flex__<"div">;
  mockupTextPlaceholderLine68?: Flex__<"div">;
  mockupTextPlaceholderContent70?: Flex__<"div">;
  placeholder77?: Flex__<"div">;
  mockupTextPlaceholderLine69?: Flex__<"div">;
  mockupTextPlaceholderContent71?: Flex__<"div">;
  placeholder78?: Flex__<"div">;
  mockupTextPlaceholderLine70?: Flex__<"div">;
  mockupTextPlaceholderContent72?: Flex__<"div">;
  placeholder79?: Flex__<"div">;
  mockupTextPlaceholderLine71?: Flex__<"div">;
  mockupTextPlaceholderContent73?: Flex__<"div">;
  placeholder80?: Flex__<"div">;
  mockupTextPlaceholderLine72?: Flex__<"div">;
  mockupTextPlaceholderContent74?: Flex__<"div">;
  placeholder81?: Flex__<"div">;
  total4?: Flex__<"div">;
  title38?: Flex__<"div">;
  val9?: Flex__<"div">;
  edge2?: Flex__<"div">;
  tri33?: Flex__<"div">;
  rect33?: Flex__<"div">;
  tri34?: Flex__<"div">;
  rect34?: Flex__<"div">;
  tri35?: Flex__<"div">;
  rect35?: Flex__<"div">;
  tri36?: Flex__<"div">;
  rect36?: Flex__<"div">;
  tri37?: Flex__<"div">;
  rect37?: Flex__<"div">;
  tri38?: Flex__<"div">;
  rect38?: Flex__<"div">;
  tri39?: Flex__<"div">;
  rect39?: Flex__<"div">;
  tri40?: Flex__<"div">;
  rect40?: Flex__<"div">;
  tri41?: Flex__<"div">;
  rect41?: Flex__<"div">;
  tri42?: Flex__<"div">;
  rect42?: Flex__<"div">;
  tri43?: Flex__<"div">;
  rect43?: Flex__<"div">;
  tri44?: Flex__<"div">;
  rect44?: Flex__<"div">;
  tri45?: Flex__<"div">;
  rect45?: Flex__<"div">;
  tri46?: Flex__<"div">;
  rect46?: Flex__<"div">;
  tri47?: Flex__<"div">;
  rect47?: Flex__<"div">;
  tri48?: Flex__<"div">;
  rect48?: Flex__<"div">;
  tri49?: Flex__<"div">;
  rect49?: Flex__<"div">;
  tri50?: Flex__<"div">;
  rect50?: Flex__<"div">;
  tri51?: Flex__<"div">;
  rect51?: Flex__<"div">;
  tri52?: Flex__<"div">;
  rect52?: Flex__<"div">;
  tri53?: Flex__<"div">;
  rect53?: Flex__<"div">;
  tri54?: Flex__<"div">;
  rect54?: Flex__<"div">;
  tri55?: Flex__<"div">;
  rect55?: Flex__<"div">;
  tri56?: Flex__<"div">;
  rect56?: Flex__<"div">;
  tri57?: Flex__<"div">;
  rect57?: Flex__<"div">;
  tri58?: Flex__<"div">;
  rect58?: Flex__<"div">;
  tri59?: Flex__<"div">;
  rect59?: Flex__<"div">;
  tri60?: Flex__<"div">;
  rect60?: Flex__<"div">;
  tri61?: Flex__<"div">;
  rect61?: Flex__<"div">;
  tri62?: Flex__<"div">;
  rect62?: Flex__<"div">;
  tri63?: Flex__<"div">;
  rect63?: Flex__<"div">;
  tri64?: Flex__<"div">;
  rect64?: Flex__<"div">;
  shade4?: Flex__<"div">;
  alert4?: Flex__<"div">;
  icon31?: Flex__<"div">;
  content6?: Flex__<"div">;
  text15?: Flex__<"div">;
  icon32?: Flex__<"div">;
  text16?: Flex__<"div">;
  title39?: Flex__<"div">;
  desc11?: Flex__<"div">;
  features2?: Flex__<"div">;
  title40?: Flex__<"div">;
  contents?: Flex__<"div">;
  contentsItem18?: Flex__<"div">;
  icon33?: Flex__<"div">;
  text17?: Flex__<"div">;
  contentsItem19?: Flex__<"div">;
  icon34?: Flex__<"div">;
  text18?: Flex__<"div">;
  contentsItem20?: Flex__<"div">;
  icon35?: Flex__<"div">;
  text19?: Flex__<"div">;
  contentsItem21?: Flex__<"div">;
  icon36?: Flex__<"div">;
  text20?: Flex__<"div">;
  contentsItem22?: Flex__<"div">;
  icon7?: Flex__<"div">;
  text21?: Flex__<"div">;
  contentsItem23?: Flex__<"div">;
  icon37?: Flex__<"div">;
  text22?: Flex__<"div">;
  contentsItem24?: Flex__<"div">;
  icon38?: Flex__<"div">;
  text23?: Flex__<"div">;
  contentsItem25?: Flex__<"div">;
  icon39?: Flex__<"div">;
  text24?: Flex__<"div">;
  content7?: Flex__<"div">;
  placeholder82?: Flex__<"div">;
  intro7?: Flex__<"div">;
  img7?: Flex__<"div">;
  cap2?: Flex__<"div">;
  header27?: Flex__<"div">;
  subtitle11?: Flex__<"div">;
  title42?: Flex__<"div">;
  main9?: Flex__<"div">;
  placeholder84?: Flex__<"div">;
  field2?: Flex__<"div">;
  label14?: Flex__<"div">;
  select2?: Flex__<"div">;
  input2?: Flex__<"div">;
  leftIcon2?: Flex__<"div">;
  text54?: Flex__<"div">;
  rightIcon2?: Flex__<"div">;
  row4?: Flex__<"div">;
  prop5?: Flex__<"div">;
  label15?: Flex__<"div">;
  val10?: Flex__<"div">;
  prop6?: Flex__<"div">;
  label16?: Flex__<"div">;
  val11?: Flex__<"div">;
  text79?: Flex__<"div">;
  title46?: Flex__<"div">;
  desc12?: Flex__<"div">;
  features4?: Flex__<"div">;
  title47?: Flex__<"div">;
  grid?: Flex__<"div">;
  contentsItem26?: Flex__<"div">;
  icon41?: Flex__<"div">;
  text80?: Flex__<"div">;
  contentsItem27?: Flex__<"div">;
  icon42?: Flex__<"div">;
  text81?: Flex__<"div">;
  contentsItem28?: Flex__<"div">;
  icon43?: Flex__<"div">;
  text82?: Flex__<"div">;
  contentsItem29?: Flex__<"div">;
  icon44?: Flex__<"div">;
  text83?: Flex__<"div">;
  contentsItem30?: Flex__<"div">;
  icon45?: Flex__<"div">;
  text84?: Flex__<"div">;
  contentsItem31?: Flex__<"div">;
  icon46?: Flex__<"div">;
  text85?: Flex__<"div">;
  contentsItem32?: Flex__<"div">;
  icon47?: Flex__<"div">;
  text86?: Flex__<"div">;
  contentsItem33?: Flex__<"div">;
  icon48?: Flex__<"div">;
  text87?: Flex__<"div">;
  contentsItem34?: Flex__<"div">;
  icon49?: Flex__<"div">;
  text88?: Flex__<"div">;
};

export interface DefaultHomeProductsSectionProps {
  className?: string;
}

const $$ = {};

function useNextRouter() {
  try {
    return useRouter();
  } catch {}
  return undefined;
}

function PlasmicHomeProductsSection__RenderFunc(props: {
  variants: PlasmicHomeProductsSection__VariantsArgs;
  args: PlasmicHomeProductsSection__ArgsType;
  overrides: PlasmicHomeProductsSection__OverridesType;
  forNode?: string;
}) {
  const { variants, overrides, forNode } = props;

  const args = React.useMemo(
    () =>
      Object.assign(
        {},
        Object.fromEntries(
          Object.entries(props.args).filter(([_, v]) => v !== undefined)
        )
      ),
    [props.args]
  );

  const $props = {
    ...args,
    ...variants
  };

  const __nextRouter = useNextRouter();

  const $ctx = useDataEnv?.() || {};
  const refsRef = React.useRef({});
  const $refs = refsRef.current;

  const stateSpecs: Parameters<typeof useDollarState>[0] = React.useMemo(
    () => [
      {
        path: "accordion",
        type: "private",
        variableType: "number",
        initFunc: ({ $props, $state, $queries, $q, $ctx }) => 0
      },
      {
        path: "productTabs.activeKey",
        type: "private",
        variableType: "text",
        initFunc: ({ $props, $state, $queries, $q, $ctx }) => "1"
      },
      {
        path: "tabs.activeKey",
        type: "private",
        variableType: "text",
        initFunc: ({ $props, $state, $queries, $q, $ctx }) =>
          hasVariant(globalVariants, "mobile", "mobileXSmall") ? "1" : "1"
      }
    ],
    [$props, $ctx, $refs]
  );

  const globalVariants = _useGlobalVariants();

  const $state = useDollarState(stateSpecs, {
    $props,
    $ctx,
    $queries: {},
    $q: {},
    $refs
  });

  const styleTokensClassNames = _useStyleTokens();

  return (
    <section
      data-plasmic-name={"productsSection"}
      data-plasmic-override={overrides.productsSection}
      data-plasmic-root={true}
      data-plasmic-for-node={forNode}
      className={classNames(
        "all",
        "root_reset_bvRZj1oZhhFBeMnkX2LkQu",
        "plasmic_default_styles",
        "plasmic_mixins",
        styleTokensClassNames,
        sty.productsSection
      )}
    >
      <DataProvider
        data-plasmic-name={"productsProvider"}
        data-plasmic-override={overrides.productsProvider}
        className={classNames("__wab_instance", sty.productsProvider)}
        data={[
          {
            product: "myEvaluations",
            header:
              "System integrating evaluations, milestones, EPAs, quizzes, schedules and more.",
            title: "Experience the Future of Medical Education Management",
            subtitle:
              "MyEvaluations revolutionizes medical training management with streamlined scheduling, patient logs, clinical hour compliance, and custom evaluations. Its efficient workflow and secure, accessible platform save time, resources, and paper, while enabling comprehensive reports and early intervention alerts for improved training outcomes.",
            bulletPoints: {
              bulletpointsLeft: [
                "Evaluations, Milestones & EPAs",
                "Performance Improvement Plans & Clinical Learning Contracts",
                "Scheduling and Compliance",
                "Educational Compliance",
                "ACGME Compliance Tracking"
              ],
              bulletpointsRight: [
                "Curriculum Management",
                "MyQuiz & Learning Assignments",
                "Procedure & Patient Logging",
                "Return Demonstrations",
                "Administrative Tools"
              ]
            }
          },
          {
            product: "myCme",
            header:
              "CME management from credit tracking to critical report generation.",
            title: "Unified Solution To Manage, Track, and Report CME Credits",
            subtitle:
              "MyCME facilitates the fulfilment of CME requirements. Organizations can automate PARS reports and maintain cross-departmental financial records. In turn, faculty members gain a unified system for tracking evaluations and reporting MOC to various boards supported by the ACCME.",
            bulletPoints: {
              bulletpointsLeft: [
                "Live & Durable Event Scheduling",
                "CME Certificate Management"
              ],
              bulletpointsRight: [
                "ACCME Connectivity to PARS",
                "Event Financial Management"
              ]
            }
          },
          {
            product: "myGme",
            header:
              "Fiscal management including submitting work-hour data to Medicare",
            title: "Step Into a World of Simplified GME Financial Management",
            subtitle:
              "My GME Fiscal utilizes data from MyEvaluations for precise fiscal management, particularly in Medicare reimbursements. With features like Master Rotation Schedules, Gap and Overlap Analysis, and detailed reports, it provides comprehensive oversight. Use it to ensure accurate submissions and gain unhindered access to critical information.",
            bulletPoints: {
              bulletpointsLeft: [
                "Reimbursement & Cost Reporting",
                "IRIS/STAR Export",
                "Billing & Invoicing",
                "FTE Reports & CAP Analysis"
              ],
              bulletpointsRight: [
                "Audit Management",
                "Errors & Omissions Analysis",
                "MyQuickPass Integration"
              ]
            }
          }
        ]}
        name={"products"}
      >
        <DataCtxReader__>
          {$ctx => (
            <React.Fragment>
              {(
                hasVariant(globalVariants, "mobile", "mobile")
                  ? false
                  : hasVariant(globalVariants, "mobile", "tabletPortrait")
                    ? false
                    : true
              ) ? (
                <div
                  data-plasmic-name={"desktopWrapper"}
                  data-plasmic-override={overrides.desktopWrapper}
                  className={classNames("all", sty.desktopWrapper)}
                >
                  <div
                    data-plasmic-name={"intro2"}
                    data-plasmic-override={overrides.intro2}
                    className={classNames("all", sty.intro2)}
                  >
                    <div
                      data-plasmic-name={"header9"}
                      data-plasmic-override={overrides.header9}
                      className={classNames("all", sty.header9)}
                    >
                      <div
                        data-plasmic-name={"top3"}
                        data-plasmic-override={overrides.top3}
                        className={classNames("all", sty.top3)}
                      >
                        <div
                          data-plasmic-name={"subtitle"}
                          data-plasmic-override={overrides.subtitle}
                          className={classNames(
                            "all",
                            "__wab_text",
                            sty.subtitle
                          )}
                        >
                          {"One Integrated Platform"}
                        </div>
                        <div
                          data-plasmic-name={"title"}
                          data-plasmic-override={overrides.title}
                          className={classNames("all", "__wab_text", sty.title)}
                        >
                          {
                            "Technology That Strengthens \nEducational Conversations"
                          }
                        </div>
                      </div>
                      <div
                        data-plasmic-name={"body6"}
                        data-plasmic-override={overrides.body6}
                        className={classNames("all", "__wab_text", sty.body6)}
                      >
                        {
                          "MyEvaluations unifies every aspect of medical education within a single \nplatform, connecting assessments, competency management, curriculum, \nscheduling, institutional reporting, and compliance. By eliminating fragmented \nsystems and disconnected information, institutions gain actionable insight to \nsupport Continuous Educational Improvement."
                        }
                      </div>
                    </div>
                    <div
                      data-plasmic-name={"col4"}
                      data-plasmic-override={overrides.col4}
                      className={classNames("all", sty.col4)}
                    >
                      <div
                        data-plasmic-name={"nav"}
                        data-plasmic-override={overrides.nav}
                        className={classNames("all", sty.nav)}
                      >
                        <div
                          data-plasmic-name={"img2"}
                          data-plasmic-override={overrides.img2}
                          className={classNames("all", sty.img2)}
                        >
                          <div
                            data-plasmic-name={"logoIcon"}
                            data-plasmic-override={overrides.logoIcon}
                            className={classNames("all", sty.logoIcon)}
                          >
                            <G782Icon
                              className={classNames("all", sty.svg___2Yksr)}
                              role={"img"}
                            />

                            <Path842Icon
                              className={classNames("all", sty.svg___5T1BX)}
                              role={"img"}
                            />

                            <G942Icon
                              className={classNames("all", sty.svg___7Mr1Q)}
                              role={"img"}
                            />

                            <G902Icon
                              className={classNames("all", sty.svg__pPbKl)}
                              role={"img"}
                            />

                            <G902Icon
                              className={classNames("all", sty.svg__c1Cx)}
                              role={"img"}
                            />
                          </div>
                          <PlasmicImg__
                            alt={""}
                            className={classNames(sty.img__yxvJk)}
                            displayHeight={"164px"}
                            displayMaxHeight={"none"}
                            displayMaxWidth={"100%"}
                            displayMinHeight={"0"}
                            displayMinWidth={"0"}
                            displayWidth={"178px"}
                            loader={"plasmic"}
                            loading={"lazy"}
                            src={{
                              src: "https://site-assets.plasmic.app/69bb81e6d432a0ddf00880c2ec36acbd.svg",
                              fullWidth: 178,
                              fullHeight: 164
                            }}
                          />

                          <PlasmicImg__
                            alt={""}
                            className={classNames(sty.img__oHyDs)}
                            displayHeight={"268px"}
                            displayMaxHeight={"none"}
                            displayMaxWidth={"100%"}
                            displayMinHeight={"0"}
                            displayMinWidth={"0"}
                            displayWidth={"171px"}
                            loader={"plasmic"}
                            loading={"lazy"}
                            src={{
                              src: "https://site-assets.plasmic.app/2fbb4b6cad4ae972112b5473c0b9c726.svg",
                              fullWidth: 171,
                              fullHeight: 268
                            }}
                          />

                          <PlasmicImg__
                            alt={""}
                            className={classNames(sty.img__pm2UC)}
                            displayHeight={"200px"}
                            displayMaxHeight={"none"}
                            displayMaxWidth={"100%"}
                            displayMinHeight={"0"}
                            displayMinWidth={"0"}
                            displayWidth={"357px"}
                            loader={"plasmic"}
                            loading={"lazy"}
                            src={{
                              src: "https://site-assets.plasmic.app/ad8e22b75eb3a2d158898613b820dce9.svg",
                              fullWidth: 357,
                              fullHeight: 200
                            }}
                          />

                          <Logo
                            data-plasmic-name={"logo7"}
                            data-plasmic-override={overrides.logo7}
                            className={classNames("__wab_instance", sty.logo7)}
                          />

                          <Logo
                            data-plasmic-name={"logo2"}
                            data-plasmic-override={overrides.logo2}
                            className={classNames("__wab_instance", sty.logo2)}
                            product={"myGme"}
                          />

                          <Logo
                            data-plasmic-name={"logo3"}
                            data-plasmic-override={overrides.logo3}
                            className={classNames("__wab_instance", sty.logo3)}
                            product={"myCme"}
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                  <AntdTabs
                    data-plasmic-name={"productTabs"}
                    data-plasmic-override={overrides.productTabs}
                    activeKey={generateStateValueProp($state, [
                      "productTabs",
                      "activeKey"
                    ])}
                    animateTabBar={true}
                    animateTabContent={false}
                    animated={true}
                    centered={false}
                    className={classNames("__wab_instance", sty.productTabs)}
                    defaultActiveKey={"1"}
                    destroyInactiveTabPane={true}
                    items={
                      <React.Fragment>
                        <AntdTabItem
                          className={classNames(
                            "__wab_instance",
                            sty.tabItem__l82Na
                          )}
                          key={"1"}
                          label={
                            <div
                              className={classNames("all", sty.freeBox___2GaH)}
                            >
                              <PlasmicImg__
                                alt={""}
                                className={classNames(sty.img__bpfxl)}
                                displayHeight={"40px"}
                                displayMaxHeight={"none"}
                                displayMaxWidth={"100%"}
                                displayMinHeight={"0"}
                                displayMinWidth={"0"}
                                displayWidth={"236px"}
                                loader={"plasmic"}
                                loading={"lazy"}
                                src={{
                                  src: "https://site-assets.plasmic.app/e0d717efc79e1714572b0ff755fc9dba.svg",
                                  fullWidth: 113.777,
                                  fullHeight: 19.887,
                                  aspectRatio: 5.7
                                }}
                              />
                            </div>
                          }
                        >
                          <div
                            data-plasmic-name={"content"}
                            data-plasmic-override={overrides.content}
                            className={classNames("all", sty.content)}
                          >
                            <div
                              data-plasmic-name={"placeholder"}
                              data-plasmic-override={overrides.placeholder}
                              className={classNames("all", sty.placeholder)}
                            >
                              <div
                                data-plasmic-name={"intro"}
                                data-plasmic-override={overrides.intro}
                                className={classNames("all", sty.intro)}
                              >
                                <div
                                  data-plasmic-name={"col"}
                                  data-plasmic-override={overrides.col}
                                  className={classNames("all", sty.col)}
                                >
                                  <Logo
                                    data-plasmic-name={"logo"}
                                    data-plasmic-override={overrides.logo}
                                    className={classNames(
                                      "__wab_instance",
                                      sty.logo
                                    )}
                                  />

                                  <div
                                    data-plasmic-name={"text53"}
                                    data-plasmic-override={overrides.text53}
                                    className={classNames("all", sty.text53)}
                                  >
                                    <div
                                      data-plasmic-name={"title23"}
                                      data-plasmic-override={overrides.title23}
                                      className={classNames(
                                        "all",
                                        "__wab_text",
                                        sty.title23
                                      )}
                                    >
                                      {
                                        "Experience the Future \nof Medical Education Management"
                                      }
                                    </div>
                                    <div
                                      data-plasmic-name={"desc"}
                                      data-plasmic-override={overrides.desc}
                                      className={classNames(
                                        "all",
                                        "__wab_text",
                                        sty.desc
                                      )}
                                    >
                                      {
                                        "MyEvaluations revolutionizes medical training management with streamlined scheduling, patient logs, clinical hour compliance, and custom evaluations. Its efficient workflow and secure, accessible platform save time, resources, and paper, while enabling comprehensive reports and early intervention alerts for improved training outcomes."
                                      }
                                    </div>
                                  </div>
                                </div>
                                <div
                                  data-plasmic-name={"img"}
                                  data-plasmic-override={overrides.img}
                                  className={classNames("all", sty.img)}
                                >
                                  <PlasmicImg__
                                    alt={""}
                                    className={classNames(sty.img__xU7YT)}
                                    displayHeight={"auto"}
                                    displayMaxHeight={"none"}
                                    displayMaxWidth={"100%"}
                                    displayMinHeight={"0"}
                                    displayMinWidth={"0"}
                                    displayWidth={"auto"}
                                    loader={"plasmic"}
                                    loading={"lazy"}
                                    src={{
                                      src: "https://img.plasmic.app/img-optimizer/v1/img/cada1878bf9849f9c3027454c9cb64e1.png",
                                      fullWidth: 715,
                                      fullHeight: 402
                                    }}
                                  />
                                </div>
                              </div>
                              <div
                                className={classNames(
                                  "all",
                                  sty.freeBox___5S77S
                                )}
                              >
                                <PlasmicImg__
                                  alt={""}
                                  className={classNames(sty.img__oilUm)}
                                  displayHeight={"auto"}
                                  displayMaxHeight={"none"}
                                  displayMaxWidth={"100%"}
                                  displayMinHeight={"0"}
                                  displayMinWidth={"0"}
                                  displayWidth={"auto"}
                                  loader={"plasmic"}
                                  loading={"lazy"}
                                  src={{
                                    src: "https://img.plasmic.app/img-optimizer/v1/img/ca4b4e1c941ba81b105794fafc0e5123.png",
                                    fullWidth: 352,
                                    fullHeight: 620
                                  }}
                                />

                                <PlasmicImg__
                                  alt={""}
                                  className={classNames(sty.img__iwtq9)}
                                  displayHeight={"auto"}
                                  displayMaxHeight={"none"}
                                  displayMaxWidth={"100%"}
                                  displayMinHeight={"0"}
                                  displayMinWidth={"0"}
                                  displayWidth={"auto"}
                                  loader={"plasmic"}
                                  loading={"lazy"}
                                  src={{
                                    src: "https://img.plasmic.app/img-optimizer/v1/img/12f046abb0ee868881678a53aeb431e3.png",
                                    fullWidth: 352,
                                    fullHeight: 620
                                  }}
                                />

                                <PlasmicImg__
                                  alt={""}
                                  className={classNames(sty.img__xmHzw)}
                                  displayHeight={"auto"}
                                  displayMaxHeight={"none"}
                                  displayMaxWidth={"100%"}
                                  displayMinHeight={"0"}
                                  displayMinWidth={"0"}
                                  displayWidth={"auto"}
                                  loader={"plasmic"}
                                  loading={"lazy"}
                                  src={{
                                    src: "https://img.plasmic.app/img-optimizer/v1/img/f1001f000bed2228f4e59018fe78c9ed.png",
                                    fullWidth: 352,
                                    fullHeight: 620
                                  }}
                                />
                              </div>
                              <div
                                data-plasmic-name={"areas"}
                                data-plasmic-override={overrides.areas}
                                className={classNames("all", sty.areas)}
                              >
                                <div
                                  data-plasmic-name={"header10"}
                                  data-plasmic-override={overrides.header10}
                                  className={classNames("all", sty.header10)}
                                >
                                  <div
                                    data-plasmic-name={"title11"}
                                    data-plasmic-override={overrides.title11}
                                    className={classNames(
                                      "all",
                                      "__wab_text",
                                      sty.title11
                                    )}
                                  >
                                    {
                                      "\nA Comprehensive Medical Education Platform"
                                    }
                                  </div>
                                  <div
                                    data-plasmic-name={"body7"}
                                    data-plasmic-override={overrides.body7}
                                    className={classNames(
                                      "all",
                                      "__wab_text",
                                      sty.body7
                                    )}
                                  >
                                    {
                                      "Built on a single integrated platform, MyEvaluations provides:"
                                    }
                                  </div>
                                </div>
                                <div
                                  data-plasmic-name={"frame22"}
                                  data-plasmic-override={overrides.frame22}
                                  className={classNames("all", sty.frame22)}
                                >
                                  <div
                                    data-plasmic-name={"item17"}
                                    data-plasmic-override={overrides.item17}
                                    className={classNames("all", sty.item17)}
                                  >
                                    <div
                                      data-plasmic-name={"title12"}
                                      data-plasmic-override={overrides.title12}
                                      className={classNames(
                                        "all",
                                        "__wab_text",
                                        sty.title12
                                      )}
                                    >
                                      {"Assessment & Competency Management"}
                                    </div>
                                    <div
                                      data-plasmic-name={"desc7"}
                                      data-plasmic-override={overrides.desc7}
                                      className={classNames(
                                        "all",
                                        "__wab_text",
                                        sty.desc7
                                      )}
                                    >
                                      {
                                        "Evaluations, Milestones, EPAs, SAGE\u2122, and Performance Improvement Plans."
                                      }
                                    </div>
                                  </div>
                                  <div
                                    data-plasmic-name={"item18"}
                                    data-plasmic-override={overrides.item18}
                                    className={classNames("all", sty.item18)}
                                  >
                                    <div
                                      data-plasmic-name={"title13"}
                                      data-plasmic-override={overrides.title13}
                                      className={classNames(
                                        "all",
                                        "__wab_text",
                                        sty.title13
                                      )}
                                    >
                                      {"Educational Operations"}
                                    </div>
                                    <div
                                      data-plasmic-name={"desc2"}
                                      data-plasmic-override={overrides.desc2}
                                      className={classNames(
                                        "all",
                                        "__wab_text",
                                        sty.desc2
                                      )}
                                    >
                                      {
                                        "Scheduling, Clinical Hours, Curriculum Management, Procedure & Patient Logs, and Return Demonstrations."
                                      }
                                    </div>
                                  </div>
                                  <div
                                    data-plasmic-name={"item19"}
                                    data-plasmic-override={overrides.item19}
                                    className={classNames("all", sty.item19)}
                                  >
                                    <div
                                      data-plasmic-name={"title14"}
                                      data-plasmic-override={overrides.title14}
                                      className={classNames(
                                        "all",
                                        "__wab_text",
                                        sty.title14
                                      )}
                                    >
                                      {"Learning & Development"}
                                    </div>
                                    <div
                                      data-plasmic-name={"desc3"}
                                      data-plasmic-override={overrides.desc3}
                                      className={classNames(
                                        "all",
                                        "__wab_text",
                                        sty.desc3
                                      )}
                                    >
                                      {
                                        "MyQuiz\u2122, Learning Assignments, and Clinical Learning Contracts."
                                      }
                                    </div>
                                  </div>
                                  <div
                                    data-plasmic-name={"item20"}
                                    data-plasmic-override={overrides.item20}
                                    className={classNames("all", sty.item20)}
                                  >
                                    <div
                                      data-plasmic-name={"title15"}
                                      data-plasmic-override={overrides.title15}
                                      className={classNames(
                                        "all",
                                        "__wab_text",
                                        sty.title15
                                      )}
                                    >
                                      {"Leadership & Analytics"}
                                    </div>
                                    <div
                                      data-plasmic-name={"desc4"}
                                      data-plasmic-override={overrides.desc4}
                                      className={classNames(
                                        "all",
                                        "__wab_text",
                                        sty.desc4
                                      )}
                                    >
                                      {
                                        "MyInsights\u00ae, accreditation support, administrative reporting, and Continuous Educational Improvement tools."
                                      }
                                    </div>
                                  </div>
                                  <div
                                    data-plasmic-name={"item21"}
                                    data-plasmic-override={overrides.item21}
                                    className={classNames("all", sty.item21)}
                                  >
                                    <div
                                      data-plasmic-name={"title16"}
                                      data-plasmic-override={overrides.title16}
                                      className={classNames(
                                        "all",
                                        "__wab_text",
                                        sty.title16
                                      )}
                                    >
                                      {"Continuing Education"}
                                    </div>
                                    <div
                                      data-plasmic-name={"desc5"}
                                      data-plasmic-override={overrides.desc5}
                                      className={classNames(
                                        "all",
                                        "__wab_text",
                                        sty.desc5
                                      )}
                                    >
                                      {
                                        "MyCME\u2122 for continuing medical education management, event planning, accreditation, and learner tracking."
                                      }
                                    </div>
                                  </div>
                                  <div
                                    data-plasmic-name={"item22"}
                                    data-plasmic-override={overrides.item22}
                                    className={classNames("all", sty.item22)}
                                  >
                                    <div
                                      data-plasmic-name={"title17"}
                                      data-plasmic-override={overrides.title17}
                                      className={classNames(
                                        "all",
                                        "__wab_text",
                                        sty.title17
                                      )}
                                    >
                                      {"Fiscal Management"}
                                    </div>
                                    <div
                                      data-plasmic-name={"desc6"}
                                      data-plasmic-override={overrides.desc6}
                                      className={classNames(
                                        "all",
                                        "__wab_text",
                                        sty.desc6
                                      )}
                                    >
                                      {
                                        "MyGME Fiscal\u2122 for IRIS reporting, invoicing, and cost reporting."
                                      }
                                    </div>
                                  </div>
                                </div>
                                <div
                                  data-plasmic-name={"footnote"}
                                  data-plasmic-override={overrides.footnote}
                                  className={classNames(
                                    "all",
                                    "__wab_text",
                                    sty.footnote
                                  )}
                                >
                                  {
                                    "By connecting educational information across the learner journey, MyEvaluations strengthens educator judgment, reduces fragmented workflows, and provides the actionable insight needed to support better decisions at the program and institutional levels."
                                  }
                                </div>
                              </div>
                            </div>
                          </div>
                        </AntdTabItem>
                        <AntdTabItem
                          className={classNames(
                            "__wab_instance",
                            sty.tabItem__sfq8R
                          )}
                          key={"2"}
                          label={
                            <div
                              className={classNames("all", sty.freeBox__lVod3)}
                            >
                              <PlasmicImg__
                                alt={""}
                                className={classNames(sty.img__qq7Dz)}
                                displayHeight={"45px"}
                                displayMaxHeight={"none"}
                                displayMaxWidth={"100%"}
                                displayMinHeight={"0"}
                                displayMinWidth={"0"}
                                displayWidth={"126px"}
                                loader={"plasmic"}
                                loading={"lazy"}
                                src={{
                                  src: "https://site-assets.plasmic.app/78d6d60c4e6cb4ef6edce275a40282b3.svg",
                                  fullWidth: 300,
                                  fullHeight: 116,
                                  aspectRatio: 2.595745
                                }}
                              />
                            </div>
                          }
                        >
                          {(_par =>
                            !_par ? [] : Array.isArray(_par) ? _par : [_par])(
                            (() => {
                              try {
                                return $ctx.products[1].product;
                              } catch (e) {
                                if (
                                  e instanceof TypeError ||
                                  e?.plasmicType === "PlasmicUndefinedDataError"
                                ) {
                                  return [];
                                }
                                throw e;
                              }
                            })()
                          ).map((__plasmic_item_0, __plasmic_idx_0) => {
                            const currentItem = __plasmic_item_0;
                            const currentIndex = __plasmic_idx_0;
                            return (
                              <div
                                data-plasmic-name={"bodyWrapper6"}
                                data-plasmic-override={overrides.bodyWrapper6}
                                className={classNames("all", sty.bodyWrapper6)}
                                key={currentIndex}
                              >
                                <div
                                  data-plasmic-name={"intro4"}
                                  data-plasmic-override={overrides.intro4}
                                  className={classNames("all", sty.intro4)}
                                >
                                  <div
                                    data-plasmic-name={"col7"}
                                    data-plasmic-override={overrides.col7}
                                    className={classNames("all", sty.col7)}
                                  >
                                    <Logo
                                      data-plasmic-name={"logo9"}
                                      data-plasmic-override={overrides.logo9}
                                      className={classNames(
                                        "__wab_instance",
                                        sty.logo9
                                      )}
                                      product={"myCme"}
                                    />

                                    <div
                                      data-plasmic-name={"text44"}
                                      data-plasmic-override={overrides.text44}
                                      className={classNames("all", sty.text44)}
                                    >
                                      <div
                                        data-plasmic-name={"title27"}
                                        data-plasmic-override={
                                          overrides.title27
                                        }
                                        className={classNames(
                                          "all",
                                          "__wab_text",
                                          sty.title27
                                        )}
                                      >
                                        {
                                          "One Platform for Continuing Medical Education"
                                        }
                                      </div>
                                      <div
                                        data-plasmic-name={"desc9"}
                                        data-plasmic-override={overrides.desc9}
                                        className={classNames(
                                          "all",
                                          "__wab_text",
                                          sty.desc9
                                        )}
                                      >
                                        {
                                          "MyCME\u2122 centralizes continuing medical education activities, participation, credit management, reporting, and financial oversight. Organizations can manage live and enduring activities, issue certificates, track CME and Maintenance of Certification credits, maintain event financial records, and support ACCME reporting through PARS."
                                        }
                                      </div>
                                    </div>
                                  </div>
                                  <div
                                    data-plasmic-name={"img4"}
                                    data-plasmic-override={overrides.img4}
                                    className={classNames("all", sty.img4)}
                                  >
                                    <div
                                      data-plasmic-name={"bg3"}
                                      data-plasmic-override={overrides.bg3}
                                      className={classNames("all", sty.bg3)}
                                    >
                                      <div
                                        data-plasmic-name={"xmlid7457"}
                                        data-plasmic-override={
                                          overrides.xmlid7457
                                        }
                                        className={classNames(
                                          "all",
                                          sty.xmlid7457
                                        )}
                                      >
                                        <Xmlid6613Icon
                                          className={classNames(
                                            "all",
                                            sty.svg___7Gff4
                                          )}
                                          role={"img"}
                                        />

                                        <div
                                          data-plasmic-name={"xmlid6776"}
                                          data-plasmic-override={
                                            overrides.xmlid6776
                                          }
                                          className={classNames(
                                            "all",
                                            sty.xmlid6776
                                          )}
                                        >
                                          {false ? (
                                            <Xmlid7308Icon
                                              className={classNames(
                                                "all",
                                                sty.svg__jV5LO
                                              )}
                                              role={"img"}
                                            />
                                          ) : null}
                                        </div>
                                        <Xmlid6615Icon
                                          className={classNames(
                                            "all",
                                            sty.svg__t5Zyf
                                          )}
                                          role={"img"}
                                        />

                                        <div
                                          data-plasmic-name={"xmlid7433"}
                                          data-plasmic-override={
                                            overrides.xmlid7433
                                          }
                                          className={classNames(
                                            "all",
                                            sty.xmlid7433
                                          )}
                                        >
                                          {false ? (
                                            <Xmlid7443Icon
                                              className={classNames(
                                                "all",
                                                sty.svg___4XlQf
                                              )}
                                              role={"img"}
                                            />
                                          ) : null}
                                        </div>
                                        <Xmlid6614Icon
                                          className={classNames(
                                            "all",
                                            sty.svg__vyA8E
                                          )}
                                          role={"img"}
                                        />

                                        <div
                                          data-plasmic-name={"xmlid7339"}
                                          data-plasmic-override={
                                            overrides.xmlid7339
                                          }
                                          className={classNames(
                                            "all",
                                            sty.xmlid7339
                                          )}
                                        >
                                          {false ? (
                                            <Xmlid7347Icon
                                              className={classNames(
                                                "all",
                                                sty.svg__geSxH
                                              )}
                                              role={"img"}
                                            />
                                          ) : null}
                                        </div>
                                        <Xmlid7207Icon
                                          className={classNames(
                                            "all",
                                            sty.svg__zxJda
                                          )}
                                          role={"img"}
                                        />

                                        <Xmlid7207Icon
                                          className={classNames(
                                            "all",
                                            sty.svg__oAdR
                                          )}
                                          role={"img"}
                                        />

                                        <Xmlid7207Icon
                                          className={classNames(
                                            "all",
                                            sty.svg__dTfag
                                          )}
                                          role={"img"}
                                        />

                                        <Xmlid7207Icon
                                          className={classNames(
                                            "all",
                                            sty.svg__bVTui
                                          )}
                                          role={"img"}
                                        />

                                        <Xmlid7207Icon
                                          className={classNames(
                                            "all",
                                            sty.svg__tE8Ng
                                          )}
                                          role={"img"}
                                        />

                                        <Xmlid7207Icon
                                          className={classNames(
                                            "all",
                                            sty.svg__mesqw
                                          )}
                                          role={"img"}
                                        />

                                        <Xmlid7207Icon
                                          className={classNames(
                                            "all",
                                            sty.svg__oozDb
                                          )}
                                          role={"img"}
                                        />

                                        <Xmlid7207Icon
                                          className={classNames(
                                            "all",
                                            sty.svg__zfqua
                                          )}
                                          role={"img"}
                                        />
                                      </div>
                                    </div>
                                    <div
                                      data-plasmic-name={"alert3"}
                                      data-plasmic-override={overrides.alert3}
                                      className={classNames("all", sty.alert3)}
                                    >
                                      <div
                                        data-plasmic-name={"icon20"}
                                        data-plasmic-override={overrides.icon20}
                                        className={classNames(
                                          "all",
                                          sty.icon20
                                        )}
                                      >
                                        <Icon91Icon
                                          className={classNames(
                                            "all",
                                            sty.svg__tviJf
                                          )}
                                          role={"img"}
                                        />
                                      </div>
                                      <div
                                        data-plasmic-name={"content3"}
                                        data-plasmic-override={
                                          overrides.content3
                                        }
                                        className={classNames(
                                          "all",
                                          sty.content3
                                        )}
                                      >
                                        <div
                                          data-plasmic-name={"text45"}
                                          data-plasmic-override={
                                            overrides.text45
                                          }
                                          className={classNames(
                                            "all",
                                            "__wab_text",
                                            sty.text45
                                          )}
                                        >
                                          {"Event Created"}
                                        </div>
                                      </div>
                                      <div
                                        data-plasmic-name={"icon21"}
                                        data-plasmic-override={overrides.icon21}
                                        className={classNames(
                                          "all",
                                          sty.icon21
                                        )}
                                      >
                                        <Icon84Icon
                                          className={classNames(
                                            "all",
                                            sty.svg__fB9Ud
                                          )}
                                          role={"img"}
                                        />
                                      </div>
                                    </div>
                                    <div
                                      data-plasmic-name={"credits"}
                                      data-plasmic-override={overrides.credits}
                                      className={classNames("all", sty.credits)}
                                    >
                                      <div
                                        data-plasmic-name={"header20"}
                                        data-plasmic-override={
                                          overrides.header20
                                        }
                                        className={classNames(
                                          "all",
                                          sty.header20
                                        )}
                                      >
                                        <div
                                          data-plasmic-name={"subtitle5"}
                                          data-plasmic-override={
                                            overrides.subtitle5
                                          }
                                          className={classNames(
                                            "all",
                                            "__wab_text",
                                            sty.subtitle5
                                          )}
                                        >
                                          {"Subtitle"}
                                        </div>
                                        <div
                                          data-plasmic-name={"title28"}
                                          data-plasmic-override={
                                            overrides.title28
                                          }
                                          className={classNames(
                                            "all",
                                            "__wab_text",
                                            sty.title28
                                          )}
                                        >
                                          {"User Credits"}
                                        </div>
                                      </div>
                                      <div
                                        data-plasmic-name={"main6"}
                                        data-plasmic-override={overrides.main6}
                                        className={classNames("all", sty.main6)}
                                      >
                                        <div
                                          data-plasmic-name={"mockupCmeCredits"}
                                          data-plasmic-override={
                                            overrides.mockupCmeCredits
                                          }
                                          className={classNames(
                                            "all",
                                            sty.mockupCmeCredits
                                          )}
                                        >
                                          <div
                                            data-plasmic-name={"table"}
                                            data-plasmic-override={
                                              overrides.table
                                            }
                                            className={classNames(
                                              "all",
                                              sty.table
                                            )}
                                          >
                                            <div
                                              data-plasmic-name={"col8"}
                                              data-plasmic-override={
                                                overrides.col8
                                              }
                                              className={classNames(
                                                "all",
                                                sty.col8
                                              )}
                                            >
                                              <div
                                                data-plasmic-name={
                                                  "mockupTableCellText"
                                                }
                                                data-plasmic-override={
                                                  overrides.mockupTableCellText
                                                }
                                                className={classNames(
                                                  "all",
                                                  sty.mockupTableCellText
                                                )}
                                              >
                                                <div
                                                  data-plasmic-name={"text46"}
                                                  data-plasmic-override={
                                                    overrides.text46
                                                  }
                                                  className={classNames(
                                                    "all",
                                                    "__wab_text",
                                                    sty.text46
                                                  )}
                                                >
                                                  {""}
                                                </div>
                                              </div>
                                              <div
                                                data-plasmic-name={
                                                  "mockupTableCellAvatar"
                                                }
                                                data-plasmic-override={
                                                  overrides.mockupTableCellAvatar
                                                }
                                                className={classNames(
                                                  "all",
                                                  sty.mockupTableCellAvatar
                                                )}
                                              >
                                                <PlasmicImg__
                                                  alt={""}
                                                  className={classNames(
                                                    sty.img__pGbCz
                                                  )}
                                                  displayHeight={"24px"}
                                                  displayMaxHeight={"none"}
                                                  displayMaxWidth={"100%"}
                                                  displayMinHeight={"0"}
                                                  displayMinWidth={"0"}
                                                  displayWidth={"24px"}
                                                  loader={"plasmic"}
                                                  loading={"lazy"}
                                                  src={{
                                                    src: "https://site-assets.plasmic.app/48cb2e30f5edb1f1e7499f4413ed6ee0.svg",
                                                    fullWidth: 24,
                                                    fullHeight: 24
                                                  }}
                                                />
                                              </div>
                                              <div
                                                data-plasmic-name={
                                                  "mockupTableCellAvatar2"
                                                }
                                                data-plasmic-override={
                                                  overrides.mockupTableCellAvatar2
                                                }
                                                className={classNames(
                                                  "all",
                                                  sty.mockupTableCellAvatar2
                                                )}
                                              >
                                                <PlasmicImg__
                                                  alt={""}
                                                  className={classNames(
                                                    sty.img__z65So
                                                  )}
                                                  displayHeight={"24px"}
                                                  displayMaxHeight={"none"}
                                                  displayMaxWidth={"100%"}
                                                  displayMinHeight={"0"}
                                                  displayMinWidth={"0"}
                                                  displayWidth={"24px"}
                                                  loader={"plasmic"}
                                                  loading={"lazy"}
                                                  src={{
                                                    src: "https://site-assets.plasmic.app/ac4af14f25084692502ede5e82771843.svg",
                                                    fullWidth: 24,
                                                    fullHeight: 24
                                                  }}
                                                />
                                              </div>
                                              <div
                                                data-plasmic-name={
                                                  "mockupTableCellAvatar3"
                                                }
                                                data-plasmic-override={
                                                  overrides.mockupTableCellAvatar3
                                                }
                                                className={classNames(
                                                  "all",
                                                  sty.mockupTableCellAvatar3
                                                )}
                                              >
                                                <PlasmicImg__
                                                  alt={""}
                                                  className={classNames(
                                                    sty.img___7TN
                                                  )}
                                                  displayHeight={"24px"}
                                                  displayMaxHeight={"none"}
                                                  displayMaxWidth={"100%"}
                                                  displayMinHeight={"0"}
                                                  displayMinWidth={"0"}
                                                  displayWidth={"24px"}
                                                  loader={"plasmic"}
                                                  loading={"lazy"}
                                                  src={{
                                                    src: "https://site-assets.plasmic.app/5e2ccb72a7aa58df912292af94e54ab7.svg",
                                                    fullWidth: 24,
                                                    fullHeight: 24
                                                  }}
                                                />
                                              </div>
                                            </div>
                                            <div
                                              data-plasmic-name={"col9"}
                                              data-plasmic-override={
                                                overrides.col9
                                              }
                                              className={classNames(
                                                "all",
                                                sty.col9
                                              )}
                                            >
                                              <div
                                                data-plasmic-name={
                                                  "mockupTableCellText2"
                                                }
                                                data-plasmic-override={
                                                  overrides.mockupTableCellText2
                                                }
                                                className={classNames(
                                                  "all",
                                                  sty.mockupTableCellText2
                                                )}
                                              >
                                                <div
                                                  data-plasmic-name={"text47"}
                                                  data-plasmic-override={
                                                    overrides.text47
                                                  }
                                                  className={classNames(
                                                    "all",
                                                    "__wab_text",
                                                    sty.text47
                                                  )}
                                                >
                                                  {"Name"}
                                                </div>
                                              </div>
                                              <div
                                                data-plasmic-name={
                                                  "mockupTableCellText3"
                                                }
                                                data-plasmic-override={
                                                  overrides.mockupTableCellText3
                                                }
                                                className={classNames(
                                                  "all",
                                                  sty.mockupTableCellText3
                                                )}
                                              >
                                                <div
                                                  data-plasmic-name={"text48"}
                                                  data-plasmic-override={
                                                    overrides.text48
                                                  }
                                                  className={classNames(
                                                    "all",
                                                    "__wab_text",
                                                    sty.text48
                                                  )}
                                                >
                                                  {"Janet Kertzmann"}
                                                </div>
                                              </div>
                                              <div
                                                data-plasmic-name={
                                                  "mockupTableCellText4"
                                                }
                                                data-plasmic-override={
                                                  overrides.mockupTableCellText4
                                                }
                                                className={classNames(
                                                  "all",
                                                  sty.mockupTableCellText4
                                                )}
                                              >
                                                <div
                                                  data-plasmic-name={"text49"}
                                                  data-plasmic-override={
                                                    overrides.text49
                                                  }
                                                  className={classNames(
                                                    "all",
                                                    "__wab_text",
                                                    sty.text49
                                                  )}
                                                >
                                                  {"Robin Gerhold"}
                                                </div>
                                              </div>
                                              <div
                                                data-plasmic-name={
                                                  "mockupTableCellText5"
                                                }
                                                data-plasmic-override={
                                                  overrides.mockupTableCellText5
                                                }
                                                className={classNames(
                                                  "all",
                                                  sty.mockupTableCellText5
                                                )}
                                              >
                                                <div
                                                  data-plasmic-name={"text50"}
                                                  data-plasmic-override={
                                                    overrides.text50
                                                  }
                                                  className={classNames(
                                                    "all",
                                                    "__wab_text",
                                                    sty.text50
                                                  )}
                                                >
                                                  {"Isabel Heaney"}
                                                </div>
                                              </div>
                                            </div>
                                            {false ? (
                                              <div
                                                data-plasmic-name={"col10"}
                                                data-plasmic-override={
                                                  overrides.col10
                                                }
                                                className={classNames(
                                                  "all",
                                                  sty.col10
                                                )}
                                              >
                                                <div
                                                  data-plasmic-name={
                                                    "mockupTableCellText6"
                                                  }
                                                  data-plasmic-override={
                                                    overrides.mockupTableCellText6
                                                  }
                                                  className={classNames(
                                                    "all",
                                                    sty.mockupTableCellText6
                                                  )}
                                                >
                                                  <div
                                                    data-plasmic-name={"text51"}
                                                    data-plasmic-override={
                                                      overrides.text51
                                                    }
                                                    className={classNames(
                                                      "all",
                                                      "__wab_text",
                                                      sty.text51
                                                    )}
                                                  >
                                                    {"Claimed"}
                                                  </div>
                                                </div>
                                                <div
                                                  data-plasmic-name={
                                                    "mockupTableCellText7"
                                                  }
                                                  data-plasmic-override={
                                                    overrides.mockupTableCellText7
                                                  }
                                                  className={classNames(
                                                    "all",
                                                    sty.mockupTableCellText7
                                                  )}
                                                >
                                                  <div
                                                    data-plasmic-name={"text52"}
                                                    data-plasmic-override={
                                                      overrides.text52
                                                    }
                                                    className={classNames(
                                                      "all",
                                                      "__wab_text",
                                                      sty.text52
                                                    )}
                                                  >
                                                    {"2.00"}
                                                  </div>
                                                </div>
                                                <div
                                                  data-plasmic-name={
                                                    "mockupTableCellText8"
                                                  }
                                                  data-plasmic-override={
                                                    overrides.mockupTableCellText8
                                                  }
                                                  className={classNames(
                                                    "all",
                                                    sty.mockupTableCellText8
                                                  )}
                                                >
                                                  <div
                                                    data-plasmic-name={"text57"}
                                                    data-plasmic-override={
                                                      overrides.text57
                                                    }
                                                    className={classNames(
                                                      "all",
                                                      "__wab_text",
                                                      sty.text57
                                                    )}
                                                  >
                                                    {"2.50"}
                                                  </div>
                                                </div>
                                                <div
                                                  data-plasmic-name={
                                                    "mockupTableCellText9"
                                                  }
                                                  data-plasmic-override={
                                                    overrides.mockupTableCellText9
                                                  }
                                                  className={classNames(
                                                    "all",
                                                    sty.mockupTableCellText9
                                                  )}
                                                >
                                                  <div
                                                    data-plasmic-name={"text58"}
                                                    data-plasmic-override={
                                                      overrides.text58
                                                    }
                                                    className={classNames(
                                                      "all",
                                                      "__wab_text",
                                                      sty.text58
                                                    )}
                                                  >
                                                    {"2.00"}
                                                  </div>
                                                </div>
                                              </div>
                                            ) : null}
                                            <div
                                              data-plasmic-name={"col11"}
                                              data-plasmic-override={
                                                overrides.col11
                                              }
                                              className={classNames(
                                                "all",
                                                sty.col11
                                              )}
                                            >
                                              <div
                                                data-plasmic-name={
                                                  "mockupTableCellText10"
                                                }
                                                data-plasmic-override={
                                                  overrides.mockupTableCellText10
                                                }
                                                className={classNames(
                                                  "all",
                                                  sty.mockupTableCellText10
                                                )}
                                              >
                                                <div
                                                  data-plasmic-name={"text59"}
                                                  data-plasmic-override={
                                                    overrides.text59
                                                  }
                                                  className={classNames(
                                                    "all",
                                                    "__wab_text",
                                                    sty.text59
                                                  )}
                                                >
                                                  {"Available"}
                                                </div>
                                              </div>
                                              <div
                                                data-plasmic-name={
                                                  "mockupTableCellText11"
                                                }
                                                data-plasmic-override={
                                                  overrides.mockupTableCellText11
                                                }
                                                className={classNames(
                                                  "all",
                                                  sty.mockupTableCellText11
                                                )}
                                              >
                                                <div
                                                  data-plasmic-name={"text60"}
                                                  data-plasmic-override={
                                                    overrides.text60
                                                  }
                                                  className={classNames(
                                                    "all",
                                                    "__wab_text",
                                                    sty.text60
                                                  )}
                                                >
                                                  {"12.50"}
                                                </div>
                                              </div>
                                              <div
                                                data-plasmic-name={
                                                  "mockupTableCellText12"
                                                }
                                                data-plasmic-override={
                                                  overrides.mockupTableCellText12
                                                }
                                                className={classNames(
                                                  "all",
                                                  sty.mockupTableCellText12
                                                )}
                                              >
                                                <div
                                                  data-plasmic-name={"text70"}
                                                  data-plasmic-override={
                                                    overrides.text70
                                                  }
                                                  className={classNames(
                                                    "all",
                                                    "__wab_text",
                                                    sty.text70
                                                  )}
                                                >
                                                  {"16.00"}
                                                </div>
                                              </div>
                                              <div
                                                data-plasmic-name={
                                                  "mockupTableCellText13"
                                                }
                                                data-plasmic-override={
                                                  overrides.mockupTableCellText13
                                                }
                                                className={classNames(
                                                  "all",
                                                  sty.mockupTableCellText13
                                                )}
                                              >
                                                <div
                                                  data-plasmic-name={"text71"}
                                                  data-plasmic-override={
                                                    overrides.text71
                                                  }
                                                  className={classNames(
                                                    "all",
                                                    "__wab_text",
                                                    sty.text71
                                                  )}
                                                >
                                                  {"27.50"}
                                                </div>
                                              </div>
                                            </div>
                                          </div>
                                          <div
                                            data-plasmic-name={"mockupButton7"}
                                            data-plasmic-override={
                                              overrides.mockupButton7
                                            }
                                            className={classNames(
                                              "all",
                                              sty.mockupButton7
                                            )}
                                          >
                                            <div
                                              data-plasmic-name={"link10"}
                                              data-plasmic-override={
                                                overrides.link10
                                              }
                                              className={classNames(
                                                "all",
                                                "__wab_text",
                                                sty.link10
                                              )}
                                            >
                                              {"Add Event"}
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                    <div
                                      data-plasmic-name={"certificate"}
                                      data-plasmic-override={
                                        overrides.certificate
                                      }
                                      className={classNames(
                                        "all",
                                        sty.certificate
                                      )}
                                    >
                                      <div
                                        data-plasmic-name={"top5"}
                                        data-plasmic-override={overrides.top5}
                                        className={classNames("all", sty.top5)}
                                      >
                                        <div
                                          data-plasmic-name={
                                            "mockupCertificateIcon"
                                          }
                                          data-plasmic-override={
                                            overrides.mockupCertificateIcon
                                          }
                                          className={classNames(
                                            "all",
                                            sty.mockupCertificateIcon
                                          )}
                                        >
                                          <div
                                            data-plasmic-name={"bg4"}
                                            data-plasmic-override={
                                              overrides.bg4
                                            }
                                            className={classNames(
                                              "all",
                                              sty.bg4
                                            )}
                                          />

                                          <div
                                            data-plasmic-name={"group1"}
                                            data-plasmic-override={
                                              overrides.group1
                                            }
                                            className={classNames(
                                              "all",
                                              sty.group1
                                            )}
                                          >
                                            <div
                                              data-plasmic-name={"paper1"}
                                              data-plasmic-override={
                                                overrides.paper1
                                              }
                                              className={classNames(
                                                "all",
                                                sty.paper1
                                              )}
                                            >
                                              <Group15Icon
                                                className={classNames(
                                                  "all",
                                                  sty.svg__uxwxX
                                                )}
                                                role={"img"}
                                              />
                                            </div>
                                            <div
                                              data-plasmic-name={"paper2"}
                                              data-plasmic-override={
                                                overrides.paper2
                                              }
                                              className={classNames(
                                                "all",
                                                sty.paper2
                                              )}
                                            >
                                              <Group15Icon
                                                className={classNames(
                                                  "all",
                                                  sty.svg__awuil
                                                )}
                                                role={"img"}
                                              />
                                            </div>
                                            <div
                                              data-plasmic-name={"cert"}
                                              data-plasmic-override={
                                                overrides.cert
                                              }
                                              className={classNames(
                                                "all",
                                                sty.cert
                                              )}
                                            >
                                              <VectorIcon
                                                className={classNames(
                                                  "all",
                                                  sty.svg__qf5RI
                                                )}
                                                role={"img"}
                                              />

                                              <div
                                                data-plasmic-name={"award491"}
                                                data-plasmic-override={
                                                  overrides.award491
                                                }
                                                className={classNames(
                                                  "all",
                                                  sty.award491
                                                )}
                                              >
                                                <PlasmicImg__
                                                  alt={""}
                                                  className={classNames(
                                                    sty.img___0DwkZ
                                                  )}
                                                  displayHeight={"40.25px"}
                                                  displayMaxHeight={"none"}
                                                  displayMaxWidth={"100%"}
                                                  displayMinHeight={"0"}
                                                  displayMinWidth={"0"}
                                                  displayWidth={"40.25px"}
                                                  loader={"plasmic"}
                                                  loading={"lazy"}
                                                  src={{
                                                    src: "https://site-assets.plasmic.app/0064a86bab071b89f97be19685d49a0b.svg",
                                                    fullWidth: 40.25,
                                                    fullHeight: 40.25
                                                  }}
                                                />
                                              </div>
                                            </div>
                                          </div>
                                          <div
                                            data-plasmic-name={"overlay"}
                                            data-plasmic-override={
                                              overrides.overlay
                                            }
                                            className={classNames(
                                              "all",
                                              sty.overlay
                                            )}
                                          />
                                        </div>
                                        <div
                                          data-plasmic-name={"title29"}
                                          data-plasmic-override={
                                            overrides.title29
                                          }
                                          className={classNames(
                                            "all",
                                            "__wab_text",
                                            sty.title29
                                          )}
                                        >
                                          {"Certificate"}
                                        </div>
                                        <div
                                          data-plasmic-name={
                                            "mockupTextPlaceholder"
                                          }
                                          data-plasmic-override={
                                            overrides.mockupTextPlaceholder
                                          }
                                          className={classNames(
                                            "all",
                                            sty.mockupTextPlaceholder
                                          )}
                                        >
                                          <div
                                            data-plasmic-name={
                                              "mockupTextPlaceholderParagraph"
                                            }
                                            data-plasmic-override={
                                              overrides.mockupTextPlaceholderParagraph
                                            }
                                            className={classNames(
                                              "all",
                                              sty.mockupTextPlaceholderParagraph
                                            )}
                                          >
                                            <div
                                              data-plasmic-name={
                                                "mockupTextPlaceholderLine"
                                              }
                                              data-plasmic-override={
                                                overrides.mockupTextPlaceholderLine
                                              }
                                              className={classNames(
                                                "all",
                                                sty.mockupTextPlaceholderLine
                                              )}
                                            >
                                              <div
                                                data-plasmic-name={
                                                  "mockupTextPlaceholderContent37"
                                                }
                                                data-plasmic-override={
                                                  overrides.mockupTextPlaceholderContent37
                                                }
                                                className={classNames(
                                                  "all",
                                                  sty.mockupTextPlaceholderContent37
                                                )}
                                              >
                                                <div
                                                  data-plasmic-name={
                                                    "placeholder38"
                                                  }
                                                  data-plasmic-override={
                                                    overrides.placeholder38
                                                  }
                                                  className={classNames(
                                                    "all",
                                                    sty.placeholder38
                                                  )}
                                                />
                                              </div>
                                            </div>
                                            <div
                                              data-plasmic-name={
                                                "mockupTextPlaceholderLine2"
                                              }
                                              data-plasmic-override={
                                                overrides.mockupTextPlaceholderLine2
                                              }
                                              className={classNames(
                                                "all",
                                                sty.mockupTextPlaceholderLine2
                                              )}
                                            >
                                              <div
                                                data-plasmic-name={
                                                  "mockupTextPlaceholderContent38"
                                                }
                                                data-plasmic-override={
                                                  overrides.mockupTextPlaceholderContent38
                                                }
                                                className={classNames(
                                                  "all",
                                                  sty.mockupTextPlaceholderContent38
                                                )}
                                              >
                                                <div
                                                  data-plasmic-name={
                                                    "placeholder39"
                                                  }
                                                  data-plasmic-override={
                                                    overrides.placeholder39
                                                  }
                                                  className={classNames(
                                                    "all",
                                                    sty.placeholder39
                                                  )}
                                                />
                                              </div>
                                            </div>
                                            <div
                                              data-plasmic-name={
                                                "mockupTextPlaceholderLine3"
                                              }
                                              data-plasmic-override={
                                                overrides.mockupTextPlaceholderLine3
                                              }
                                              className={classNames(
                                                "all",
                                                sty.mockupTextPlaceholderLine3
                                              )}
                                            >
                                              <div
                                                data-plasmic-name={
                                                  "mockupTextPlaceholderContent39"
                                                }
                                                data-plasmic-override={
                                                  overrides.mockupTextPlaceholderContent39
                                                }
                                                className={classNames(
                                                  "all",
                                                  sty.mockupTextPlaceholderContent39
                                                )}
                                              >
                                                <div
                                                  data-plasmic-name={
                                                    "placeholder40"
                                                  }
                                                  data-plasmic-override={
                                                    overrides.placeholder40
                                                  }
                                                  className={classNames(
                                                    "all",
                                                    sty.placeholder40
                                                  )}
                                                />
                                              </div>
                                            </div>
                                            <div
                                              data-plasmic-name={
                                                "mockupTextPlaceholderLine4"
                                              }
                                              data-plasmic-override={
                                                overrides.mockupTextPlaceholderLine4
                                              }
                                              className={classNames(
                                                "all",
                                                sty.mockupTextPlaceholderLine4
                                              )}
                                            >
                                              <div
                                                data-plasmic-name={
                                                  "mockupTextPlaceholderContent40"
                                                }
                                                data-plasmic-override={
                                                  overrides.mockupTextPlaceholderContent40
                                                }
                                                className={classNames(
                                                  "all",
                                                  sty.mockupTextPlaceholderContent40
                                                )}
                                              >
                                                <div
                                                  data-plasmic-name={
                                                    "placeholder41"
                                                  }
                                                  data-plasmic-override={
                                                    overrides.placeholder41
                                                  }
                                                  className={classNames(
                                                    "all",
                                                    sty.placeholder41
                                                  )}
                                                />
                                              </div>
                                            </div>
                                            {false ? (
                                              <div
                                                data-plasmic-name={
                                                  "mockupTextPlaceholderLine5"
                                                }
                                                data-plasmic-override={
                                                  overrides.mockupTextPlaceholderLine5
                                                }
                                                className={classNames(
                                                  "all",
                                                  sty.mockupTextPlaceholderLine5
                                                )}
                                              >
                                                <div
                                                  data-plasmic-name={
                                                    "mockupTextPlaceholderContent41"
                                                  }
                                                  data-plasmic-override={
                                                    overrides.mockupTextPlaceholderContent41
                                                  }
                                                  className={classNames(
                                                    "all",
                                                    sty.mockupTextPlaceholderContent41
                                                  )}
                                                >
                                                  <div
                                                    data-plasmic-name={
                                                      "placeholder42"
                                                    }
                                                    data-plasmic-override={
                                                      overrides.placeholder42
                                                    }
                                                    className={classNames(
                                                      "all",
                                                      sty.placeholder42
                                                    )}
                                                  />
                                                </div>
                                              </div>
                                            ) : null}
                                          </div>
                                          {false ? (
                                            <div
                                              data-plasmic-name={
                                                "mockupTextPlaceholderParagraph2"
                                              }
                                              data-plasmic-override={
                                                overrides.mockupTextPlaceholderParagraph2
                                              }
                                              className={classNames(
                                                "all",
                                                sty.mockupTextPlaceholderParagraph2
                                              )}
                                            >
                                              <div
                                                data-plasmic-name={
                                                  "mockupTextPlaceholderLine6"
                                                }
                                                data-plasmic-override={
                                                  overrides.mockupTextPlaceholderLine6
                                                }
                                                className={classNames(
                                                  "all",
                                                  sty.mockupTextPlaceholderLine6
                                                )}
                                              >
                                                <div
                                                  data-plasmic-name={
                                                    "mockupTextPlaceholderContent42"
                                                  }
                                                  data-plasmic-override={
                                                    overrides.mockupTextPlaceholderContent42
                                                  }
                                                  className={classNames(
                                                    "all",
                                                    sty.mockupTextPlaceholderContent42
                                                  )}
                                                >
                                                  <div
                                                    data-plasmic-name={
                                                      "placeholder43"
                                                    }
                                                    data-plasmic-override={
                                                      overrides.placeholder43
                                                    }
                                                    className={classNames(
                                                      "all",
                                                      sty.placeholder43
                                                    )}
                                                  />
                                                </div>
                                              </div>
                                              <div
                                                data-plasmic-name={
                                                  "mockupTextPlaceholderLine7"
                                                }
                                                data-plasmic-override={
                                                  overrides.mockupTextPlaceholderLine7
                                                }
                                                className={classNames(
                                                  "all",
                                                  sty.mockupTextPlaceholderLine7
                                                )}
                                              >
                                                <div
                                                  data-plasmic-name={
                                                    "mockupTextPlaceholderContent43"
                                                  }
                                                  data-plasmic-override={
                                                    overrides.mockupTextPlaceholderContent43
                                                  }
                                                  className={classNames(
                                                    "all",
                                                    sty.mockupTextPlaceholderContent43
                                                  )}
                                                >
                                                  <div
                                                    data-plasmic-name={
                                                      "placeholder44"
                                                    }
                                                    data-plasmic-override={
                                                      overrides.placeholder44
                                                    }
                                                    className={classNames(
                                                      "all",
                                                      sty.placeholder44
                                                    )}
                                                  />
                                                </div>
                                              </div>
                                              <div
                                                data-plasmic-name={
                                                  "mockupTextPlaceholderLine8"
                                                }
                                                data-plasmic-override={
                                                  overrides.mockupTextPlaceholderLine8
                                                }
                                                className={classNames(
                                                  "all",
                                                  sty.mockupTextPlaceholderLine8
                                                )}
                                              >
                                                <div
                                                  data-plasmic-name={
                                                    "mockupTextPlaceholderContent44"
                                                  }
                                                  data-plasmic-override={
                                                    overrides.mockupTextPlaceholderContent44
                                                  }
                                                  className={classNames(
                                                    "all",
                                                    sty.mockupTextPlaceholderContent44
                                                  )}
                                                >
                                                  <div
                                                    data-plasmic-name={
                                                      "placeholder45"
                                                    }
                                                    data-plasmic-override={
                                                      overrides.placeholder45
                                                    }
                                                    className={classNames(
                                                      "all",
                                                      sty.placeholder45
                                                    )}
                                                  />
                                                </div>
                                              </div>
                                              <div
                                                data-plasmic-name={
                                                  "mockupTextPlaceholderLine9"
                                                }
                                                data-plasmic-override={
                                                  overrides.mockupTextPlaceholderLine9
                                                }
                                                className={classNames(
                                                  "all",
                                                  sty.mockupTextPlaceholderLine9
                                                )}
                                              >
                                                <div
                                                  data-plasmic-name={
                                                    "mockupTextPlaceholderContent45"
                                                  }
                                                  data-plasmic-override={
                                                    overrides.mockupTextPlaceholderContent45
                                                  }
                                                  className={classNames(
                                                    "all",
                                                    sty.mockupTextPlaceholderContent45
                                                  )}
                                                >
                                                  <div
                                                    data-plasmic-name={
                                                      "placeholder46"
                                                    }
                                                    data-plasmic-override={
                                                      overrides.placeholder46
                                                    }
                                                    className={classNames(
                                                      "all",
                                                      sty.placeholder46
                                                    )}
                                                  />
                                                </div>
                                              </div>
                                              <div
                                                data-plasmic-name={
                                                  "mockupTextPlaceholderLine10"
                                                }
                                                data-plasmic-override={
                                                  overrides.mockupTextPlaceholderLine10
                                                }
                                                className={classNames(
                                                  "all",
                                                  sty.mockupTextPlaceholderLine10
                                                )}
                                              >
                                                <div
                                                  data-plasmic-name={
                                                    "mockupTextPlaceholderContent46"
                                                  }
                                                  data-plasmic-override={
                                                    overrides.mockupTextPlaceholderContent46
                                                  }
                                                  className={classNames(
                                                    "all",
                                                    sty.mockupTextPlaceholderContent46
                                                  )}
                                                >
                                                  <div
                                                    data-plasmic-name={
                                                      "placeholder47"
                                                    }
                                                    data-plasmic-override={
                                                      overrides.placeholder47
                                                    }
                                                    className={classNames(
                                                      "all",
                                                      sty.placeholder47
                                                    )}
                                                  />
                                                </div>
                                              </div>
                                              <div
                                                data-plasmic-name={
                                                  "mockupTextPlaceholderLine11"
                                                }
                                                data-plasmic-override={
                                                  overrides.mockupTextPlaceholderLine11
                                                }
                                                className={classNames(
                                                  "all",
                                                  sty.mockupTextPlaceholderLine11
                                                )}
                                              >
                                                <div
                                                  data-plasmic-name={
                                                    "mockupTextPlaceholderContent47"
                                                  }
                                                  data-plasmic-override={
                                                    overrides.mockupTextPlaceholderContent47
                                                  }
                                                  className={classNames(
                                                    "all",
                                                    sty.mockupTextPlaceholderContent47
                                                  )}
                                                >
                                                  <div
                                                    data-plasmic-name={
                                                      "placeholder48"
                                                    }
                                                    data-plasmic-override={
                                                      overrides.placeholder48
                                                    }
                                                    className={classNames(
                                                      "all",
                                                      sty.placeholder48
                                                    )}
                                                  />
                                                </div>
                                              </div>
                                              <div
                                                data-plasmic-name={
                                                  "mockupTextPlaceholderLine12"
                                                }
                                                data-plasmic-override={
                                                  overrides.mockupTextPlaceholderLine12
                                                }
                                                className={classNames(
                                                  "all",
                                                  sty.mockupTextPlaceholderLine12
                                                )}
                                              >
                                                <div
                                                  data-plasmic-name={
                                                    "mockupTextPlaceholderContent48"
                                                  }
                                                  data-plasmic-override={
                                                    overrides.mockupTextPlaceholderContent48
                                                  }
                                                  className={classNames(
                                                    "all",
                                                    sty.mockupTextPlaceholderContent48
                                                  )}
                                                >
                                                  <div
                                                    data-plasmic-name={
                                                      "placeholder49"
                                                    }
                                                    data-plasmic-override={
                                                      overrides.placeholder49
                                                    }
                                                    className={classNames(
                                                      "all",
                                                      sty.placeholder49
                                                    )}
                                                  />
                                                </div>
                                              </div>
                                              <div
                                                data-plasmic-name={
                                                  "mockupTextPlaceholderLine13"
                                                }
                                                data-plasmic-override={
                                                  overrides.mockupTextPlaceholderLine13
                                                }
                                                className={classNames(
                                                  "all",
                                                  sty.mockupTextPlaceholderLine13
                                                )}
                                              >
                                                <div
                                                  data-plasmic-name={
                                                    "mockupTextPlaceholderContent49"
                                                  }
                                                  data-plasmic-override={
                                                    overrides.mockupTextPlaceholderContent49
                                                  }
                                                  className={classNames(
                                                    "all",
                                                    sty.mockupTextPlaceholderContent49
                                                  )}
                                                >
                                                  <div
                                                    data-plasmic-name={
                                                      "placeholder50"
                                                    }
                                                    data-plasmic-override={
                                                      overrides.placeholder50
                                                    }
                                                    className={classNames(
                                                      "all",
                                                      sty.placeholder50
                                                    )}
                                                  />
                                                </div>
                                              </div>
                                            </div>
                                          ) : null}
                                          {false ? (
                                            <div
                                              data-plasmic-name={
                                                "mockupTextPlaceholderParagraph3"
                                              }
                                              data-plasmic-override={
                                                overrides.mockupTextPlaceholderParagraph3
                                              }
                                              className={classNames(
                                                "all",
                                                sty.mockupTextPlaceholderParagraph3
                                              )}
                                            >
                                              <div
                                                data-plasmic-name={
                                                  "mockupTextPlaceholderLine14"
                                                }
                                                data-plasmic-override={
                                                  overrides.mockupTextPlaceholderLine14
                                                }
                                                className={classNames(
                                                  "all",
                                                  sty.mockupTextPlaceholderLine14
                                                )}
                                              >
                                                <div
                                                  data-plasmic-name={
                                                    "mockupTextPlaceholderContent50"
                                                  }
                                                  data-plasmic-override={
                                                    overrides.mockupTextPlaceholderContent50
                                                  }
                                                  className={classNames(
                                                    "all",
                                                    sty.mockupTextPlaceholderContent50
                                                  )}
                                                >
                                                  <div
                                                    data-plasmic-name={
                                                      "placeholder51"
                                                    }
                                                    data-plasmic-override={
                                                      overrides.placeholder51
                                                    }
                                                    className={classNames(
                                                      "all",
                                                      sty.placeholder51
                                                    )}
                                                  />
                                                </div>
                                              </div>
                                              <div
                                                data-plasmic-name={
                                                  "mockupTextPlaceholderLine15"
                                                }
                                                data-plasmic-override={
                                                  overrides.mockupTextPlaceholderLine15
                                                }
                                                className={classNames(
                                                  "all",
                                                  sty.mockupTextPlaceholderLine15
                                                )}
                                              >
                                                <div
                                                  data-plasmic-name={
                                                    "mockupTextPlaceholderContent15"
                                                  }
                                                  data-plasmic-override={
                                                    overrides.mockupTextPlaceholderContent15
                                                  }
                                                  className={classNames(
                                                    "all",
                                                    sty.mockupTextPlaceholderContent15
                                                  )}
                                                >
                                                  <div
                                                    data-plasmic-name={
                                                      "placeholder52"
                                                    }
                                                    data-plasmic-override={
                                                      overrides.placeholder52
                                                    }
                                                    className={classNames(
                                                      "all",
                                                      sty.placeholder52
                                                    )}
                                                  />
                                                </div>
                                              </div>
                                              <div
                                                data-plasmic-name={
                                                  "mockupTextPlaceholderLine16"
                                                }
                                                data-plasmic-override={
                                                  overrides.mockupTextPlaceholderLine16
                                                }
                                                className={classNames(
                                                  "all",
                                                  sty.mockupTextPlaceholderLine16
                                                )}
                                              >
                                                <div
                                                  data-plasmic-name={
                                                    "mockupTextPlaceholderContent16"
                                                  }
                                                  data-plasmic-override={
                                                    overrides.mockupTextPlaceholderContent16
                                                  }
                                                  className={classNames(
                                                    "all",
                                                    sty.mockupTextPlaceholderContent16
                                                  )}
                                                >
                                                  <div
                                                    data-plasmic-name={
                                                      "placeholder53"
                                                    }
                                                    data-plasmic-override={
                                                      overrides.placeholder53
                                                    }
                                                    className={classNames(
                                                      "all",
                                                      sty.placeholder53
                                                    )}
                                                  />
                                                </div>
                                              </div>
                                              <div
                                                data-plasmic-name={
                                                  "mockupTextPlaceholderLine17"
                                                }
                                                data-plasmic-override={
                                                  overrides.mockupTextPlaceholderLine17
                                                }
                                                className={classNames(
                                                  "all",
                                                  sty.mockupTextPlaceholderLine17
                                                )}
                                              >
                                                <div
                                                  data-plasmic-name={
                                                    "mockupTextPlaceholderContent17"
                                                  }
                                                  data-plasmic-override={
                                                    overrides.mockupTextPlaceholderContent17
                                                  }
                                                  className={classNames(
                                                    "all",
                                                    sty.mockupTextPlaceholderContent17
                                                  )}
                                                >
                                                  <div
                                                    data-plasmic-name={
                                                      "placeholder54"
                                                    }
                                                    data-plasmic-override={
                                                      overrides.placeholder54
                                                    }
                                                    className={classNames(
                                                      "all",
                                                      sty.placeholder54
                                                    )}
                                                  />
                                                </div>
                                              </div>
                                              <div
                                                data-plasmic-name={
                                                  "mockupTextPlaceholderLine18"
                                                }
                                                data-plasmic-override={
                                                  overrides.mockupTextPlaceholderLine18
                                                }
                                                className={classNames(
                                                  "all",
                                                  sty.mockupTextPlaceholderLine18
                                                )}
                                              >
                                                <div
                                                  data-plasmic-name={
                                                    "mockupTextPlaceholderContent18"
                                                  }
                                                  data-plasmic-override={
                                                    overrides.mockupTextPlaceholderContent18
                                                  }
                                                  className={classNames(
                                                    "all",
                                                    sty.mockupTextPlaceholderContent18
                                                  )}
                                                >
                                                  <div
                                                    data-plasmic-name={
                                                      "placeholder55"
                                                    }
                                                    data-plasmic-override={
                                                      overrides.placeholder55
                                                    }
                                                    className={classNames(
                                                      "all",
                                                      sty.placeholder55
                                                    )}
                                                  />
                                                </div>
                                              </div>
                                            </div>
                                          ) : null}
                                          <div
                                            data-plasmic-name={
                                              "mockupTextPlaceholderParagraph4"
                                            }
                                            data-plasmic-override={
                                              overrides.mockupTextPlaceholderParagraph4
                                            }
                                            className={classNames(
                                              "all",
                                              sty.mockupTextPlaceholderParagraph4
                                            )}
                                          >
                                            <div
                                              data-plasmic-name={
                                                "mockupTextPlaceholderLine19"
                                              }
                                              data-plasmic-override={
                                                overrides.mockupTextPlaceholderLine19
                                              }
                                              className={classNames(
                                                "all",
                                                sty.mockupTextPlaceholderLine19
                                              )}
                                            >
                                              <div
                                                data-plasmic-name={
                                                  "mockupTextPlaceholderContent19"
                                                }
                                                data-plasmic-override={
                                                  overrides.mockupTextPlaceholderContent19
                                                }
                                                className={classNames(
                                                  "all",
                                                  sty.mockupTextPlaceholderContent19
                                                )}
                                              >
                                                <div
                                                  data-plasmic-name={
                                                    "placeholder19"
                                                  }
                                                  data-plasmic-override={
                                                    overrides.placeholder19
                                                  }
                                                  className={classNames(
                                                    "all",
                                                    sty.placeholder19
                                                  )}
                                                />
                                              </div>
                                            </div>
                                            {false ? (
                                              <div
                                                data-plasmic-name={
                                                  "mockupTextPlaceholderLine20"
                                                }
                                                data-plasmic-override={
                                                  overrides.mockupTextPlaceholderLine20
                                                }
                                                className={classNames(
                                                  "all",
                                                  sty.mockupTextPlaceholderLine20
                                                )}
                                              >
                                                <div
                                                  data-plasmic-name={
                                                    "mockupTextPlaceholderContent20"
                                                  }
                                                  data-plasmic-override={
                                                    overrides.mockupTextPlaceholderContent20
                                                  }
                                                  className={classNames(
                                                    "all",
                                                    sty.mockupTextPlaceholderContent20
                                                  )}
                                                >
                                                  <div
                                                    data-plasmic-name={
                                                      "placeholder20"
                                                    }
                                                    data-plasmic-override={
                                                      overrides.placeholder20
                                                    }
                                                    className={classNames(
                                                      "all",
                                                      sty.placeholder20
                                                    )}
                                                  />
                                                </div>
                                              </div>
                                            ) : null}
                                            <div
                                              data-plasmic-name={
                                                "mockupTextPlaceholderLine21"
                                              }
                                              data-plasmic-override={
                                                overrides.mockupTextPlaceholderLine21
                                              }
                                              className={classNames(
                                                "all",
                                                sty.mockupTextPlaceholderLine21
                                              )}
                                            >
                                              <div
                                                data-plasmic-name={
                                                  "mockupTextPlaceholderContent21"
                                                }
                                                data-plasmic-override={
                                                  overrides.mockupTextPlaceholderContent21
                                                }
                                                className={classNames(
                                                  "all",
                                                  sty.mockupTextPlaceholderContent21
                                                )}
                                              >
                                                <div
                                                  data-plasmic-name={
                                                    "placeholder21"
                                                  }
                                                  data-plasmic-override={
                                                    overrides.placeholder21
                                                  }
                                                  className={classNames(
                                                    "all",
                                                    sty.placeholder21
                                                  )}
                                                />
                                              </div>
                                            </div>
                                            {false ? (
                                              <div
                                                data-plasmic-name={
                                                  "mockupTextPlaceholderLine22"
                                                }
                                                data-plasmic-override={
                                                  overrides.mockupTextPlaceholderLine22
                                                }
                                                className={classNames(
                                                  "all",
                                                  sty.mockupTextPlaceholderLine22
                                                )}
                                              >
                                                <div
                                                  data-plasmic-name={
                                                    "mockupTextPlaceholderContent22"
                                                  }
                                                  data-plasmic-override={
                                                    overrides.mockupTextPlaceholderContent22
                                                  }
                                                  className={classNames(
                                                    "all",
                                                    sty.mockupTextPlaceholderContent22
                                                  )}
                                                >
                                                  <div
                                                    data-plasmic-name={
                                                      "placeholder22"
                                                    }
                                                    data-plasmic-override={
                                                      overrides.placeholder22
                                                    }
                                                    className={classNames(
                                                      "all",
                                                      sty.placeholder22
                                                    )}
                                                  />
                                                </div>
                                              </div>
                                            ) : null}
                                            {false ? (
                                              <div
                                                data-plasmic-name={
                                                  "mockupTextPlaceholderLine23"
                                                }
                                                data-plasmic-override={
                                                  overrides.mockupTextPlaceholderLine23
                                                }
                                                className={classNames(
                                                  "all",
                                                  sty.mockupTextPlaceholderLine23
                                                )}
                                              >
                                                <div
                                                  data-plasmic-name={
                                                    "mockupTextPlaceholderContent23"
                                                  }
                                                  data-plasmic-override={
                                                    overrides.mockupTextPlaceholderContent23
                                                  }
                                                  className={classNames(
                                                    "all",
                                                    sty.mockupTextPlaceholderContent23
                                                  )}
                                                >
                                                  <div
                                                    data-plasmic-name={
                                                      "placeholder23"
                                                    }
                                                    data-plasmic-override={
                                                      overrides.placeholder23
                                                    }
                                                    className={classNames(
                                                      "all",
                                                      sty.placeholder23
                                                    )}
                                                  />
                                                </div>
                                              </div>
                                            ) : null}
                                            {false ? (
                                              <div
                                                data-plasmic-name={
                                                  "mockupTextPlaceholderLine24"
                                                }
                                                data-plasmic-override={
                                                  overrides.mockupTextPlaceholderLine24
                                                }
                                                className={classNames(
                                                  "all",
                                                  sty.mockupTextPlaceholderLine24
                                                )}
                                              >
                                                <div
                                                  data-plasmic-name={
                                                    "mockupTextPlaceholderContent24"
                                                  }
                                                  data-plasmic-override={
                                                    overrides.mockupTextPlaceholderContent24
                                                  }
                                                  className={classNames(
                                                    "all",
                                                    sty.mockupTextPlaceholderContent24
                                                  )}
                                                >
                                                  <div
                                                    data-plasmic-name={
                                                      "placeholder24"
                                                    }
                                                    data-plasmic-override={
                                                      overrides.placeholder24
                                                    }
                                                    className={classNames(
                                                      "all",
                                                      sty.placeholder24
                                                    )}
                                                  />
                                                </div>
                                              </div>
                                            ) : null}
                                            {false ? (
                                              <div
                                                data-plasmic-name={
                                                  "mockupTextPlaceholderLine25"
                                                }
                                                data-plasmic-override={
                                                  overrides.mockupTextPlaceholderLine25
                                                }
                                                className={classNames(
                                                  "all",
                                                  sty.mockupTextPlaceholderLine25
                                                )}
                                              >
                                                <div
                                                  data-plasmic-name={
                                                    "mockupTextPlaceholderContent25"
                                                  }
                                                  data-plasmic-override={
                                                    overrides.mockupTextPlaceholderContent25
                                                  }
                                                  className={classNames(
                                                    "all",
                                                    sty.mockupTextPlaceholderContent25
                                                  )}
                                                >
                                                  <div
                                                    data-plasmic-name={
                                                      "placeholder25"
                                                    }
                                                    data-plasmic-override={
                                                      overrides.placeholder25
                                                    }
                                                    className={classNames(
                                                      "all",
                                                      sty.placeholder25
                                                    )}
                                                  />
                                                </div>
                                              </div>
                                            ) : null}
                                            <div
                                              data-plasmic-name={
                                                "mockupTextPlaceholderLine26"
                                              }
                                              data-plasmic-override={
                                                overrides.mockupTextPlaceholderLine26
                                              }
                                              className={classNames(
                                                "all",
                                                sty.mockupTextPlaceholderLine26
                                              )}
                                            >
                                              <div
                                                data-plasmic-name={
                                                  "mockupTextPlaceholderContent26"
                                                }
                                                data-plasmic-override={
                                                  overrides.mockupTextPlaceholderContent26
                                                }
                                                className={classNames(
                                                  "all",
                                                  sty.mockupTextPlaceholderContent26
                                                )}
                                              >
                                                <div
                                                  data-plasmic-name={
                                                    "placeholder26"
                                                  }
                                                  data-plasmic-override={
                                                    overrides.placeholder26
                                                  }
                                                  className={classNames(
                                                    "all",
                                                    sty.placeholder26
                                                  )}
                                                />
                                              </div>
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                      <div
                                        data-plasmic-name={"mockupButton8"}
                                        data-plasmic-override={
                                          overrides.mockupButton8
                                        }
                                        className={classNames(
                                          "all",
                                          sty.mockupButton8
                                        )}
                                      >
                                        <div
                                          data-plasmic-name={"link11"}
                                          data-plasmic-override={
                                            overrides.link11
                                          }
                                          className={classNames(
                                            "all",
                                            "__wab_text",
                                            sty.link11
                                          )}
                                        >
                                          {"Generate"}
                                        </div>
                                      </div>
                                    </div>
                                    {false ? (
                                      <div
                                        data-plasmic-name={"alert2"}
                                        data-plasmic-override={overrides.alert2}
                                        className={classNames(
                                          "all",
                                          sty.alert2
                                        )}
                                      >
                                        <div
                                          data-plasmic-name={"icon22"}
                                          data-plasmic-override={
                                            overrides.icon22
                                          }
                                          className={classNames(
                                            "all",
                                            sty.icon22
                                          )}
                                        >
                                          <div
                                            data-plasmic-name={"check2"}
                                            data-plasmic-override={
                                              overrides.check2
                                            }
                                            className={classNames(
                                              "all",
                                              sty.check2
                                            )}
                                          >
                                            <Group17Icon
                                              className={classNames(
                                                "all",
                                                sty.svg__eKoTq
                                              )}
                                              role={"img"}
                                            />
                                          </div>
                                        </div>
                                        <div
                                          data-plasmic-name={"content4"}
                                          data-plasmic-override={
                                            overrides.content4
                                          }
                                          className={classNames(
                                            "all",
                                            sty.content4
                                          )}
                                        >
                                          <div
                                            className={classNames(
                                              "all",
                                              "__wab_text",
                                              sty.text__fhavd
                                            )}
                                          >
                                            {"Event Created"}
                                          </div>
                                        </div>
                                      </div>
                                    ) : null}
                                    <div
                                      data-plasmic-name={"report"}
                                      data-plasmic-override={overrides.report}
                                      className={classNames("all", sty.report)}
                                    >
                                      <div
                                        data-plasmic-name={"bill"}
                                        data-plasmic-override={overrides.bill}
                                        className={classNames("all", sty.bill)}
                                      >
                                        <div
                                          data-plasmic-name={"header21"}
                                          data-plasmic-override={
                                            overrides.header21
                                          }
                                          className={classNames(
                                            "all",
                                            sty.header21
                                          )}
                                        >
                                          <div
                                            data-plasmic-name={"subtitle9"}
                                            data-plasmic-override={
                                              overrides.subtitle9
                                            }
                                            className={classNames(
                                              "all",
                                              "__wab_text",
                                              sty.subtitle9
                                            )}
                                          >
                                            {"Event"}
                                          </div>
                                          <div
                                            data-plasmic-name={"title30"}
                                            data-plasmic-override={
                                              overrides.title30
                                            }
                                            className={classNames(
                                              "all",
                                              "__wab_text",
                                              sty.title30
                                            )}
                                          >
                                            {"Financial Report"}
                                          </div>
                                        </div>
                                        <div
                                          data-plasmic-name={"main7"}
                                          data-plasmic-override={
                                            overrides.main7
                                          }
                                          className={classNames(
                                            "all",
                                            sty.main7
                                          )}
                                        >
                                          <div
                                            data-plasmic-name={"placeholder27"}
                                            data-plasmic-override={
                                              overrides.placeholder27
                                            }
                                            className={classNames(
                                              "all",
                                              sty.placeholder27
                                            )}
                                          >
                                            <div
                                              data-plasmic-name={"header22"}
                                              data-plasmic-override={
                                                overrides.header22
                                              }
                                              className={classNames(
                                                "all",
                                                sty.header22
                                              )}
                                            >
                                              <div
                                                data-plasmic-name={"title31"}
                                                data-plasmic-override={
                                                  overrides.title31
                                                }
                                                className={classNames(
                                                  "all",
                                                  "__wab_text",
                                                  sty.title31
                                                )}
                                              >
                                                {
                                                  "Trends in Neurology: Bridging Research to Clinical Practice"
                                                }
                                              </div>
                                              <div
                                                data-plasmic-name={"date"}
                                                data-plasmic-override={
                                                  overrides.date
                                                }
                                                className={classNames(
                                                  "all",
                                                  "__wab_text",
                                                  sty.date
                                                )}
                                              >
                                                {"17 Mar 2024\u201319 Mar 2024"}
                                              </div>
                                            </div>
                                            <div
                                              data-plasmic-name={"section"}
                                              data-plasmic-override={
                                                overrides.section
                                              }
                                              className={classNames(
                                                "all",
                                                sty.section
                                              )}
                                            >
                                              <div
                                                data-plasmic-name={"head"}
                                                data-plasmic-override={
                                                  overrides.head
                                                }
                                                className={classNames(
                                                  "all",
                                                  "__wab_text",
                                                  sty.head
                                                )}
                                              >
                                                {"Income"}
                                              </div>
                                              <div
                                                data-plasmic-name={
                                                  "mockupTextPlaceholderParagraph5"
                                                }
                                                data-plasmic-override={
                                                  overrides.mockupTextPlaceholderParagraph5
                                                }
                                                className={classNames(
                                                  "all",
                                                  sty.mockupTextPlaceholderParagraph5
                                                )}
                                              >
                                                <div
                                                  data-plasmic-name={
                                                    "mockupTextPlaceholderLine27"
                                                  }
                                                  data-plasmic-override={
                                                    overrides.mockupTextPlaceholderLine27
                                                  }
                                                  className={classNames(
                                                    "all",
                                                    sty.mockupTextPlaceholderLine27
                                                  )}
                                                >
                                                  <div
                                                    data-plasmic-name={
                                                      "mockupTextPlaceholderContent27"
                                                    }
                                                    data-plasmic-override={
                                                      overrides.mockupTextPlaceholderContent27
                                                    }
                                                    className={classNames(
                                                      "all",
                                                      sty.mockupTextPlaceholderContent27
                                                    )}
                                                  >
                                                    <div
                                                      data-plasmic-name={
                                                        "placeholder28"
                                                      }
                                                      data-plasmic-override={
                                                        overrides.placeholder28
                                                      }
                                                      className={classNames(
                                                        "all",
                                                        sty.placeholder28
                                                      )}
                                                    />
                                                  </div>
                                                </div>
                                                {false ? (
                                                  <div
                                                    data-plasmic-name={
                                                      "mockupTextPlaceholderLine28"
                                                    }
                                                    data-plasmic-override={
                                                      overrides.mockupTextPlaceholderLine28
                                                    }
                                                    className={classNames(
                                                      "all",
                                                      sty.mockupTextPlaceholderLine28
                                                    )}
                                                  >
                                                    <div
                                                      data-plasmic-name={
                                                        "mockupTextPlaceholderContent28"
                                                      }
                                                      data-plasmic-override={
                                                        overrides.mockupTextPlaceholderContent28
                                                      }
                                                      className={classNames(
                                                        "all",
                                                        sty.mockupTextPlaceholderContent28
                                                      )}
                                                    >
                                                      <div
                                                        data-plasmic-name={
                                                          "placeholder29"
                                                        }
                                                        data-plasmic-override={
                                                          overrides.placeholder29
                                                        }
                                                        className={classNames(
                                                          "all",
                                                          sty.placeholder29
                                                        )}
                                                      />
                                                    </div>
                                                  </div>
                                                ) : null}
                                                {false ? (
                                                  <div
                                                    data-plasmic-name={
                                                      "mockupTextPlaceholderLine29"
                                                    }
                                                    data-plasmic-override={
                                                      overrides.mockupTextPlaceholderLine29
                                                    }
                                                    className={classNames(
                                                      "all",
                                                      sty.mockupTextPlaceholderLine29
                                                    )}
                                                  >
                                                    <div
                                                      data-plasmic-name={
                                                        "mockupTextPlaceholderContent29"
                                                      }
                                                      data-plasmic-override={
                                                        overrides.mockupTextPlaceholderContent29
                                                      }
                                                      className={classNames(
                                                        "all",
                                                        sty.mockupTextPlaceholderContent29
                                                      )}
                                                    >
                                                      <div
                                                        data-plasmic-name={
                                                          "placeholder30"
                                                        }
                                                        data-plasmic-override={
                                                          overrides.placeholder30
                                                        }
                                                        className={classNames(
                                                          "all",
                                                          sty.placeholder30
                                                        )}
                                                      />
                                                    </div>
                                                  </div>
                                                ) : null}
                                                <div
                                                  data-plasmic-name={
                                                    "mockupTextPlaceholderLine30"
                                                  }
                                                  data-plasmic-override={
                                                    overrides.mockupTextPlaceholderLine30
                                                  }
                                                  className={classNames(
                                                    "all",
                                                    sty.mockupTextPlaceholderLine30
                                                  )}
                                                >
                                                  <div
                                                    data-plasmic-name={
                                                      "mockupTextPlaceholderContent30"
                                                    }
                                                    data-plasmic-override={
                                                      overrides.mockupTextPlaceholderContent30
                                                    }
                                                    className={classNames(
                                                      "all",
                                                      sty.mockupTextPlaceholderContent30
                                                    )}
                                                  >
                                                    <div
                                                      data-plasmic-name={
                                                        "placeholder31"
                                                      }
                                                      data-plasmic-override={
                                                        overrides.placeholder31
                                                      }
                                                      className={classNames(
                                                        "all",
                                                        sty.placeholder31
                                                      )}
                                                    />
                                                  </div>
                                                </div>
                                                <div
                                                  data-plasmic-name={
                                                    "mockupTextPlaceholderLine31"
                                                  }
                                                  data-plasmic-override={
                                                    overrides.mockupTextPlaceholderLine31
                                                  }
                                                  className={classNames(
                                                    "all",
                                                    sty.mockupTextPlaceholderLine31
                                                  )}
                                                >
                                                  <div
                                                    data-plasmic-name={
                                                      "mockupTextPlaceholderContent31"
                                                    }
                                                    data-plasmic-override={
                                                      overrides.mockupTextPlaceholderContent31
                                                    }
                                                    className={classNames(
                                                      "all",
                                                      sty.mockupTextPlaceholderContent31
                                                    )}
                                                  >
                                                    <div
                                                      data-plasmic-name={
                                                        "placeholder32"
                                                      }
                                                      data-plasmic-override={
                                                        overrides.placeholder32
                                                      }
                                                      className={classNames(
                                                        "all",
                                                        sty.placeholder32
                                                      )}
                                                    />
                                                  </div>
                                                </div>
                                              </div>
                                              <div
                                                data-plasmic-name={"total"}
                                                data-plasmic-override={
                                                  overrides.total
                                                }
                                                className={classNames(
                                                  "all",
                                                  sty.total
                                                )}
                                              >
                                                <div
                                                  data-plasmic-name={"title32"}
                                                  data-plasmic-override={
                                                    overrides.title32
                                                  }
                                                  className={classNames(
                                                    "all",
                                                    "__wab_text",
                                                    sty.title32
                                                  )}
                                                >
                                                  {"Total"}
                                                </div>
                                                <div
                                                  data-plasmic-name={"val6"}
                                                  data-plasmic-override={
                                                    overrides.val6
                                                  }
                                                  className={classNames(
                                                    "all",
                                                    "__wab_text",
                                                    sty.val6
                                                  )}
                                                >
                                                  {"$18,975"}
                                                </div>
                                              </div>
                                            </div>
                                            <div
                                              data-plasmic-name={"section2"}
                                              data-plasmic-override={
                                                overrides.section2
                                              }
                                              className={classNames(
                                                "all",
                                                sty.section2
                                              )}
                                            >
                                              <div
                                                data-plasmic-name={"head2"}
                                                data-plasmic-override={
                                                  overrides.head2
                                                }
                                                className={classNames(
                                                  "all",
                                                  "__wab_text",
                                                  sty.head2
                                                )}
                                              >
                                                {"Expenses"}
                                              </div>
                                              <div
                                                data-plasmic-name={
                                                  "mockupTextPlaceholderParagraph6"
                                                }
                                                data-plasmic-override={
                                                  overrides.mockupTextPlaceholderParagraph6
                                                }
                                                className={classNames(
                                                  "all",
                                                  sty.mockupTextPlaceholderParagraph6
                                                )}
                                              >
                                                {false ? (
                                                  <div
                                                    data-plasmic-name={
                                                      "mockupTextPlaceholderLine32"
                                                    }
                                                    data-plasmic-override={
                                                      overrides.mockupTextPlaceholderLine32
                                                    }
                                                    className={classNames(
                                                      "all",
                                                      sty.mockupTextPlaceholderLine32
                                                    )}
                                                  >
                                                    <div
                                                      data-plasmic-name={
                                                        "mockupTextPlaceholderContent32"
                                                      }
                                                      data-plasmic-override={
                                                        overrides.mockupTextPlaceholderContent32
                                                      }
                                                      className={classNames(
                                                        "all",
                                                        sty.mockupTextPlaceholderContent32
                                                      )}
                                                    >
                                                      <div
                                                        data-plasmic-name={
                                                          "placeholder33"
                                                        }
                                                        data-plasmic-override={
                                                          overrides.placeholder33
                                                        }
                                                        className={classNames(
                                                          "all",
                                                          sty.placeholder33
                                                        )}
                                                      />
                                                    </div>
                                                  </div>
                                                ) : null}
                                                {false ? (
                                                  <div
                                                    data-plasmic-name={
                                                      "mockupTextPlaceholderLine33"
                                                    }
                                                    data-plasmic-override={
                                                      overrides.mockupTextPlaceholderLine33
                                                    }
                                                    className={classNames(
                                                      "all",
                                                      sty.mockupTextPlaceholderLine33
                                                    )}
                                                  >
                                                    <div
                                                      data-plasmic-name={
                                                        "mockupTextPlaceholderContent33"
                                                      }
                                                      data-plasmic-override={
                                                        overrides.mockupTextPlaceholderContent33
                                                      }
                                                      className={classNames(
                                                        "all",
                                                        sty.mockupTextPlaceholderContent33
                                                      )}
                                                    >
                                                      <div
                                                        data-plasmic-name={
                                                          "placeholder34"
                                                        }
                                                        data-plasmic-override={
                                                          overrides.placeholder34
                                                        }
                                                        className={classNames(
                                                          "all",
                                                          sty.placeholder34
                                                        )}
                                                      />
                                                    </div>
                                                  </div>
                                                ) : null}
                                                <div
                                                  data-plasmic-name={
                                                    "mockupTextPlaceholderLine34"
                                                  }
                                                  data-plasmic-override={
                                                    overrides.mockupTextPlaceholderLine34
                                                  }
                                                  className={classNames(
                                                    "all",
                                                    sty.mockupTextPlaceholderLine34
                                                  )}
                                                >
                                                  <div
                                                    data-plasmic-name={
                                                      "mockupTextPlaceholderContent34"
                                                    }
                                                    data-plasmic-override={
                                                      overrides.mockupTextPlaceholderContent34
                                                    }
                                                    className={classNames(
                                                      "all",
                                                      sty.mockupTextPlaceholderContent34
                                                    )}
                                                  >
                                                    <div
                                                      data-plasmic-name={
                                                        "placeholder35"
                                                      }
                                                      data-plasmic-override={
                                                        overrides.placeholder35
                                                      }
                                                      className={classNames(
                                                        "all",
                                                        sty.placeholder35
                                                      )}
                                                    />
                                                  </div>
                                                </div>
                                                <div
                                                  data-plasmic-name={
                                                    "mockupTextPlaceholderLine35"
                                                  }
                                                  data-plasmic-override={
                                                    overrides.mockupTextPlaceholderLine35
                                                  }
                                                  className={classNames(
                                                    "all",
                                                    sty.mockupTextPlaceholderLine35
                                                  )}
                                                >
                                                  <div
                                                    data-plasmic-name={
                                                      "mockupTextPlaceholderContent35"
                                                    }
                                                    data-plasmic-override={
                                                      overrides.mockupTextPlaceholderContent35
                                                    }
                                                    className={classNames(
                                                      "all",
                                                      sty.mockupTextPlaceholderContent35
                                                    )}
                                                  >
                                                    <div
                                                      data-plasmic-name={
                                                        "placeholder36"
                                                      }
                                                      data-plasmic-override={
                                                        overrides.placeholder36
                                                      }
                                                      className={classNames(
                                                        "all",
                                                        sty.placeholder36
                                                      )}
                                                    />
                                                  </div>
                                                </div>
                                                {false ? (
                                                  <div
                                                    data-plasmic-name={
                                                      "mockupTextPlaceholderLine36"
                                                    }
                                                    data-plasmic-override={
                                                      overrides.mockupTextPlaceholderLine36
                                                    }
                                                    className={classNames(
                                                      "all",
                                                      sty.mockupTextPlaceholderLine36
                                                    )}
                                                  >
                                                    <div
                                                      data-plasmic-name={
                                                        "mockupTextPlaceholderContent36"
                                                      }
                                                      data-plasmic-override={
                                                        overrides.mockupTextPlaceholderContent36
                                                      }
                                                      className={classNames(
                                                        "all",
                                                        sty.mockupTextPlaceholderContent36
                                                      )}
                                                    >
                                                      <div
                                                        data-plasmic-name={
                                                          "placeholder37"
                                                        }
                                                        data-plasmic-override={
                                                          overrides.placeholder37
                                                        }
                                                        className={classNames(
                                                          "all",
                                                          sty.placeholder37
                                                        )}
                                                      />
                                                    </div>
                                                  </div>
                                                ) : null}
                                              </div>
                                              <div
                                                data-plasmic-name={"total2"}
                                                data-plasmic-override={
                                                  overrides.total2
                                                }
                                                className={classNames(
                                                  "all",
                                                  sty.total2
                                                )}
                                              >
                                                <div
                                                  data-plasmic-name={"title34"}
                                                  data-plasmic-override={
                                                    overrides.title34
                                                  }
                                                  className={classNames(
                                                    "all",
                                                    "__wab_text",
                                                    sty.title34
                                                  )}
                                                >
                                                  {"Total"}
                                                </div>
                                                <div
                                                  data-plasmic-name={"val7"}
                                                  data-plasmic-override={
                                                    overrides.val7
                                                  }
                                                  className={classNames(
                                                    "all",
                                                    "__wab_text",
                                                    sty.val7
                                                  )}
                                                >
                                                  {"$3,021"}
                                                </div>
                                              </div>
                                            </div>
                                          </div>
                                        </div>
                                        <div
                                          data-plasmic-name={"edge"}
                                          data-plasmic-override={overrides.edge}
                                          className={classNames(
                                            "all",
                                            sty.edge
                                          )}
                                        >
                                          <div
                                            data-plasmic-name={"tri"}
                                            data-plasmic-override={
                                              overrides.tri
                                            }
                                            className={classNames(
                                              "all",
                                              sty.tri
                                            )}
                                          >
                                            <div
                                              data-plasmic-name={"rect"}
                                              data-plasmic-override={
                                                overrides.rect
                                              }
                                              className={classNames(
                                                "all",
                                                sty.rect
                                              )}
                                            />
                                          </div>
                                          <div
                                            data-plasmic-name={"tri2"}
                                            data-plasmic-override={
                                              overrides.tri2
                                            }
                                            className={classNames(
                                              "all",
                                              sty.tri2
                                            )}
                                          >
                                            <div
                                              data-plasmic-name={"rect2"}
                                              data-plasmic-override={
                                                overrides.rect2
                                              }
                                              className={classNames(
                                                "all",
                                                sty.rect2
                                              )}
                                            />
                                          </div>
                                          <div
                                            data-plasmic-name={"tri3"}
                                            data-plasmic-override={
                                              overrides.tri3
                                            }
                                            className={classNames(
                                              "all",
                                              sty.tri3
                                            )}
                                          >
                                            <div
                                              data-plasmic-name={"rect3"}
                                              data-plasmic-override={
                                                overrides.rect3
                                              }
                                              className={classNames(
                                                "all",
                                                sty.rect3
                                              )}
                                            />
                                          </div>
                                          <div
                                            data-plasmic-name={"tri4"}
                                            data-plasmic-override={
                                              overrides.tri4
                                            }
                                            className={classNames(
                                              "all",
                                              sty.tri4
                                            )}
                                          >
                                            <div
                                              data-plasmic-name={"rect4"}
                                              data-plasmic-override={
                                                overrides.rect4
                                              }
                                              className={classNames(
                                                "all",
                                                sty.rect4
                                              )}
                                            />
                                          </div>
                                          <div
                                            data-plasmic-name={"tri5"}
                                            data-plasmic-override={
                                              overrides.tri5
                                            }
                                            className={classNames(
                                              "all",
                                              sty.tri5
                                            )}
                                          >
                                            <div
                                              data-plasmic-name={"rect5"}
                                              data-plasmic-override={
                                                overrides.rect5
                                              }
                                              className={classNames(
                                                "all",
                                                sty.rect5
                                              )}
                                            />
                                          </div>
                                          <div
                                            data-plasmic-name={"tri6"}
                                            data-plasmic-override={
                                              overrides.tri6
                                            }
                                            className={classNames(
                                              "all",
                                              sty.tri6
                                            )}
                                          >
                                            <div
                                              data-plasmic-name={"rect6"}
                                              data-plasmic-override={
                                                overrides.rect6
                                              }
                                              className={classNames(
                                                "all",
                                                sty.rect6
                                              )}
                                            />
                                          </div>
                                          <div
                                            data-plasmic-name={"tri7"}
                                            data-plasmic-override={
                                              overrides.tri7
                                            }
                                            className={classNames(
                                              "all",
                                              sty.tri7
                                            )}
                                          >
                                            <div
                                              data-plasmic-name={"rect7"}
                                              data-plasmic-override={
                                                overrides.rect7
                                              }
                                              className={classNames(
                                                "all",
                                                sty.rect7
                                              )}
                                            />
                                          </div>
                                          <div
                                            data-plasmic-name={"tri8"}
                                            data-plasmic-override={
                                              overrides.tri8
                                            }
                                            className={classNames(
                                              "all",
                                              sty.tri8
                                            )}
                                          >
                                            <div
                                              data-plasmic-name={"rect8"}
                                              data-plasmic-override={
                                                overrides.rect8
                                              }
                                              className={classNames(
                                                "all",
                                                sty.rect8
                                              )}
                                            />
                                          </div>
                                          <div
                                            data-plasmic-name={"tri9"}
                                            data-plasmic-override={
                                              overrides.tri9
                                            }
                                            className={classNames(
                                              "all",
                                              sty.tri9
                                            )}
                                          >
                                            <div
                                              data-plasmic-name={"rect9"}
                                              data-plasmic-override={
                                                overrides.rect9
                                              }
                                              className={classNames(
                                                "all",
                                                sty.rect9
                                              )}
                                            />
                                          </div>
                                          <div
                                            data-plasmic-name={"tri10"}
                                            data-plasmic-override={
                                              overrides.tri10
                                            }
                                            className={classNames(
                                              "all",
                                              sty.tri10
                                            )}
                                          >
                                            <div
                                              data-plasmic-name={"rect10"}
                                              data-plasmic-override={
                                                overrides.rect10
                                              }
                                              className={classNames(
                                                "all",
                                                sty.rect10
                                              )}
                                            />
                                          </div>
                                          <div
                                            data-plasmic-name={"tri11"}
                                            data-plasmic-override={
                                              overrides.tri11
                                            }
                                            className={classNames(
                                              "all",
                                              sty.tri11
                                            )}
                                          >
                                            <div
                                              data-plasmic-name={"rect11"}
                                              data-plasmic-override={
                                                overrides.rect11
                                              }
                                              className={classNames(
                                                "all",
                                                sty.rect11
                                              )}
                                            />
                                          </div>
                                          <div
                                            data-plasmic-name={"tri12"}
                                            data-plasmic-override={
                                              overrides.tri12
                                            }
                                            className={classNames(
                                              "all",
                                              sty.tri12
                                            )}
                                          >
                                            <div
                                              data-plasmic-name={"rect12"}
                                              data-plasmic-override={
                                                overrides.rect12
                                              }
                                              className={classNames(
                                                "all",
                                                sty.rect12
                                              )}
                                            />
                                          </div>
                                          <div
                                            data-plasmic-name={"tri13"}
                                            data-plasmic-override={
                                              overrides.tri13
                                            }
                                            className={classNames(
                                              "all",
                                              sty.tri13
                                            )}
                                          >
                                            <div
                                              data-plasmic-name={"rect13"}
                                              data-plasmic-override={
                                                overrides.rect13
                                              }
                                              className={classNames(
                                                "all",
                                                sty.rect13
                                              )}
                                            />
                                          </div>
                                          <div
                                            data-plasmic-name={"tri14"}
                                            data-plasmic-override={
                                              overrides.tri14
                                            }
                                            className={classNames(
                                              "all",
                                              sty.tri14
                                            )}
                                          >
                                            <div
                                              data-plasmic-name={"rect14"}
                                              data-plasmic-override={
                                                overrides.rect14
                                              }
                                              className={classNames(
                                                "all",
                                                sty.rect14
                                              )}
                                            />
                                          </div>
                                          <div
                                            data-plasmic-name={"tri15"}
                                            data-plasmic-override={
                                              overrides.tri15
                                            }
                                            className={classNames(
                                              "all",
                                              sty.tri15
                                            )}
                                          >
                                            <div
                                              data-plasmic-name={"rect15"}
                                              data-plasmic-override={
                                                overrides.rect15
                                              }
                                              className={classNames(
                                                "all",
                                                sty.rect15
                                              )}
                                            />
                                          </div>
                                          <div
                                            data-plasmic-name={"tri16"}
                                            data-plasmic-override={
                                              overrides.tri16
                                            }
                                            className={classNames(
                                              "all",
                                              sty.tri16
                                            )}
                                          >
                                            <div
                                              data-plasmic-name={"rect16"}
                                              data-plasmic-override={
                                                overrides.rect16
                                              }
                                              className={classNames(
                                                "all",
                                                sty.rect16
                                              )}
                                            />
                                          </div>
                                          <div
                                            data-plasmic-name={"tri17"}
                                            data-plasmic-override={
                                              overrides.tri17
                                            }
                                            className={classNames(
                                              "all",
                                              sty.tri17
                                            )}
                                          >
                                            <div
                                              data-plasmic-name={"rect17"}
                                              data-plasmic-override={
                                                overrides.rect17
                                              }
                                              className={classNames(
                                                "all",
                                                sty.rect17
                                              )}
                                            />
                                          </div>
                                          <div
                                            data-plasmic-name={"tri18"}
                                            data-plasmic-override={
                                              overrides.tri18
                                            }
                                            className={classNames(
                                              "all",
                                              sty.tri18
                                            )}
                                          >
                                            <div
                                              data-plasmic-name={"rect18"}
                                              data-plasmic-override={
                                                overrides.rect18
                                              }
                                              className={classNames(
                                                "all",
                                                sty.rect18
                                              )}
                                            />
                                          </div>
                                          <div
                                            data-plasmic-name={"tri19"}
                                            data-plasmic-override={
                                              overrides.tri19
                                            }
                                            className={classNames(
                                              "all",
                                              sty.tri19
                                            )}
                                          >
                                            <div
                                              data-plasmic-name={"rect19"}
                                              data-plasmic-override={
                                                overrides.rect19
                                              }
                                              className={classNames(
                                                "all",
                                                sty.rect19
                                              )}
                                            />
                                          </div>
                                          <div
                                            data-plasmic-name={"tri20"}
                                            data-plasmic-override={
                                              overrides.tri20
                                            }
                                            className={classNames(
                                              "all",
                                              sty.tri20
                                            )}
                                          >
                                            <div
                                              data-plasmic-name={"rect20"}
                                              data-plasmic-override={
                                                overrides.rect20
                                              }
                                              className={classNames(
                                                "all",
                                                sty.rect20
                                              )}
                                            />
                                          </div>
                                          <div
                                            data-plasmic-name={"tri21"}
                                            data-plasmic-override={
                                              overrides.tri21
                                            }
                                            className={classNames(
                                              "all",
                                              sty.tri21
                                            )}
                                          >
                                            <div
                                              data-plasmic-name={"rect21"}
                                              data-plasmic-override={
                                                overrides.rect21
                                              }
                                              className={classNames(
                                                "all",
                                                sty.rect21
                                              )}
                                            />
                                          </div>
                                          <div
                                            data-plasmic-name={"tri22"}
                                            data-plasmic-override={
                                              overrides.tri22
                                            }
                                            className={classNames(
                                              "all",
                                              sty.tri22
                                            )}
                                          >
                                            <div
                                              data-plasmic-name={"rect22"}
                                              data-plasmic-override={
                                                overrides.rect22
                                              }
                                              className={classNames(
                                                "all",
                                                sty.rect22
                                              )}
                                            />
                                          </div>
                                          <div
                                            data-plasmic-name={"tri23"}
                                            data-plasmic-override={
                                              overrides.tri23
                                            }
                                            className={classNames(
                                              "all",
                                              sty.tri23
                                            )}
                                          >
                                            <div
                                              data-plasmic-name={"rect23"}
                                              data-plasmic-override={
                                                overrides.rect23
                                              }
                                              className={classNames(
                                                "all",
                                                sty.rect23
                                              )}
                                            />
                                          </div>
                                          <div
                                            data-plasmic-name={"tri24"}
                                            data-plasmic-override={
                                              overrides.tri24
                                            }
                                            className={classNames(
                                              "all",
                                              sty.tri24
                                            )}
                                          >
                                            <div
                                              data-plasmic-name={"rect24"}
                                              data-plasmic-override={
                                                overrides.rect24
                                              }
                                              className={classNames(
                                                "all",
                                                sty.rect24
                                              )}
                                            />
                                          </div>
                                          <div
                                            data-plasmic-name={"tri25"}
                                            data-plasmic-override={
                                              overrides.tri25
                                            }
                                            className={classNames(
                                              "all",
                                              sty.tri25
                                            )}
                                          >
                                            <div
                                              data-plasmic-name={"rect25"}
                                              data-plasmic-override={
                                                overrides.rect25
                                              }
                                              className={classNames(
                                                "all",
                                                sty.rect25
                                              )}
                                            />
                                          </div>
                                          <div
                                            data-plasmic-name={"tri26"}
                                            data-plasmic-override={
                                              overrides.tri26
                                            }
                                            className={classNames(
                                              "all",
                                              sty.tri26
                                            )}
                                          >
                                            <div
                                              data-plasmic-name={"rect26"}
                                              data-plasmic-override={
                                                overrides.rect26
                                              }
                                              className={classNames(
                                                "all",
                                                sty.rect26
                                              )}
                                            />
                                          </div>
                                          <div
                                            data-plasmic-name={"tri27"}
                                            data-plasmic-override={
                                              overrides.tri27
                                            }
                                            className={classNames(
                                              "all",
                                              sty.tri27
                                            )}
                                          >
                                            <div
                                              data-plasmic-name={"rect27"}
                                              data-plasmic-override={
                                                overrides.rect27
                                              }
                                              className={classNames(
                                                "all",
                                                sty.rect27
                                              )}
                                            />
                                          </div>
                                          <div
                                            data-plasmic-name={"tri28"}
                                            data-plasmic-override={
                                              overrides.tri28
                                            }
                                            className={classNames(
                                              "all",
                                              sty.tri28
                                            )}
                                          >
                                            <div
                                              data-plasmic-name={"rect28"}
                                              data-plasmic-override={
                                                overrides.rect28
                                              }
                                              className={classNames(
                                                "all",
                                                sty.rect28
                                              )}
                                            />
                                          </div>
                                          <div
                                            data-plasmic-name={"tri29"}
                                            data-plasmic-override={
                                              overrides.tri29
                                            }
                                            className={classNames(
                                              "all",
                                              sty.tri29
                                            )}
                                          >
                                            <div
                                              data-plasmic-name={"rect29"}
                                              data-plasmic-override={
                                                overrides.rect29
                                              }
                                              className={classNames(
                                                "all",
                                                sty.rect29
                                              )}
                                            />
                                          </div>
                                          <div
                                            data-plasmic-name={"tri30"}
                                            data-plasmic-override={
                                              overrides.tri30
                                            }
                                            className={classNames(
                                              "all",
                                              sty.tri30
                                            )}
                                          >
                                            <div
                                              data-plasmic-name={"rect30"}
                                              data-plasmic-override={
                                                overrides.rect30
                                              }
                                              className={classNames(
                                                "all",
                                                sty.rect30
                                              )}
                                            />
                                          </div>
                                          <div
                                            data-plasmic-name={"tri31"}
                                            data-plasmic-override={
                                              overrides.tri31
                                            }
                                            className={classNames(
                                              "all",
                                              sty.tri31
                                            )}
                                          >
                                            <div
                                              data-plasmic-name={"rect31"}
                                              data-plasmic-override={
                                                overrides.rect31
                                              }
                                              className={classNames(
                                                "all",
                                                sty.rect31
                                              )}
                                            />
                                          </div>
                                          <div
                                            data-plasmic-name={"tri32"}
                                            data-plasmic-override={
                                              overrides.tri32
                                            }
                                            className={classNames(
                                              "all",
                                              sty.tri32
                                            )}
                                          >
                                            <div
                                              data-plasmic-name={"rect32"}
                                              data-plasmic-override={
                                                overrides.rect32
                                              }
                                              className={classNames(
                                                "all",
                                                sty.rect32
                                              )}
                                            />
                                          </div>
                                        </div>
                                      </div>
                                      <div
                                        data-plasmic-name={"shade3"}
                                        data-plasmic-override={overrides.shade3}
                                        className={classNames(
                                          "all",
                                          sty.shade3
                                        )}
                                      />
                                    </div>
                                  </div>
                                </div>
                                <div
                                  data-plasmic-name={"features3"}
                                  data-plasmic-override={overrides.features3}
                                  className={classNames("all", sty.features3)}
                                >
                                  <div
                                    data-plasmic-name={"title33"}
                                    data-plasmic-override={overrides.title33}
                                    className={classNames(
                                      "all",
                                      "__wab_text",
                                      sty.title33
                                    )}
                                  >
                                    {"Key Capabilities"}
                                  </div>
                                  <div
                                    className={classNames(
                                      "all",
                                      sty.freeBox__g8QjH
                                    )}
                                  >
                                    <div
                                      data-plasmic-name={"figmaPaste2"}
                                      data-plasmic-override={
                                        overrides.figmaPaste2
                                      }
                                      className={classNames(
                                        "all",
                                        sty.figmaPaste2
                                      )}
                                    >
                                      <div
                                        data-plasmic-name={"contentsItem10"}
                                        data-plasmic-override={
                                          overrides.contentsItem10
                                        }
                                        className={classNames(
                                          "all",
                                          sty.contentsItem10
                                        )}
                                      >
                                        <div
                                          data-plasmic-name={"icon23"}
                                          data-plasmic-override={
                                            overrides.icon23
                                          }
                                          className={classNames(
                                            "all",
                                            sty.icon23
                                          )}
                                        >
                                          <Icon87Icon
                                            className={classNames(
                                              "all",
                                              sty.svg__wJhRs
                                            )}
                                            role={"img"}
                                          />
                                        </div>
                                        <div
                                          data-plasmic-name={"text61"}
                                          data-plasmic-override={
                                            overrides.text61
                                          }
                                          className={classNames(
                                            "all",
                                            "__wab_text",
                                            sty.text61
                                          )}
                                        >
                                          {
                                            "Live and Enduring Activity Scheduling"
                                          }
                                        </div>
                                      </div>
                                      <div
                                        data-plasmic-name={"contentsItem11"}
                                        data-plasmic-override={
                                          overrides.contentsItem11
                                        }
                                        className={classNames(
                                          "all",
                                          sty.contentsItem11
                                        )}
                                      >
                                        <div
                                          data-plasmic-name={"icon24"}
                                          data-plasmic-override={
                                            overrides.icon24
                                          }
                                          className={classNames(
                                            "all",
                                            sty.icon24
                                          )}
                                        >
                                          <Icon87Icon
                                            className={classNames(
                                              "all",
                                              sty.svg___3OrnD
                                            )}
                                            role={"img"}
                                          />
                                        </div>
                                        <div
                                          data-plasmic-name={"text62"}
                                          data-plasmic-override={
                                            overrides.text62
                                          }
                                          className={classNames(
                                            "all",
                                            "__wab_text",
                                            sty.text62
                                          )}
                                        >
                                          {"CME Credit Tracing"}
                                        </div>
                                      </div>
                                      <div
                                        data-plasmic-name={"contentsItem12"}
                                        data-plasmic-override={
                                          overrides.contentsItem12
                                        }
                                        className={classNames(
                                          "all",
                                          sty.contentsItem12
                                        )}
                                      >
                                        <div
                                          data-plasmic-name={"icon25"}
                                          data-plasmic-override={
                                            overrides.icon25
                                          }
                                          className={classNames(
                                            "all",
                                            sty.icon25
                                          )}
                                        >
                                          <Icon87Icon
                                            className={classNames(
                                              "all",
                                              sty.svg___5Qlht
                                            )}
                                            role={"img"}
                                          />
                                        </div>
                                        <div
                                          data-plasmic-name={"text63"}
                                          data-plasmic-override={
                                            overrides.text63
                                          }
                                          className={classNames(
                                            "all",
                                            "__wab_text",
                                            sty.text63
                                          )}
                                        >
                                          {"Certificate Management"}
                                        </div>
                                      </div>
                                      <div
                                        data-plasmic-name={"contentsItem13"}
                                        data-plasmic-override={
                                          overrides.contentsItem13
                                        }
                                        className={classNames(
                                          "all",
                                          sty.contentsItem13
                                        )}
                                      >
                                        <div
                                          data-plasmic-name={"icon26"}
                                          data-plasmic-override={
                                            overrides.icon26
                                          }
                                          className={classNames(
                                            "all",
                                            sty.icon26
                                          )}
                                        >
                                          <Icon87Icon
                                            className={classNames(
                                              "all",
                                              sty.svg__e2Mic
                                            )}
                                            role={"img"}
                                          />
                                        </div>
                                        <div
                                          data-plasmic-name={"text64"}
                                          data-plasmic-override={
                                            overrides.text64
                                          }
                                          className={classNames(
                                            "all",
                                            "__wab_text",
                                            sty.text64
                                          )}
                                        >
                                          {"ACCME PARS Connectivity"}
                                        </div>
                                      </div>
                                      <div
                                        data-plasmic-name={"contentsItem14"}
                                        data-plasmic-override={
                                          overrides.contentsItem14
                                        }
                                        className={classNames(
                                          "all",
                                          sty.contentsItem14
                                        )}
                                      >
                                        <div
                                          data-plasmic-name={"icon27"}
                                          data-plasmic-override={
                                            overrides.icon27
                                          }
                                          className={classNames(
                                            "all",
                                            sty.icon27
                                          )}
                                        >
                                          <Icon87Icon
                                            className={classNames(
                                              "all",
                                              sty.svg__p1VTf
                                            )}
                                            role={"img"}
                                          />
                                        </div>
                                        <div
                                          data-plasmic-name={"text65"}
                                          data-plasmic-override={
                                            overrides.text65
                                          }
                                          className={classNames(
                                            "all",
                                            "__wab_text",
                                            sty.text65
                                          )}
                                        >
                                          {
                                            "Maintenance of Certification Reporting"
                                          }
                                        </div>
                                      </div>
                                      <div
                                        data-plasmic-name={"contentsItem15"}
                                        data-plasmic-override={
                                          overrides.contentsItem15
                                        }
                                        className={classNames(
                                          "all",
                                          sty.contentsItem15
                                        )}
                                      >
                                        <div
                                          data-plasmic-name={"icon28"}
                                          data-plasmic-override={
                                            overrides.icon28
                                          }
                                          className={classNames(
                                            "all",
                                            sty.icon28
                                          )}
                                        >
                                          <Icon87Icon
                                            className={classNames(
                                              "all",
                                              sty.svg___43YoQ
                                            )}
                                            role={"img"}
                                          />
                                        </div>
                                        <div
                                          data-plasmic-name={"text66"}
                                          data-plasmic-override={
                                            overrides.text66
                                          }
                                          className={classNames(
                                            "all",
                                            "__wab_text",
                                            sty.text66
                                          )}
                                        >
                                          {
                                            "Registration and Participation Tracking"
                                          }
                                        </div>
                                      </div>
                                      <div
                                        data-plasmic-name={"contentsItem16"}
                                        data-plasmic-override={
                                          overrides.contentsItem16
                                        }
                                        className={classNames(
                                          "all",
                                          sty.contentsItem16
                                        )}
                                      >
                                        <div
                                          data-plasmic-name={"icon29"}
                                          data-plasmic-override={
                                            overrides.icon29
                                          }
                                          className={classNames(
                                            "all",
                                            sty.icon29
                                          )}
                                        >
                                          <Icon87Icon
                                            className={classNames(
                                              "all",
                                              sty.svg__iHp7U
                                            )}
                                            role={"img"}
                                          />
                                        </div>
                                        <div
                                          data-plasmic-name={"text67"}
                                          data-plasmic-override={
                                            overrides.text67
                                          }
                                          className={classNames(
                                            "all",
                                            "__wab_text",
                                            sty.text67
                                          )}
                                        >
                                          {"Event Financial Management"}
                                        </div>
                                      </div>
                                      <div
                                        data-plasmic-name={"contentsItem17"}
                                        data-plasmic-override={
                                          overrides.contentsItem17
                                        }
                                        className={classNames(
                                          "all",
                                          sty.contentsItem17
                                        )}
                                      >
                                        <div
                                          data-plasmic-name={"icon30"}
                                          data-plasmic-override={
                                            overrides.icon30
                                          }
                                          className={classNames(
                                            "all",
                                            sty.icon30
                                          )}
                                        >
                                          <Icon87Icon
                                            className={classNames(
                                              "all",
                                              sty.svg__szoVf
                                            )}
                                            role={"img"}
                                          />
                                        </div>
                                        <div
                                          data-plasmic-name={"text68"}
                                          data-plasmic-override={
                                            overrides.text68
                                          }
                                          className={classNames(
                                            "all",
                                            "__wab_text",
                                            sty.text68
                                          )}
                                        >
                                          {"Cross-Departmental Reporting"}
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            );
                          })}
                        </AntdTabItem>
                        <AntdTabItem
                          className={classNames(
                            "__wab_instance",
                            sty.tabItem__mqp4N
                          )}
                          key={"3"}
                          label={
                            <div
                              className={classNames("all", sty.freeBox__wW81B)}
                            >
                              <PlasmicImg__
                                alt={""}
                                className={classNames(sty.img__zdQDu)}
                                displayHeight={"45px"}
                                displayMaxHeight={"none"}
                                displayMaxWidth={"100%"}
                                displayMinHeight={"0"}
                                displayMinWidth={"0"}
                                displayWidth={"216px"}
                                loader={"plasmic"}
                                loading={"lazy"}
                                src={{
                                  src: "https://site-assets.plasmic.app/9fd573b79cd2a308d894f39aa424fd70.svg",
                                  fullWidth: 220,
                                  fullHeight: 46,
                                  aspectRatio: 4.782609
                                }}
                              />
                            </div>
                          }
                        >
                          {(_par =>
                            !_par ? [] : Array.isArray(_par) ? _par : [_par])(
                            (() => {
                              try {
                                return $ctx.products[2].product;
                              } catch (e) {
                                if (
                                  e instanceof TypeError ||
                                  e?.plasmicType === "PlasmicUndefinedDataError"
                                ) {
                                  return [];
                                }
                                throw e;
                              }
                            })()
                          ).map((__plasmic_item_0, __plasmic_idx_0) => {
                            const currentItem = __plasmic_item_0;
                            const currentIndex = __plasmic_idx_0;
                            return (
                              <div
                                data-plasmic-name={"bodyWrapper5"}
                                data-plasmic-override={overrides.bodyWrapper5}
                                className={classNames("all", sty.bodyWrapper5)}
                                key={currentIndex}
                              >
                                <div
                                  data-plasmic-name={"intro3"}
                                  data-plasmic-override={overrides.intro3}
                                  className={classNames("all", sty.intro3)}
                                >
                                  <div
                                    data-plasmic-name={"col5"}
                                    data-plasmic-override={overrides.col5}
                                    className={classNames("all", sty.col5)}
                                  >
                                    <Logo
                                      data-plasmic-name={"logo8"}
                                      data-plasmic-override={overrides.logo8}
                                      className={classNames(
                                        "__wab_instance",
                                        sty.logo8
                                      )}
                                      product={"myGme"}
                                    />

                                    <div
                                      data-plasmic-name={"text"}
                                      data-plasmic-override={overrides.text}
                                      className={classNames("all", sty.text)}
                                    >
                                      <div
                                        data-plasmic-name={"title18"}
                                        data-plasmic-override={
                                          overrides.title18
                                        }
                                        className={classNames(
                                          "all",
                                          "__wab_text",
                                          sty.title18
                                        )}
                                      >
                                        {
                                          "One Platform for GME Fiscal Management"
                                        }
                                      </div>
                                      <div
                                        data-plasmic-name={"desc8"}
                                        data-plasmic-override={overrides.desc8}
                                        className={classNames(
                                          "all",
                                          "__wab_text",
                                          sty.desc8
                                        )}
                                      >
                                        {
                                          "MyGME Fiscal\u2122 connects educational, scheduling, and clinical-hour information with the financial processes required for GME reimbursement, institutional planning, invoicing, and reporting.\nThrough IRIS and STAR exports, Master Rotation Schedules, FTE and CAP analysis, gap and overlap review, and detailed fiscal reporting, institutions gain clearer oversight of reimbursable activity and Medicare submissions."
                                        }
                                      </div>
                                    </div>
                                  </div>
                                  <div
                                    data-plasmic-name={"img3"}
                                    data-plasmic-override={overrides.img3}
                                    className={classNames("all", sty.img3)}
                                  >
                                    <div
                                      data-plasmic-name={"bg2"}
                                      data-plasmic-override={overrides.bg2}
                                      className={classNames("all", sty.bg2)}
                                    >
                                      <Wave1Icon
                                        className={classNames(
                                          "all",
                                          sty.svg__pCfE
                                        )}
                                        role={"img"}
                                      />

                                      <PlasmicImg__
                                        alt={""}
                                        className={classNames(sty.img__ud0Nf)}
                                        displayHeight={"186px"}
                                        displayMaxHeight={"none"}
                                        displayMaxWidth={"100%"}
                                        displayMinHeight={"0"}
                                        displayMinWidth={"0"}
                                        displayWidth={"715px"}
                                        loader={"plasmic"}
                                        loading={"lazy"}
                                        src={{
                                          src: "https://site-assets.plasmic.app/bf87b4d752b94e5cc36e8a6cab0a8589.svg",
                                          fullWidth: 715,
                                          fullHeight: 186
                                        }}
                                      />

                                      <Wave41Icon
                                        className={classNames(
                                          "all",
                                          sty.svg__j6PxH
                                        )}
                                        role={"img"}
                                      />
                                    </div>
                                    <div
                                      data-plasmic-name={"reimbursement"}
                                      data-plasmic-override={
                                        overrides.reimbursement
                                      }
                                      className={classNames(
                                        "all",
                                        sty.reimbursement
                                      )}
                                    >
                                      <div
                                        data-plasmic-name={"header11"}
                                        data-plasmic-override={
                                          overrides.header11
                                        }
                                        className={classNames(
                                          "all",
                                          sty.header11
                                        )}
                                      >
                                        {false ? (
                                          <div
                                            data-plasmic-name={"subtitle4"}
                                            data-plasmic-override={
                                              overrides.subtitle4
                                            }
                                            className={classNames(
                                              "all",
                                              "__wab_text",
                                              sty.subtitle4
                                            )}
                                          >
                                            {"Subtitle"}
                                          </div>
                                        ) : null}
                                        <div
                                          data-plasmic-name={"title19"}
                                          data-plasmic-override={
                                            overrides.title19
                                          }
                                          className={classNames(
                                            "all",
                                            "__wab_text",
                                            sty.title19
                                          )}
                                        >
                                          {"Reimbursement Progress"}
                                        </div>
                                      </div>
                                      <div
                                        data-plasmic-name={"main4"}
                                        data-plasmic-override={overrides.main4}
                                        className={classNames("all", sty.main4)}
                                      >
                                        <div
                                          data-plasmic-name={"placeholder16"}
                                          data-plasmic-override={
                                            overrides.placeholder16
                                          }
                                          className={classNames(
                                            "all",
                                            sty.placeholder16
                                          )}
                                        >
                                          <div
                                            data-plasmic-name={"row"}
                                            data-plasmic-override={
                                              overrides.row
                                            }
                                            className={classNames(
                                              "all",
                                              sty.row
                                            )}
                                          >
                                            <div
                                              data-plasmic-name={"prop"}
                                              data-plasmic-override={
                                                overrides.prop
                                              }
                                              className={classNames(
                                                "all",
                                                sty.prop
                                              )}
                                            >
                                              <div
                                                data-plasmic-name={"label10"}
                                                data-plasmic-override={
                                                  overrides.label10
                                                }
                                                className={classNames(
                                                  "all",
                                                  "__wab_text",
                                                  sty.label10
                                                )}
                                              >
                                                {"Fiscal Year:"}
                                              </div>
                                              <div
                                                data-plasmic-name={"val"}
                                                data-plasmic-override={
                                                  overrides.val
                                                }
                                                className={classNames(
                                                  "all",
                                                  "__wab_text",
                                                  sty.val
                                                )}
                                              >
                                                {"2023\u20132024"}
                                              </div>
                                            </div>
                                            <div
                                              data-plasmic-name={"prop2"}
                                              data-plasmic-override={
                                                overrides.prop2
                                              }
                                              className={classNames(
                                                "all",
                                                sty.prop2
                                              )}
                                            >
                                              <div
                                                data-plasmic-name={"label11"}
                                                data-plasmic-override={
                                                  overrides.label11
                                                }
                                                className={classNames(
                                                  "all",
                                                  "__wab_text",
                                                  sty.label11
                                                )}
                                              >
                                                {"Due Date:"}
                                              </div>
                                              <div
                                                data-plasmic-name={"val2"}
                                                data-plasmic-override={
                                                  overrides.val2
                                                }
                                                className={classNames(
                                                  "all",
                                                  "__wab_text",
                                                  sty.val2
                                                )}
                                              >
                                                {"Sep 30, 2024"}
                                              </div>
                                            </div>
                                          </div>
                                          <div
                                            data-plasmic-name={
                                              "mockupProgressBarWithTitle"
                                            }
                                            data-plasmic-override={
                                              overrides.mockupProgressBarWithTitle
                                            }
                                            className={classNames(
                                              "all",
                                              sty.mockupProgressBarWithTitle
                                            )}
                                          >
                                            <div
                                              data-plasmic-name={"header12"}
                                              data-plasmic-override={
                                                overrides.header12
                                              }
                                              className={classNames(
                                                "all",
                                                sty.header12
                                              )}
                                            >
                                              <div
                                                data-plasmic-name={"title20"}
                                                data-plasmic-override={
                                                  overrides.title20
                                                }
                                                className={classNames(
                                                  "all",
                                                  "__wab_text",
                                                  sty.title20
                                                )}
                                              >
                                                {"Ready for Reimbursement"}
                                              </div>
                                              <div
                                                data-plasmic-name={"val3"}
                                                data-plasmic-override={
                                                  overrides.val3
                                                }
                                                className={classNames(
                                                  "all",
                                                  "__wab_text",
                                                  sty.val3
                                                )}
                                              >
                                                {"73%"}
                                              </div>
                                            </div>
                                            <div
                                              data-plasmic-name={"bar"}
                                              data-plasmic-override={
                                                overrides.bar
                                              }
                                              className={classNames(
                                                "all",
                                                sty.bar
                                              )}
                                            >
                                              <div
                                                data-plasmic-name={"value"}
                                                data-plasmic-override={
                                                  overrides.value
                                                }
                                                className={classNames(
                                                  "all",
                                                  sty.value
                                                )}
                                              />
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                    <div
                                      data-plasmic-name={"demographics"}
                                      data-plasmic-override={
                                        overrides.demographics
                                      }
                                      className={classNames(
                                        "all",
                                        sty.demographics
                                      )}
                                    >
                                      <div
                                        data-plasmic-name={"demographics2"}
                                        data-plasmic-override={
                                          overrides.demographics2
                                        }
                                        className={classNames(
                                          "all",
                                          sty.demographics2
                                        )}
                                      >
                                        {false ? (
                                          <div
                                            data-plasmic-name={"header13"}
                                            data-plasmic-override={
                                              overrides.header13
                                            }
                                            className={classNames(
                                              "all",
                                              sty.header13
                                            )}
                                          >
                                            <div
                                              data-plasmic-name={"subtitle7"}
                                              data-plasmic-override={
                                                overrides.subtitle7
                                              }
                                              className={classNames(
                                                "all",
                                                "__wab_text",
                                                sty.subtitle7
                                              )}
                                            >
                                              {"Subtitle"}
                                            </div>
                                            <div
                                              data-plasmic-name={"title4"}
                                              data-plasmic-override={
                                                overrides.title4
                                              }
                                              className={classNames(
                                                "all",
                                                "__wab_text",
                                                sty.title4
                                              )}
                                            >
                                              {"Title"}
                                            </div>
                                          </div>
                                        ) : null}
                                        <div
                                          data-plasmic-name={"main5"}
                                          data-plasmic-override={
                                            overrides.main5
                                          }
                                          className={classNames(
                                            "all",
                                            sty.main5
                                          )}
                                        >
                                          <div
                                            data-plasmic-name={"placeholder17"}
                                            data-plasmic-override={
                                              overrides.placeholder17
                                            }
                                            className={classNames(
                                              "all",
                                              sty.placeholder17
                                            )}
                                          >
                                            <div
                                              data-plasmic-name={"row2"}
                                              data-plasmic-override={
                                                overrides.row2
                                              }
                                              className={classNames(
                                                "all",
                                                sty.row2
                                              )}
                                            >
                                              <div
                                                data-plasmic-name={"header14"}
                                                data-plasmic-override={
                                                  overrides.header14
                                                }
                                                className={classNames(
                                                  "all",
                                                  sty.header14
                                                )}
                                              >
                                                <PlasmicImg__
                                                  alt={""}
                                                  className={classNames(
                                                    sty.img__scAZz
                                                  )}
                                                  displayHeight={"24px"}
                                                  displayMaxHeight={"none"}
                                                  displayMaxWidth={"100%"}
                                                  displayMinHeight={"0"}
                                                  displayMinWidth={"0"}
                                                  displayWidth={"24px"}
                                                  loader={"plasmic"}
                                                  loading={"lazy"}
                                                  src={{
                                                    src: "https://site-assets.plasmic.app/c5e582f2b73bf9c41a1927c0d7d67fd7.svg",
                                                    fullWidth: 24,
                                                    fullHeight: 24
                                                  }}
                                                />

                                                <div
                                                  data-plasmic-name={"name6"}
                                                  data-plasmic-override={
                                                    overrides.name6
                                                  }
                                                  className={classNames(
                                                    "all",
                                                    "__wab_text",
                                                    sty.name6
                                                  )}
                                                >
                                                  {"Megan Wil"}
                                                </div>
                                              </div>
                                              <div
                                                data-plasmic-name={"error"}
                                                data-plasmic-override={
                                                  overrides.error
                                                }
                                                className={classNames(
                                                  "all",
                                                  sty.error
                                                )}
                                              >
                                                <div
                                                  className={classNames(
                                                    "all",
                                                    sty.freeBox___3N2TS
                                                  )}
                                                >
                                                  <div
                                                    data-plasmic-name={"tip"}
                                                    data-plasmic-override={
                                                      overrides.tip
                                                    }
                                                    className={classNames(
                                                      "all",
                                                      sty.tip
                                                    )}
                                                  />
                                                </div>
                                                <div
                                                  data-plasmic-name={"label3"}
                                                  data-plasmic-override={
                                                    overrides.label3
                                                  }
                                                  className={classNames(
                                                    "all",
                                                    "__wab_text",
                                                    sty.label3
                                                  )}
                                                >
                                                  {"No SSN Code"}
                                                </div>
                                                <div
                                                  data-plasmic-name={"link6"}
                                                  data-plasmic-override={
                                                    overrides.link6
                                                  }
                                                  className={classNames(
                                                    "all",
                                                    "__wab_text",
                                                    sty.link6
                                                  )}
                                                >
                                                  {"Add"}
                                                </div>
                                              </div>
                                            </div>
                                            <div
                                              data-plasmic-name={"row6"}
                                              data-plasmic-override={
                                                overrides.row6
                                              }
                                              className={classNames(
                                                "all",
                                                sty.row6
                                              )}
                                            >
                                              <div
                                                data-plasmic-name={"header15"}
                                                data-plasmic-override={
                                                  overrides.header15
                                                }
                                                className={classNames(
                                                  "all",
                                                  sty.header15
                                                )}
                                              >
                                                <PlasmicImg__
                                                  alt={""}
                                                  className={classNames(
                                                    sty.img__i2PsE
                                                  )}
                                                  displayHeight={"24px"}
                                                  displayMaxHeight={"none"}
                                                  displayMaxWidth={"100%"}
                                                  displayMinHeight={"0"}
                                                  displayMinWidth={"0"}
                                                  displayWidth={"24px"}
                                                  loader={"plasmic"}
                                                  loading={"lazy"}
                                                  src={{
                                                    src: "https://site-assets.plasmic.app/4ed22927224c5bb8fc14aaebd926842e.svg",
                                                    fullWidth: 24,
                                                    fullHeight: 24
                                                  }}
                                                />

                                                <div
                                                  data-plasmic-name={"name7"}
                                                  data-plasmic-override={
                                                    overrides.name7
                                                  }
                                                  className={classNames(
                                                    "all",
                                                    "__wab_text",
                                                    sty.name7
                                                  )}
                                                >
                                                  {"Bobby Huel"}
                                                </div>
                                              </div>
                                              <div
                                                data-plasmic-name={"error2"}
                                                data-plasmic-override={
                                                  overrides.error2
                                                }
                                                className={classNames(
                                                  "all",
                                                  sty.error2
                                                )}
                                              >
                                                <div
                                                  className={classNames(
                                                    "all",
                                                    sty.freeBox__vqpW9
                                                  )}
                                                >
                                                  <div
                                                    data-plasmic-name={"tip2"}
                                                    data-plasmic-override={
                                                      overrides.tip2
                                                    }
                                                    className={classNames(
                                                      "all",
                                                      sty.tip2
                                                    )}
                                                  />
                                                </div>
                                                <div
                                                  data-plasmic-name={"label4"}
                                                  data-plasmic-override={
                                                    overrides.label4
                                                  }
                                                  className={classNames(
                                                    "all",
                                                    "__wab_text",
                                                    sty.label4
                                                  )}
                                                >
                                                  {"No Graduation Date"}
                                                </div>
                                                <div
                                                  data-plasmic-name={"link7"}
                                                  data-plasmic-override={
                                                    overrides.link7
                                                  }
                                                  className={classNames(
                                                    "all",
                                                    "__wab_text",
                                                    sty.link7
                                                  )}
                                                >
                                                  {"Add"}
                                                </div>
                                              </div>
                                            </div>
                                            <div
                                              data-plasmic-name={"row7"}
                                              data-plasmic-override={
                                                overrides.row7
                                              }
                                              className={classNames(
                                                "all",
                                                sty.row7
                                              )}
                                            >
                                              <div
                                                data-plasmic-name={"header16"}
                                                data-plasmic-override={
                                                  overrides.header16
                                                }
                                                className={classNames(
                                                  "all",
                                                  sty.header16
                                                )}
                                              >
                                                <PlasmicImg__
                                                  alt={""}
                                                  className={classNames(
                                                    sty.img___15HTu
                                                  )}
                                                  displayHeight={"24px"}
                                                  displayMaxHeight={"none"}
                                                  displayMaxWidth={"100%"}
                                                  displayMinHeight={"0"}
                                                  displayMinWidth={"0"}
                                                  displayWidth={"24px"}
                                                  loader={"plasmic"}
                                                  loading={"lazy"}
                                                  src={{
                                                    src: "https://site-assets.plasmic.app/dd070641b260e03c8b60d2c70e463190.svg",
                                                    fullWidth: 24,
                                                    fullHeight: 24
                                                  }}
                                                />

                                                <div
                                                  data-plasmic-name={"name8"}
                                                  data-plasmic-override={
                                                    overrides.name8
                                                  }
                                                  className={classNames(
                                                    "all",
                                                    "__wab_text",
                                                    sty.name8
                                                  )}
                                                >
                                                  {"Tanya Cole"}
                                                </div>
                                              </div>
                                              <div
                                                data-plasmic-name={"error3"}
                                                data-plasmic-override={
                                                  overrides.error3
                                                }
                                                className={classNames(
                                                  "all",
                                                  sty.error3
                                                )}
                                              >
                                                <div
                                                  className={classNames(
                                                    "all",
                                                    sty.freeBox__fSMiz
                                                  )}
                                                >
                                                  <div
                                                    data-plasmic-name={"tip3"}
                                                    data-plasmic-override={
                                                      overrides.tip3
                                                    }
                                                    className={classNames(
                                                      "all",
                                                      sty.tip3
                                                    )}
                                                  />
                                                </div>
                                                <div
                                                  data-plasmic-name={"label5"}
                                                  data-plasmic-override={
                                                    overrides.label5
                                                  }
                                                  className={classNames(
                                                    "all",
                                                    "__wab_text",
                                                    sty.label5
                                                  )}
                                                >
                                                  {"No SSN Code"}
                                                </div>
                                                <div
                                                  data-plasmic-name={"link8"}
                                                  data-plasmic-override={
                                                    overrides.link8
                                                  }
                                                  className={classNames(
                                                    "all",
                                                    "__wab_text",
                                                    sty.link8
                                                  )}
                                                >
                                                  {"Add"}
                                                </div>
                                              </div>
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                      <div
                                        data-plasmic-name={"shade2"}
                                        data-plasmic-override={overrides.shade2}
                                        className={classNames(
                                          "all",
                                          sty.shade2
                                        )}
                                      />
                                    </div>
                                    <div
                                      data-plasmic-name={"cap"}
                                      data-plasmic-override={overrides.cap}
                                      className={classNames("all", sty.cap)}
                                    >
                                      <div
                                        data-plasmic-name={"header17"}
                                        data-plasmic-override={
                                          overrides.header17
                                        }
                                        className={classNames(
                                          "all",
                                          sty.header17
                                        )}
                                      >
                                        {false ? (
                                          <div
                                            data-plasmic-name={"subtitle8"}
                                            data-plasmic-override={
                                              overrides.subtitle8
                                            }
                                            className={classNames(
                                              "all",
                                              "__wab_text",
                                              sty.subtitle8
                                            )}
                                          >
                                            {"Subtitle"}
                                          </div>
                                        ) : null}
                                        <div
                                          data-plasmic-name={"title21"}
                                          data-plasmic-override={
                                            overrides.title21
                                          }
                                          className={classNames(
                                            "all",
                                            "__wab_text",
                                            sty.title21
                                          )}
                                        >
                                          {"Cap Analysis"}
                                        </div>
                                      </div>
                                      <div
                                        data-plasmic-name={"main3"}
                                        data-plasmic-override={overrides.main3}
                                        className={classNames("all", sty.main3)}
                                      >
                                        <div
                                          data-plasmic-name={"placeholder18"}
                                          data-plasmic-override={
                                            overrides.placeholder18
                                          }
                                          className={classNames(
                                            "all",
                                            sty.placeholder18
                                          )}
                                        >
                                          <div
                                            data-plasmic-name={"field"}
                                            data-plasmic-override={
                                              overrides.field
                                            }
                                            className={classNames(
                                              "all",
                                              sty.field
                                            )}
                                          >
                                            <div
                                              data-plasmic-name={"label6"}
                                              data-plasmic-override={
                                                overrides.label6
                                              }
                                              className={classNames(
                                                "all",
                                                "__wab_text",
                                                sty.label6
                                              )}
                                            >
                                              {"Institution"}
                                            </div>
                                            <div
                                              data-plasmic-name={"select"}
                                              data-plasmic-override={
                                                overrides.select
                                              }
                                              className={classNames(
                                                "all",
                                                sty.select
                                              )}
                                            >
                                              <div
                                                data-plasmic-name={"input"}
                                                data-plasmic-override={
                                                  overrides.input
                                                }
                                                className={classNames(
                                                  "all",
                                                  sty.input
                                                )}
                                              >
                                                {false ? (
                                                  <div
                                                    data-plasmic-name={
                                                      "leftIcon"
                                                    }
                                                    data-plasmic-override={
                                                      overrides.leftIcon
                                                    }
                                                    className={classNames(
                                                      "all",
                                                      sty.leftIcon
                                                    )}
                                                  >
                                                    <Icon91Icon
                                                      className={classNames(
                                                        "all",
                                                        sty.svg__tEzPf
                                                      )}
                                                      role={"img"}
                                                    />
                                                  </div>
                                                ) : null}
                                                <div
                                                  data-plasmic-name={"text25"}
                                                  data-plasmic-override={
                                                    overrides.text25
                                                  }
                                                  className={classNames(
                                                    "all",
                                                    "__wab_text",
                                                    sty.text25
                                                  )}
                                                >
                                                  {"Integrated Health One"}
                                                </div>
                                                <div
                                                  data-plasmic-name={
                                                    "rightIcon"
                                                  }
                                                  data-plasmic-override={
                                                    overrides.rightIcon
                                                  }
                                                  className={classNames(
                                                    "all",
                                                    sty.rightIcon
                                                  )}
                                                >
                                                  <PlasmicImg__
                                                    alt={""}
                                                    className={classNames(
                                                      sty.img__ctYbA
                                                    )}
                                                    displayHeight={"12px"}
                                                    displayMaxHeight={"none"}
                                                    displayMaxWidth={"100%"}
                                                    displayMinHeight={"0"}
                                                    displayMinWidth={"0"}
                                                    displayWidth={"12px"}
                                                    loader={"plasmic"}
                                                    loading={"lazy"}
                                                    src={{
                                                      src: "https://site-assets.plasmic.app/111ce4d1a6d72b3b2b7de10e9e93afd6.svg",
                                                      fullWidth: 12,
                                                      fullHeight: 12
                                                    }}
                                                  />
                                                </div>
                                              </div>
                                            </div>
                                          </div>
                                          <div
                                            data-plasmic-name={"row5"}
                                            data-plasmic-override={
                                              overrides.row5
                                            }
                                            className={classNames(
                                              "all",
                                              sty.row5
                                            )}
                                          >
                                            <div
                                              data-plasmic-name={"prop3"}
                                              data-plasmic-override={
                                                overrides.prop3
                                              }
                                              className={classNames(
                                                "all",
                                                sty.prop3
                                              )}
                                            >
                                              <div
                                                data-plasmic-name={"label7"}
                                                data-plasmic-override={
                                                  overrides.label7
                                                }
                                                className={classNames(
                                                  "all",
                                                  "__wab_text",
                                                  sty.label7
                                                )}
                                              >
                                                {"DME/Cap"}
                                              </div>
                                              <div
                                                data-plasmic-name={"val4"}
                                                data-plasmic-override={
                                                  overrides.val4
                                                }
                                                className={classNames(
                                                  "all",
                                                  "__wab_text",
                                                  sty.val4
                                                )}
                                              >
                                                {"12.11/10"}
                                              </div>
                                            </div>
                                            <div
                                              data-plasmic-name={"prop4"}
                                              data-plasmic-override={
                                                overrides.prop4
                                              }
                                              className={classNames(
                                                "all",
                                                sty.prop4
                                              )}
                                            >
                                              <div
                                                data-plasmic-name={"label8"}
                                                data-plasmic-override={
                                                  overrides.label8
                                                }
                                                className={classNames(
                                                  "all",
                                                  "__wab_text",
                                                  sty.label8
                                                )}
                                              >
                                                {"DME/Cap Variance"}
                                              </div>
                                              <div
                                                data-plasmic-name={"val5"}
                                                data-plasmic-override={
                                                  overrides.val5
                                                }
                                                className={classNames(
                                                  "all",
                                                  "__wab_text",
                                                  sty.val5
                                                )}
                                              >
                                                {"2.11"}
                                              </div>
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                    {false ? (
                                      <div
                                        data-plasmic-name={"profile3"}
                                        data-plasmic-override={
                                          overrides.profile3
                                        }
                                        className={classNames(
                                          "all",
                                          sty.profile3
                                        )}
                                      >
                                        <div
                                          data-plasmic-name={"av3"}
                                          data-plasmic-override={overrides.av3}
                                          className={classNames("all", sty.av3)}
                                        />

                                        <div
                                          data-plasmic-name={"col6"}
                                          data-plasmic-override={overrides.col6}
                                          className={classNames(
                                            "all",
                                            sty.col6
                                          )}
                                        >
                                          <div
                                            data-plasmic-name={"top4"}
                                            data-plasmic-override={
                                              overrides.top4
                                            }
                                            className={classNames(
                                              "all",
                                              sty.top4
                                            )}
                                          >
                                            <div
                                              data-plasmic-name={"header18"}
                                              data-plasmic-override={
                                                overrides.header18
                                              }
                                              className={classNames(
                                                "all",
                                                sty.header18
                                              )}
                                            >
                                              <div
                                                data-plasmic-name={"name9"}
                                                data-plasmic-override={
                                                  overrides.name9
                                                }
                                                className={classNames(
                                                  "all",
                                                  "__wab_text",
                                                  sty.name9
                                                )}
                                              >
                                                {"Jody Gleason"}
                                              </div>
                                              <div
                                                data-plasmic-name={"status3"}
                                                data-plasmic-override={
                                                  overrides.status3
                                                }
                                                className={classNames(
                                                  "all",
                                                  sty.status3
                                                )}
                                              >
                                                <div
                                                  data-plasmic-name={"label9"}
                                                  data-plasmic-override={
                                                    overrides.label9
                                                  }
                                                  className={classNames(
                                                    "all",
                                                    "__wab_text",
                                                    sty.label9
                                                  )}
                                                >
                                                  {"Status"}
                                                </div>
                                                <PlasmicImg__
                                                  alt={""}
                                                  className={classNames(
                                                    sty.img___4JBgl
                                                  )}
                                                  displayHeight={"12px"}
                                                  displayMaxHeight={"none"}
                                                  displayMaxWidth={"100%"}
                                                  displayMinHeight={"0"}
                                                  displayMinWidth={"0"}
                                                  displayWidth={"12px"}
                                                  loader={"plasmic"}
                                                  loading={"lazy"}
                                                  src={{
                                                    src: "https://site-assets.plasmic.app/fd8444da63470a9c723007422a038ef7.svg",
                                                    fullWidth: 12,
                                                    fullHeight: 12
                                                  }}
                                                />
                                              </div>
                                            </div>
                                            <div
                                              data-plasmic-name={"body8"}
                                              data-plasmic-override={
                                                overrides.body8
                                              }
                                              className={classNames(
                                                "all",
                                                sty.body8
                                              )}
                                            >
                                              <div
                                                data-plasmic-name={"year3"}
                                                data-plasmic-override={
                                                  overrides.year3
                                                }
                                                className={classNames(
                                                  "all",
                                                  "__wab_text",
                                                  sty.year3
                                                )}
                                              >
                                                {"PGY-3"}
                                              </div>
                                              <div
                                                data-plasmic-name={"name5"}
                                                data-plasmic-override={
                                                  overrides.name5
                                                }
                                                className={classNames(
                                                  "all",
                                                  "__wab_text",
                                                  sty.name5
                                                )}
                                              >
                                                {"05/01/2022-10/31/2022"}
                                              </div>
                                            </div>
                                          </div>
                                          <div
                                            data-plasmic-name={"actions3"}
                                            data-plasmic-override={
                                              overrides.actions3
                                            }
                                            className={classNames(
                                              "all",
                                              sty.actions3
                                            )}
                                          >
                                            <div
                                              data-plasmic-name={
                                                "mockupButton5"
                                              }
                                              data-plasmic-override={
                                                overrides.mockupButton5
                                              }
                                              className={classNames(
                                                "all",
                                                sty.mockupButton5
                                              )}
                                            >
                                              <div
                                                data-plasmic-name={"link9"}
                                                data-plasmic-override={
                                                  overrides.link9
                                                }
                                                className={classNames(
                                                  "all",
                                                  "__wab_text",
                                                  sty.link9
                                                )}
                                              >
                                                {"Save & Submit"}
                                              </div>
                                            </div>
                                            <div
                                              data-plasmic-name={
                                                "mockupButton6"
                                              }
                                              data-plasmic-override={
                                                overrides.mockupButton6
                                              }
                                              className={classNames(
                                                "all",
                                                sty.mockupButton6
                                              )}
                                            >
                                              <div
                                                data-plasmic-name={"link5"}
                                                data-plasmic-override={
                                                  overrides.link5
                                                }
                                                className={classNames(
                                                  "all",
                                                  "__wab_text",
                                                  sty.link5
                                                )}
                                              >
                                                {"Print"}
                                              </div>
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                    ) : null}
                                    <div
                                      data-plasmic-name={"menu2"}
                                      data-plasmic-override={overrides.menu2}
                                      className={classNames("all", sty.menu2)}
                                    >
                                      <div
                                        data-plasmic-name={"header19"}
                                        data-plasmic-override={
                                          overrides.header19
                                        }
                                        className={classNames(
                                          "all",
                                          sty.header19
                                        )}
                                      >
                                        <div
                                          data-plasmic-name={"title22"}
                                          data-plasmic-override={
                                            overrides.title22
                                          }
                                          className={classNames(
                                            "all",
                                            "__wab_text",
                                            sty.title22
                                          )}
                                        >
                                          {"Fiscal Reports"}
                                        </div>
                                        <div
                                          data-plasmic-name={"icon8"}
                                          data-plasmic-override={
                                            overrides.icon8
                                          }
                                          className={classNames(
                                            "all",
                                            sty.icon8
                                          )}
                                        >
                                          <Icon83Icon
                                            className={classNames(
                                              "all",
                                              sty.svg___3VIZo
                                            )}
                                            role={"img"}
                                          />
                                        </div>
                                      </div>
                                      <div
                                        data-plasmic-name={"list"}
                                        data-plasmic-override={overrides.list}
                                        className={classNames("all", sty.list)}
                                      >
                                        <div
                                          data-plasmic-name={"item23"}
                                          data-plasmic-override={
                                            overrides.item23
                                          }
                                          className={classNames(
                                            "all",
                                            sty.item23
                                          )}
                                        >
                                          {false ? (
                                            <Icon84Icon
                                              className={classNames(
                                                "all",
                                                sty.svg__acjsR
                                              )}
                                              role={"img"}
                                            />
                                          ) : null}
                                          <div
                                            data-plasmic-name={"text26"}
                                            data-plasmic-override={
                                              overrides.text26
                                            }
                                            className={classNames(
                                              "all",
                                              "__wab_text",
                                              sty.text26
                                            )}
                                          >
                                            {"FTE Report"}
                                          </div>
                                        </div>
                                        <div
                                          data-plasmic-name={"item24"}
                                          data-plasmic-override={
                                            overrides.item24
                                          }
                                          className={classNames(
                                            "all",
                                            sty.item24
                                          )}
                                        >
                                          {false ? (
                                            <Icon84Icon
                                              className={classNames(
                                                "all",
                                                sty.svg__ikBv
                                              )}
                                              role={"img"}
                                            />
                                          ) : null}
                                          <div
                                            data-plasmic-name={"text4"}
                                            data-plasmic-override={
                                              overrides.text4
                                            }
                                            className={classNames(
                                              "all",
                                              "__wab_text",
                                              sty.text4
                                            )}
                                          >
                                            {"IRIS Report"}
                                          </div>
                                        </div>
                                        <div
                                          data-plasmic-name={"item25"}
                                          data-plasmic-override={
                                            overrides.item25
                                          }
                                          className={classNames(
                                            "all",
                                            sty.item25
                                          )}
                                        >
                                          {false ? (
                                            <Icon84Icon
                                              className={classNames(
                                                "all",
                                                sty.svg__shIrW
                                              )}
                                              role={"img"}
                                            />
                                          ) : null}
                                          <div
                                            data-plasmic-name={"text27"}
                                            data-plasmic-override={
                                              overrides.text27
                                            }
                                            className={classNames(
                                              "all",
                                              "__wab_text",
                                              sty.text27
                                            )}
                                          >
                                            {"Medicate Audit Report"}
                                          </div>
                                        </div>
                                        {false ? (
                                          <div
                                            data-plasmic-name={"item26"}
                                            data-plasmic-override={
                                              overrides.item26
                                            }
                                            className={classNames(
                                              "all",
                                              sty.item26
                                            )}
                                          >
                                            {false ? (
                                              <Icon84Icon
                                                className={classNames(
                                                  "all",
                                                  sty.svg__affCk
                                                )}
                                                role={"img"}
                                              />
                                            ) : null}
                                            <div
                                              data-plasmic-name={"text28"}
                                              data-plasmic-override={
                                                overrides.text28
                                              }
                                              className={classNames(
                                                "all",
                                                "__wab_text",
                                                sty.text28
                                              )}
                                            >
                                              {"Settings"}
                                            </div>
                                          </div>
                                        ) : null}
                                        {false ? (
                                          <div
                                            data-plasmic-name={"item27"}
                                            data-plasmic-override={
                                              overrides.item27
                                            }
                                            className={classNames(
                                              "all",
                                              sty.item27
                                            )}
                                          >
                                            {false ? (
                                              <Icon84Icon
                                                className={classNames(
                                                  "all",
                                                  sty.svg__uVdJz
                                                )}
                                                role={"img"}
                                              />
                                            ) : null}
                                            <div
                                              data-plasmic-name={"text29"}
                                              data-plasmic-override={
                                                overrides.text29
                                              }
                                              className={classNames(
                                                "all",
                                                "__wab_text",
                                                sty.text29
                                              )}
                                            >
                                              {"Label"}
                                            </div>
                                          </div>
                                        ) : null}
                                        {false ? (
                                          <div
                                            data-plasmic-name={"item28"}
                                            data-plasmic-override={
                                              overrides.item28
                                            }
                                            className={classNames(
                                              "all",
                                              sty.item28
                                            )}
                                          >
                                            {false ? (
                                              <Icon84Icon
                                                className={classNames(
                                                  "all",
                                                  sty.svg__oSyes
                                                )}
                                                role={"img"}
                                              />
                                            ) : null}
                                            <div
                                              data-plasmic-name={"text30"}
                                              data-plasmic-override={
                                                overrides.text30
                                              }
                                              className={classNames(
                                                "all",
                                                "__wab_text",
                                                sty.text30
                                              )}
                                            >
                                              {"Label"}
                                            </div>
                                          </div>
                                        ) : null}
                                        {false ? (
                                          <div
                                            data-plasmic-name={"item29"}
                                            data-plasmic-override={
                                              overrides.item29
                                            }
                                            className={classNames(
                                              "all",
                                              sty.item29
                                            )}
                                          >
                                            {false ? (
                                              <Icon84Icon
                                                className={classNames(
                                                  "all",
                                                  sty.svg___8B0Co
                                                )}
                                                role={"img"}
                                              />
                                            ) : null}
                                            <div
                                              data-plasmic-name={"text31"}
                                              data-plasmic-override={
                                                overrides.text31
                                              }
                                              className={classNames(
                                                "all",
                                                "__wab_text",
                                                sty.text31
                                              )}
                                            >
                                              {"Label"}
                                            </div>
                                          </div>
                                        ) : null}
                                        {false ? (
                                          <div
                                            data-plasmic-name={"item30"}
                                            data-plasmic-override={
                                              overrides.item30
                                            }
                                            className={classNames(
                                              "all",
                                              sty.item30
                                            )}
                                          >
                                            {false ? (
                                              <Icon84Icon
                                                className={classNames(
                                                  "all",
                                                  sty.svg__yhccO
                                                )}
                                                role={"img"}
                                              />
                                            ) : null}
                                            <div
                                              data-plasmic-name={"text32"}
                                              data-plasmic-override={
                                                overrides.text32
                                              }
                                              className={classNames(
                                                "all",
                                                "__wab_text",
                                                sty.text32
                                              )}
                                            >
                                              {"Label"}
                                            </div>
                                          </div>
                                        ) : null}
                                        {false ? (
                                          <div
                                            data-plasmic-name={"item31"}
                                            data-plasmic-override={
                                              overrides.item31
                                            }
                                            className={classNames(
                                              "all",
                                              sty.item31
                                            )}
                                          >
                                            {false ? (
                                              <Icon84Icon
                                                className={classNames(
                                                  "all",
                                                  sty.svg__htw0Z
                                                )}
                                                role={"img"}
                                              />
                                            ) : null}
                                            <div
                                              data-plasmic-name={"text33"}
                                              data-plasmic-override={
                                                overrides.text33
                                              }
                                              className={classNames(
                                                "all",
                                                "__wab_text",
                                                sty.text33
                                              )}
                                            >
                                              {"Label"}
                                            </div>
                                          </div>
                                        ) : null}
                                        {false ? (
                                          <div
                                            data-plasmic-name={"item32"}
                                            data-plasmic-override={
                                              overrides.item32
                                            }
                                            className={classNames(
                                              "all",
                                              sty.item32
                                            )}
                                          >
                                            {false ? (
                                              <Icon84Icon
                                                className={classNames(
                                                  "all",
                                                  sty.svg___03E13
                                                )}
                                                role={"img"}
                                              />
                                            ) : null}
                                            <div
                                              data-plasmic-name={"text34"}
                                              data-plasmic-override={
                                                overrides.text34
                                              }
                                              className={classNames(
                                                "all",
                                                "__wab_text",
                                                sty.text34
                                              )}
                                            >
                                              {"Label"}
                                            </div>
                                          </div>
                                        ) : null}
                                      </div>
                                    </div>
                                    <div
                                      data-plasmic-name={"alert"}
                                      data-plasmic-override={overrides.alert}
                                      className={classNames("all", sty.alert)}
                                    >
                                      <div
                                        data-plasmic-name={"icon9"}
                                        data-plasmic-override={overrides.icon9}
                                        className={classNames("all", sty.icon9)}
                                      >
                                        <Icon91Icon
                                          className={classNames(
                                            "all",
                                            sty.svg__lv7Bw
                                          )}
                                          role={"img"}
                                        />
                                      </div>
                                      <div
                                        data-plasmic-name={"content2"}
                                        data-plasmic-override={
                                          overrides.content2
                                        }
                                        className={classNames(
                                          "all",
                                          sty.content2
                                        )}
                                      >
                                        <div
                                          data-plasmic-name={"text35"}
                                          data-plasmic-override={
                                            overrides.text35
                                          }
                                          className={classNames(
                                            "all",
                                            "__wab_text",
                                            sty.text35
                                          )}
                                        >
                                          {"Audit Report Generated"}
                                        </div>
                                      </div>
                                      <div
                                        data-plasmic-name={"icon10"}
                                        data-plasmic-override={overrides.icon10}
                                        className={classNames(
                                          "all",
                                          sty.icon10
                                        )}
                                      >
                                        <Icon84Icon
                                          className={classNames(
                                            "all",
                                            sty.svg___1KV
                                          )}
                                          role={"img"}
                                        />
                                      </div>
                                    </div>
                                  </div>
                                </div>
                                <div
                                  data-plasmic-name={"features"}
                                  data-plasmic-override={overrides.features}
                                  className={classNames("all", sty.features)}
                                >
                                  <div
                                    data-plasmic-name={"title5"}
                                    data-plasmic-override={overrides.title5}
                                    className={classNames(
                                      "all",
                                      "__wab_text",
                                      sty.title5
                                    )}
                                  >
                                    {"Key Capabilities"}
                                  </div>
                                  <div
                                    className={classNames(
                                      "all",
                                      sty.freeBox__nczQa
                                    )}
                                  >
                                    <div
                                      data-plasmic-name={"figmaPaste"}
                                      data-plasmic-override={
                                        overrides.figmaPaste
                                      }
                                      className={classNames(
                                        "all",
                                        sty.figmaPaste
                                      )}
                                    >
                                      <div
                                        data-plasmic-name={"contentsItem"}
                                        data-plasmic-override={
                                          overrides.contentsItem
                                        }
                                        className={classNames(
                                          "all",
                                          sty.contentsItem
                                        )}
                                      >
                                        <div
                                          data-plasmic-name={"icon11"}
                                          data-plasmic-override={
                                            overrides.icon11
                                          }
                                          className={classNames(
                                            "all",
                                            sty.icon11
                                          )}
                                        >
                                          <Icon87Icon
                                            className={classNames(
                                              "all",
                                              sty.svg__voOIh
                                            )}
                                            role={"img"}
                                          />
                                        </div>
                                        <div
                                          data-plasmic-name={"text36"}
                                          data-plasmic-override={
                                            overrides.text36
                                          }
                                          className={classNames(
                                            "all",
                                            "__wab_text",
                                            sty.text36
                                          )}
                                        >
                                          {
                                            "Medicare Reimbursement & Cost Reporting"
                                          }
                                        </div>
                                      </div>
                                      <div
                                        data-plasmic-name={"contentsItem2"}
                                        data-plasmic-override={
                                          overrides.contentsItem2
                                        }
                                        className={classNames(
                                          "all",
                                          sty.contentsItem2
                                        )}
                                      >
                                        <div
                                          data-plasmic-name={"icon12"}
                                          data-plasmic-override={
                                            overrides.icon12
                                          }
                                          className={classNames(
                                            "all",
                                            sty.icon12
                                          )}
                                        >
                                          <Icon87Icon
                                            className={classNames(
                                              "all",
                                              sty.svg__ybj7C
                                            )}
                                            role={"img"}
                                          />
                                        </div>
                                        <div
                                          data-plasmic-name={"text37"}
                                          data-plasmic-override={
                                            overrides.text37
                                          }
                                          className={classNames(
                                            "all",
                                            "__wab_text",
                                            sty.text37
                                          )}
                                        >
                                          {"IRIS & STAR Export"}
                                        </div>
                                      </div>
                                      <div
                                        data-plasmic-name={"contentsItem3"}
                                        data-plasmic-override={
                                          overrides.contentsItem3
                                        }
                                        className={classNames(
                                          "all",
                                          sty.contentsItem3
                                        )}
                                      >
                                        <div
                                          data-plasmic-name={"icon13"}
                                          data-plasmic-override={
                                            overrides.icon13
                                          }
                                          className={classNames(
                                            "all",
                                            sty.icon13
                                          )}
                                        >
                                          <Icon87Icon
                                            className={classNames(
                                              "all",
                                              sty.svg__olCJ
                                            )}
                                            role={"img"}
                                          />
                                        </div>
                                        <div
                                          data-plasmic-name={"text38"}
                                          data-plasmic-override={
                                            overrides.text38
                                          }
                                          className={classNames(
                                            "all",
                                            "__wab_text",
                                            sty.text38
                                          )}
                                        >
                                          {"Billing & Invoicing"}
                                        </div>
                                      </div>
                                      <div
                                        data-plasmic-name={"contentsItem4"}
                                        data-plasmic-override={
                                          overrides.contentsItem4
                                        }
                                        className={classNames(
                                          "all",
                                          sty.contentsItem4
                                        )}
                                      >
                                        <div
                                          data-plasmic-name={"icon14"}
                                          data-plasmic-override={
                                            overrides.icon14
                                          }
                                          className={classNames(
                                            "all",
                                            sty.icon14
                                          )}
                                        >
                                          <Icon87Icon
                                            className={classNames(
                                              "all",
                                              sty.svg__rpqZc
                                            )}
                                            role={"img"}
                                          />
                                        </div>
                                        <div
                                          data-plasmic-name={"text39"}
                                          data-plasmic-override={
                                            overrides.text39
                                          }
                                          className={classNames(
                                            "all",
                                            "__wab_text",
                                            sty.text39
                                          )}
                                        >
                                          {"FTE Reporting & CAP Analysis"}
                                        </div>
                                      </div>
                                      <div
                                        data-plasmic-name={"contentsItem5"}
                                        data-plasmic-override={
                                          overrides.contentsItem5
                                        }
                                        className={classNames(
                                          "all",
                                          sty.contentsItem5
                                        )}
                                      >
                                        <div
                                          data-plasmic-name={"icon15"}
                                          data-plasmic-override={
                                            overrides.icon15
                                          }
                                          className={classNames(
                                            "all",
                                            sty.icon15
                                          )}
                                        >
                                          <Icon87Icon
                                            className={classNames(
                                              "all",
                                              sty.svg___77Ns1
                                            )}
                                            role={"img"}
                                          />
                                        </div>
                                        <div
                                          data-plasmic-name={"text5"}
                                          data-plasmic-override={
                                            overrides.text5
                                          }
                                          className={classNames(
                                            "all",
                                            "__wab_text",
                                            sty.text5
                                          )}
                                        >
                                          {
                                            "Master Rotation Schedule Management"
                                          }
                                        </div>
                                      </div>
                                      <div
                                        data-plasmic-name={"contentsItem6"}
                                        data-plasmic-override={
                                          overrides.contentsItem6
                                        }
                                        className={classNames(
                                          "all",
                                          sty.contentsItem6
                                        )}
                                      >
                                        <div
                                          data-plasmic-name={"icon16"}
                                          data-plasmic-override={
                                            overrides.icon16
                                          }
                                          className={classNames(
                                            "all",
                                            sty.icon16
                                          )}
                                        >
                                          <Icon87Icon
                                            className={classNames(
                                              "all",
                                              sty.svg__dhWel
                                            )}
                                            role={"img"}
                                          />
                                        </div>
                                        <div
                                          data-plasmic-name={"text40"}
                                          data-plasmic-override={
                                            overrides.text40
                                          }
                                          className={classNames(
                                            "all",
                                            "__wab_text",
                                            sty.text40
                                          )}
                                        >
                                          {"Gap & Overlap Analysis"}
                                        </div>
                                      </div>
                                      <div
                                        data-plasmic-name={"contentsItem7"}
                                        data-plasmic-override={
                                          overrides.contentsItem7
                                        }
                                        className={classNames(
                                          "all",
                                          sty.contentsItem7
                                        )}
                                      >
                                        <div
                                          data-plasmic-name={"icon17"}
                                          data-plasmic-override={
                                            overrides.icon17
                                          }
                                          className={classNames(
                                            "all",
                                            sty.icon17
                                          )}
                                        >
                                          <Icon87Icon
                                            className={classNames(
                                              "all",
                                              sty.svg__oy0JC
                                            )}
                                            role={"img"}
                                          />
                                        </div>
                                        <div
                                          data-plasmic-name={"text41"}
                                          data-plasmic-override={
                                            overrides.text41
                                          }
                                          className={classNames(
                                            "all",
                                            "__wab_text",
                                            sty.text41
                                          )}
                                        >
                                          {"Audit Management"}
                                        </div>
                                      </div>
                                      <div
                                        data-plasmic-name={"contentsItem8"}
                                        data-plasmic-override={
                                          overrides.contentsItem8
                                        }
                                        className={classNames(
                                          "all",
                                          sty.contentsItem8
                                        )}
                                      >
                                        <div
                                          data-plasmic-name={"icon18"}
                                          data-plasmic-override={
                                            overrides.icon18
                                          }
                                          className={classNames(
                                            "all",
                                            sty.icon18
                                          )}
                                        >
                                          <Icon87Icon
                                            className={classNames(
                                              "all",
                                              sty.svg__gk3Af
                                            )}
                                            role={"img"}
                                          />
                                        </div>
                                        <div
                                          data-plasmic-name={"text42"}
                                          data-plasmic-override={
                                            overrides.text42
                                          }
                                          className={classNames(
                                            "all",
                                            "__wab_text",
                                            sty.text42
                                          )}
                                        >
                                          {"Errors & Omissions Analysis"}
                                        </div>
                                      </div>
                                      <div
                                        data-plasmic-name={"contentsItem9"}
                                        data-plasmic-override={
                                          overrides.contentsItem9
                                        }
                                        className={classNames(
                                          "all",
                                          sty.contentsItem9
                                        )}
                                      >
                                        <div
                                          data-plasmic-name={"icon19"}
                                          data-plasmic-override={
                                            overrides.icon19
                                          }
                                          className={classNames(
                                            "all",
                                            sty.icon19
                                          )}
                                        >
                                          <Icon87Icon
                                            className={classNames(
                                              "all",
                                              sty.svg__sttom
                                            )}
                                            role={"img"}
                                          />
                                        </div>
                                        <div
                                          data-plasmic-name={"text43"}
                                          data-plasmic-override={
                                            overrides.text43
                                          }
                                          className={classNames(
                                            "all",
                                            "__wab_text",
                                            sty.text43
                                          )}
                                        >
                                          {"MyQuickPass\u2122 Integration"}
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            );
                          })}
                        </AntdTabItem>
                      </React.Fragment>
                    }
                    onChange={async (...eventArgs: any) => {
                      generateStateOnChangeProp($state, [
                        "productTabs",
                        "activeKey"
                      ]).apply(null, eventArgs);
                    }}
                    size={"middle"}
                    sticky={false}
                    tabBarBackground={"#FFF"}
                    tabBarClassName={classNames({
                      [sty["pcls_rD0wo-WDIPys"]]: hasVariant(
                        globalVariants,
                        "mobile",
                        "tabletLandscape"
                      ),
                      [sty["pcls_xdVRZnowjy_L"]]: true
                    })}
                    tabPosition={"top"}
                    tabsDropdownClassName={classNames({
                      [sty["pcls_cosBQM60nlAy"]]: hasVariant(
                        globalVariants,
                        "mobile",
                        "tabletLandscape"
                      ),
                      [sty["pcls_rPwEUHX6XxjP"]]: true
                    })}
                    tabsDropdownScopeClassName={
                      sty["productTabs__tabsDropdown"]
                    }
                    tabsScopeClassName={sty["productTabs__tabs"]}
                    type={"card"}
                  />
                </div>
              ) : null}
              {(
                hasVariant(globalVariants, "mobile", "mobile")
                  ? true
                  : hasVariant(globalVariants, "mobile", "tabletPortrait")
                    ? true
                    : false
              ) ? (
                <div
                  data-plasmic-name={"mobileWrapper"}
                  data-plasmic-override={overrides.mobileWrapper}
                  className={classNames("all", sty.mobileWrapper)}
                >
                  <div
                    data-plasmic-name={"header"}
                    data-plasmic-override={overrides.header}
                    className={classNames("all", sty.header)}
                  >
                    <div
                      data-plasmic-name={"top"}
                      data-plasmic-override={overrides.top}
                      className={classNames("all", sty.top)}
                    >
                      <div
                        data-plasmic-name={"subtitle2"}
                        data-plasmic-override={overrides.subtitle2}
                        className={classNames(
                          "all",
                          "__wab_text",
                          sty.subtitle2
                        )}
                      >
                        {"One Integrated Platform"}
                      </div>
                      <div
                        data-plasmic-name={"title2"}
                        data-plasmic-override={overrides.title2}
                        className={classNames("all", "__wab_text", sty.title2)}
                      >
                        {
                          "Technology That Strengthens Educational Conversations"
                        }
                      </div>
                    </div>
                    <div
                      data-plasmic-name={"body"}
                      data-plasmic-override={overrides.body}
                      className={classNames("all", "__wab_text", sty.body)}
                    >
                      {
                        "MyEvaluations brings educational management, continuing medical education, and GME fiscal management together within one connected platform.\nThrough MyEvaluations, MyCME\u2122, and MyGME Fiscal\u2122, institutions can strengthen assessment quality, simplify educational operations, gain actionable insight, and support Continuous Educational Improvement\u00a0across the organization."
                      }
                    </div>
                  </div>
                  <AntdTabs
                    data-plasmic-name={"tabs"}
                    data-plasmic-override={overrides.tabs}
                    activeKey={generateStateValueProp($state, [
                      "tabs",
                      "activeKey"
                    ])}
                    animateTabBar={
                      hasVariant(globalVariants, "mobile", "mobileXSmall")
                        ? true
                        : true
                    }
                    animateTabContent={
                      hasVariant(globalVariants, "mobile", "mobileXSmall")
                        ? false
                        : false
                    }
                    animated={true}
                    centered={
                      hasVariant(globalVariants, "mobile", "mobileXSmall")
                        ? false
                        : undefined
                    }
                    className={classNames("__wab_instance", sty.tabs)}
                    defaultActiveKey={
                      hasVariant(globalVariants, "mobile", "mobileXSmall")
                        ? "1"
                        : "1"
                    }
                    destroyInactiveTabPane={true}
                    items={
                      <React.Fragment>
                        <AntdTabItem
                          className={classNames(
                            "__wab_instance",
                            sty.tabItem__tOgHf
                          )}
                          key={"1"}
                          label={
                            <PlasmicImg__
                              alt={""}
                              className={classNames(sty.img__d7R2B)}
                              displayHeight={"auto"}
                              displayMaxHeight={"none"}
                              displayMaxWidth={"100%"}
                              displayMinHeight={"0"}
                              displayMinWidth={"0"}
                              displayWidth={"auto"}
                              loader={"plasmic"}
                              loading={"lazy"}
                              src={{
                                src: "https://img.plasmic.app/img-optimizer/v1/img/3b6d6cba65fa1554404e1fa051f41319.png",
                                fullWidth: 114,
                                fullHeight: 24
                              }}
                            />
                          }
                        >
                          <div
                            data-plasmic-name={"content8"}
                            data-plasmic-override={overrides.content8}
                            className={classNames("all", sty.content8)}
                          >
                            <div
                              data-plasmic-name={"placeholder83"}
                              data-plasmic-override={overrides.placeholder83}
                              className={classNames("all", sty.placeholder83)}
                            >
                              <div
                                data-plasmic-name={"intro5"}
                                data-plasmic-override={overrides.intro5}
                                className={classNames("all", sty.intro5)}
                              >
                                <div
                                  data-plasmic-name={"img5"}
                                  data-plasmic-override={overrides.img5}
                                  className={classNames("all", sty.img5)}
                                >
                                  <div
                                    data-plasmic-name={"bg"}
                                    data-plasmic-override={overrides.bg}
                                    className={classNames("all", sty.bg)}
                                  >
                                    <PlasmicImg__
                                      alt={""}
                                      className={classNames(sty.img__cW0Ef)}
                                      displayHeight={"536.2925415039062px"}
                                      displayMaxHeight={"none"}
                                      displayMaxWidth={"100%"}
                                      displayMinHeight={"0"}
                                      displayMinWidth={"0"}
                                      displayWidth={"568.2182006835938px"}
                                      loader={"plasmic"}
                                      loading={"lazy"}
                                      src={{
                                        src: "https://site-assets.plasmic.app/c23eacda9c196b182b87a03d0b58d65a.svg",
                                        fullWidth: 568.2182006835938,
                                        fullHeight: 536.2925415039062
                                      }}
                                    />
                                  </div>
                                  <div
                                    data-plasmic-name={"compWrap"}
                                    data-plasmic-override={overrides.compWrap}
                                    className={classNames("all", sty.compWrap)}
                                  >
                                    <div
                                      data-plasmic-name={"perf"}
                                      data-plasmic-override={overrides.perf}
                                      className={classNames("all", sty.perf)}
                                    >
                                      {false ? (
                                        <div
                                          data-plasmic-name={"header6"}
                                          data-plasmic-override={
                                            overrides.header6
                                          }
                                          className={classNames(
                                            "all",
                                            sty.header6
                                          )}
                                        >
                                          {false ? (
                                            <div
                                              data-plasmic-name={"subtitle3"}
                                              data-plasmic-override={
                                                overrides.subtitle3
                                              }
                                              className={classNames(
                                                "all",
                                                "__wab_text",
                                                sty.subtitle3
                                              )}
                                            >
                                              {"Subtitle"}
                                            </div>
                                          ) : null}
                                          <div
                                            data-plasmic-name={"title24"}
                                            data-plasmic-override={
                                              overrides.title24
                                            }
                                            className={classNames(
                                              "all",
                                              "__wab_text",
                                              sty.title24
                                            )}
                                          >
                                            {"Competency Performance"}
                                          </div>
                                        </div>
                                      ) : null}
                                      <div
                                        data-plasmic-name={"main"}
                                        data-plasmic-override={overrides.main}
                                        className={classNames("all", sty.main)}
                                      >
                                        <div
                                          data-plasmic-name={
                                            "mockupCompetencies"
                                          }
                                          data-plasmic-override={
                                            overrides.mockupCompetencies
                                          }
                                          className={classNames(
                                            "all",
                                            sty.mockupCompetencies
                                          )}
                                        >
                                          {false ? (
                                            <div
                                              data-plasmic-name={"graph"}
                                              data-plasmic-override={
                                                overrides.graph
                                              }
                                              className={classNames(
                                                "all",
                                                sty.graph
                                              )}
                                            >
                                              <Tri5Icon
                                                className={classNames(
                                                  "all",
                                                  sty.svg__m2XNv
                                                )}
                                                role={"img"}
                                              />

                                              <Tri6Icon
                                                className={classNames(
                                                  "all",
                                                  sty.svg__lj6Fb
                                                )}
                                                role={"img"}
                                              />

                                              <Tri5Icon
                                                className={classNames(
                                                  "all",
                                                  sty.svg___6Zgl3
                                                )}
                                                role={"img"}
                                              />

                                              <Tri7Icon
                                                className={classNames(
                                                  "all",
                                                  sty.svg__b65Hl
                                                )}
                                                role={"img"}
                                              />

                                              <Tri8Icon
                                                className={classNames(
                                                  "all",
                                                  sty.svg__dQgXp
                                                )}
                                                role={"img"}
                                              />

                                              <Tri9Icon
                                                className={classNames(
                                                  "all",
                                                  sty.svg__yS1U
                                                )}
                                                role={"img"}
                                              />

                                              <Guides3Icon
                                                className={classNames(
                                                  "all",
                                                  sty.svg__cqCqu
                                                )}
                                                role={"img"}
                                              />

                                              <div
                                                data-plasmic-name={"labels"}
                                                data-plasmic-override={
                                                  overrides.labels
                                                }
                                                className={classNames(
                                                  "all",
                                                  sty.labels
                                                )}
                                              >
                                                <div
                                                  className={classNames(
                                                    "all",
                                                    "__wab_text",
                                                    sty.text__sZvXb
                                                  )}
                                                >
                                                  {"IC"}
                                                </div>
                                                <div
                                                  className={classNames(
                                                    "all",
                                                    "__wab_text",
                                                    sty.text__p1RSr
                                                  )}
                                                >
                                                  {"PC"}
                                                </div>
                                                <div
                                                  className={classNames(
                                                    "all",
                                                    "__wab_text",
                                                    sty.text___5FMdP
                                                  )}
                                                >
                                                  {"PB"}
                                                </div>
                                                <div
                                                  className={classNames(
                                                    "all",
                                                    "__wab_text",
                                                    sty.text__u71E
                                                  )}
                                                >
                                                  {"MK"}
                                                </div>
                                                <div
                                                  className={classNames(
                                                    "all",
                                                    "__wab_text",
                                                    sty.text__fk9H0
                                                  )}
                                                >
                                                  {"PR"}
                                                </div>
                                                <div
                                                  className={classNames(
                                                    "all",
                                                    "__wab_text",
                                                    sty.text__ibRvd
                                                  )}
                                                >
                                                  {"SB"}
                                                </div>
                                              </div>
                                              <PlasmicImg__
                                                alt={""}
                                                className={classNames(
                                                  sty.img__t28P
                                                )}
                                                displayHeight={
                                                  "123.71424865722656px"
                                                }
                                                displayMaxHeight={"none"}
                                                displayMaxWidth={"100%"}
                                                displayMinHeight={"0"}
                                                displayMinWidth={"0"}
                                                displayWidth={
                                                  "145.18930053710938px"
                                                }
                                                loader={"plasmic"}
                                                loading={"lazy"}
                                                src={{
                                                  src: "https://site-assets.plasmic.app/7d8642c767fee22110ac0a2882f05985.svg",
                                                  fullWidth: 145.18930053710938,
                                                  fullHeight: 123.71424865722656
                                                }}
                                              />

                                              {false ? (
                                                <div
                                                  data-plasmic-name={"series2"}
                                                  data-plasmic-override={
                                                    overrides.series2
                                                  }
                                                  className={classNames(
                                                    "all",
                                                    sty.series2
                                                  )}
                                                >
                                                  <Poly5Icon
                                                    className={classNames(
                                                      "all",
                                                      sty.svg__gWy08
                                                    )}
                                                    role={"img"}
                                                  />

                                                  <div
                                                    data-plasmic-name={
                                                      "rectangle1"
                                                    }
                                                    data-plasmic-override={
                                                      overrides.rectangle1
                                                    }
                                                    className={classNames(
                                                      "all",
                                                      sty.rectangle1
                                                    )}
                                                  />

                                                  <div
                                                    data-plasmic-name={
                                                      "rectangle2"
                                                    }
                                                    data-plasmic-override={
                                                      overrides.rectangle2
                                                    }
                                                    className={classNames(
                                                      "all",
                                                      sty.rectangle2
                                                    )}
                                                  />

                                                  <div
                                                    data-plasmic-name={
                                                      "rectangle3"
                                                    }
                                                    data-plasmic-override={
                                                      overrides.rectangle3
                                                    }
                                                    className={classNames(
                                                      "all",
                                                      sty.rectangle3
                                                    )}
                                                  />

                                                  <div
                                                    data-plasmic-name={
                                                      "rectangle4"
                                                    }
                                                    data-plasmic-override={
                                                      overrides.rectangle4
                                                    }
                                                    className={classNames(
                                                      "all",
                                                      sty.rectangle4
                                                    )}
                                                  />

                                                  <div
                                                    data-plasmic-name={
                                                      "rectangle5"
                                                    }
                                                    data-plasmic-override={
                                                      overrides.rectangle5
                                                    }
                                                    className={classNames(
                                                      "all",
                                                      sty.rectangle5
                                                    )}
                                                  />

                                                  <div
                                                    data-plasmic-name={
                                                      "rectangle6"
                                                    }
                                                    data-plasmic-override={
                                                      overrides.rectangle6
                                                    }
                                                    className={classNames(
                                                      "all",
                                                      sty.rectangle6
                                                    )}
                                                  />
                                                </div>
                                              ) : null}
                                              <div
                                                data-plasmic-name={"series3"}
                                                data-plasmic-override={
                                                  overrides.series3
                                                }
                                                className={classNames(
                                                  "all",
                                                  sty.series3
                                                )}
                                              >
                                                <Poly6Icon
                                                  className={classNames(
                                                    "all",
                                                    sty.svg__zoImE
                                                  )}
                                                  role={"img"}
                                                />

                                                <div
                                                  data-plasmic-name={
                                                    "rectangle7"
                                                  }
                                                  data-plasmic-override={
                                                    overrides.rectangle7
                                                  }
                                                  className={classNames(
                                                    "all",
                                                    sty.rectangle7
                                                  )}
                                                />

                                                <div
                                                  data-plasmic-name={
                                                    "rectangle8"
                                                  }
                                                  data-plasmic-override={
                                                    overrides.rectangle8
                                                  }
                                                  className={classNames(
                                                    "all",
                                                    sty.rectangle8
                                                  )}
                                                />

                                                <div
                                                  data-plasmic-name={
                                                    "rectangle9"
                                                  }
                                                  data-plasmic-override={
                                                    overrides.rectangle9
                                                  }
                                                  className={classNames(
                                                    "all",
                                                    sty.rectangle9
                                                  )}
                                                />

                                                <div
                                                  data-plasmic-name={
                                                    "rectangle10"
                                                  }
                                                  data-plasmic-override={
                                                    overrides.rectangle10
                                                  }
                                                  className={classNames(
                                                    "all",
                                                    sty.rectangle10
                                                  )}
                                                />

                                                <div
                                                  data-plasmic-name={
                                                    "rectangle11"
                                                  }
                                                  data-plasmic-override={
                                                    overrides.rectangle11
                                                  }
                                                  className={classNames(
                                                    "all",
                                                    sty.rectangle11
                                                  )}
                                                />

                                                <div
                                                  data-plasmic-name={
                                                    "rectangle12"
                                                  }
                                                  data-plasmic-override={
                                                    overrides.rectangle12
                                                  }
                                                  className={classNames(
                                                    "all",
                                                    sty.rectangle12
                                                  )}
                                                />
                                              </div>
                                              <div
                                                data-plasmic-name={"scores"}
                                                data-plasmic-override={
                                                  overrides.scores
                                                }
                                                className={classNames(
                                                  "all",
                                                  sty.scores
                                                )}
                                              >
                                                <div
                                                  data-plasmic-name={
                                                    "graphScore"
                                                  }
                                                  data-plasmic-override={
                                                    overrides.graphScore
                                                  }
                                                  className={classNames(
                                                    "all",
                                                    sty.graphScore
                                                  )}
                                                >
                                                  <div
                                                    data-plasmic-name={"num"}
                                                    data-plasmic-override={
                                                      overrides.num
                                                    }
                                                    className={classNames(
                                                      "all",
                                                      "__wab_text",
                                                      sty.num
                                                    )}
                                                  >
                                                    {"5"}
                                                  </div>
                                                </div>
                                                <div
                                                  data-plasmic-name={
                                                    "graphScore2"
                                                  }
                                                  data-plasmic-override={
                                                    overrides.graphScore2
                                                  }
                                                  className={classNames(
                                                    "all",
                                                    sty.graphScore2
                                                  )}
                                                >
                                                  <div
                                                    data-plasmic-name={"num2"}
                                                    data-plasmic-override={
                                                      overrides.num2
                                                    }
                                                    className={classNames(
                                                      "all",
                                                      "__wab_text",
                                                      sty.num2
                                                    )}
                                                  >
                                                    {"1"}
                                                  </div>
                                                </div>
                                                <div
                                                  data-plasmic-name={
                                                    "graphScore3"
                                                  }
                                                  data-plasmic-override={
                                                    overrides.graphScore3
                                                  }
                                                  className={classNames(
                                                    "all",
                                                    sty.graphScore3
                                                  )}
                                                >
                                                  <div
                                                    data-plasmic-name={"num3"}
                                                    data-plasmic-override={
                                                      overrides.num3
                                                    }
                                                    className={classNames(
                                                      "all",
                                                      "__wab_text",
                                                      sty.num3
                                                    )}
                                                  >
                                                    {"3"}
                                                  </div>
                                                </div>
                                              </div>
                                            </div>
                                          ) : null}
                                          {false ? (
                                            <div
                                              data-plasmic-name={"smallerGraph"}
                                              data-plasmic-override={
                                                overrides.smallerGraph
                                              }
                                              className={classNames(
                                                "all",
                                                sty.smallerGraph
                                              )}
                                            >
                                              <div
                                                data-plasmic-name={"inner"}
                                                data-plasmic-override={
                                                  overrides.inner
                                                }
                                                className={classNames(
                                                  "all",
                                                  sty.inner
                                                )}
                                              >
                                                <Tri10Icon
                                                  className={classNames(
                                                    "all",
                                                    sty.svg__y4AzA
                                                  )}
                                                  role={"img"}
                                                />

                                                <Tri10Icon
                                                  className={classNames(
                                                    "all",
                                                    sty.svg___0EmOr
                                                  )}
                                                  role={"img"}
                                                />

                                                <Tri10Icon
                                                  className={classNames(
                                                    "all",
                                                    sty.svg__cqHqp
                                                  )}
                                                  role={"img"}
                                                />

                                                <Tri10Icon
                                                  className={classNames(
                                                    "all",
                                                    sty.svg__oaC7R
                                                  )}
                                                  role={"img"}
                                                />

                                                <Tri10Icon
                                                  className={classNames(
                                                    "all",
                                                    sty.svg__fIsLf
                                                  )}
                                                  role={"img"}
                                                />

                                                <Tri10Icon
                                                  className={classNames(
                                                    "all",
                                                    sty.svg__awB11
                                                  )}
                                                  role={"img"}
                                                />

                                                <Guides4Icon
                                                  className={classNames(
                                                    "all",
                                                    sty.svg__rfuyl
                                                  )}
                                                  role={"img"}
                                                />

                                                <div
                                                  data-plasmic-name={"labels2"}
                                                  data-plasmic-override={
                                                    overrides.labels2
                                                  }
                                                  className={classNames(
                                                    "all",
                                                    sty.labels2
                                                  )}
                                                >
                                                  <div
                                                    className={classNames(
                                                      "all",
                                                      "__wab_text",
                                                      sty.text__eDdKs
                                                    )}
                                                  >
                                                    {"IC"}
                                                  </div>
                                                  <div
                                                    className={classNames(
                                                      "all",
                                                      "__wab_text",
                                                      sty.text__mEnCo
                                                    )}
                                                  >
                                                    {"PC"}
                                                  </div>
                                                  <div
                                                    className={classNames(
                                                      "all",
                                                      "__wab_text",
                                                      sty.text__gADkA
                                                    )}
                                                  >
                                                    {"PB"}
                                                  </div>
                                                  <div
                                                    className={classNames(
                                                      "all",
                                                      "__wab_text",
                                                      sty.text__gDfN8
                                                    )}
                                                  >
                                                    {"MK"}
                                                  </div>
                                                  <div
                                                    className={classNames(
                                                      "all",
                                                      "__wab_text",
                                                      sty.text__pnFir
                                                    )}
                                                  >
                                                    {"PR"}
                                                  </div>
                                                  <div
                                                    className={classNames(
                                                      "all",
                                                      "__wab_text",
                                                      sty.text__qZoZl
                                                    )}
                                                  >
                                                    {"SB"}
                                                  </div>
                                                </div>
                                                <PlasmicImg__
                                                  alt={""}
                                                  className={classNames(
                                                    sty.img___7MqIk
                                                  )}
                                                  displayHeight={
                                                    "91.64018249511719px"
                                                  }
                                                  displayMaxHeight={"none"}
                                                  displayMaxWidth={"100%"}
                                                  displayMinHeight={"0"}
                                                  displayMinWidth={"0"}
                                                  displayWidth={
                                                    "107.5476303100586px"
                                                  }
                                                  loader={"plasmic"}
                                                  loading={"lazy"}
                                                  src={{
                                                    src: "https://site-assets.plasmic.app/a119afaedd00910085da56a104853901.svg",
                                                    fullWidth: 107.5476303100586,
                                                    fullHeight: 91.64018249511719
                                                  }}
                                                />

                                                {false ? (
                                                  <div
                                                    data-plasmic-name={
                                                      "series22"
                                                    }
                                                    data-plasmic-override={
                                                      overrides.series22
                                                    }
                                                    className={classNames(
                                                      "all",
                                                      sty.series22
                                                    )}
                                                  >
                                                    <Poly7Icon
                                                      className={classNames(
                                                        "all",
                                                        sty.svg___8Dku5
                                                      )}
                                                      role={"img"}
                                                    />

                                                    <div
                                                      data-plasmic-name={
                                                        "rectangle13"
                                                      }
                                                      data-plasmic-override={
                                                        overrides.rectangle13
                                                      }
                                                      className={classNames(
                                                        "all",
                                                        sty.rectangle13
                                                      )}
                                                    />

                                                    <div
                                                      data-plasmic-name={
                                                        "rectangle14"
                                                      }
                                                      data-plasmic-override={
                                                        overrides.rectangle14
                                                      }
                                                      className={classNames(
                                                        "all",
                                                        sty.rectangle14
                                                      )}
                                                    />

                                                    <div
                                                      data-plasmic-name={
                                                        "rectangle15"
                                                      }
                                                      data-plasmic-override={
                                                        overrides.rectangle15
                                                      }
                                                      className={classNames(
                                                        "all",
                                                        sty.rectangle15
                                                      )}
                                                    />

                                                    <div
                                                      data-plasmic-name={
                                                        "rectangle16"
                                                      }
                                                      data-plasmic-override={
                                                        overrides.rectangle16
                                                      }
                                                      className={classNames(
                                                        "all",
                                                        sty.rectangle16
                                                      )}
                                                    />

                                                    <div
                                                      data-plasmic-name={
                                                        "rectangle17"
                                                      }
                                                      data-plasmic-override={
                                                        overrides.rectangle17
                                                      }
                                                      className={classNames(
                                                        "all",
                                                        sty.rectangle17
                                                      )}
                                                    />

                                                    <div
                                                      data-plasmic-name={
                                                        "rectangle18"
                                                      }
                                                      data-plasmic-override={
                                                        overrides.rectangle18
                                                      }
                                                      className={classNames(
                                                        "all",
                                                        sty.rectangle18
                                                      )}
                                                    />
                                                  </div>
                                                ) : null}
                                                <div
                                                  data-plasmic-name={"series32"}
                                                  data-plasmic-override={
                                                    overrides.series32
                                                  }
                                                  className={classNames(
                                                    "all",
                                                    sty.series32
                                                  )}
                                                >
                                                  <Poly8Icon
                                                    className={classNames(
                                                      "all",
                                                      sty.svg__a83S
                                                    )}
                                                    role={"img"}
                                                  />

                                                  <div
                                                    data-plasmic-name={
                                                      "rectangle19"
                                                    }
                                                    data-plasmic-override={
                                                      overrides.rectangle19
                                                    }
                                                    className={classNames(
                                                      "all",
                                                      sty.rectangle19
                                                    )}
                                                  />

                                                  <div
                                                    data-plasmic-name={
                                                      "rectangle20"
                                                    }
                                                    data-plasmic-override={
                                                      overrides.rectangle20
                                                    }
                                                    className={classNames(
                                                      "all",
                                                      sty.rectangle20
                                                    )}
                                                  />

                                                  <div
                                                    data-plasmic-name={
                                                      "rectangle21"
                                                    }
                                                    data-plasmic-override={
                                                      overrides.rectangle21
                                                    }
                                                    className={classNames(
                                                      "all",
                                                      sty.rectangle21
                                                    )}
                                                  />

                                                  <div
                                                    data-plasmic-name={
                                                      "rectangle22"
                                                    }
                                                    data-plasmic-override={
                                                      overrides.rectangle22
                                                    }
                                                    className={classNames(
                                                      "all",
                                                      sty.rectangle22
                                                    )}
                                                  />

                                                  <div
                                                    data-plasmic-name={
                                                      "rectangle23"
                                                    }
                                                    data-plasmic-override={
                                                      overrides.rectangle23
                                                    }
                                                    className={classNames(
                                                      "all",
                                                      sty.rectangle23
                                                    )}
                                                  />

                                                  <div
                                                    data-plasmic-name={
                                                      "rectangle24"
                                                    }
                                                    data-plasmic-override={
                                                      overrides.rectangle24
                                                    }
                                                    className={classNames(
                                                      "all",
                                                      sty.rectangle24
                                                    )}
                                                  />
                                                </div>
                                                <div
                                                  data-plasmic-name={"scores2"}
                                                  data-plasmic-override={
                                                    overrides.scores2
                                                  }
                                                  className={classNames(
                                                    "all",
                                                    sty.scores2
                                                  )}
                                                >
                                                  <div
                                                    data-plasmic-name={
                                                      "graphScore4"
                                                    }
                                                    data-plasmic-override={
                                                      overrides.graphScore4
                                                    }
                                                    className={classNames(
                                                      "all",
                                                      sty.graphScore4
                                                    )}
                                                  >
                                                    <div
                                                      data-plasmic-name={"num4"}
                                                      data-plasmic-override={
                                                        overrides.num4
                                                      }
                                                      className={classNames(
                                                        "all",
                                                        "__wab_text",
                                                        sty.num4
                                                      )}
                                                    >
                                                      {"5"}
                                                    </div>
                                                  </div>
                                                  <div
                                                    data-plasmic-name={
                                                      "graphScore5"
                                                    }
                                                    data-plasmic-override={
                                                      overrides.graphScore5
                                                    }
                                                    className={classNames(
                                                      "all",
                                                      sty.graphScore5
                                                    )}
                                                  >
                                                    <div
                                                      data-plasmic-name={"num5"}
                                                      data-plasmic-override={
                                                        overrides.num5
                                                      }
                                                      className={classNames(
                                                        "all",
                                                        "__wab_text",
                                                        sty.num5
                                                      )}
                                                    >
                                                      {"1"}
                                                    </div>
                                                  </div>
                                                  <div
                                                    data-plasmic-name={
                                                      "graphScore6"
                                                    }
                                                    data-plasmic-override={
                                                      overrides.graphScore6
                                                    }
                                                    className={classNames(
                                                      "all",
                                                      sty.graphScore6
                                                    )}
                                                  >
                                                    <div
                                                      data-plasmic-name={"num6"}
                                                      data-plasmic-override={
                                                        overrides.num6
                                                      }
                                                      className={classNames(
                                                        "all",
                                                        "__wab_text",
                                                        sty.num6
                                                      )}
                                                    >
                                                      {"3"}
                                                    </div>
                                                  </div>
                                                </div>
                                              </div>
                                            </div>
                                          ) : null}
                                          <div
                                            data-plasmic-name={"list6"}
                                            data-plasmic-override={
                                              overrides.list6
                                            }
                                            className={classNames(
                                              "all",
                                              sty.list6
                                            )}
                                          >
                                            <div
                                              data-plasmic-name={"item"}
                                              data-plasmic-override={
                                                overrides.item
                                              }
                                              className={classNames(
                                                "all",
                                                sty.item
                                              )}
                                            >
                                              <div
                                                data-plasmic-name={"icon"}
                                                data-plasmic-override={
                                                  overrides.icon
                                                }
                                                className={classNames(
                                                  "all",
                                                  sty.icon
                                                )}
                                              >
                                                <div
                                                  data-plasmic-name={"abbr"}
                                                  data-plasmic-override={
                                                    overrides.abbr
                                                  }
                                                  className={classNames(
                                                    "all",
                                                    "__wab_text",
                                                    sty.abbr
                                                  )}
                                                >
                                                  {"PC"}
                                                </div>
                                              </div>
                                              <div
                                                data-plasmic-name={"title25"}
                                                data-plasmic-override={
                                                  overrides.title25
                                                }
                                                className={classNames(
                                                  "all",
                                                  "__wab_text",
                                                  sty.title25
                                                )}
                                              >
                                                {
                                                  "Patient Care and Procedural Skills"
                                                }
                                              </div>
                                            </div>
                                            <div
                                              data-plasmic-name={"item2"}
                                              data-plasmic-override={
                                                overrides.item2
                                              }
                                              className={classNames(
                                                "all",
                                                sty.item2
                                              )}
                                            >
                                              <div
                                                data-plasmic-name={"icon2"}
                                                data-plasmic-override={
                                                  overrides.icon2
                                                }
                                                className={classNames(
                                                  "all",
                                                  sty.icon2
                                                )}
                                              >
                                                <div
                                                  data-plasmic-name={"abbr2"}
                                                  data-plasmic-override={
                                                    overrides.abbr2
                                                  }
                                                  className={classNames(
                                                    "all",
                                                    "__wab_text",
                                                    sty.abbr2
                                                  )}
                                                >
                                                  {"MK"}
                                                </div>
                                              </div>
                                              <div
                                                data-plasmic-name={"title3"}
                                                data-plasmic-override={
                                                  overrides.title3
                                                }
                                                className={classNames(
                                                  "all",
                                                  "__wab_text",
                                                  sty.title3
                                                )}
                                              >
                                                {"Medical Knowledge"}
                                              </div>
                                            </div>
                                            {false ? (
                                              <div
                                                data-plasmic-name={"item3"}
                                                data-plasmic-override={
                                                  overrides.item3
                                                }
                                                className={classNames(
                                                  "all",
                                                  sty.item3
                                                )}
                                              >
                                                <div
                                                  data-plasmic-name={"icon3"}
                                                  data-plasmic-override={
                                                    overrides.icon3
                                                  }
                                                  className={classNames(
                                                    "all",
                                                    sty.icon3
                                                  )}
                                                >
                                                  <div
                                                    data-plasmic-name={"abbr3"}
                                                    data-plasmic-override={
                                                      overrides.abbr3
                                                    }
                                                    className={classNames(
                                                      "all",
                                                      "__wab_text",
                                                      sty.abbr3
                                                    )}
                                                  >
                                                    {"SB"}
                                                  </div>
                                                </div>
                                                <div
                                                  data-plasmic-name={"title41"}
                                                  data-plasmic-override={
                                                    overrides.title41
                                                  }
                                                  className={classNames(
                                                    "all",
                                                    "__wab_text",
                                                    sty.title41
                                                  )}
                                                >
                                                  {"System Based Practices"}
                                                </div>
                                              </div>
                                            ) : null}
                                            {false ? (
                                              <div
                                                data-plasmic-name={"item4"}
                                                data-plasmic-override={
                                                  overrides.item4
                                                }
                                                className={classNames(
                                                  "all",
                                                  sty.item4
                                                )}
                                              >
                                                <div
                                                  data-plasmic-name={"icon4"}
                                                  data-plasmic-override={
                                                    overrides.icon4
                                                  }
                                                  className={classNames(
                                                    "all",
                                                    sty.icon4
                                                  )}
                                                >
                                                  <div
                                                    data-plasmic-name={"abbr4"}
                                                    data-plasmic-override={
                                                      overrides.abbr4
                                                    }
                                                    className={classNames(
                                                      "all",
                                                      "__wab_text",
                                                      sty.abbr4
                                                    )}
                                                  >
                                                    {"PB"}
                                                  </div>
                                                </div>
                                                <div
                                                  data-plasmic-name={"title43"}
                                                  data-plasmic-override={
                                                    overrides.title43
                                                  }
                                                  className={classNames(
                                                    "all",
                                                    "__wab_text",
                                                    sty.title43
                                                  )}
                                                >
                                                  {
                                                    "Practice-Based Learning and Imp."
                                                  }
                                                </div>
                                              </div>
                                            ) : null}
                                            {false ? (
                                              <div
                                                data-plasmic-name={"item5"}
                                                data-plasmic-override={
                                                  overrides.item5
                                                }
                                                className={classNames(
                                                  "all",
                                                  sty.item5
                                                )}
                                              >
                                                <div
                                                  data-plasmic-name={"icon5"}
                                                  data-plasmic-override={
                                                    overrides.icon5
                                                  }
                                                  className={classNames(
                                                    "all",
                                                    sty.icon5
                                                  )}
                                                >
                                                  <div
                                                    data-plasmic-name={"abbr5"}
                                                    data-plasmic-override={
                                                      overrides.abbr5
                                                    }
                                                    className={classNames(
                                                      "all",
                                                      "__wab_text",
                                                      sty.abbr5
                                                    )}
                                                  >
                                                    {"PB"}
                                                  </div>
                                                </div>
                                                <div
                                                  data-plasmic-name={"title6"}
                                                  data-plasmic-override={
                                                    overrides.title6
                                                  }
                                                  className={classNames(
                                                    "all",
                                                    "__wab_text",
                                                    sty.title6
                                                  )}
                                                >
                                                  {"Professionalism"}
                                                </div>
                                              </div>
                                            ) : null}
                                            {false ? (
                                              <div
                                                data-plasmic-name={"item6"}
                                                data-plasmic-override={
                                                  overrides.item6
                                                }
                                                className={classNames(
                                                  "all",
                                                  sty.item6
                                                )}
                                              >
                                                <div
                                                  data-plasmic-name={"icon6"}
                                                  data-plasmic-override={
                                                    overrides.icon6
                                                  }
                                                  className={classNames(
                                                    "all",
                                                    sty.icon6
                                                  )}
                                                >
                                                  <div
                                                    data-plasmic-name={"abbr6"}
                                                    data-plasmic-override={
                                                      overrides.abbr6
                                                    }
                                                    className={classNames(
                                                      "all",
                                                      "__wab_text",
                                                      sty.abbr6
                                                    )}
                                                  >
                                                    {"PB"}
                                                  </div>
                                                </div>
                                                <div
                                                  data-plasmic-name={"title7"}
                                                  data-plasmic-override={
                                                    overrides.title7
                                                  }
                                                  className={classNames(
                                                    "all",
                                                    "__wab_text",
                                                    sty.title7
                                                  )}
                                                >
                                                  {
                                                    "Interpersonal and Communication Skills"
                                                  }
                                                </div>
                                              </div>
                                            ) : null}
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                    <div
                                      data-plasmic-name={"shade"}
                                      data-plasmic-override={overrides.shade}
                                      className={classNames("all", sty.shade)}
                                    />
                                  </div>
                                  <div
                                    data-plasmic-name={"nav2"}
                                    data-plasmic-override={overrides.nav2}
                                    className={classNames("all", sty.nav2)}
                                  >
                                    <div
                                      data-plasmic-name={"btn"}
                                      data-plasmic-override={overrides.btn}
                                      className={classNames("all", sty.btn)}
                                    >
                                      <PlasmicImg__
                                        alt={""}
                                        className={classNames(sty.img__sm9BJ)}
                                        displayHeight={"12px"}
                                        displayMaxHeight={"none"}
                                        displayMaxWidth={"100%"}
                                        displayMinHeight={"0"}
                                        displayMinWidth={"0"}
                                        displayWidth={"12px"}
                                        loader={"plasmic"}
                                        loading={"lazy"}
                                        src={{
                                          src: "https://site-assets.plasmic.app/2f363906d01c06ca8cfba3301de14ab6.svg",
                                          fullWidth: 12,
                                          fullHeight: 12
                                        }}
                                      />

                                      {false ? (
                                        <div
                                          data-plasmic-name={"text55"}
                                          data-plasmic-override={
                                            overrides.text55
                                          }
                                          className={classNames(
                                            "all",
                                            "__wab_text",
                                            sty.text55
                                          )}
                                        >
                                          {"Label"}
                                        </div>
                                      ) : null}
                                      {(
                                        hasVariant(
                                          globalVariants,
                                          "mobile",
                                          "tabletPortrait"
                                        )
                                          ? true
                                          : false
                                      ) ? (
                                        <Icon84Icon
                                          className={classNames(
                                            "all",
                                            sty.svg__md0Sk
                                          )}
                                          role={"img"}
                                        />
                                      ) : null}
                                    </div>
                                    <div
                                      data-plasmic-name={"btn2"}
                                      data-plasmic-override={overrides.btn2}
                                      className={classNames("all", sty.btn2)}
                                    >
                                      <IconXSmall12Envelope2Icon
                                        className={classNames(
                                          "all",
                                          sty.svg__jsv2N
                                        )}
                                        role={"img"}
                                      />

                                      {false ? (
                                        <div
                                          data-plasmic-name={"text2"}
                                          data-plasmic-override={
                                            overrides.text2
                                          }
                                          className={classNames(
                                            "all",
                                            "__wab_text",
                                            sty.text2
                                          )}
                                        >
                                          {"Label"}
                                        </div>
                                      ) : null}
                                      {(
                                        hasVariant(
                                          globalVariants,
                                          "mobile",
                                          "tabletPortrait"
                                        )
                                          ? true
                                          : false
                                      ) ? (
                                        <Icon84Icon
                                          className={classNames(
                                            "all",
                                            sty.svg__vCm1M
                                          )}
                                          role={"img"}
                                        />
                                      ) : null}
                                    </div>
                                    {false ? (
                                      <div
                                        data-plasmic-name={"btn3"}
                                        data-plasmic-override={overrides.btn3}
                                        className={classNames("all", sty.btn3)}
                                      >
                                        {(
                                          hasVariant(
                                            globalVariants,
                                            "mobile",
                                            "tabletPortrait"
                                          )
                                            ? true
                                            : false
                                        ) ? (
                                          <Icon84Icon
                                            className={classNames(
                                              "all",
                                              sty.svg__zdyXw
                                            )}
                                            role={"img"}
                                          />
                                        ) : null}
                                        <div
                                          data-plasmic-name={"text3"}
                                          data-plasmic-override={
                                            overrides.text3
                                          }
                                          className={classNames(
                                            "all",
                                            "__wab_text",
                                            sty.text3
                                          )}
                                        >
                                          {"Security"}
                                        </div>
                                        {(
                                          hasVariant(
                                            globalVariants,
                                            "mobile",
                                            "tabletPortrait"
                                          )
                                            ? true
                                            : false
                                        ) ? (
                                          <Icon84Icon
                                            className={classNames(
                                              "all",
                                              sty.svg__cp4C2
                                            )}
                                            role={"img"}
                                          />
                                        ) : null}
                                      </div>
                                    ) : null}
                                    {false ? (
                                      <div
                                        data-plasmic-name={"btn4"}
                                        data-plasmic-override={overrides.btn4}
                                        className={classNames("all", sty.btn4)}
                                      >
                                        {(
                                          hasVariant(
                                            globalVariants,
                                            "mobile",
                                            "tabletPortrait"
                                          )
                                            ? true
                                            : false
                                        ) ? (
                                          <Icon84Icon
                                            className={classNames(
                                              "all",
                                              sty.svg__mqHf2
                                            )}
                                            role={"img"}
                                          />
                                        ) : null}
                                        <div
                                          data-plasmic-name={"text56"}
                                          data-plasmic-override={
                                            overrides.text56
                                          }
                                          className={classNames(
                                            "all",
                                            "__wab_text",
                                            sty.text56
                                          )}
                                        >
                                          {"Users"}
                                        </div>
                                        {(
                                          hasVariant(
                                            globalVariants,
                                            "mobile",
                                            "tabletPortrait"
                                          )
                                            ? true
                                            : false
                                        ) ? (
                                          <Icon84Icon
                                            className={classNames(
                                              "all",
                                              sty.svg__du5Zw
                                            )}
                                            role={"img"}
                                          />
                                        ) : null}
                                      </div>
                                    ) : null}
                                    <div
                                      data-plasmic-name={"mockupButtonBarItem"}
                                      data-plasmic-override={
                                        overrides.mockupButtonBarItem
                                      }
                                      className={classNames(
                                        "all",
                                        sty.mockupButtonBarItem
                                      )}
                                    >
                                      {(
                                        hasVariant(
                                          globalVariants,
                                          "mobile",
                                          "tabletPortrait"
                                        )
                                          ? true
                                          : false
                                      ) ? (
                                        <Icon84Icon
                                          className={classNames(
                                            "all",
                                            sty.svg__i8Pe
                                          )}
                                          role={"img"}
                                        />
                                      ) : null}
                                      <div
                                        data-plasmic-name={"text69"}
                                        data-plasmic-override={overrides.text69}
                                        className={classNames(
                                          "all",
                                          "__wab_text",
                                          sty.text69
                                        )}
                                      >
                                        {"Learning"}
                                      </div>
                                      {(
                                        hasVariant(
                                          globalVariants,
                                          "mobile",
                                          "tabletPortrait"
                                        )
                                          ? true
                                          : false
                                      ) ? (
                                        <Icon84Icon
                                          className={classNames(
                                            "all",
                                            sty.svg__g4Xni
                                          )}
                                          role={"img"}
                                        />
                                      ) : null}
                                    </div>
                                    <div
                                      data-plasmic-name={"btn5"}
                                      data-plasmic-override={overrides.btn5}
                                      className={classNames("all", sty.btn5)}
                                    >
                                      {(
                                        hasVariant(
                                          globalVariants,
                                          "mobile",
                                          "tabletPortrait"
                                        )
                                          ? true
                                          : false
                                      ) ? (
                                        <Icon84Icon
                                          className={classNames(
                                            "all",
                                            sty.svg___3U08K
                                          )}
                                          role={"img"}
                                        />
                                      ) : null}
                                      <div
                                        data-plasmic-name={"text6"}
                                        data-plasmic-override={overrides.text6}
                                        className={classNames(
                                          "all",
                                          "__wab_text",
                                          sty.text6
                                        )}
                                      >
                                        {"Procedures"}
                                      </div>
                                      {(
                                        hasVariant(
                                          globalVariants,
                                          "mobile",
                                          "tabletPortrait"
                                        )
                                          ? true
                                          : false
                                      ) ? (
                                        <Icon84Icon
                                          className={classNames(
                                            "all",
                                            sty.svg__o3TNd
                                          )}
                                          role={"img"}
                                        />
                                      ) : null}
                                    </div>
                                    <div
                                      data-plasmic-name={"btn6"}
                                      data-plasmic-override={overrides.btn6}
                                      className={classNames("all", sty.btn6)}
                                    >
                                      {(
                                        hasVariant(
                                          globalVariants,
                                          "mobile",
                                          "tabletPortrait"
                                        )
                                          ? true
                                          : false
                                      ) ? (
                                        <Icon84Icon
                                          className={classNames(
                                            "all",
                                            sty.svg__vvd5C
                                          )}
                                          role={"img"}
                                        />
                                      ) : null}
                                      <div
                                        data-plasmic-name={"text7"}
                                        data-plasmic-override={overrides.text7}
                                        className={classNames(
                                          "all",
                                          "__wab_text",
                                          sty.text7
                                        )}
                                      >
                                        {"Evaluations"}
                                      </div>
                                      {(
                                        hasVariant(
                                          globalVariants,
                                          "mobile",
                                          "tabletPortrait"
                                        )
                                          ? true
                                          : false
                                      ) ? (
                                        <Icon84Icon
                                          className={classNames(
                                            "all",
                                            sty.svg__u0Y6
                                          )}
                                          role={"img"}
                                        />
                                      ) : null}
                                    </div>
                                    <div
                                      data-plasmic-name={"btn7"}
                                      data-plasmic-override={overrides.btn7}
                                      className={classNames("all", sty.btn7)}
                                    >
                                      {(
                                        hasVariant(
                                          globalVariants,
                                          "mobile",
                                          "tabletPortrait"
                                        )
                                          ? true
                                          : false
                                      ) ? (
                                        <Icon84Icon
                                          className={classNames(
                                            "all",
                                            sty.svg__pf6WH
                                          )}
                                          role={"img"}
                                        />
                                      ) : null}
                                      <div
                                        data-plasmic-name={"text8"}
                                        data-plasmic-override={overrides.text8}
                                        className={classNames(
                                          "all",
                                          "__wab_text",
                                          sty.text8
                                        )}
                                      >
                                        {"Clinical Hours"}
                                      </div>
                                      {(
                                        hasVariant(
                                          globalVariants,
                                          "mobile",
                                          "tabletPortrait"
                                        )
                                          ? true
                                          : false
                                      ) ? (
                                        <Icon84Icon
                                          className={classNames(
                                            "all",
                                            sty.svg___6Ra0A
                                          )}
                                          role={"img"}
                                        />
                                      ) : null}
                                    </div>
                                    <div
                                      data-plasmic-name={"btn8"}
                                      data-plasmic-override={overrides.btn8}
                                      className={classNames("all", sty.btn8)}
                                    >
                                      {(
                                        hasVariant(
                                          globalVariants,
                                          "mobile",
                                          "tabletPortrait"
                                        )
                                          ? true
                                          : false
                                      ) ? (
                                        <Icon84Icon
                                          className={classNames(
                                            "all",
                                            sty.svg__mNfSc
                                          )}
                                          role={"img"}
                                        />
                                      ) : null}
                                      <div
                                        data-plasmic-name={"text9"}
                                        data-plasmic-override={overrides.text9}
                                        className={classNames(
                                          "all",
                                          "__wab_text",
                                          sty.text9
                                        )}
                                      >
                                        {"Reports"}
                                      </div>
                                      {(
                                        hasVariant(
                                          globalVariants,
                                          "mobile",
                                          "tabletPortrait"
                                        )
                                          ? true
                                          : false
                                      ) ? (
                                        <Icon84Icon
                                          className={classNames(
                                            "all",
                                            sty.svg__voThH
                                          )}
                                          role={"img"}
                                        />
                                      ) : null}
                                    </div>
                                    <div
                                      data-plasmic-name={"btn9"}
                                      data-plasmic-override={overrides.btn9}
                                      className={classNames("all", sty.btn9)}
                                    >
                                      {(
                                        hasVariant(
                                          globalVariants,
                                          "mobile",
                                          "tabletPortrait"
                                        )
                                          ? true
                                          : false
                                      ) ? (
                                        <Icon84Icon
                                          className={classNames(
                                            "all",
                                            sty.svg__qracf
                                          )}
                                          role={"img"}
                                        />
                                      ) : null}
                                      <div
                                        data-plasmic-name={"text10"}
                                        data-plasmic-override={overrides.text10}
                                        className={classNames(
                                          "all",
                                          "__wab_text",
                                          sty.text10
                                        )}
                                      >
                                        {"Settings"}
                                      </div>
                                      {(
                                        hasVariant(
                                          globalVariants,
                                          "mobile",
                                          "tabletPortrait"
                                        )
                                          ? true
                                          : false
                                      ) ? (
                                        <Icon84Icon
                                          className={classNames(
                                            "all",
                                            sty.svg__pwdeJ
                                          )}
                                          role={"img"}
                                        />
                                      ) : null}
                                    </div>
                                  </div>
                                  <div
                                    data-plasmic-name={"profile"}
                                    data-plasmic-override={overrides.profile}
                                    className={classNames("all", sty.profile)}
                                  >
                                    <div
                                      data-plasmic-name={"av"}
                                      data-plasmic-override={overrides.av}
                                      className={classNames("all", sty.av)}
                                    />

                                    <div
                                      data-plasmic-name={"col12"}
                                      data-plasmic-override={overrides.col12}
                                      className={classNames("all", sty.col12)}
                                    >
                                      <div
                                        data-plasmic-name={"top2"}
                                        data-plasmic-override={overrides.top2}
                                        className={classNames("all", sty.top2)}
                                      >
                                        <div
                                          data-plasmic-name={"header2"}
                                          data-plasmic-override={
                                            overrides.header2
                                          }
                                          className={classNames(
                                            "all",
                                            sty.header2
                                          )}
                                        >
                                          <div
                                            data-plasmic-name={"name"}
                                            data-plasmic-override={
                                              overrides.name
                                            }
                                            className={classNames(
                                              "all",
                                              "__wab_text",
                                              sty.name
                                            )}
                                          >
                                            {"Jody Gleason"}
                                          </div>
                                          <div
                                            data-plasmic-name={"status"}
                                            data-plasmic-override={
                                              overrides.status
                                            }
                                            className={classNames(
                                              "all",
                                              sty.status
                                            )}
                                          >
                                            {false ? (
                                              <div
                                                data-plasmic-name={"label"}
                                                data-plasmic-override={
                                                  overrides.label
                                                }
                                                className={classNames(
                                                  "all",
                                                  "__wab_text",
                                                  sty.label
                                                )}
                                              >
                                                {"Status"}
                                              </div>
                                            ) : null}
                                            <div
                                              data-plasmic-name={"line"}
                                              data-plasmic-override={
                                                overrides.line
                                              }
                                              className={classNames(
                                                "all",
                                                sty.line
                                              )}
                                            >
                                              <div
                                                data-plasmic-name={
                                                  "mockupTextPlaceholderContent"
                                                }
                                                data-plasmic-override={
                                                  overrides.mockupTextPlaceholderContent
                                                }
                                                className={classNames(
                                                  "all",
                                                  sty.mockupTextPlaceholderContent
                                                )}
                                              >
                                                <div
                                                  data-plasmic-name={
                                                    "placeholder2"
                                                  }
                                                  data-plasmic-override={
                                                    overrides.placeholder2
                                                  }
                                                  className={classNames(
                                                    "all",
                                                    sty.placeholder2
                                                  )}
                                                />
                                              </div>
                                            </div>
                                            <PlasmicImg__
                                              alt={""}
                                              className={classNames(
                                                sty.img__cmntZ
                                              )}
                                              displayHeight={"12px"}
                                              displayMaxHeight={"none"}
                                              displayMaxWidth={"100%"}
                                              displayMinHeight={"0"}
                                              displayMinWidth={"0"}
                                              displayWidth={"12px"}
                                              loader={"plasmic"}
                                              loading={"lazy"}
                                              src={{
                                                src: "https://site-assets.plasmic.app/fd8444da63470a9c723007422a038ef7.svg",
                                                fullWidth: 12,
                                                fullHeight: 12
                                              }}
                                            />
                                          </div>
                                        </div>
                                        <div
                                          data-plasmic-name={"body3"}
                                          data-plasmic-override={
                                            overrides.body3
                                          }
                                          className={classNames(
                                            "all",
                                            sty.body3
                                          )}
                                        >
                                          <div
                                            data-plasmic-name={"year"}
                                            data-plasmic-override={
                                              overrides.year
                                            }
                                            className={classNames(
                                              "all",
                                              "__wab_text",
                                              sty.year
                                            )}
                                          >
                                            {"PGY-3"}
                                          </div>
                                          {false ? (
                                            <div
                                              data-plasmic-name={"name2"}
                                              data-plasmic-override={
                                                overrides.name2
                                              }
                                              className={classNames(
                                                "all",
                                                "__wab_text",
                                                sty.name2
                                              )}
                                            >
                                              {"05/01/2022-10/31/2022"}
                                            </div>
                                          ) : null}
                                          <div
                                            data-plasmic-name={"line2"}
                                            data-plasmic-override={
                                              overrides.line2
                                            }
                                            className={classNames(
                                              "all",
                                              sty.line2
                                            )}
                                          >
                                            <div
                                              data-plasmic-name={
                                                "mockupTextPlaceholderContent2"
                                              }
                                              data-plasmic-override={
                                                overrides.mockupTextPlaceholderContent2
                                              }
                                              className={classNames(
                                                "all",
                                                sty.mockupTextPlaceholderContent2
                                              )}
                                            >
                                              <div
                                                data-plasmic-name={
                                                  "placeholder3"
                                                }
                                                data-plasmic-override={
                                                  overrides.placeholder3
                                                }
                                                className={classNames(
                                                  "all",
                                                  sty.placeholder3
                                                )}
                                              />
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                      <div
                                        data-plasmic-name={"actions"}
                                        data-plasmic-override={
                                          overrides.actions
                                        }
                                        className={classNames(
                                          "all",
                                          sty.actions
                                        )}
                                      >
                                        <div
                                          data-plasmic-name={"mockupButton"}
                                          data-plasmic-override={
                                            overrides.mockupButton
                                          }
                                          className={classNames(
                                            "all",
                                            sty.mockupButton
                                          )}
                                        >
                                          <div
                                            data-plasmic-name={"link"}
                                            data-plasmic-override={
                                              overrides.link
                                            }
                                            className={classNames(
                                              "all",
                                              "__wab_text",
                                              sty.link
                                            )}
                                          >
                                            {"Print"}
                                          </div>
                                        </div>
                                        <div
                                          data-plasmic-name={"mockupButton2"}
                                          data-plasmic-override={
                                            overrides.mockupButton2
                                          }
                                          className={classNames(
                                            "all",
                                            sty.mockupButton2
                                          )}
                                        >
                                          <div
                                            data-plasmic-name={"link2"}
                                            data-plasmic-override={
                                              overrides.link2
                                            }
                                            className={classNames(
                                              "all",
                                              "__wab_text",
                                              sty.link2
                                            )}
                                          >
                                            {"Save & Submit"}
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                                <div
                                  data-plasmic-name={"text11"}
                                  data-plasmic-override={overrides.text11}
                                  className={classNames("all", sty.text11)}
                                >
                                  <div
                                    data-plasmic-name={"title8"}
                                    data-plasmic-override={overrides.title8}
                                    className={classNames(
                                      "all",
                                      "__wab_text",
                                      sty.title8
                                    )}
                                  >
                                    {
                                      "One Platform for the Entire Educational Journey"
                                    }
                                  </div>
                                  <div
                                    data-plasmic-name={"desc13"}
                                    data-plasmic-override={overrides.desc13}
                                    className={classNames(
                                      "all",
                                      "__wab_text",
                                      sty.desc13
                                    )}
                                  >
                                    {
                                      "MyEvaluations unifies assessments, competency management, curriculum, scheduling, clinical hours, learner development, and institutional reporting within one comprehensive platform."
                                    }
                                  </div>
                                </div>
                              </div>
                              <div
                                className={classNames(
                                  "all",
                                  sty.freeBox___9NxSl
                                )}
                              >
                                <PlasmicImg__
                                  alt={""}
                                  className={classNames(sty.img__l2P1)}
                                  displayHeight={"auto"}
                                  displayMaxHeight={"none"}
                                  displayMaxWidth={"100%"}
                                  displayMinHeight={"0"}
                                  displayMinWidth={"0"}
                                  displayWidth={"auto"}
                                  loader={"plasmic"}
                                  loading={"lazy"}
                                  src={{
                                    src: "https://img.plasmic.app/img-optimizer/v1/img/f90046cc8a7e23ae8a36019c30eed15b.png",
                                    fullWidth: 326,
                                    fullHeight: 1804
                                  }}
                                />
                              </div>
                              <div
                                data-plasmic-name={"areas2"}
                                data-plasmic-override={overrides.areas2}
                                className={classNames("all", sty.areas2)}
                              >
                                <div
                                  data-plasmic-name={"header3"}
                                  data-plasmic-override={overrides.header3}
                                  className={classNames("all", sty.header3)}
                                >
                                  <div
                                    data-plasmic-name={"title49"}
                                    data-plasmic-override={overrides.title49}
                                    className={classNames(
                                      "all",
                                      "__wab_text",
                                      sty.title49
                                    )}
                                  >
                                    {
                                      "A Comprehensive Medical Education Platform"
                                    }
                                  </div>
                                  <div
                                    data-plasmic-name={"body2"}
                                    data-plasmic-override={overrides.body2}
                                    className={classNames(
                                      "all",
                                      "__wab_text",
                                      sty.body2
                                    )}
                                  >
                                    {
                                      "Built on a single integrated platform, MyEvaluations provides:"
                                    }
                                  </div>
                                </div>
                                <div
                                  data-plasmic-name={"frame23"}
                                  data-plasmic-override={overrides.frame23}
                                  className={classNames("all", sty.frame23)}
                                >
                                  <div
                                    data-plasmic-name={"item7"}
                                    data-plasmic-override={overrides.item7}
                                    className={classNames("all", sty.item7)}
                                  >
                                    <div
                                      data-plasmic-name={"title50"}
                                      data-plasmic-override={overrides.title50}
                                      className={classNames(
                                        "all",
                                        "__wab_text",
                                        sty.title50
                                      )}
                                    >
                                      {"Assessment & Competency Management"}
                                    </div>
                                    <div
                                      data-plasmic-name={"desc17"}
                                      data-plasmic-override={overrides.desc17}
                                      className={classNames(
                                        "all",
                                        "__wab_text",
                                        sty.desc17
                                      )}
                                    >
                                      {
                                        "Evaluations, Milestones, EPAs, SAGE\u2122, and Performance Improvement Plans."
                                      }
                                    </div>
                                  </div>
                                  <div
                                    data-plasmic-name={"item8"}
                                    data-plasmic-override={overrides.item8}
                                    className={classNames("all", sty.item8)}
                                  >
                                    <div
                                      data-plasmic-name={"title51"}
                                      data-plasmic-override={overrides.title51}
                                      className={classNames(
                                        "all",
                                        "__wab_text",
                                        sty.title51
                                      )}
                                    >
                                      {"Educational Operations"}
                                    </div>
                                    <div
                                      data-plasmic-name={"desc18"}
                                      data-plasmic-override={overrides.desc18}
                                      className={classNames(
                                        "all",
                                        "__wab_text",
                                        sty.desc18
                                      )}
                                    >
                                      {
                                        "Scheduling, Clinical Hours, Curriculum Management, Procedure & Patient Logs, and Return Demonstrations."
                                      }
                                    </div>
                                  </div>
                                  <div
                                    data-plasmic-name={"item9"}
                                    data-plasmic-override={overrides.item9}
                                    className={classNames("all", sty.item9)}
                                  >
                                    <div
                                      data-plasmic-name={"title52"}
                                      data-plasmic-override={overrides.title52}
                                      className={classNames(
                                        "all",
                                        "__wab_text",
                                        sty.title52
                                      )}
                                    >
                                      {"Learning & Development"}
                                    </div>
                                    <div
                                      data-plasmic-name={"desc19"}
                                      data-plasmic-override={overrides.desc19}
                                      className={classNames(
                                        "all",
                                        "__wab_text",
                                        sty.desc19
                                      )}
                                    >
                                      {
                                        "MyQuiz\u2122, Learning Assignments, and Clinical Learning Contracts."
                                      }
                                    </div>
                                  </div>
                                  <div
                                    data-plasmic-name={"item10"}
                                    data-plasmic-override={overrides.item10}
                                    className={classNames("all", sty.item10)}
                                  >
                                    <div
                                      data-plasmic-name={"title53"}
                                      data-plasmic-override={overrides.title53}
                                      className={classNames(
                                        "all",
                                        "__wab_text",
                                        sty.title53
                                      )}
                                    >
                                      {"Leadership & Analytics"}
                                    </div>
                                    <div
                                      data-plasmic-name={"desc20"}
                                      data-plasmic-override={overrides.desc20}
                                      className={classNames(
                                        "all",
                                        "__wab_text",
                                        sty.desc20
                                      )}
                                    >
                                      {
                                        "MyInsights\u00ae, accreditation support, administrative reporting, and Continuous Educational Improvement tools."
                                      }
                                    </div>
                                  </div>
                                  <div
                                    data-plasmic-name={"item11"}
                                    data-plasmic-override={overrides.item11}
                                    className={classNames("all", sty.item11)}
                                  >
                                    <div
                                      data-plasmic-name={"title54"}
                                      data-plasmic-override={overrides.title54}
                                      className={classNames(
                                        "all",
                                        "__wab_text",
                                        sty.title54
                                      )}
                                    >
                                      {"Continuing Education"}
                                    </div>
                                    <div
                                      data-plasmic-name={"desc21"}
                                      data-plasmic-override={overrides.desc21}
                                      className={classNames(
                                        "all",
                                        "__wab_text",
                                        sty.desc21
                                      )}
                                    >
                                      {
                                        "MyCME\u2122 for continuing medical education management, event planning, accreditation, and learner tracking."
                                      }
                                    </div>
                                  </div>
                                  <div
                                    data-plasmic-name={"item12"}
                                    data-plasmic-override={overrides.item12}
                                    className={classNames("all", sty.item12)}
                                  >
                                    <div
                                      data-plasmic-name={"title55"}
                                      data-plasmic-override={overrides.title55}
                                      className={classNames(
                                        "all",
                                        "__wab_text",
                                        sty.title55
                                      )}
                                    >
                                      {"Fiscal Management"}
                                    </div>
                                    <div
                                      data-plasmic-name={"desc10"}
                                      data-plasmic-override={overrides.desc10}
                                      className={classNames(
                                        "all",
                                        "__wab_text",
                                        sty.desc10
                                      )}
                                    >
                                      {
                                        "MyGME Fiscal\u2122 for IRIS reporting, invoicing, and cost reporting."
                                      }
                                    </div>
                                  </div>
                                </div>
                                <div
                                  data-plasmic-name={"footnote2"}
                                  data-plasmic-override={overrides.footnote2}
                                  className={classNames(
                                    "all",
                                    "__wab_text",
                                    sty.footnote2
                                  )}
                                >
                                  {
                                    "By connecting educational information across the learner journey, MyEvaluations strengthens educator judgment, reduces fragmented workflows, and provides the actionable insight needed to support better decisions at the program and institutional levels."
                                  }
                                </div>
                              </div>
                            </div>
                          </div>
                        </AntdTabItem>
                        <AntdTabItem
                          className={classNames(
                            "__wab_instance",
                            sty.tabItem__kFwp
                          )}
                          key={"2"}
                          label={
                            <PlasmicImg__
                              alt={""}
                              className={classNames(sty.img__el9VR)}
                              displayHeight={"auto"}
                              displayMaxHeight={"none"}
                              displayMaxWidth={"100%"}
                              displayMinHeight={"0"}
                              displayMinWidth={"0"}
                              displayWidth={"auto"}
                              loader={"plasmic"}
                              loading={"lazy"}
                              src={{
                                src: "https://img.plasmic.app/img-optimizer/v1/img/3884dd3a790e5b3cba8307c739629e6b.png",
                                fullWidth: 114,
                                fullHeight: 24
                              }}
                            />
                          }
                        >
                          <div
                            data-plasmic-name={"content5"}
                            data-plasmic-override={overrides.content5}
                            className={classNames("all", sty.content5)}
                          >
                            <div
                              data-plasmic-name={"placeholder56"}
                              data-plasmic-override={overrides.placeholder56}
                              className={classNames("all", sty.placeholder56)}
                            >
                              <div
                                data-plasmic-name={"intro6"}
                                data-plasmic-override={overrides.intro6}
                                className={classNames("all", sty.intro6)}
                              >
                                <div
                                  data-plasmic-name={"img6"}
                                  data-plasmic-override={overrides.img6}
                                  className={classNames("all", sty.img6)}
                                >
                                  <div
                                    data-plasmic-name={"bg5"}
                                    data-plasmic-override={overrides.bg5}
                                    className={classNames("all", sty.bg5)}
                                  >
                                    <div
                                      data-plasmic-name={"xmlid74572"}
                                      data-plasmic-override={
                                        overrides.xmlid74572
                                      }
                                      className={classNames(
                                        "all",
                                        sty.xmlid74572
                                      )}
                                    >
                                      <Xmlid6613Icon
                                        className={classNames(
                                          "all",
                                          sty.svg___9Tza
                                        )}
                                        role={"img"}
                                      />

                                      <div
                                        data-plasmic-name={"xmlid67762"}
                                        data-plasmic-override={
                                          overrides.xmlid67762
                                        }
                                        className={classNames(
                                          "all",
                                          sty.xmlid67762
                                        )}
                                      >
                                        {(
                                          hasVariant(
                                            globalVariants,
                                            "mobile",
                                            "tabletPortrait"
                                          )
                                            ? true
                                            : false
                                        ) ? (
                                          <Xmlid7308Icon
                                            className={classNames(
                                              "all",
                                              sty.svg__yhIt
                                            )}
                                            role={"img"}
                                          />
                                        ) : null}
                                      </div>
                                      <Xmlid6615Icon
                                        className={classNames(
                                          "all",
                                          sty.svg___8PhRi
                                        )}
                                        role={"img"}
                                      />

                                      <div
                                        data-plasmic-name={"xmlid74332"}
                                        data-plasmic-override={
                                          overrides.xmlid74332
                                        }
                                        className={classNames(
                                          "all",
                                          sty.xmlid74332
                                        )}
                                      >
                                        {(
                                          hasVariant(
                                            globalVariants,
                                            "mobile",
                                            "tabletPortrait"
                                          )
                                            ? true
                                            : false
                                        ) ? (
                                          <Xmlid7443Icon
                                            className={classNames(
                                              "all",
                                              sty.svg___8VDQs
                                            )}
                                            role={"img"}
                                          />
                                        ) : null}
                                      </div>
                                      <Xmlid6614Icon
                                        className={classNames(
                                          "all",
                                          sty.svg__rA1E
                                        )}
                                        role={"img"}
                                      />

                                      <div
                                        data-plasmic-name={"xmlid73392"}
                                        data-plasmic-override={
                                          overrides.xmlid73392
                                        }
                                        className={classNames(
                                          "all",
                                          sty.xmlid73392
                                        )}
                                      >
                                        {(
                                          hasVariant(
                                            globalVariants,
                                            "mobile",
                                            "tabletPortrait"
                                          )
                                            ? true
                                            : false
                                        ) ? (
                                          <Xmlid7347Icon
                                            className={classNames(
                                              "all",
                                              sty.svg___8Enn7
                                            )}
                                            role={"img"}
                                          />
                                        ) : null}
                                      </div>
                                      <Xmlid7207Icon
                                        className={classNames(
                                          "all",
                                          sty.svg__ryDl6
                                        )}
                                        role={"img"}
                                      />

                                      <Xmlid7207Icon
                                        className={classNames(
                                          "all",
                                          sty.svg__r4YMa
                                        )}
                                        role={"img"}
                                      />

                                      <Xmlid7207Icon
                                        className={classNames(
                                          "all",
                                          sty.svg__ciAvw
                                        )}
                                        role={"img"}
                                      />

                                      <Xmlid7207Icon
                                        className={classNames(
                                          "all",
                                          sty.svg___3WvA0
                                        )}
                                        role={"img"}
                                      />

                                      <Xmlid7207Icon
                                        className={classNames(
                                          "all",
                                          sty.svg__ctVuS
                                        )}
                                        role={"img"}
                                      />

                                      <Xmlid7207Icon
                                        className={classNames(
                                          "all",
                                          sty.svg__uPyvo
                                        )}
                                        role={"img"}
                                      />

                                      <Xmlid7207Icon
                                        className={classNames(
                                          "all",
                                          sty.svg__o5I8G
                                        )}
                                        role={"img"}
                                      />

                                      <Xmlid7207Icon
                                        className={classNames(
                                          "all",
                                          sty.svg__oyIf8
                                        )}
                                        role={"img"}
                                      />
                                    </div>
                                  </div>
                                  <div
                                    data-plasmic-name={"certificate2"}
                                    data-plasmic-override={
                                      overrides.certificate2
                                    }
                                    className={classNames(
                                      "all",
                                      sty.certificate2
                                    )}
                                  >
                                    <div
                                      data-plasmic-name={"top6"}
                                      data-plasmic-override={overrides.top6}
                                      className={classNames("all", sty.top6)}
                                    >
                                      <div
                                        data-plasmic-name={
                                          "mockupCertificateIcon2"
                                        }
                                        data-plasmic-override={
                                          overrides.mockupCertificateIcon2
                                        }
                                        className={classNames(
                                          "all",
                                          sty.mockupCertificateIcon2
                                        )}
                                      >
                                        <div
                                          data-plasmic-name={"bg6"}
                                          data-plasmic-override={overrides.bg6}
                                          className={classNames("all", sty.bg6)}
                                        />

                                        <div
                                          data-plasmic-name={"group2"}
                                          data-plasmic-override={
                                            overrides.group2
                                          }
                                          className={classNames(
                                            "all",
                                            sty.group2
                                          )}
                                        >
                                          <div
                                            data-plasmic-name={"paper3"}
                                            data-plasmic-override={
                                              overrides.paper3
                                            }
                                            className={classNames(
                                              "all",
                                              sty.paper3
                                            )}
                                          >
                                            <Group18Icon
                                              className={classNames(
                                                "all",
                                                sty.svg__w6J
                                              )}
                                              role={"img"}
                                            />
                                          </div>
                                          <div
                                            data-plasmic-name={"paper4"}
                                            data-plasmic-override={
                                              overrides.paper4
                                            }
                                            className={classNames(
                                              "all",
                                              sty.paper4
                                            )}
                                          >
                                            <Group19Icon
                                              className={classNames(
                                                "all",
                                                sty.svg__c6Nlg
                                              )}
                                              role={"img"}
                                            />
                                          </div>
                                          <div
                                            data-plasmic-name={"cert2"}
                                            data-plasmic-override={
                                              overrides.cert2
                                            }
                                            className={classNames(
                                              "all",
                                              sty.cert2
                                            )}
                                          >
                                            <Vector2Icon
                                              className={classNames(
                                                "all",
                                                sty.svg__v7Cy
                                              )}
                                              role={"img"}
                                            />

                                            <div
                                              data-plasmic-name={"award492"}
                                              data-plasmic-override={
                                                overrides.award492
                                              }
                                              className={classNames(
                                                "all",
                                                sty.award492
                                              )}
                                            >
                                              <PlasmicImg__
                                                alt={""}
                                                className={classNames(
                                                  sty.img__oe4Kd
                                                )}
                                                displayHeight={"20.125px"}
                                                displayMaxHeight={"none"}
                                                displayMaxWidth={"100%"}
                                                displayMinHeight={"0"}
                                                displayMinWidth={"0"}
                                                displayWidth={"20.125px"}
                                                loader={"plasmic"}
                                                loading={"lazy"}
                                                src={{
                                                  src: "https://site-assets.plasmic.app/ba6beef3dddb83407fe78b43dfeb77fe.svg",
                                                  fullWidth: 20.125,
                                                  fullHeight: 20.125
                                                }}
                                              />
                                            </div>
                                          </div>
                                        </div>
                                        <div
                                          data-plasmic-name={"overlay2"}
                                          data-plasmic-override={
                                            overrides.overlay2
                                          }
                                          className={classNames(
                                            "all",
                                            sty.overlay2
                                          )}
                                        />
                                      </div>
                                      <div
                                        data-plasmic-name={"title26"}
                                        data-plasmic-override={
                                          overrides.title26
                                        }
                                        className={classNames(
                                          "all",
                                          "__wab_text",
                                          sty.title26
                                        )}
                                      >
                                        {"Certificate"}
                                      </div>
                                      {false ? (
                                        <div
                                          data-plasmic-name={
                                            "mockupTextPlaceholder2"
                                          }
                                          data-plasmic-override={
                                            overrides.mockupTextPlaceholder2
                                          }
                                          className={classNames(
                                            "all",
                                            sty.mockupTextPlaceholder2
                                          )}
                                        >
                                          <div
                                            data-plasmic-name={
                                              "mockupTextPlaceholderParagraph7"
                                            }
                                            data-plasmic-override={
                                              overrides.mockupTextPlaceholderParagraph7
                                            }
                                            className={classNames(
                                              "all",
                                              sty.mockupTextPlaceholderParagraph7
                                            )}
                                          >
                                            <div
                                              data-plasmic-name={
                                                "mockupTextPlaceholderLine37"
                                              }
                                              data-plasmic-override={
                                                overrides.mockupTextPlaceholderLine37
                                              }
                                              className={classNames(
                                                "all",
                                                sty.mockupTextPlaceholderLine37
                                              )}
                                            >
                                              <div
                                                data-plasmic-name={
                                                  "mockupTextPlaceholderContent51"
                                                }
                                                data-plasmic-override={
                                                  overrides.mockupTextPlaceholderContent51
                                                }
                                                className={classNames(
                                                  "all",
                                                  sty.mockupTextPlaceholderContent51
                                                )}
                                              >
                                                <div
                                                  data-plasmic-name={
                                                    "placeholder57"
                                                  }
                                                  data-plasmic-override={
                                                    overrides.placeholder57
                                                  }
                                                  className={classNames(
                                                    "all",
                                                    sty.placeholder57
                                                  )}
                                                />
                                              </div>
                                            </div>
                                            <div
                                              data-plasmic-name={
                                                "mockupTextPlaceholderLine38"
                                              }
                                              data-plasmic-override={
                                                overrides.mockupTextPlaceholderLine38
                                              }
                                              className={classNames(
                                                "all",
                                                sty.mockupTextPlaceholderLine38
                                              )}
                                            >
                                              <div
                                                data-plasmic-name={
                                                  "mockupTextPlaceholderContent52"
                                                }
                                                data-plasmic-override={
                                                  overrides.mockupTextPlaceholderContent52
                                                }
                                                className={classNames(
                                                  "all",
                                                  sty.mockupTextPlaceholderContent52
                                                )}
                                              >
                                                <div
                                                  data-plasmic-name={
                                                    "placeholder58"
                                                  }
                                                  data-plasmic-override={
                                                    overrides.placeholder58
                                                  }
                                                  className={classNames(
                                                    "all",
                                                    sty.placeholder58
                                                  )}
                                                />
                                              </div>
                                            </div>
                                            <div
                                              data-plasmic-name={
                                                "mockupTextPlaceholderLine39"
                                              }
                                              data-plasmic-override={
                                                overrides.mockupTextPlaceholderLine39
                                              }
                                              className={classNames(
                                                "all",
                                                sty.mockupTextPlaceholderLine39
                                              )}
                                            >
                                              <div
                                                data-plasmic-name={
                                                  "mockupTextPlaceholderContent3"
                                                }
                                                data-plasmic-override={
                                                  overrides.mockupTextPlaceholderContent3
                                                }
                                                className={classNames(
                                                  "all",
                                                  sty.mockupTextPlaceholderContent3
                                                )}
                                              >
                                                <div
                                                  data-plasmic-name={
                                                    "placeholder4"
                                                  }
                                                  data-plasmic-override={
                                                    overrides.placeholder4
                                                  }
                                                  className={classNames(
                                                    "all",
                                                    sty.placeholder4
                                                  )}
                                                />
                                              </div>
                                            </div>
                                            <div
                                              data-plasmic-name={
                                                "mockupTextPlaceholderLine40"
                                              }
                                              data-plasmic-override={
                                                overrides.mockupTextPlaceholderLine40
                                              }
                                              className={classNames(
                                                "all",
                                                sty.mockupTextPlaceholderLine40
                                              )}
                                            >
                                              <div
                                                data-plasmic-name={
                                                  "mockupTextPlaceholderContent4"
                                                }
                                                data-plasmic-override={
                                                  overrides.mockupTextPlaceholderContent4
                                                }
                                                className={classNames(
                                                  "all",
                                                  sty.mockupTextPlaceholderContent4
                                                )}
                                              >
                                                <div
                                                  data-plasmic-name={
                                                    "placeholder5"
                                                  }
                                                  data-plasmic-override={
                                                    overrides.placeholder5
                                                  }
                                                  className={classNames(
                                                    "all",
                                                    sty.placeholder5
                                                  )}
                                                />
                                              </div>
                                            </div>
                                            {false ? (
                                              <div
                                                data-plasmic-name={
                                                  "mockupTextPlaceholderLine41"
                                                }
                                                data-plasmic-override={
                                                  overrides.mockupTextPlaceholderLine41
                                                }
                                                className={classNames(
                                                  "all",
                                                  sty.mockupTextPlaceholderLine41
                                                )}
                                              >
                                                <div
                                                  data-plasmic-name={
                                                    "mockupTextPlaceholderContent5"
                                                  }
                                                  data-plasmic-override={
                                                    overrides.mockupTextPlaceholderContent5
                                                  }
                                                  className={classNames(
                                                    "all",
                                                    sty.mockupTextPlaceholderContent5
                                                  )}
                                                >
                                                  <div
                                                    data-plasmic-name={
                                                      "placeholder6"
                                                    }
                                                    data-plasmic-override={
                                                      overrides.placeholder6
                                                    }
                                                    className={classNames(
                                                      "all",
                                                      sty.placeholder6
                                                    )}
                                                  />
                                                </div>
                                              </div>
                                            ) : null}
                                          </div>
                                          {false ? (
                                            <div
                                              data-plasmic-name={
                                                "mockupTextPlaceholderParagraph8"
                                              }
                                              data-plasmic-override={
                                                overrides.mockupTextPlaceholderParagraph8
                                              }
                                              className={classNames(
                                                "all",
                                                sty.mockupTextPlaceholderParagraph8
                                              )}
                                            >
                                              <div
                                                data-plasmic-name={
                                                  "mockupTextPlaceholderLine42"
                                                }
                                                data-plasmic-override={
                                                  overrides.mockupTextPlaceholderLine42
                                                }
                                                className={classNames(
                                                  "all",
                                                  sty.mockupTextPlaceholderLine42
                                                )}
                                              >
                                                <div
                                                  data-plasmic-name={
                                                    "mockupTextPlaceholderContent6"
                                                  }
                                                  data-plasmic-override={
                                                    overrides.mockupTextPlaceholderContent6
                                                  }
                                                  className={classNames(
                                                    "all",
                                                    sty.mockupTextPlaceholderContent6
                                                  )}
                                                >
                                                  <div
                                                    data-plasmic-name={
                                                      "placeholder7"
                                                    }
                                                    data-plasmic-override={
                                                      overrides.placeholder7
                                                    }
                                                    className={classNames(
                                                      "all",
                                                      sty.placeholder7
                                                    )}
                                                  />
                                                </div>
                                              </div>
                                              <div
                                                data-plasmic-name={
                                                  "mockupTextPlaceholderLine43"
                                                }
                                                data-plasmic-override={
                                                  overrides.mockupTextPlaceholderLine43
                                                }
                                                className={classNames(
                                                  "all",
                                                  sty.mockupTextPlaceholderLine43
                                                )}
                                              >
                                                <div
                                                  data-plasmic-name={
                                                    "mockupTextPlaceholderContent7"
                                                  }
                                                  data-plasmic-override={
                                                    overrides.mockupTextPlaceholderContent7
                                                  }
                                                  className={classNames(
                                                    "all",
                                                    sty.mockupTextPlaceholderContent7
                                                  )}
                                                >
                                                  <div
                                                    data-plasmic-name={
                                                      "placeholder8"
                                                    }
                                                    data-plasmic-override={
                                                      overrides.placeholder8
                                                    }
                                                    className={classNames(
                                                      "all",
                                                      sty.placeholder8
                                                    )}
                                                  />
                                                </div>
                                              </div>
                                              <div
                                                data-plasmic-name={
                                                  "mockupTextPlaceholderLine44"
                                                }
                                                data-plasmic-override={
                                                  overrides.mockupTextPlaceholderLine44
                                                }
                                                className={classNames(
                                                  "all",
                                                  sty.mockupTextPlaceholderLine44
                                                )}
                                              >
                                                <div
                                                  data-plasmic-name={
                                                    "mockupTextPlaceholderContent8"
                                                  }
                                                  data-plasmic-override={
                                                    overrides.mockupTextPlaceholderContent8
                                                  }
                                                  className={classNames(
                                                    "all",
                                                    sty.mockupTextPlaceholderContent8
                                                  )}
                                                >
                                                  <div
                                                    data-plasmic-name={
                                                      "placeholder9"
                                                    }
                                                    data-plasmic-override={
                                                      overrides.placeholder9
                                                    }
                                                    className={classNames(
                                                      "all",
                                                      sty.placeholder9
                                                    )}
                                                  />
                                                </div>
                                              </div>
                                              <div
                                                data-plasmic-name={
                                                  "mockupTextPlaceholderLine45"
                                                }
                                                data-plasmic-override={
                                                  overrides.mockupTextPlaceholderLine45
                                                }
                                                className={classNames(
                                                  "all",
                                                  sty.mockupTextPlaceholderLine45
                                                )}
                                              >
                                                <div
                                                  data-plasmic-name={
                                                    "mockupTextPlaceholderContent9"
                                                  }
                                                  data-plasmic-override={
                                                    overrides.mockupTextPlaceholderContent9
                                                  }
                                                  className={classNames(
                                                    "all",
                                                    sty.mockupTextPlaceholderContent9
                                                  )}
                                                >
                                                  <div
                                                    data-plasmic-name={
                                                      "placeholder10"
                                                    }
                                                    data-plasmic-override={
                                                      overrides.placeholder10
                                                    }
                                                    className={classNames(
                                                      "all",
                                                      sty.placeholder10
                                                    )}
                                                  />
                                                </div>
                                              </div>
                                              <div
                                                data-plasmic-name={
                                                  "mockupTextPlaceholderLine46"
                                                }
                                                data-plasmic-override={
                                                  overrides.mockupTextPlaceholderLine46
                                                }
                                                className={classNames(
                                                  "all",
                                                  sty.mockupTextPlaceholderLine46
                                                )}
                                              >
                                                <div
                                                  data-plasmic-name={
                                                    "mockupTextPlaceholderContent10"
                                                  }
                                                  data-plasmic-override={
                                                    overrides.mockupTextPlaceholderContent10
                                                  }
                                                  className={classNames(
                                                    "all",
                                                    sty.mockupTextPlaceholderContent10
                                                  )}
                                                >
                                                  <div
                                                    data-plasmic-name={
                                                      "placeholder11"
                                                    }
                                                    data-plasmic-override={
                                                      overrides.placeholder11
                                                    }
                                                    className={classNames(
                                                      "all",
                                                      sty.placeholder11
                                                    )}
                                                  />
                                                </div>
                                              </div>
                                              <div
                                                data-plasmic-name={
                                                  "mockupTextPlaceholderLine47"
                                                }
                                                data-plasmic-override={
                                                  overrides.mockupTextPlaceholderLine47
                                                }
                                                className={classNames(
                                                  "all",
                                                  sty.mockupTextPlaceholderLine47
                                                )}
                                              >
                                                <div
                                                  data-plasmic-name={
                                                    "mockupTextPlaceholderContent11"
                                                  }
                                                  data-plasmic-override={
                                                    overrides.mockupTextPlaceholderContent11
                                                  }
                                                  className={classNames(
                                                    "all",
                                                    sty.mockupTextPlaceholderContent11
                                                  )}
                                                >
                                                  <div
                                                    data-plasmic-name={
                                                      "placeholder12"
                                                    }
                                                    data-plasmic-override={
                                                      overrides.placeholder12
                                                    }
                                                    className={classNames(
                                                      "all",
                                                      sty.placeholder12
                                                    )}
                                                  />
                                                </div>
                                              </div>
                                              <div
                                                data-plasmic-name={
                                                  "mockupTextPlaceholderLine48"
                                                }
                                                data-plasmic-override={
                                                  overrides.mockupTextPlaceholderLine48
                                                }
                                                className={classNames(
                                                  "all",
                                                  sty.mockupTextPlaceholderLine48
                                                )}
                                              >
                                                <div
                                                  data-plasmic-name={
                                                    "mockupTextPlaceholderContent12"
                                                  }
                                                  data-plasmic-override={
                                                    overrides.mockupTextPlaceholderContent12
                                                  }
                                                  className={classNames(
                                                    "all",
                                                    sty.mockupTextPlaceholderContent12
                                                  )}
                                                >
                                                  <div
                                                    data-plasmic-name={
                                                      "placeholder13"
                                                    }
                                                    data-plasmic-override={
                                                      overrides.placeholder13
                                                    }
                                                    className={classNames(
                                                      "all",
                                                      sty.placeholder13
                                                    )}
                                                  />
                                                </div>
                                              </div>
                                              <div
                                                data-plasmic-name={
                                                  "mockupTextPlaceholderLine49"
                                                }
                                                data-plasmic-override={
                                                  overrides.mockupTextPlaceholderLine49
                                                }
                                                className={classNames(
                                                  "all",
                                                  sty.mockupTextPlaceholderLine49
                                                )}
                                              >
                                                <div
                                                  data-plasmic-name={
                                                    "mockupTextPlaceholderContent13"
                                                  }
                                                  data-plasmic-override={
                                                    overrides.mockupTextPlaceholderContent13
                                                  }
                                                  className={classNames(
                                                    "all",
                                                    sty.mockupTextPlaceholderContent13
                                                  )}
                                                >
                                                  <div
                                                    data-plasmic-name={
                                                      "placeholder14"
                                                    }
                                                    data-plasmic-override={
                                                      overrides.placeholder14
                                                    }
                                                    className={classNames(
                                                      "all",
                                                      sty.placeholder14
                                                    )}
                                                  />
                                                </div>
                                              </div>
                                            </div>
                                          ) : null}
                                          {false ? (
                                            <div
                                              data-plasmic-name={
                                                "mockupTextPlaceholderParagraph9"
                                              }
                                              data-plasmic-override={
                                                overrides.mockupTextPlaceholderParagraph9
                                              }
                                              className={classNames(
                                                "all",
                                                sty.mockupTextPlaceholderParagraph9
                                              )}
                                            >
                                              <div
                                                data-plasmic-name={
                                                  "mockupTextPlaceholderLine50"
                                                }
                                                data-plasmic-override={
                                                  overrides.mockupTextPlaceholderLine50
                                                }
                                                className={classNames(
                                                  "all",
                                                  sty.mockupTextPlaceholderLine50
                                                )}
                                              >
                                                <div
                                                  data-plasmic-name={
                                                    "mockupTextPlaceholderContent14"
                                                  }
                                                  data-plasmic-override={
                                                    overrides.mockupTextPlaceholderContent14
                                                  }
                                                  className={classNames(
                                                    "all",
                                                    sty.mockupTextPlaceholderContent14
                                                  )}
                                                >
                                                  <div
                                                    data-plasmic-name={
                                                      "placeholder15"
                                                    }
                                                    data-plasmic-override={
                                                      overrides.placeholder15
                                                    }
                                                    className={classNames(
                                                      "all",
                                                      sty.placeholder15
                                                    )}
                                                  />
                                                </div>
                                              </div>
                                              <div
                                                data-plasmic-name={
                                                  "mockupTextPlaceholderLine51"
                                                }
                                                data-plasmic-override={
                                                  overrides.mockupTextPlaceholderLine51
                                                }
                                                className={classNames(
                                                  "all",
                                                  sty.mockupTextPlaceholderLine51
                                                )}
                                              >
                                                <div
                                                  data-plasmic-name={
                                                    "mockupTextPlaceholderContent53"
                                                  }
                                                  data-plasmic-override={
                                                    overrides.mockupTextPlaceholderContent53
                                                  }
                                                  className={classNames(
                                                    "all",
                                                    sty.mockupTextPlaceholderContent53
                                                  )}
                                                >
                                                  <div
                                                    data-plasmic-name={
                                                      "placeholder59"
                                                    }
                                                    data-plasmic-override={
                                                      overrides.placeholder59
                                                    }
                                                    className={classNames(
                                                      "all",
                                                      sty.placeholder59
                                                    )}
                                                  />
                                                </div>
                                              </div>
                                              <div
                                                data-plasmic-name={
                                                  "mockupTextPlaceholderLine52"
                                                }
                                                data-plasmic-override={
                                                  overrides.mockupTextPlaceholderLine52
                                                }
                                                className={classNames(
                                                  "all",
                                                  sty.mockupTextPlaceholderLine52
                                                )}
                                              >
                                                <div
                                                  data-plasmic-name={
                                                    "mockupTextPlaceholderContent54"
                                                  }
                                                  data-plasmic-override={
                                                    overrides.mockupTextPlaceholderContent54
                                                  }
                                                  className={classNames(
                                                    "all",
                                                    sty.mockupTextPlaceholderContent54
                                                  )}
                                                >
                                                  <div
                                                    data-plasmic-name={
                                                      "placeholder60"
                                                    }
                                                    data-plasmic-override={
                                                      overrides.placeholder60
                                                    }
                                                    className={classNames(
                                                      "all",
                                                      sty.placeholder60
                                                    )}
                                                  />
                                                </div>
                                              </div>
                                              <div
                                                data-plasmic-name={
                                                  "mockupTextPlaceholderLine53"
                                                }
                                                data-plasmic-override={
                                                  overrides.mockupTextPlaceholderLine53
                                                }
                                                className={classNames(
                                                  "all",
                                                  sty.mockupTextPlaceholderLine53
                                                )}
                                              >
                                                <div
                                                  data-plasmic-name={
                                                    "mockupTextPlaceholderContent55"
                                                  }
                                                  data-plasmic-override={
                                                    overrides.mockupTextPlaceholderContent55
                                                  }
                                                  className={classNames(
                                                    "all",
                                                    sty.mockupTextPlaceholderContent55
                                                  )}
                                                >
                                                  <div
                                                    data-plasmic-name={
                                                      "placeholder61"
                                                    }
                                                    data-plasmic-override={
                                                      overrides.placeholder61
                                                    }
                                                    className={classNames(
                                                      "all",
                                                      sty.placeholder61
                                                    )}
                                                  />
                                                </div>
                                              </div>
                                              <div
                                                data-plasmic-name={
                                                  "mockupTextPlaceholderLine54"
                                                }
                                                data-plasmic-override={
                                                  overrides.mockupTextPlaceholderLine54
                                                }
                                                className={classNames(
                                                  "all",
                                                  sty.mockupTextPlaceholderLine54
                                                )}
                                              >
                                                <div
                                                  data-plasmic-name={
                                                    "mockupTextPlaceholderContent56"
                                                  }
                                                  data-plasmic-override={
                                                    overrides.mockupTextPlaceholderContent56
                                                  }
                                                  className={classNames(
                                                    "all",
                                                    sty.mockupTextPlaceholderContent56
                                                  )}
                                                >
                                                  <div
                                                    data-plasmic-name={
                                                      "placeholder62"
                                                    }
                                                    data-plasmic-override={
                                                      overrides.placeholder62
                                                    }
                                                    className={classNames(
                                                      "all",
                                                      sty.placeholder62
                                                    )}
                                                  />
                                                </div>
                                              </div>
                                            </div>
                                          ) : null}
                                          <div
                                            data-plasmic-name={
                                              "mockupTextPlaceholderParagraph10"
                                            }
                                            data-plasmic-override={
                                              overrides.mockupTextPlaceholderParagraph10
                                            }
                                            className={classNames(
                                              "all",
                                              sty.mockupTextPlaceholderParagraph10
                                            )}
                                          >
                                            <div
                                              data-plasmic-name={
                                                "mockupTextPlaceholderLine55"
                                              }
                                              data-plasmic-override={
                                                overrides.mockupTextPlaceholderLine55
                                              }
                                              className={classNames(
                                                "all",
                                                sty.mockupTextPlaceholderLine55
                                              )}
                                            >
                                              <div
                                                data-plasmic-name={
                                                  "mockupTextPlaceholderContent57"
                                                }
                                                data-plasmic-override={
                                                  overrides.mockupTextPlaceholderContent57
                                                }
                                                className={classNames(
                                                  "all",
                                                  sty.mockupTextPlaceholderContent57
                                                )}
                                              >
                                                <div
                                                  data-plasmic-name={
                                                    "placeholder63"
                                                  }
                                                  data-plasmic-override={
                                                    overrides.placeholder63
                                                  }
                                                  className={classNames(
                                                    "all",
                                                    sty.placeholder63
                                                  )}
                                                />
                                              </div>
                                            </div>
                                            {false ? (
                                              <div
                                                data-plasmic-name={
                                                  "mockupTextPlaceholderLine56"
                                                }
                                                data-plasmic-override={
                                                  overrides.mockupTextPlaceholderLine56
                                                }
                                                className={classNames(
                                                  "all",
                                                  sty.mockupTextPlaceholderLine56
                                                )}
                                              >
                                                <div
                                                  data-plasmic-name={
                                                    "mockupTextPlaceholderContent58"
                                                  }
                                                  data-plasmic-override={
                                                    overrides.mockupTextPlaceholderContent58
                                                  }
                                                  className={classNames(
                                                    "all",
                                                    sty.mockupTextPlaceholderContent58
                                                  )}
                                                >
                                                  <div
                                                    data-plasmic-name={
                                                      "placeholder64"
                                                    }
                                                    data-plasmic-override={
                                                      overrides.placeholder64
                                                    }
                                                    className={classNames(
                                                      "all",
                                                      sty.placeholder64
                                                    )}
                                                  />
                                                </div>
                                              </div>
                                            ) : null}
                                            <div
                                              data-plasmic-name={
                                                "mockupTextPlaceholderLine57"
                                              }
                                              data-plasmic-override={
                                                overrides.mockupTextPlaceholderLine57
                                              }
                                              className={classNames(
                                                "all",
                                                sty.mockupTextPlaceholderLine57
                                              )}
                                            >
                                              <div
                                                data-plasmic-name={
                                                  "mockupTextPlaceholderContent59"
                                                }
                                                data-plasmic-override={
                                                  overrides.mockupTextPlaceholderContent59
                                                }
                                                className={classNames(
                                                  "all",
                                                  sty.mockupTextPlaceholderContent59
                                                )}
                                              >
                                                <div
                                                  data-plasmic-name={
                                                    "placeholder65"
                                                  }
                                                  data-plasmic-override={
                                                    overrides.placeholder65
                                                  }
                                                  className={classNames(
                                                    "all",
                                                    sty.placeholder65
                                                  )}
                                                />
                                              </div>
                                            </div>
                                            {false ? (
                                              <div
                                                data-plasmic-name={
                                                  "mockupTextPlaceholderLine58"
                                                }
                                                data-plasmic-override={
                                                  overrides.mockupTextPlaceholderLine58
                                                }
                                                className={classNames(
                                                  "all",
                                                  sty.mockupTextPlaceholderLine58
                                                )}
                                              >
                                                <div
                                                  data-plasmic-name={
                                                    "mockupTextPlaceholderContent60"
                                                  }
                                                  data-plasmic-override={
                                                    overrides.mockupTextPlaceholderContent60
                                                  }
                                                  className={classNames(
                                                    "all",
                                                    sty.mockupTextPlaceholderContent60
                                                  )}
                                                >
                                                  <div
                                                    data-plasmic-name={
                                                      "placeholder66"
                                                    }
                                                    data-plasmic-override={
                                                      overrides.placeholder66
                                                    }
                                                    className={classNames(
                                                      "all",
                                                      sty.placeholder66
                                                    )}
                                                  />
                                                </div>
                                              </div>
                                            ) : null}
                                            {false ? (
                                              <div
                                                data-plasmic-name={
                                                  "mockupTextPlaceholderLine59"
                                                }
                                                data-plasmic-override={
                                                  overrides.mockupTextPlaceholderLine59
                                                }
                                                className={classNames(
                                                  "all",
                                                  sty.mockupTextPlaceholderLine59
                                                )}
                                              >
                                                <div
                                                  data-plasmic-name={
                                                    "mockupTextPlaceholderContent61"
                                                  }
                                                  data-plasmic-override={
                                                    overrides.mockupTextPlaceholderContent61
                                                  }
                                                  className={classNames(
                                                    "all",
                                                    sty.mockupTextPlaceholderContent61
                                                  )}
                                                >
                                                  <div
                                                    data-plasmic-name={
                                                      "placeholder67"
                                                    }
                                                    data-plasmic-override={
                                                      overrides.placeholder67
                                                    }
                                                    className={classNames(
                                                      "all",
                                                      sty.placeholder67
                                                    )}
                                                  />
                                                </div>
                                              </div>
                                            ) : null}
                                            {false ? (
                                              <div
                                                data-plasmic-name={
                                                  "mockupTextPlaceholderLine60"
                                                }
                                                data-plasmic-override={
                                                  overrides.mockupTextPlaceholderLine60
                                                }
                                                className={classNames(
                                                  "all",
                                                  sty.mockupTextPlaceholderLine60
                                                )}
                                              >
                                                <div
                                                  data-plasmic-name={
                                                    "mockupTextPlaceholderContent62"
                                                  }
                                                  data-plasmic-override={
                                                    overrides.mockupTextPlaceholderContent62
                                                  }
                                                  className={classNames(
                                                    "all",
                                                    sty.mockupTextPlaceholderContent62
                                                  )}
                                                >
                                                  <div
                                                    data-plasmic-name={
                                                      "placeholder68"
                                                    }
                                                    data-plasmic-override={
                                                      overrides.placeholder68
                                                    }
                                                    className={classNames(
                                                      "all",
                                                      sty.placeholder68
                                                    )}
                                                  />
                                                </div>
                                              </div>
                                            ) : null}
                                            {false ? (
                                              <div
                                                data-plasmic-name={
                                                  "mockupTextPlaceholderLine61"
                                                }
                                                data-plasmic-override={
                                                  overrides.mockupTextPlaceholderLine61
                                                }
                                                className={classNames(
                                                  "all",
                                                  sty.mockupTextPlaceholderLine61
                                                )}
                                              >
                                                <div
                                                  data-plasmic-name={
                                                    "mockupTextPlaceholderContent63"
                                                  }
                                                  data-plasmic-override={
                                                    overrides.mockupTextPlaceholderContent63
                                                  }
                                                  className={classNames(
                                                    "all",
                                                    sty.mockupTextPlaceholderContent63
                                                  )}
                                                >
                                                  <div
                                                    data-plasmic-name={
                                                      "placeholder69"
                                                    }
                                                    data-plasmic-override={
                                                      overrides.placeholder69
                                                    }
                                                    className={classNames(
                                                      "all",
                                                      sty.placeholder69
                                                    )}
                                                  />
                                                </div>
                                              </div>
                                            ) : null}
                                            <div
                                              data-plasmic-name={
                                                "mockupTextPlaceholderLine62"
                                              }
                                              data-plasmic-override={
                                                overrides.mockupTextPlaceholderLine62
                                              }
                                              className={classNames(
                                                "all",
                                                sty.mockupTextPlaceholderLine62
                                              )}
                                            >
                                              <div
                                                data-plasmic-name={
                                                  "mockupTextPlaceholderContent64"
                                                }
                                                data-plasmic-override={
                                                  overrides.mockupTextPlaceholderContent64
                                                }
                                                className={classNames(
                                                  "all",
                                                  sty.mockupTextPlaceholderContent64
                                                )}
                                              >
                                                <div
                                                  data-plasmic-name={
                                                    "placeholder70"
                                                  }
                                                  data-plasmic-override={
                                                    overrides.placeholder70
                                                  }
                                                  className={classNames(
                                                    "all",
                                                    sty.placeholder70
                                                  )}
                                                />
                                              </div>
                                            </div>
                                          </div>
                                        </div>
                                      ) : null}
                                    </div>
                                    <div
                                      data-plasmic-name={"mockupButton3"}
                                      data-plasmic-override={
                                        overrides.mockupButton3
                                      }
                                      className={classNames(
                                        "all",
                                        sty.mockupButton3
                                      )}
                                    >
                                      <div
                                        data-plasmic-name={"link3"}
                                        data-plasmic-override={overrides.link3}
                                        className={classNames(
                                          "all",
                                          "__wab_text",
                                          sty.link3
                                        )}
                                      >
                                        {"Generate"}
                                      </div>
                                    </div>
                                  </div>
                                  <div
                                    data-plasmic-name={"bill3"}
                                    data-plasmic-override={overrides.bill3}
                                    className={classNames("all", sty.bill3)}
                                  >
                                    <div
                                      data-plasmic-name={"bill2"}
                                      data-plasmic-override={overrides.bill2}
                                      className={classNames("all", sty.bill2)}
                                    >
                                      <div
                                        data-plasmic-name={"header4"}
                                        data-plasmic-override={
                                          overrides.header4
                                        }
                                        className={classNames(
                                          "all",
                                          sty.header4
                                        )}
                                      >
                                        {false ? (
                                          <div
                                            data-plasmic-name={"subtitle6"}
                                            data-plasmic-override={
                                              overrides.subtitle6
                                            }
                                            className={classNames(
                                              "all",
                                              "__wab_text",
                                              sty.subtitle6
                                            )}
                                          >
                                            {"Event"}
                                          </div>
                                        ) : null}
                                        <div
                                          data-plasmic-name={"title35"}
                                          data-plasmic-override={
                                            overrides.title35
                                          }
                                          className={classNames(
                                            "all",
                                            "__wab_text",
                                            sty.title35
                                          )}
                                        >
                                          {"Financial Report"}
                                        </div>
                                      </div>
                                      <div
                                        data-plasmic-name={"main2"}
                                        data-plasmic-override={overrides.main2}
                                        className={classNames("all", sty.main2)}
                                      >
                                        <div
                                          data-plasmic-name={"placeholder71"}
                                          data-plasmic-override={
                                            overrides.placeholder71
                                          }
                                          className={classNames(
                                            "all",
                                            sty.placeholder71
                                          )}
                                        >
                                          {false ? (
                                            <div
                                              data-plasmic-name={"header5"}
                                              data-plasmic-override={
                                                overrides.header5
                                              }
                                              className={classNames(
                                                "all",
                                                sty.header5
                                              )}
                                            >
                                              <div
                                                data-plasmic-name={"title36"}
                                                data-plasmic-override={
                                                  overrides.title36
                                                }
                                                className={classNames(
                                                  "all",
                                                  "__wab_text",
                                                  sty.title36
                                                )}
                                              >
                                                {
                                                  "Trends in Neurology: Bridging Research to Clinical Practice"
                                                }
                                              </div>
                                              <div
                                                data-plasmic-name={"date2"}
                                                data-plasmic-override={
                                                  overrides.date2
                                                }
                                                className={classNames(
                                                  "all",
                                                  "__wab_text",
                                                  sty.date2
                                                )}
                                              >
                                                {"17 Mar 2024\u201319 Mar 2024"}
                                              </div>
                                            </div>
                                          ) : null}
                                          <div
                                            data-plasmic-name={"section3"}
                                            data-plasmic-override={
                                              overrides.section3
                                            }
                                            className={classNames(
                                              "all",
                                              sty.section3
                                            )}
                                          >
                                            <div
                                              data-plasmic-name={"head3"}
                                              data-plasmic-override={
                                                overrides.head3
                                              }
                                              className={classNames(
                                                "all",
                                                "__wab_text",
                                                sty.head3
                                              )}
                                            >
                                              {"Income"}
                                            </div>
                                            <div
                                              data-plasmic-name={
                                                "mockupTextPlaceholderParagraph11"
                                              }
                                              data-plasmic-override={
                                                overrides.mockupTextPlaceholderParagraph11
                                              }
                                              className={classNames(
                                                "all",
                                                sty.mockupTextPlaceholderParagraph11
                                              )}
                                            >
                                              <div
                                                data-plasmic-name={
                                                  "mockupTextPlaceholderLine63"
                                                }
                                                data-plasmic-override={
                                                  overrides.mockupTextPlaceholderLine63
                                                }
                                                className={classNames(
                                                  "all",
                                                  sty.mockupTextPlaceholderLine63
                                                )}
                                              >
                                                <div
                                                  data-plasmic-name={
                                                    "mockupTextPlaceholderContent65"
                                                  }
                                                  data-plasmic-override={
                                                    overrides.mockupTextPlaceholderContent65
                                                  }
                                                  className={classNames(
                                                    "all",
                                                    sty.mockupTextPlaceholderContent65
                                                  )}
                                                >
                                                  <div
                                                    data-plasmic-name={
                                                      "placeholder72"
                                                    }
                                                    data-plasmic-override={
                                                      overrides.placeholder72
                                                    }
                                                    className={classNames(
                                                      "all",
                                                      sty.placeholder72
                                                    )}
                                                  />
                                                </div>
                                              </div>
                                              {false ? (
                                                <div
                                                  data-plasmic-name={
                                                    "mockupTextPlaceholderLine64"
                                                  }
                                                  data-plasmic-override={
                                                    overrides.mockupTextPlaceholderLine64
                                                  }
                                                  className={classNames(
                                                    "all",
                                                    sty.mockupTextPlaceholderLine64
                                                  )}
                                                >
                                                  <div
                                                    data-plasmic-name={
                                                      "mockupTextPlaceholderContent66"
                                                    }
                                                    data-plasmic-override={
                                                      overrides.mockupTextPlaceholderContent66
                                                    }
                                                    className={classNames(
                                                      "all",
                                                      sty.mockupTextPlaceholderContent66
                                                    )}
                                                  >
                                                    <div
                                                      data-plasmic-name={
                                                        "placeholder73"
                                                      }
                                                      data-plasmic-override={
                                                        overrides.placeholder73
                                                      }
                                                      className={classNames(
                                                        "all",
                                                        sty.placeholder73
                                                      )}
                                                    />
                                                  </div>
                                                </div>
                                              ) : null}
                                              {false ? (
                                                <div
                                                  data-plasmic-name={
                                                    "mockupTextPlaceholderLine65"
                                                  }
                                                  data-plasmic-override={
                                                    overrides.mockupTextPlaceholderLine65
                                                  }
                                                  className={classNames(
                                                    "all",
                                                    sty.mockupTextPlaceholderLine65
                                                  )}
                                                >
                                                  <div
                                                    data-plasmic-name={
                                                      "mockupTextPlaceholderContent67"
                                                    }
                                                    data-plasmic-override={
                                                      overrides.mockupTextPlaceholderContent67
                                                    }
                                                    className={classNames(
                                                      "all",
                                                      sty.mockupTextPlaceholderContent67
                                                    )}
                                                  >
                                                    <div
                                                      data-plasmic-name={
                                                        "placeholder74"
                                                      }
                                                      data-plasmic-override={
                                                        overrides.placeholder74
                                                      }
                                                      className={classNames(
                                                        "all",
                                                        sty.placeholder74
                                                      )}
                                                    />
                                                  </div>
                                                </div>
                                              ) : null}
                                              <div
                                                data-plasmic-name={
                                                  "mockupTextPlaceholderLine66"
                                                }
                                                data-plasmic-override={
                                                  overrides.mockupTextPlaceholderLine66
                                                }
                                                className={classNames(
                                                  "all",
                                                  sty.mockupTextPlaceholderLine66
                                                )}
                                              >
                                                <div
                                                  data-plasmic-name={
                                                    "mockupTextPlaceholderContent68"
                                                  }
                                                  data-plasmic-override={
                                                    overrides.mockupTextPlaceholderContent68
                                                  }
                                                  className={classNames(
                                                    "all",
                                                    sty.mockupTextPlaceholderContent68
                                                  )}
                                                >
                                                  <div
                                                    data-plasmic-name={
                                                      "placeholder75"
                                                    }
                                                    data-plasmic-override={
                                                      overrides.placeholder75
                                                    }
                                                    className={classNames(
                                                      "all",
                                                      sty.placeholder75
                                                    )}
                                                  />
                                                </div>
                                              </div>
                                              <div
                                                data-plasmic-name={
                                                  "mockupTextPlaceholderLine67"
                                                }
                                                data-plasmic-override={
                                                  overrides.mockupTextPlaceholderLine67
                                                }
                                                className={classNames(
                                                  "all",
                                                  sty.mockupTextPlaceholderLine67
                                                )}
                                              >
                                                <div
                                                  data-plasmic-name={
                                                    "mockupTextPlaceholderContent69"
                                                  }
                                                  data-plasmic-override={
                                                    overrides.mockupTextPlaceholderContent69
                                                  }
                                                  className={classNames(
                                                    "all",
                                                    sty.mockupTextPlaceholderContent69
                                                  )}
                                                >
                                                  <div
                                                    data-plasmic-name={
                                                      "placeholder76"
                                                    }
                                                    data-plasmic-override={
                                                      overrides.placeholder76
                                                    }
                                                    className={classNames(
                                                      "all",
                                                      sty.placeholder76
                                                    )}
                                                  />
                                                </div>
                                              </div>
                                            </div>
                                            <div
                                              data-plasmic-name={"total3"}
                                              data-plasmic-override={
                                                overrides.total3
                                              }
                                              className={classNames(
                                                "all",
                                                sty.total3
                                              )}
                                            >
                                              <div
                                                data-plasmic-name={"title37"}
                                                data-plasmic-override={
                                                  overrides.title37
                                                }
                                                className={classNames(
                                                  "all",
                                                  "__wab_text",
                                                  sty.title37
                                                )}
                                              >
                                                {"Total"}
                                              </div>
                                              <div
                                                data-plasmic-name={"val8"}
                                                data-plasmic-override={
                                                  overrides.val8
                                                }
                                                className={classNames(
                                                  "all",
                                                  "__wab_text",
                                                  sty.val8
                                                )}
                                              >
                                                {"$18,975"}
                                              </div>
                                            </div>
                                          </div>
                                          {false ? (
                                            <div
                                              data-plasmic-name={"section4"}
                                              data-plasmic-override={
                                                overrides.section4
                                              }
                                              className={classNames(
                                                "all",
                                                sty.section4
                                              )}
                                            >
                                              <div
                                                data-plasmic-name={"head4"}
                                                data-plasmic-override={
                                                  overrides.head4
                                                }
                                                className={classNames(
                                                  "all",
                                                  "__wab_text",
                                                  sty.head4
                                                )}
                                              >
                                                {"Expenses"}
                                              </div>
                                              <div
                                                data-plasmic-name={
                                                  "mockupTextPlaceholderParagraph12"
                                                }
                                                data-plasmic-override={
                                                  overrides.mockupTextPlaceholderParagraph12
                                                }
                                                className={classNames(
                                                  "all",
                                                  sty.mockupTextPlaceholderParagraph12
                                                )}
                                              >
                                                {false ? (
                                                  <div
                                                    data-plasmic-name={
                                                      "mockupTextPlaceholderLine68"
                                                    }
                                                    data-plasmic-override={
                                                      overrides.mockupTextPlaceholderLine68
                                                    }
                                                    className={classNames(
                                                      "all",
                                                      sty.mockupTextPlaceholderLine68
                                                    )}
                                                  >
                                                    <div
                                                      data-plasmic-name={
                                                        "mockupTextPlaceholderContent70"
                                                      }
                                                      data-plasmic-override={
                                                        overrides.mockupTextPlaceholderContent70
                                                      }
                                                      className={classNames(
                                                        "all",
                                                        sty.mockupTextPlaceholderContent70
                                                      )}
                                                    >
                                                      <div
                                                        data-plasmic-name={
                                                          "placeholder77"
                                                        }
                                                        data-plasmic-override={
                                                          overrides.placeholder77
                                                        }
                                                        className={classNames(
                                                          "all",
                                                          sty.placeholder77
                                                        )}
                                                      />
                                                    </div>
                                                  </div>
                                                ) : null}
                                                {false ? (
                                                  <div
                                                    data-plasmic-name={
                                                      "mockupTextPlaceholderLine69"
                                                    }
                                                    data-plasmic-override={
                                                      overrides.mockupTextPlaceholderLine69
                                                    }
                                                    className={classNames(
                                                      "all",
                                                      sty.mockupTextPlaceholderLine69
                                                    )}
                                                  >
                                                    <div
                                                      data-plasmic-name={
                                                        "mockupTextPlaceholderContent71"
                                                      }
                                                      data-plasmic-override={
                                                        overrides.mockupTextPlaceholderContent71
                                                      }
                                                      className={classNames(
                                                        "all",
                                                        sty.mockupTextPlaceholderContent71
                                                      )}
                                                    >
                                                      <div
                                                        data-plasmic-name={
                                                          "placeholder78"
                                                        }
                                                        data-plasmic-override={
                                                          overrides.placeholder78
                                                        }
                                                        className={classNames(
                                                          "all",
                                                          sty.placeholder78
                                                        )}
                                                      />
                                                    </div>
                                                  </div>
                                                ) : null}
                                                <div
                                                  data-plasmic-name={
                                                    "mockupTextPlaceholderLine70"
                                                  }
                                                  data-plasmic-override={
                                                    overrides.mockupTextPlaceholderLine70
                                                  }
                                                  className={classNames(
                                                    "all",
                                                    sty.mockupTextPlaceholderLine70
                                                  )}
                                                >
                                                  <div
                                                    data-plasmic-name={
                                                      "mockupTextPlaceholderContent72"
                                                    }
                                                    data-plasmic-override={
                                                      overrides.mockupTextPlaceholderContent72
                                                    }
                                                    className={classNames(
                                                      "all",
                                                      sty.mockupTextPlaceholderContent72
                                                    )}
                                                  >
                                                    <div
                                                      data-plasmic-name={
                                                        "placeholder79"
                                                      }
                                                      data-plasmic-override={
                                                        overrides.placeholder79
                                                      }
                                                      className={classNames(
                                                        "all",
                                                        sty.placeholder79
                                                      )}
                                                    />
                                                  </div>
                                                </div>
                                                <div
                                                  data-plasmic-name={
                                                    "mockupTextPlaceholderLine71"
                                                  }
                                                  data-plasmic-override={
                                                    overrides.mockupTextPlaceholderLine71
                                                  }
                                                  className={classNames(
                                                    "all",
                                                    sty.mockupTextPlaceholderLine71
                                                  )}
                                                >
                                                  <div
                                                    data-plasmic-name={
                                                      "mockupTextPlaceholderContent73"
                                                    }
                                                    data-plasmic-override={
                                                      overrides.mockupTextPlaceholderContent73
                                                    }
                                                    className={classNames(
                                                      "all",
                                                      sty.mockupTextPlaceholderContent73
                                                    )}
                                                  >
                                                    <div
                                                      data-plasmic-name={
                                                        "placeholder80"
                                                      }
                                                      data-plasmic-override={
                                                        overrides.placeholder80
                                                      }
                                                      className={classNames(
                                                        "all",
                                                        sty.placeholder80
                                                      )}
                                                    />
                                                  </div>
                                                </div>
                                                {false ? (
                                                  <div
                                                    data-plasmic-name={
                                                      "mockupTextPlaceholderLine72"
                                                    }
                                                    data-plasmic-override={
                                                      overrides.mockupTextPlaceholderLine72
                                                    }
                                                    className={classNames(
                                                      "all",
                                                      sty.mockupTextPlaceholderLine72
                                                    )}
                                                  >
                                                    <div
                                                      data-plasmic-name={
                                                        "mockupTextPlaceholderContent74"
                                                      }
                                                      data-plasmic-override={
                                                        overrides.mockupTextPlaceholderContent74
                                                      }
                                                      className={classNames(
                                                        "all",
                                                        sty.mockupTextPlaceholderContent74
                                                      )}
                                                    >
                                                      <div
                                                        data-plasmic-name={
                                                          "placeholder81"
                                                        }
                                                        data-plasmic-override={
                                                          overrides.placeholder81
                                                        }
                                                        className={classNames(
                                                          "all",
                                                          sty.placeholder81
                                                        )}
                                                      />
                                                    </div>
                                                  </div>
                                                ) : null}
                                              </div>
                                              <div
                                                data-plasmic-name={"total4"}
                                                data-plasmic-override={
                                                  overrides.total4
                                                }
                                                className={classNames(
                                                  "all",
                                                  sty.total4
                                                )}
                                              >
                                                <div
                                                  data-plasmic-name={"title38"}
                                                  data-plasmic-override={
                                                    overrides.title38
                                                  }
                                                  className={classNames(
                                                    "all",
                                                    "__wab_text",
                                                    sty.title38
                                                  )}
                                                >
                                                  {"Total"}
                                                </div>
                                                <div
                                                  data-plasmic-name={"val9"}
                                                  data-plasmic-override={
                                                    overrides.val9
                                                  }
                                                  className={classNames(
                                                    "all",
                                                    "__wab_text",
                                                    sty.val9
                                                  )}
                                                >
                                                  {"$3,021"}
                                                </div>
                                              </div>
                                            </div>
                                          ) : null}
                                        </div>
                                      </div>
                                      <div
                                        data-plasmic-name={"edge2"}
                                        data-plasmic-override={overrides.edge2}
                                        className={classNames("all", sty.edge2)}
                                      >
                                        <div
                                          data-plasmic-name={"tri33"}
                                          data-plasmic-override={
                                            overrides.tri33
                                          }
                                          className={classNames(
                                            "all",
                                            sty.tri33
                                          )}
                                        >
                                          <div
                                            data-plasmic-name={"rect33"}
                                            data-plasmic-override={
                                              overrides.rect33
                                            }
                                            className={classNames(
                                              "all",
                                              sty.rect33
                                            )}
                                          />
                                        </div>
                                        <div
                                          data-plasmic-name={"tri34"}
                                          data-plasmic-override={
                                            overrides.tri34
                                          }
                                          className={classNames(
                                            "all",
                                            sty.tri34
                                          )}
                                        >
                                          <div
                                            data-plasmic-name={"rect34"}
                                            data-plasmic-override={
                                              overrides.rect34
                                            }
                                            className={classNames(
                                              "all",
                                              sty.rect34
                                            )}
                                          />
                                        </div>
                                        <div
                                          data-plasmic-name={"tri35"}
                                          data-plasmic-override={
                                            overrides.tri35
                                          }
                                          className={classNames(
                                            "all",
                                            sty.tri35
                                          )}
                                        >
                                          <div
                                            data-plasmic-name={"rect35"}
                                            data-plasmic-override={
                                              overrides.rect35
                                            }
                                            className={classNames(
                                              "all",
                                              sty.rect35
                                            )}
                                          />
                                        </div>
                                        <div
                                          data-plasmic-name={"tri36"}
                                          data-plasmic-override={
                                            overrides.tri36
                                          }
                                          className={classNames(
                                            "all",
                                            sty.tri36
                                          )}
                                        >
                                          <div
                                            data-plasmic-name={"rect36"}
                                            data-plasmic-override={
                                              overrides.rect36
                                            }
                                            className={classNames(
                                              "all",
                                              sty.rect36
                                            )}
                                          />
                                        </div>
                                        <div
                                          data-plasmic-name={"tri37"}
                                          data-plasmic-override={
                                            overrides.tri37
                                          }
                                          className={classNames(
                                            "all",
                                            sty.tri37
                                          )}
                                        >
                                          <div
                                            data-plasmic-name={"rect37"}
                                            data-plasmic-override={
                                              overrides.rect37
                                            }
                                            className={classNames(
                                              "all",
                                              sty.rect37
                                            )}
                                          />
                                        </div>
                                        <div
                                          data-plasmic-name={"tri38"}
                                          data-plasmic-override={
                                            overrides.tri38
                                          }
                                          className={classNames(
                                            "all",
                                            sty.tri38
                                          )}
                                        >
                                          <div
                                            data-plasmic-name={"rect38"}
                                            data-plasmic-override={
                                              overrides.rect38
                                            }
                                            className={classNames(
                                              "all",
                                              sty.rect38
                                            )}
                                          />
                                        </div>
                                        <div
                                          data-plasmic-name={"tri39"}
                                          data-plasmic-override={
                                            overrides.tri39
                                          }
                                          className={classNames(
                                            "all",
                                            sty.tri39
                                          )}
                                        >
                                          <div
                                            data-plasmic-name={"rect39"}
                                            data-plasmic-override={
                                              overrides.rect39
                                            }
                                            className={classNames(
                                              "all",
                                              sty.rect39
                                            )}
                                          />
                                        </div>
                                        <div
                                          data-plasmic-name={"tri40"}
                                          data-plasmic-override={
                                            overrides.tri40
                                          }
                                          className={classNames(
                                            "all",
                                            sty.tri40
                                          )}
                                        >
                                          <div
                                            data-plasmic-name={"rect40"}
                                            data-plasmic-override={
                                              overrides.rect40
                                            }
                                            className={classNames(
                                              "all",
                                              sty.rect40
                                            )}
                                          />
                                        </div>
                                        <div
                                          data-plasmic-name={"tri41"}
                                          data-plasmic-override={
                                            overrides.tri41
                                          }
                                          className={classNames(
                                            "all",
                                            sty.tri41
                                          )}
                                        >
                                          <div
                                            data-plasmic-name={"rect41"}
                                            data-plasmic-override={
                                              overrides.rect41
                                            }
                                            className={classNames(
                                              "all",
                                              sty.rect41
                                            )}
                                          />
                                        </div>
                                        <div
                                          data-plasmic-name={"tri42"}
                                          data-plasmic-override={
                                            overrides.tri42
                                          }
                                          className={classNames(
                                            "all",
                                            sty.tri42
                                          )}
                                        >
                                          <div
                                            data-plasmic-name={"rect42"}
                                            data-plasmic-override={
                                              overrides.rect42
                                            }
                                            className={classNames(
                                              "all",
                                              sty.rect42
                                            )}
                                          />
                                        </div>
                                        <div
                                          data-plasmic-name={"tri43"}
                                          data-plasmic-override={
                                            overrides.tri43
                                          }
                                          className={classNames(
                                            "all",
                                            sty.tri43
                                          )}
                                        >
                                          <div
                                            data-plasmic-name={"rect43"}
                                            data-plasmic-override={
                                              overrides.rect43
                                            }
                                            className={classNames(
                                              "all",
                                              sty.rect43
                                            )}
                                          />
                                        </div>
                                        <div
                                          data-plasmic-name={"tri44"}
                                          data-plasmic-override={
                                            overrides.tri44
                                          }
                                          className={classNames(
                                            "all",
                                            sty.tri44
                                          )}
                                        >
                                          <div
                                            data-plasmic-name={"rect44"}
                                            data-plasmic-override={
                                              overrides.rect44
                                            }
                                            className={classNames(
                                              "all",
                                              sty.rect44
                                            )}
                                          />
                                        </div>
                                        <div
                                          data-plasmic-name={"tri45"}
                                          data-plasmic-override={
                                            overrides.tri45
                                          }
                                          className={classNames(
                                            "all",
                                            sty.tri45
                                          )}
                                        >
                                          <div
                                            data-plasmic-name={"rect45"}
                                            data-plasmic-override={
                                              overrides.rect45
                                            }
                                            className={classNames(
                                              "all",
                                              sty.rect45
                                            )}
                                          />
                                        </div>
                                        <div
                                          data-plasmic-name={"tri46"}
                                          data-plasmic-override={
                                            overrides.tri46
                                          }
                                          className={classNames(
                                            "all",
                                            sty.tri46
                                          )}
                                        >
                                          <div
                                            data-plasmic-name={"rect46"}
                                            data-plasmic-override={
                                              overrides.rect46
                                            }
                                            className={classNames(
                                              "all",
                                              sty.rect46
                                            )}
                                          />
                                        </div>
                                        <div
                                          data-plasmic-name={"tri47"}
                                          data-plasmic-override={
                                            overrides.tri47
                                          }
                                          className={classNames(
                                            "all",
                                            sty.tri47
                                          )}
                                        >
                                          <div
                                            data-plasmic-name={"rect47"}
                                            data-plasmic-override={
                                              overrides.rect47
                                            }
                                            className={classNames(
                                              "all",
                                              sty.rect47
                                            )}
                                          />
                                        </div>
                                        <div
                                          data-plasmic-name={"tri48"}
                                          data-plasmic-override={
                                            overrides.tri48
                                          }
                                          className={classNames(
                                            "all",
                                            sty.tri48
                                          )}
                                        >
                                          <div
                                            data-plasmic-name={"rect48"}
                                            data-plasmic-override={
                                              overrides.rect48
                                            }
                                            className={classNames(
                                              "all",
                                              sty.rect48
                                            )}
                                          />
                                        </div>
                                        <div
                                          data-plasmic-name={"tri49"}
                                          data-plasmic-override={
                                            overrides.tri49
                                          }
                                          className={classNames(
                                            "all",
                                            sty.tri49
                                          )}
                                        >
                                          <div
                                            data-plasmic-name={"rect49"}
                                            data-plasmic-override={
                                              overrides.rect49
                                            }
                                            className={classNames(
                                              "all",
                                              sty.rect49
                                            )}
                                          />
                                        </div>
                                        <div
                                          data-plasmic-name={"tri50"}
                                          data-plasmic-override={
                                            overrides.tri50
                                          }
                                          className={classNames(
                                            "all",
                                            sty.tri50
                                          )}
                                        >
                                          <div
                                            data-plasmic-name={"rect50"}
                                            data-plasmic-override={
                                              overrides.rect50
                                            }
                                            className={classNames(
                                              "all",
                                              sty.rect50
                                            )}
                                          />
                                        </div>
                                        <div
                                          data-plasmic-name={"tri51"}
                                          data-plasmic-override={
                                            overrides.tri51
                                          }
                                          className={classNames(
                                            "all",
                                            sty.tri51
                                          )}
                                        >
                                          <div
                                            data-plasmic-name={"rect51"}
                                            data-plasmic-override={
                                              overrides.rect51
                                            }
                                            className={classNames(
                                              "all",
                                              sty.rect51
                                            )}
                                          />
                                        </div>
                                        <div
                                          data-plasmic-name={"tri52"}
                                          data-plasmic-override={
                                            overrides.tri52
                                          }
                                          className={classNames(
                                            "all",
                                            sty.tri52
                                          )}
                                        >
                                          <div
                                            data-plasmic-name={"rect52"}
                                            data-plasmic-override={
                                              overrides.rect52
                                            }
                                            className={classNames(
                                              "all",
                                              sty.rect52
                                            )}
                                          />
                                        </div>
                                        <div
                                          data-plasmic-name={"tri53"}
                                          data-plasmic-override={
                                            overrides.tri53
                                          }
                                          className={classNames(
                                            "all",
                                            sty.tri53
                                          )}
                                        >
                                          <div
                                            data-plasmic-name={"rect53"}
                                            data-plasmic-override={
                                              overrides.rect53
                                            }
                                            className={classNames(
                                              "all",
                                              sty.rect53
                                            )}
                                          />
                                        </div>
                                        <div
                                          data-plasmic-name={"tri54"}
                                          data-plasmic-override={
                                            overrides.tri54
                                          }
                                          className={classNames(
                                            "all",
                                            sty.tri54
                                          )}
                                        >
                                          <div
                                            data-plasmic-name={"rect54"}
                                            data-plasmic-override={
                                              overrides.rect54
                                            }
                                            className={classNames(
                                              "all",
                                              sty.rect54
                                            )}
                                          />
                                        </div>
                                        <div
                                          data-plasmic-name={"tri55"}
                                          data-plasmic-override={
                                            overrides.tri55
                                          }
                                          className={classNames(
                                            "all",
                                            sty.tri55
                                          )}
                                        >
                                          <div
                                            data-plasmic-name={"rect55"}
                                            data-plasmic-override={
                                              overrides.rect55
                                            }
                                            className={classNames(
                                              "all",
                                              sty.rect55
                                            )}
                                          />
                                        </div>
                                        <div
                                          data-plasmic-name={"tri56"}
                                          data-plasmic-override={
                                            overrides.tri56
                                          }
                                          className={classNames(
                                            "all",
                                            sty.tri56
                                          )}
                                        >
                                          <div
                                            data-plasmic-name={"rect56"}
                                            data-plasmic-override={
                                              overrides.rect56
                                            }
                                            className={classNames(
                                              "all",
                                              sty.rect56
                                            )}
                                          />
                                        </div>
                                        <div
                                          data-plasmic-name={"tri57"}
                                          data-plasmic-override={
                                            overrides.tri57
                                          }
                                          className={classNames(
                                            "all",
                                            sty.tri57
                                          )}
                                        >
                                          <div
                                            data-plasmic-name={"rect57"}
                                            data-plasmic-override={
                                              overrides.rect57
                                            }
                                            className={classNames(
                                              "all",
                                              sty.rect57
                                            )}
                                          />
                                        </div>
                                        <div
                                          data-plasmic-name={"tri58"}
                                          data-plasmic-override={
                                            overrides.tri58
                                          }
                                          className={classNames(
                                            "all",
                                            sty.tri58
                                          )}
                                        >
                                          <div
                                            data-plasmic-name={"rect58"}
                                            data-plasmic-override={
                                              overrides.rect58
                                            }
                                            className={classNames(
                                              "all",
                                              sty.rect58
                                            )}
                                          />
                                        </div>
                                        <div
                                          data-plasmic-name={"tri59"}
                                          data-plasmic-override={
                                            overrides.tri59
                                          }
                                          className={classNames(
                                            "all",
                                            sty.tri59
                                          )}
                                        >
                                          <div
                                            data-plasmic-name={"rect59"}
                                            data-plasmic-override={
                                              overrides.rect59
                                            }
                                            className={classNames(
                                              "all",
                                              sty.rect59
                                            )}
                                          />
                                        </div>
                                        <div
                                          data-plasmic-name={"tri60"}
                                          data-plasmic-override={
                                            overrides.tri60
                                          }
                                          className={classNames(
                                            "all",
                                            sty.tri60
                                          )}
                                        >
                                          <div
                                            data-plasmic-name={"rect60"}
                                            data-plasmic-override={
                                              overrides.rect60
                                            }
                                            className={classNames(
                                              "all",
                                              sty.rect60
                                            )}
                                          />
                                        </div>
                                        <div
                                          data-plasmic-name={"tri61"}
                                          data-plasmic-override={
                                            overrides.tri61
                                          }
                                          className={classNames(
                                            "all",
                                            sty.tri61
                                          )}
                                        >
                                          <div
                                            data-plasmic-name={"rect61"}
                                            data-plasmic-override={
                                              overrides.rect61
                                            }
                                            className={classNames(
                                              "all",
                                              sty.rect61
                                            )}
                                          />
                                        </div>
                                        <div
                                          data-plasmic-name={"tri62"}
                                          data-plasmic-override={
                                            overrides.tri62
                                          }
                                          className={classNames(
                                            "all",
                                            sty.tri62
                                          )}
                                        >
                                          <div
                                            data-plasmic-name={"rect62"}
                                            data-plasmic-override={
                                              overrides.rect62
                                            }
                                            className={classNames(
                                              "all",
                                              sty.rect62
                                            )}
                                          />
                                        </div>
                                        <div
                                          data-plasmic-name={"tri63"}
                                          data-plasmic-override={
                                            overrides.tri63
                                          }
                                          className={classNames(
                                            "all",
                                            sty.tri63
                                          )}
                                        >
                                          <div
                                            data-plasmic-name={"rect63"}
                                            data-plasmic-override={
                                              overrides.rect63
                                            }
                                            className={classNames(
                                              "all",
                                              sty.rect63
                                            )}
                                          />
                                        </div>
                                        <div
                                          data-plasmic-name={"tri64"}
                                          data-plasmic-override={
                                            overrides.tri64
                                          }
                                          className={classNames(
                                            "all",
                                            sty.tri64
                                          )}
                                        >
                                          <div
                                            data-plasmic-name={"rect64"}
                                            data-plasmic-override={
                                              overrides.rect64
                                            }
                                            className={classNames(
                                              "all",
                                              sty.rect64
                                            )}
                                          />
                                        </div>
                                      </div>
                                    </div>
                                    <div
                                      data-plasmic-name={"shade4"}
                                      data-plasmic-override={overrides.shade4}
                                      className={classNames("all", sty.shade4)}
                                    />
                                  </div>
                                  <div
                                    data-plasmic-name={"alert4"}
                                    data-plasmic-override={overrides.alert4}
                                    className={classNames("all", sty.alert4)}
                                  >
                                    <div
                                      data-plasmic-name={"icon31"}
                                      data-plasmic-override={overrides.icon31}
                                      className={classNames("all", sty.icon31)}
                                    >
                                      <Icon91Icon
                                        className={classNames(
                                          "all",
                                          sty.svg___68Yvx
                                        )}
                                        role={"img"}
                                      />
                                    </div>
                                    <div
                                      data-plasmic-name={"content6"}
                                      data-plasmic-override={overrides.content6}
                                      className={classNames(
                                        "all",
                                        sty.content6
                                      )}
                                    >
                                      <div
                                        data-plasmic-name={"text15"}
                                        data-plasmic-override={overrides.text15}
                                        className={classNames(
                                          "all",
                                          "__wab_text",
                                          sty.text15
                                        )}
                                      >
                                        {"Event Created"}
                                      </div>
                                    </div>
                                    <div
                                      data-plasmic-name={"icon32"}
                                      data-plasmic-override={overrides.icon32}
                                      className={classNames("all", sty.icon32)}
                                    >
                                      <Icon84Icon
                                        className={classNames(
                                          "all",
                                          sty.svg___63A8S
                                        )}
                                        role={"img"}
                                      />
                                    </div>
                                  </div>
                                </div>
                                <div
                                  data-plasmic-name={"text16"}
                                  data-plasmic-override={overrides.text16}
                                  className={classNames("all", sty.text16)}
                                >
                                  <div
                                    data-plasmic-name={"title39"}
                                    data-plasmic-override={overrides.title39}
                                    className={classNames(
                                      "all",
                                      "__wab_text",
                                      sty.title39
                                    )}
                                  >
                                    {
                                      "One Platform for Continuing Medical Education"
                                    }
                                  </div>
                                  <div
                                    data-plasmic-name={"desc11"}
                                    data-plasmic-override={overrides.desc11}
                                    className={classNames(
                                      "all",
                                      "__wab_text",
                                      sty.desc11
                                    )}
                                  >
                                    {
                                      "MyCME\u2122 centralizes continuing medical education activities, participation, credit management, reporting, and financial oversight. Organizations can manage live and enduring activities, issue certificates, track CME and Maintenance of Certification credits, maintain event financial records, and support ACCME reporting through PARS."
                                    }
                                  </div>
                                </div>
                              </div>
                              <div
                                data-plasmic-name={"features2"}
                                data-plasmic-override={overrides.features2}
                                className={classNames("all", sty.features2)}
                              >
                                <div
                                  data-plasmic-name={"title40"}
                                  data-plasmic-override={overrides.title40}
                                  className={classNames(
                                    "all",
                                    "__wab_text",
                                    sty.title40
                                  )}
                                >
                                  {"Key Capabilities"}
                                </div>
                                <div
                                  data-plasmic-name={"contents"}
                                  data-plasmic-override={overrides.contents}
                                  className={classNames("all", sty.contents)}
                                >
                                  <div
                                    data-plasmic-name={"contentsItem18"}
                                    data-plasmic-override={
                                      overrides.contentsItem18
                                    }
                                    className={classNames(
                                      "all",
                                      sty.contentsItem18
                                    )}
                                  >
                                    <div
                                      data-plasmic-name={"icon33"}
                                      data-plasmic-override={overrides.icon33}
                                      className={classNames("all", sty.icon33)}
                                    >
                                      <Icon87Icon
                                        className={classNames(
                                          "all",
                                          sty.svg__mh20Y
                                        )}
                                        role={"img"}
                                      />
                                    </div>
                                    <div
                                      data-plasmic-name={"text17"}
                                      data-plasmic-override={overrides.text17}
                                      className={classNames(
                                        "all",
                                        "__wab_text",
                                        sty.text17
                                      )}
                                    >
                                      {"Live and Enduring Activity Scheduling"}
                                    </div>
                                  </div>
                                  <div
                                    data-plasmic-name={"contentsItem19"}
                                    data-plasmic-override={
                                      overrides.contentsItem19
                                    }
                                    className={classNames(
                                      "all",
                                      sty.contentsItem19
                                    )}
                                  >
                                    <div
                                      data-plasmic-name={"icon34"}
                                      data-plasmic-override={overrides.icon34}
                                      className={classNames("all", sty.icon34)}
                                    >
                                      <Icon87Icon
                                        className={classNames(
                                          "all",
                                          sty.svg___63Ai
                                        )}
                                        role={"img"}
                                      />
                                    </div>
                                    <div
                                      data-plasmic-name={"text18"}
                                      data-plasmic-override={overrides.text18}
                                      className={classNames(
                                        "all",
                                        "__wab_text",
                                        sty.text18
                                      )}
                                    >
                                      {"CME Credit Tracing"}
                                    </div>
                                  </div>
                                  <div
                                    data-plasmic-name={"contentsItem20"}
                                    data-plasmic-override={
                                      overrides.contentsItem20
                                    }
                                    className={classNames(
                                      "all",
                                      sty.contentsItem20
                                    )}
                                  >
                                    <div
                                      data-plasmic-name={"icon35"}
                                      data-plasmic-override={overrides.icon35}
                                      className={classNames("all", sty.icon35)}
                                    >
                                      <Icon87Icon
                                        className={classNames(
                                          "all",
                                          sty.svg__itZat
                                        )}
                                        role={"img"}
                                      />
                                    </div>
                                    <div
                                      data-plasmic-name={"text19"}
                                      data-plasmic-override={overrides.text19}
                                      className={classNames(
                                        "all",
                                        "__wab_text",
                                        sty.text19
                                      )}
                                    >
                                      {"Certificate Management"}
                                    </div>
                                  </div>
                                  <div
                                    data-plasmic-name={"contentsItem21"}
                                    data-plasmic-override={
                                      overrides.contentsItem21
                                    }
                                    className={classNames(
                                      "all",
                                      sty.contentsItem21
                                    )}
                                  >
                                    <div
                                      data-plasmic-name={"icon36"}
                                      data-plasmic-override={overrides.icon36}
                                      className={classNames("all", sty.icon36)}
                                    >
                                      <Icon87Icon
                                        className={classNames(
                                          "all",
                                          sty.svg__nTrWo
                                        )}
                                        role={"img"}
                                      />
                                    </div>
                                    <div
                                      data-plasmic-name={"text20"}
                                      data-plasmic-override={overrides.text20}
                                      className={classNames(
                                        "all",
                                        "__wab_text",
                                        sty.text20
                                      )}
                                    >
                                      {"ACCME PARS Connectivity"}
                                    </div>
                                  </div>
                                  <div
                                    data-plasmic-name={"contentsItem22"}
                                    data-plasmic-override={
                                      overrides.contentsItem22
                                    }
                                    className={classNames(
                                      "all",
                                      sty.contentsItem22
                                    )}
                                  >
                                    <div
                                      data-plasmic-name={"icon7"}
                                      data-plasmic-override={overrides.icon7}
                                      className={classNames("all", sty.icon7)}
                                    >
                                      <Icon87Icon
                                        className={classNames(
                                          "all",
                                          sty.svg__zxNhA
                                        )}
                                        role={"img"}
                                      />
                                    </div>
                                    <div
                                      data-plasmic-name={"text21"}
                                      data-plasmic-override={overrides.text21}
                                      className={classNames(
                                        "all",
                                        "__wab_text",
                                        sty.text21
                                      )}
                                    >
                                      {"Maintenance of Certification Reporting"}
                                    </div>
                                  </div>
                                  <div
                                    data-plasmic-name={"contentsItem23"}
                                    data-plasmic-override={
                                      overrides.contentsItem23
                                    }
                                    className={classNames(
                                      "all",
                                      sty.contentsItem23
                                    )}
                                  >
                                    <div
                                      data-plasmic-name={"icon37"}
                                      data-plasmic-override={overrides.icon37}
                                      className={classNames("all", sty.icon37)}
                                    >
                                      <Icon87Icon
                                        className={classNames(
                                          "all",
                                          sty.svg__dfDoP
                                        )}
                                        role={"img"}
                                      />
                                    </div>
                                    <div
                                      data-plasmic-name={"text22"}
                                      data-plasmic-override={overrides.text22}
                                      className={classNames(
                                        "all",
                                        "__wab_text",
                                        sty.text22
                                      )}
                                    >
                                      {
                                        "Registration and Participation Tracking"
                                      }
                                    </div>
                                  </div>
                                  <div
                                    data-plasmic-name={"contentsItem24"}
                                    data-plasmic-override={
                                      overrides.contentsItem24
                                    }
                                    className={classNames(
                                      "all",
                                      sty.contentsItem24
                                    )}
                                  >
                                    <div
                                      data-plasmic-name={"icon38"}
                                      data-plasmic-override={overrides.icon38}
                                      className={classNames("all", sty.icon38)}
                                    >
                                      <Icon87Icon
                                        className={classNames(
                                          "all",
                                          sty.svg__hFqM
                                        )}
                                        role={"img"}
                                      />
                                    </div>
                                    <div
                                      data-plasmic-name={"text23"}
                                      data-plasmic-override={overrides.text23}
                                      className={classNames(
                                        "all",
                                        "__wab_text",
                                        sty.text23
                                      )}
                                    >
                                      {"Event Financial Management"}
                                    </div>
                                  </div>
                                  <div
                                    data-plasmic-name={"contentsItem25"}
                                    data-plasmic-override={
                                      overrides.contentsItem25
                                    }
                                    className={classNames(
                                      "all",
                                      sty.contentsItem25
                                    )}
                                  >
                                    <div
                                      data-plasmic-name={"icon39"}
                                      data-plasmic-override={overrides.icon39}
                                      className={classNames("all", sty.icon39)}
                                    >
                                      <Icon87Icon
                                        className={classNames(
                                          "all",
                                          sty.svg___7ZedG
                                        )}
                                        role={"img"}
                                      />
                                    </div>
                                    <div
                                      data-plasmic-name={"text24"}
                                      data-plasmic-override={overrides.text24}
                                      className={classNames(
                                        "all",
                                        "__wab_text",
                                        sty.text24
                                      )}
                                    >
                                      {"Cross-Departmental Reporting"}
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </AntdTabItem>
                        <AntdTabItem
                          className={classNames(
                            "__wab_instance",
                            sty.tabItem__dcgAx
                          )}
                          key={"3"}
                          label={
                            <PlasmicImg__
                              alt={""}
                              className={classNames(sty.img___31Cpz)}
                              displayHeight={"auto"}
                              displayMaxHeight={"none"}
                              displayMaxWidth={"100%"}
                              displayMinHeight={"0"}
                              displayMinWidth={"0"}
                              displayWidth={"auto"}
                              loader={"plasmic"}
                              loading={"lazy"}
                              src={{
                                src: "https://img.plasmic.app/img-optimizer/v1/img/2d38d092578df512366a87b10cb3140e.png",
                                fullWidth: 98,
                                fullHeight: 21
                              }}
                            />
                          }
                        >
                          <div
                            data-plasmic-name={"content7"}
                            data-plasmic-override={overrides.content7}
                            className={classNames("all", sty.content7)}
                          >
                            <div
                              data-plasmic-name={"placeholder82"}
                              data-plasmic-override={overrides.placeholder82}
                              className={classNames("all", sty.placeholder82)}
                            >
                              <div
                                data-plasmic-name={"intro7"}
                                data-plasmic-override={overrides.intro7}
                                className={classNames("all", sty.intro7)}
                              >
                                <div
                                  data-plasmic-name={"img7"}
                                  data-plasmic-override={overrides.img7}
                                  className={classNames("all", sty.img7)}
                                >
                                  {false ? (
                                    <div
                                      data-plasmic-name={"cap2"}
                                      data-plasmic-override={overrides.cap2}
                                      className={classNames("all", sty.cap2)}
                                    >
                                      {false ? (
                                        <div
                                          data-plasmic-name={"header27"}
                                          data-plasmic-override={
                                            overrides.header27
                                          }
                                          className={classNames(
                                            "all",
                                            sty.header27
                                          )}
                                        >
                                          {false ? (
                                            <div
                                              data-plasmic-name={"subtitle11"}
                                              data-plasmic-override={
                                                overrides.subtitle11
                                              }
                                              className={classNames(
                                                "all",
                                                "__wab_text",
                                                sty.subtitle11
                                              )}
                                            >
                                              {"Subtitle"}
                                            </div>
                                          ) : null}
                                          <div
                                            data-plasmic-name={"title42"}
                                            data-plasmic-override={
                                              overrides.title42
                                            }
                                            className={classNames(
                                              "all",
                                              "__wab_text",
                                              sty.title42
                                            )}
                                          >
                                            {"Cap Analysis"}
                                          </div>
                                        </div>
                                      ) : null}
                                      <div
                                        data-plasmic-name={"main9"}
                                        data-plasmic-override={overrides.main9}
                                        className={classNames("all", sty.main9)}
                                      >
                                        <div
                                          data-plasmic-name={"placeholder84"}
                                          data-plasmic-override={
                                            overrides.placeholder84
                                          }
                                          className={classNames(
                                            "all",
                                            sty.placeholder84
                                          )}
                                        >
                                          {false ? (
                                            <div
                                              data-plasmic-name={"field2"}
                                              data-plasmic-override={
                                                overrides.field2
                                              }
                                              className={classNames(
                                                "all",
                                                sty.field2
                                              )}
                                            >
                                              <div
                                                data-plasmic-name={"label14"}
                                                data-plasmic-override={
                                                  overrides.label14
                                                }
                                                className={classNames(
                                                  "all",
                                                  "__wab_text",
                                                  sty.label14
                                                )}
                                              >
                                                {"Institution"}
                                              </div>
                                              <div
                                                data-plasmic-name={"select2"}
                                                data-plasmic-override={
                                                  overrides.select2
                                                }
                                                className={classNames(
                                                  "all",
                                                  sty.select2
                                                )}
                                              >
                                                <div
                                                  data-plasmic-name={"input2"}
                                                  data-plasmic-override={
                                                    overrides.input2
                                                  }
                                                  className={classNames(
                                                    "all",
                                                    sty.input2
                                                  )}
                                                >
                                                  {false ? (
                                                    <div
                                                      data-plasmic-name={
                                                        "leftIcon2"
                                                      }
                                                      data-plasmic-override={
                                                        overrides.leftIcon2
                                                      }
                                                      className={classNames(
                                                        "all",
                                                        sty.leftIcon2
                                                      )}
                                                    >
                                                      <Icon91Icon
                                                        className={classNames(
                                                          "all",
                                                          sty.svg__lRh
                                                        )}
                                                        role={"img"}
                                                      />
                                                    </div>
                                                  ) : null}
                                                  <div
                                                    data-plasmic-name={"text54"}
                                                    data-plasmic-override={
                                                      overrides.text54
                                                    }
                                                    className={classNames(
                                                      "all",
                                                      "__wab_text",
                                                      sty.text54
                                                    )}
                                                  >
                                                    {"Integrated Health One"}
                                                  </div>
                                                  <div
                                                    data-plasmic-name={
                                                      "rightIcon2"
                                                    }
                                                    data-plasmic-override={
                                                      overrides.rightIcon2
                                                    }
                                                    className={classNames(
                                                      "all",
                                                      sty.rightIcon2
                                                    )}
                                                  >
                                                    <PlasmicImg__
                                                      alt={""}
                                                      className={classNames(
                                                        sty.img__umkLh
                                                      )}
                                                      displayHeight={"12px"}
                                                      displayMaxHeight={"none"}
                                                      displayMaxWidth={"100%"}
                                                      displayMinHeight={"0"}
                                                      displayMinWidth={"0"}
                                                      displayWidth={"12px"}
                                                      loader={"plasmic"}
                                                      loading={"lazy"}
                                                      src={{
                                                        src: "https://site-assets.plasmic.app/111ce4d1a6d72b3b2b7de10e9e93afd6.svg",
                                                        fullWidth: 12,
                                                        fullHeight: 12
                                                      }}
                                                    />
                                                  </div>
                                                </div>
                                              </div>
                                            </div>
                                          ) : null}
                                          <div
                                            data-plasmic-name={"row4"}
                                            data-plasmic-override={
                                              overrides.row4
                                            }
                                            className={classNames(
                                              "all",
                                              sty.row4
                                            )}
                                          >
                                            <div
                                              data-plasmic-name={"prop5"}
                                              data-plasmic-override={
                                                overrides.prop5
                                              }
                                              className={classNames(
                                                "all",
                                                sty.prop5
                                              )}
                                            >
                                              <div
                                                data-plasmic-name={"label15"}
                                                data-plasmic-override={
                                                  overrides.label15
                                                }
                                                className={classNames(
                                                  "all",
                                                  "__wab_text",
                                                  sty.label15
                                                )}
                                              >
                                                {"DME/Cap"}
                                              </div>
                                              <div
                                                data-plasmic-name={"val10"}
                                                data-plasmic-override={
                                                  overrides.val10
                                                }
                                                className={classNames(
                                                  "all",
                                                  "__wab_text",
                                                  sty.val10
                                                )}
                                              >
                                                {"12.11/10"}
                                              </div>
                                            </div>
                                            <div
                                              data-plasmic-name={"prop6"}
                                              data-plasmic-override={
                                                overrides.prop6
                                              }
                                              className={classNames(
                                                "all",
                                                sty.prop6
                                              )}
                                            >
                                              <div
                                                data-plasmic-name={"label16"}
                                                data-plasmic-override={
                                                  overrides.label16
                                                }
                                                className={classNames(
                                                  "all",
                                                  "__wab_text",
                                                  sty.label16
                                                )}
                                              >
                                                {"DME/Cap Variance"}
                                              </div>
                                              <div
                                                data-plasmic-name={"val11"}
                                                data-plasmic-override={
                                                  overrides.val11
                                                }
                                                className={classNames(
                                                  "all",
                                                  "__wab_text",
                                                  sty.val11
                                                )}
                                              >
                                                {"2.11"}
                                              </div>
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  ) : null}
                                  <PlasmicImg__
                                    alt={""}
                                    className={classNames(sty.img__oIbl)}
                                    displayHeight={"auto"}
                                    displayMaxHeight={"none"}
                                    displayMaxWidth={"100%"}
                                    displayMinHeight={"0"}
                                    displayMinWidth={"0"}
                                    displayWidth={"auto"}
                                    loader={"plasmic"}
                                    loading={"lazy"}
                                    src={{
                                      src: "https://img.plasmic.app/img-optimizer/v1/img/1368bc4c833d8bb92d49a32a73a4dd2c.png",
                                      fullWidth: 326,
                                      fullHeight: 244
                                    }}
                                  />
                                </div>
                                <div
                                  data-plasmic-name={"text79"}
                                  data-plasmic-override={overrides.text79}
                                  className={classNames("all", sty.text79)}
                                >
                                  <div
                                    data-plasmic-name={"title46"}
                                    data-plasmic-override={overrides.title46}
                                    className={classNames(
                                      "all",
                                      "__wab_text",
                                      sty.title46
                                    )}
                                  >
                                    {"One Platform for GME Fiscal Management"}
                                  </div>
                                  <div
                                    data-plasmic-name={"desc12"}
                                    data-plasmic-override={overrides.desc12}
                                    className={classNames(
                                      "all",
                                      "__wab_text",
                                      sty.desc12
                                    )}
                                  >
                                    {
                                      "MyGME Fiscal\u2122 connects educational, scheduling, and clinical-hour information with the financial processes required for GME reimbursement, institutional planning, invoicing, and reporting.\nThrough IRIS and STAR exports, Master Rotation Schedules, FTE and CAP analysis, gap and overlap review, and detailed fiscal reporting, institutions gain clearer oversight of reimbursable activity and Medicare submissions."
                                    }
                                  </div>
                                </div>
                              </div>
                              <div
                                data-plasmic-name={"features4"}
                                data-plasmic-override={overrides.features4}
                                className={classNames("all", sty.features4)}
                              >
                                <div
                                  data-plasmic-name={"title47"}
                                  data-plasmic-override={overrides.title47}
                                  className={classNames(
                                    "all",
                                    "__wab_text",
                                    sty.title47
                                  )}
                                >
                                  {"Key Capabilities"}
                                </div>
                                <div
                                  data-plasmic-name={"grid"}
                                  data-plasmic-override={overrides.grid}
                                  className={classNames("all", sty.grid)}
                                >
                                  <div
                                    data-plasmic-name={"contentsItem26"}
                                    data-plasmic-override={
                                      overrides.contentsItem26
                                    }
                                    className={classNames(
                                      "all",
                                      sty.contentsItem26
                                    )}
                                  >
                                    <div
                                      data-plasmic-name={"icon41"}
                                      data-plasmic-override={overrides.icon41}
                                      className={classNames("all", sty.icon41)}
                                    >
                                      <Icon87Icon
                                        className={classNames(
                                          "all",
                                          sty.svg__xxygd
                                        )}
                                        role={"img"}
                                      />
                                    </div>
                                    <div
                                      data-plasmic-name={"text80"}
                                      data-plasmic-override={overrides.text80}
                                      className={classNames(
                                        "all",
                                        "__wab_text",
                                        sty.text80
                                      )}
                                    >
                                      {
                                        "Medicare Reimbursement & Cost Reporting"
                                      }
                                    </div>
                                  </div>
                                  <div
                                    data-plasmic-name={"contentsItem27"}
                                    data-plasmic-override={
                                      overrides.contentsItem27
                                    }
                                    className={classNames(
                                      "all",
                                      sty.contentsItem27
                                    )}
                                  >
                                    <div
                                      data-plasmic-name={"icon42"}
                                      data-plasmic-override={overrides.icon42}
                                      className={classNames("all", sty.icon42)}
                                    >
                                      <Icon87Icon
                                        className={classNames(
                                          "all",
                                          sty.svg__qt0Zx
                                        )}
                                        role={"img"}
                                      />
                                    </div>
                                    <div
                                      data-plasmic-name={"text81"}
                                      data-plasmic-override={overrides.text81}
                                      className={classNames(
                                        "all",
                                        "__wab_text",
                                        sty.text81
                                      )}
                                    >
                                      {"IRIS & STAR Export"}
                                    </div>
                                  </div>
                                  <div
                                    data-plasmic-name={"contentsItem28"}
                                    data-plasmic-override={
                                      overrides.contentsItem28
                                    }
                                    className={classNames(
                                      "all",
                                      sty.contentsItem28
                                    )}
                                  >
                                    <div
                                      data-plasmic-name={"icon43"}
                                      data-plasmic-override={overrides.icon43}
                                      className={classNames("all", sty.icon43)}
                                    >
                                      <Icon87Icon
                                        className={classNames(
                                          "all",
                                          sty.svg__zIeSv
                                        )}
                                        role={"img"}
                                      />
                                    </div>
                                    <div
                                      data-plasmic-name={"text82"}
                                      data-plasmic-override={overrides.text82}
                                      className={classNames(
                                        "all",
                                        "__wab_text",
                                        sty.text82
                                      )}
                                    >
                                      {"Billing & Invoicing"}
                                    </div>
                                  </div>
                                  <div
                                    data-plasmic-name={"contentsItem29"}
                                    data-plasmic-override={
                                      overrides.contentsItem29
                                    }
                                    className={classNames(
                                      "all",
                                      sty.contentsItem29
                                    )}
                                  >
                                    <div
                                      data-plasmic-name={"icon44"}
                                      data-plasmic-override={overrides.icon44}
                                      className={classNames("all", sty.icon44)}
                                    >
                                      <Icon87Icon
                                        className={classNames(
                                          "all",
                                          sty.svg__rd7Kj
                                        )}
                                        role={"img"}
                                      />
                                    </div>
                                    <div
                                      data-plasmic-name={"text83"}
                                      data-plasmic-override={overrides.text83}
                                      className={classNames(
                                        "all",
                                        "__wab_text",
                                        sty.text83
                                      )}
                                    >
                                      {"FTE Reporting & CAP Analysis"}
                                    </div>
                                  </div>
                                  <div
                                    data-plasmic-name={"contentsItem30"}
                                    data-plasmic-override={
                                      overrides.contentsItem30
                                    }
                                    className={classNames(
                                      "all",
                                      sty.contentsItem30
                                    )}
                                  >
                                    <div
                                      data-plasmic-name={"icon45"}
                                      data-plasmic-override={overrides.icon45}
                                      className={classNames("all", sty.icon45)}
                                    >
                                      <Icon87Icon
                                        className={classNames(
                                          "all",
                                          sty.svg__jGmuw
                                        )}
                                        role={"img"}
                                      />
                                    </div>
                                    <div
                                      data-plasmic-name={"text84"}
                                      data-plasmic-override={overrides.text84}
                                      className={classNames(
                                        "all",
                                        "__wab_text",
                                        sty.text84
                                      )}
                                    >
                                      {"Master Rotation Schedule Management"}
                                    </div>
                                  </div>
                                  <div
                                    data-plasmic-name={"contentsItem31"}
                                    data-plasmic-override={
                                      overrides.contentsItem31
                                    }
                                    className={classNames(
                                      "all",
                                      sty.contentsItem31
                                    )}
                                  >
                                    <div
                                      data-plasmic-name={"icon46"}
                                      data-plasmic-override={overrides.icon46}
                                      className={classNames("all", sty.icon46)}
                                    >
                                      <Icon87Icon
                                        className={classNames(
                                          "all",
                                          sty.svg__ddjHs
                                        )}
                                        role={"img"}
                                      />
                                    </div>
                                    <div
                                      data-plasmic-name={"text85"}
                                      data-plasmic-override={overrides.text85}
                                      className={classNames(
                                        "all",
                                        "__wab_text",
                                        sty.text85
                                      )}
                                    >
                                      {"Gap & Overlap Analysis"}
                                    </div>
                                  </div>
                                  <div
                                    data-plasmic-name={"contentsItem32"}
                                    data-plasmic-override={
                                      overrides.contentsItem32
                                    }
                                    className={classNames(
                                      "all",
                                      sty.contentsItem32
                                    )}
                                  >
                                    <div
                                      data-plasmic-name={"icon47"}
                                      data-plasmic-override={overrides.icon47}
                                      className={classNames("all", sty.icon47)}
                                    >
                                      <Icon87Icon
                                        className={classNames(
                                          "all",
                                          sty.svg__loiZb
                                        )}
                                        role={"img"}
                                      />
                                    </div>
                                    <div
                                      data-plasmic-name={"text86"}
                                      data-plasmic-override={overrides.text86}
                                      className={classNames(
                                        "all",
                                        "__wab_text",
                                        sty.text86
                                      )}
                                    >
                                      {"Audit Management"}
                                    </div>
                                  </div>
                                  <div
                                    data-plasmic-name={"contentsItem33"}
                                    data-plasmic-override={
                                      overrides.contentsItem33
                                    }
                                    className={classNames(
                                      "all",
                                      sty.contentsItem33
                                    )}
                                  >
                                    <div
                                      data-plasmic-name={"icon48"}
                                      data-plasmic-override={overrides.icon48}
                                      className={classNames("all", sty.icon48)}
                                    >
                                      <Icon87Icon
                                        className={classNames(
                                          "all",
                                          sty.svg__p19
                                        )}
                                        role={"img"}
                                      />
                                    </div>
                                    <div
                                      data-plasmic-name={"text87"}
                                      data-plasmic-override={overrides.text87}
                                      className={classNames(
                                        "all",
                                        "__wab_text",
                                        sty.text87
                                      )}
                                    >
                                      {"Errors & Omissions Analysis"}
                                    </div>
                                  </div>
                                  <div
                                    data-plasmic-name={"contentsItem34"}
                                    data-plasmic-override={
                                      overrides.contentsItem34
                                    }
                                    className={classNames(
                                      "all",
                                      sty.contentsItem34
                                    )}
                                  >
                                    <div
                                      data-plasmic-name={"icon49"}
                                      data-plasmic-override={overrides.icon49}
                                      className={classNames("all", sty.icon49)}
                                    >
                                      <Icon87Icon
                                        className={classNames(
                                          "all",
                                          sty.svg__rj8Zd
                                        )}
                                        role={"img"}
                                      />
                                    </div>
                                    <div
                                      data-plasmic-name={"text88"}
                                      data-plasmic-override={overrides.text88}
                                      className={classNames(
                                        "all",
                                        "__wab_text",
                                        sty.text88
                                      )}
                                    >
                                      {"MyQuickPass\u2122 Integration"}
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </AntdTabItem>
                      </React.Fragment>
                    }
                    onChange={async (...eventArgs: any) => {
                      generateStateOnChangeProp($state, [
                        "tabs",
                        "activeKey"
                      ]).apply(null, eventArgs);
                    }}
                    sticky={false}
                    tabBarBackground={"#FFF"}
                    tabBarClassName={classNames({
                      [sty["pcls_GT0pdL8BDlPo"]]: true
                    })}
                    tabsDropdownClassName={classNames({
                      [sty["pcls_2vWKynaYgGtO"]]: true
                    })}
                    tabsDropdownScopeClassName={sty["tabs__tabsDropdown"]}
                    tabsScopeClassName={sty["tabs__tabs"]}
                    type={"card"}
                  />
                </div>
              ) : null}
            </React.Fragment>
          )}
        </DataCtxReader__>
      </DataProvider>
    </section>
  ) as React.ReactElement | null;
}

const PlasmicDescendants = {
  productsSection: [
    "productsSection",
    "productsProvider",
    "desktopWrapper",
    "intro2",
    "header9",
    "top3",
    "subtitle",
    "title",
    "body6",
    "col4",
    "nav",
    "img2",
    "logoIcon",
    "logo7",
    "logo2",
    "logo3",
    "productTabs",
    "content",
    "placeholder",
    "intro",
    "col",
    "logo",
    "text53",
    "title23",
    "desc",
    "img",
    "areas",
    "header10",
    "title11",
    "body7",
    "frame22",
    "item17",
    "title12",
    "desc7",
    "item18",
    "title13",
    "desc2",
    "item19",
    "title14",
    "desc3",
    "item20",
    "title15",
    "desc4",
    "item21",
    "title16",
    "desc5",
    "item22",
    "title17",
    "desc6",
    "footnote",
    "bodyWrapper6",
    "intro4",
    "col7",
    "logo9",
    "text44",
    "title27",
    "desc9",
    "img4",
    "bg3",
    "xmlid7457",
    "xmlid6776",
    "xmlid7433",
    "xmlid7339",
    "alert3",
    "icon20",
    "content3",
    "text45",
    "icon21",
    "credits",
    "header20",
    "subtitle5",
    "title28",
    "main6",
    "mockupCmeCredits",
    "table",
    "col8",
    "mockupTableCellText",
    "text46",
    "mockupTableCellAvatar",
    "mockupTableCellAvatar2",
    "mockupTableCellAvatar3",
    "col9",
    "mockupTableCellText2",
    "text47",
    "mockupTableCellText3",
    "text48",
    "mockupTableCellText4",
    "text49",
    "mockupTableCellText5",
    "text50",
    "col10",
    "mockupTableCellText6",
    "text51",
    "mockupTableCellText7",
    "text52",
    "mockupTableCellText8",
    "text57",
    "mockupTableCellText9",
    "text58",
    "col11",
    "mockupTableCellText10",
    "text59",
    "mockupTableCellText11",
    "text60",
    "mockupTableCellText12",
    "text70",
    "mockupTableCellText13",
    "text71",
    "mockupButton7",
    "link10",
    "certificate",
    "top5",
    "mockupCertificateIcon",
    "bg4",
    "group1",
    "paper1",
    "paper2",
    "cert",
    "award491",
    "overlay",
    "title29",
    "mockupTextPlaceholder",
    "mockupTextPlaceholderParagraph",
    "mockupTextPlaceholderLine",
    "mockupTextPlaceholderContent37",
    "placeholder38",
    "mockupTextPlaceholderLine2",
    "mockupTextPlaceholderContent38",
    "placeholder39",
    "mockupTextPlaceholderLine3",
    "mockupTextPlaceholderContent39",
    "placeholder40",
    "mockupTextPlaceholderLine4",
    "mockupTextPlaceholderContent40",
    "placeholder41",
    "mockupTextPlaceholderLine5",
    "mockupTextPlaceholderContent41",
    "placeholder42",
    "mockupTextPlaceholderParagraph2",
    "mockupTextPlaceholderLine6",
    "mockupTextPlaceholderContent42",
    "placeholder43",
    "mockupTextPlaceholderLine7",
    "mockupTextPlaceholderContent43",
    "placeholder44",
    "mockupTextPlaceholderLine8",
    "mockupTextPlaceholderContent44",
    "placeholder45",
    "mockupTextPlaceholderLine9",
    "mockupTextPlaceholderContent45",
    "placeholder46",
    "mockupTextPlaceholderLine10",
    "mockupTextPlaceholderContent46",
    "placeholder47",
    "mockupTextPlaceholderLine11",
    "mockupTextPlaceholderContent47",
    "placeholder48",
    "mockupTextPlaceholderLine12",
    "mockupTextPlaceholderContent48",
    "placeholder49",
    "mockupTextPlaceholderLine13",
    "mockupTextPlaceholderContent49",
    "placeholder50",
    "mockupTextPlaceholderParagraph3",
    "mockupTextPlaceholderLine14",
    "mockupTextPlaceholderContent50",
    "placeholder51",
    "mockupTextPlaceholderLine15",
    "mockupTextPlaceholderContent15",
    "placeholder52",
    "mockupTextPlaceholderLine16",
    "mockupTextPlaceholderContent16",
    "placeholder53",
    "mockupTextPlaceholderLine17",
    "mockupTextPlaceholderContent17",
    "placeholder54",
    "mockupTextPlaceholderLine18",
    "mockupTextPlaceholderContent18",
    "placeholder55",
    "mockupTextPlaceholderParagraph4",
    "mockupTextPlaceholderLine19",
    "mockupTextPlaceholderContent19",
    "placeholder19",
    "mockupTextPlaceholderLine20",
    "mockupTextPlaceholderContent20",
    "placeholder20",
    "mockupTextPlaceholderLine21",
    "mockupTextPlaceholderContent21",
    "placeholder21",
    "mockupTextPlaceholderLine22",
    "mockupTextPlaceholderContent22",
    "placeholder22",
    "mockupTextPlaceholderLine23",
    "mockupTextPlaceholderContent23",
    "placeholder23",
    "mockupTextPlaceholderLine24",
    "mockupTextPlaceholderContent24",
    "placeholder24",
    "mockupTextPlaceholderLine25",
    "mockupTextPlaceholderContent25",
    "placeholder25",
    "mockupTextPlaceholderLine26",
    "mockupTextPlaceholderContent26",
    "placeholder26",
    "mockupButton8",
    "link11",
    "alert2",
    "icon22",
    "check2",
    "content4",
    "report",
    "bill",
    "header21",
    "subtitle9",
    "title30",
    "main7",
    "placeholder27",
    "header22",
    "title31",
    "date",
    "section",
    "head",
    "mockupTextPlaceholderParagraph5",
    "mockupTextPlaceholderLine27",
    "mockupTextPlaceholderContent27",
    "placeholder28",
    "mockupTextPlaceholderLine28",
    "mockupTextPlaceholderContent28",
    "placeholder29",
    "mockupTextPlaceholderLine29",
    "mockupTextPlaceholderContent29",
    "placeholder30",
    "mockupTextPlaceholderLine30",
    "mockupTextPlaceholderContent30",
    "placeholder31",
    "mockupTextPlaceholderLine31",
    "mockupTextPlaceholderContent31",
    "placeholder32",
    "total",
    "title32",
    "val6",
    "section2",
    "head2",
    "mockupTextPlaceholderParagraph6",
    "mockupTextPlaceholderLine32",
    "mockupTextPlaceholderContent32",
    "placeholder33",
    "mockupTextPlaceholderLine33",
    "mockupTextPlaceholderContent33",
    "placeholder34",
    "mockupTextPlaceholderLine34",
    "mockupTextPlaceholderContent34",
    "placeholder35",
    "mockupTextPlaceholderLine35",
    "mockupTextPlaceholderContent35",
    "placeholder36",
    "mockupTextPlaceholderLine36",
    "mockupTextPlaceholderContent36",
    "placeholder37",
    "total2",
    "title34",
    "val7",
    "edge",
    "tri",
    "rect",
    "tri2",
    "rect2",
    "tri3",
    "rect3",
    "tri4",
    "rect4",
    "tri5",
    "rect5",
    "tri6",
    "rect6",
    "tri7",
    "rect7",
    "tri8",
    "rect8",
    "tri9",
    "rect9",
    "tri10",
    "rect10",
    "tri11",
    "rect11",
    "tri12",
    "rect12",
    "tri13",
    "rect13",
    "tri14",
    "rect14",
    "tri15",
    "rect15",
    "tri16",
    "rect16",
    "tri17",
    "rect17",
    "tri18",
    "rect18",
    "tri19",
    "rect19",
    "tri20",
    "rect20",
    "tri21",
    "rect21",
    "tri22",
    "rect22",
    "tri23",
    "rect23",
    "tri24",
    "rect24",
    "tri25",
    "rect25",
    "tri26",
    "rect26",
    "tri27",
    "rect27",
    "tri28",
    "rect28",
    "tri29",
    "rect29",
    "tri30",
    "rect30",
    "tri31",
    "rect31",
    "tri32",
    "rect32",
    "shade3",
    "features3",
    "title33",
    "figmaPaste2",
    "contentsItem10",
    "icon23",
    "text61",
    "contentsItem11",
    "icon24",
    "text62",
    "contentsItem12",
    "icon25",
    "text63",
    "contentsItem13",
    "icon26",
    "text64",
    "contentsItem14",
    "icon27",
    "text65",
    "contentsItem15",
    "icon28",
    "text66",
    "contentsItem16",
    "icon29",
    "text67",
    "contentsItem17",
    "icon30",
    "text68",
    "bodyWrapper5",
    "intro3",
    "col5",
    "logo8",
    "text",
    "title18",
    "desc8",
    "img3",
    "bg2",
    "reimbursement",
    "header11",
    "subtitle4",
    "title19",
    "main4",
    "placeholder16",
    "row",
    "prop",
    "label10",
    "val",
    "prop2",
    "label11",
    "val2",
    "mockupProgressBarWithTitle",
    "header12",
    "title20",
    "val3",
    "bar",
    "value",
    "demographics",
    "demographics2",
    "header13",
    "subtitle7",
    "title4",
    "main5",
    "placeholder17",
    "row2",
    "header14",
    "name6",
    "error",
    "tip",
    "label3",
    "link6",
    "row6",
    "header15",
    "name7",
    "error2",
    "tip2",
    "label4",
    "link7",
    "row7",
    "header16",
    "name8",
    "error3",
    "tip3",
    "label5",
    "link8",
    "shade2",
    "cap",
    "header17",
    "subtitle8",
    "title21",
    "main3",
    "placeholder18",
    "field",
    "label6",
    "select",
    "input",
    "leftIcon",
    "text25",
    "rightIcon",
    "row5",
    "prop3",
    "label7",
    "val4",
    "prop4",
    "label8",
    "val5",
    "profile3",
    "av3",
    "col6",
    "top4",
    "header18",
    "name9",
    "status3",
    "label9",
    "body8",
    "year3",
    "name5",
    "actions3",
    "mockupButton5",
    "link9",
    "mockupButton6",
    "link5",
    "menu2",
    "header19",
    "title22",
    "icon8",
    "list",
    "item23",
    "text26",
    "item24",
    "text4",
    "item25",
    "text27",
    "item26",
    "text28",
    "item27",
    "text29",
    "item28",
    "text30",
    "item29",
    "text31",
    "item30",
    "text32",
    "item31",
    "text33",
    "item32",
    "text34",
    "alert",
    "icon9",
    "content2",
    "text35",
    "icon10",
    "features",
    "title5",
    "figmaPaste",
    "contentsItem",
    "icon11",
    "text36",
    "contentsItem2",
    "icon12",
    "text37",
    "contentsItem3",
    "icon13",
    "text38",
    "contentsItem4",
    "icon14",
    "text39",
    "contentsItem5",
    "icon15",
    "text5",
    "contentsItem6",
    "icon16",
    "text40",
    "contentsItem7",
    "icon17",
    "text41",
    "contentsItem8",
    "icon18",
    "text42",
    "contentsItem9",
    "icon19",
    "text43",
    "mobileWrapper",
    "header",
    "top",
    "subtitle2",
    "title2",
    "body",
    "tabs",
    "content8",
    "placeholder83",
    "intro5",
    "img5",
    "bg",
    "compWrap",
    "perf",
    "header6",
    "subtitle3",
    "title24",
    "main",
    "mockupCompetencies",
    "graph",
    "labels",
    "series2",
    "rectangle1",
    "rectangle2",
    "rectangle3",
    "rectangle4",
    "rectangle5",
    "rectangle6",
    "series3",
    "rectangle7",
    "rectangle8",
    "rectangle9",
    "rectangle10",
    "rectangle11",
    "rectangle12",
    "scores",
    "graphScore",
    "num",
    "graphScore2",
    "num2",
    "graphScore3",
    "num3",
    "smallerGraph",
    "inner",
    "labels2",
    "series22",
    "rectangle13",
    "rectangle14",
    "rectangle15",
    "rectangle16",
    "rectangle17",
    "rectangle18",
    "series32",
    "rectangle19",
    "rectangle20",
    "rectangle21",
    "rectangle22",
    "rectangle23",
    "rectangle24",
    "scores2",
    "graphScore4",
    "num4",
    "graphScore5",
    "num5",
    "graphScore6",
    "num6",
    "list6",
    "item",
    "icon",
    "abbr",
    "title25",
    "item2",
    "icon2",
    "abbr2",
    "title3",
    "item3",
    "icon3",
    "abbr3",
    "title41",
    "item4",
    "icon4",
    "abbr4",
    "title43",
    "item5",
    "icon5",
    "abbr5",
    "title6",
    "item6",
    "icon6",
    "abbr6",
    "title7",
    "shade",
    "nav2",
    "btn",
    "text55",
    "btn2",
    "text2",
    "btn3",
    "text3",
    "btn4",
    "text56",
    "mockupButtonBarItem",
    "text69",
    "btn5",
    "text6",
    "btn6",
    "text7",
    "btn7",
    "text8",
    "btn8",
    "text9",
    "btn9",
    "text10",
    "profile",
    "av",
    "col12",
    "top2",
    "header2",
    "name",
    "status",
    "label",
    "line",
    "mockupTextPlaceholderContent",
    "placeholder2",
    "body3",
    "year",
    "name2",
    "line2",
    "mockupTextPlaceholderContent2",
    "placeholder3",
    "actions",
    "mockupButton",
    "link",
    "mockupButton2",
    "link2",
    "text11",
    "title8",
    "desc13",
    "areas2",
    "header3",
    "title49",
    "body2",
    "frame23",
    "item7",
    "title50",
    "desc17",
    "item8",
    "title51",
    "desc18",
    "item9",
    "title52",
    "desc19",
    "item10",
    "title53",
    "desc20",
    "item11",
    "title54",
    "desc21",
    "item12",
    "title55",
    "desc10",
    "footnote2",
    "content5",
    "placeholder56",
    "intro6",
    "img6",
    "bg5",
    "xmlid74572",
    "xmlid67762",
    "xmlid74332",
    "xmlid73392",
    "certificate2",
    "top6",
    "mockupCertificateIcon2",
    "bg6",
    "group2",
    "paper3",
    "paper4",
    "cert2",
    "award492",
    "overlay2",
    "title26",
    "mockupTextPlaceholder2",
    "mockupTextPlaceholderParagraph7",
    "mockupTextPlaceholderLine37",
    "mockupTextPlaceholderContent51",
    "placeholder57",
    "mockupTextPlaceholderLine38",
    "mockupTextPlaceholderContent52",
    "placeholder58",
    "mockupTextPlaceholderLine39",
    "mockupTextPlaceholderContent3",
    "placeholder4",
    "mockupTextPlaceholderLine40",
    "mockupTextPlaceholderContent4",
    "placeholder5",
    "mockupTextPlaceholderLine41",
    "mockupTextPlaceholderContent5",
    "placeholder6",
    "mockupTextPlaceholderParagraph8",
    "mockupTextPlaceholderLine42",
    "mockupTextPlaceholderContent6",
    "placeholder7",
    "mockupTextPlaceholderLine43",
    "mockupTextPlaceholderContent7",
    "placeholder8",
    "mockupTextPlaceholderLine44",
    "mockupTextPlaceholderContent8",
    "placeholder9",
    "mockupTextPlaceholderLine45",
    "mockupTextPlaceholderContent9",
    "placeholder10",
    "mockupTextPlaceholderLine46",
    "mockupTextPlaceholderContent10",
    "placeholder11",
    "mockupTextPlaceholderLine47",
    "mockupTextPlaceholderContent11",
    "placeholder12",
    "mockupTextPlaceholderLine48",
    "mockupTextPlaceholderContent12",
    "placeholder13",
    "mockupTextPlaceholderLine49",
    "mockupTextPlaceholderContent13",
    "placeholder14",
    "mockupTextPlaceholderParagraph9",
    "mockupTextPlaceholderLine50",
    "mockupTextPlaceholderContent14",
    "placeholder15",
    "mockupTextPlaceholderLine51",
    "mockupTextPlaceholderContent53",
    "placeholder59",
    "mockupTextPlaceholderLine52",
    "mockupTextPlaceholderContent54",
    "placeholder60",
    "mockupTextPlaceholderLine53",
    "mockupTextPlaceholderContent55",
    "placeholder61",
    "mockupTextPlaceholderLine54",
    "mockupTextPlaceholderContent56",
    "placeholder62",
    "mockupTextPlaceholderParagraph10",
    "mockupTextPlaceholderLine55",
    "mockupTextPlaceholderContent57",
    "placeholder63",
    "mockupTextPlaceholderLine56",
    "mockupTextPlaceholderContent58",
    "placeholder64",
    "mockupTextPlaceholderLine57",
    "mockupTextPlaceholderContent59",
    "placeholder65",
    "mockupTextPlaceholderLine58",
    "mockupTextPlaceholderContent60",
    "placeholder66",
    "mockupTextPlaceholderLine59",
    "mockupTextPlaceholderContent61",
    "placeholder67",
    "mockupTextPlaceholderLine60",
    "mockupTextPlaceholderContent62",
    "placeholder68",
    "mockupTextPlaceholderLine61",
    "mockupTextPlaceholderContent63",
    "placeholder69",
    "mockupTextPlaceholderLine62",
    "mockupTextPlaceholderContent64",
    "placeholder70",
    "mockupButton3",
    "link3",
    "bill3",
    "bill2",
    "header4",
    "subtitle6",
    "title35",
    "main2",
    "placeholder71",
    "header5",
    "title36",
    "date2",
    "section3",
    "head3",
    "mockupTextPlaceholderParagraph11",
    "mockupTextPlaceholderLine63",
    "mockupTextPlaceholderContent65",
    "placeholder72",
    "mockupTextPlaceholderLine64",
    "mockupTextPlaceholderContent66",
    "placeholder73",
    "mockupTextPlaceholderLine65",
    "mockupTextPlaceholderContent67",
    "placeholder74",
    "mockupTextPlaceholderLine66",
    "mockupTextPlaceholderContent68",
    "placeholder75",
    "mockupTextPlaceholderLine67",
    "mockupTextPlaceholderContent69",
    "placeholder76",
    "total3",
    "title37",
    "val8",
    "section4",
    "head4",
    "mockupTextPlaceholderParagraph12",
    "mockupTextPlaceholderLine68",
    "mockupTextPlaceholderContent70",
    "placeholder77",
    "mockupTextPlaceholderLine69",
    "mockupTextPlaceholderContent71",
    "placeholder78",
    "mockupTextPlaceholderLine70",
    "mockupTextPlaceholderContent72",
    "placeholder79",
    "mockupTextPlaceholderLine71",
    "mockupTextPlaceholderContent73",
    "placeholder80",
    "mockupTextPlaceholderLine72",
    "mockupTextPlaceholderContent74",
    "placeholder81",
    "total4",
    "title38",
    "val9",
    "edge2",
    "tri33",
    "rect33",
    "tri34",
    "rect34",
    "tri35",
    "rect35",
    "tri36",
    "rect36",
    "tri37",
    "rect37",
    "tri38",
    "rect38",
    "tri39",
    "rect39",
    "tri40",
    "rect40",
    "tri41",
    "rect41",
    "tri42",
    "rect42",
    "tri43",
    "rect43",
    "tri44",
    "rect44",
    "tri45",
    "rect45",
    "tri46",
    "rect46",
    "tri47",
    "rect47",
    "tri48",
    "rect48",
    "tri49",
    "rect49",
    "tri50",
    "rect50",
    "tri51",
    "rect51",
    "tri52",
    "rect52",
    "tri53",
    "rect53",
    "tri54",
    "rect54",
    "tri55",
    "rect55",
    "tri56",
    "rect56",
    "tri57",
    "rect57",
    "tri58",
    "rect58",
    "tri59",
    "rect59",
    "tri60",
    "rect60",
    "tri61",
    "rect61",
    "tri62",
    "rect62",
    "tri63",
    "rect63",
    "tri64",
    "rect64",
    "shade4",
    "alert4",
    "icon31",
    "content6",
    "text15",
    "icon32",
    "text16",
    "title39",
    "desc11",
    "features2",
    "title40",
    "contents",
    "contentsItem18",
    "icon33",
    "text17",
    "contentsItem19",
    "icon34",
    "text18",
    "contentsItem20",
    "icon35",
    "text19",
    "contentsItem21",
    "icon36",
    "text20",
    "contentsItem22",
    "icon7",
    "text21",
    "contentsItem23",
    "icon37",
    "text22",
    "contentsItem24",
    "icon38",
    "text23",
    "contentsItem25",
    "icon39",
    "text24",
    "content7",
    "placeholder82",
    "intro7",
    "img7",
    "cap2",
    "header27",
    "subtitle11",
    "title42",
    "main9",
    "placeholder84",
    "field2",
    "label14",
    "select2",
    "input2",
    "leftIcon2",
    "text54",
    "rightIcon2",
    "row4",
    "prop5",
    "label15",
    "val10",
    "prop6",
    "label16",
    "val11",
    "text79",
    "title46",
    "desc12",
    "features4",
    "title47",
    "grid",
    "contentsItem26",
    "icon41",
    "text80",
    "contentsItem27",
    "icon42",
    "text81",
    "contentsItem28",
    "icon43",
    "text82",
    "contentsItem29",
    "icon44",
    "text83",
    "contentsItem30",
    "icon45",
    "text84",
    "contentsItem31",
    "icon46",
    "text85",
    "contentsItem32",
    "icon47",
    "text86",
    "contentsItem33",
    "icon48",
    "text87",
    "contentsItem34",
    "icon49",
    "text88"
  ],
  productsProvider: [
    "productsProvider",
    "desktopWrapper",
    "intro2",
    "header9",
    "top3",
    "subtitle",
    "title",
    "body6",
    "col4",
    "nav",
    "img2",
    "logoIcon",
    "logo7",
    "logo2",
    "logo3",
    "productTabs",
    "content",
    "placeholder",
    "intro",
    "col",
    "logo",
    "text53",
    "title23",
    "desc",
    "img",
    "areas",
    "header10",
    "title11",
    "body7",
    "frame22",
    "item17",
    "title12",
    "desc7",
    "item18",
    "title13",
    "desc2",
    "item19",
    "title14",
    "desc3",
    "item20",
    "title15",
    "desc4",
    "item21",
    "title16",
    "desc5",
    "item22",
    "title17",
    "desc6",
    "footnote",
    "bodyWrapper6",
    "intro4",
    "col7",
    "logo9",
    "text44",
    "title27",
    "desc9",
    "img4",
    "bg3",
    "xmlid7457",
    "xmlid6776",
    "xmlid7433",
    "xmlid7339",
    "alert3",
    "icon20",
    "content3",
    "text45",
    "icon21",
    "credits",
    "header20",
    "subtitle5",
    "title28",
    "main6",
    "mockupCmeCredits",
    "table",
    "col8",
    "mockupTableCellText",
    "text46",
    "mockupTableCellAvatar",
    "mockupTableCellAvatar2",
    "mockupTableCellAvatar3",
    "col9",
    "mockupTableCellText2",
    "text47",
    "mockupTableCellText3",
    "text48",
    "mockupTableCellText4",
    "text49",
    "mockupTableCellText5",
    "text50",
    "col10",
    "mockupTableCellText6",
    "text51",
    "mockupTableCellText7",
    "text52",
    "mockupTableCellText8",
    "text57",
    "mockupTableCellText9",
    "text58",
    "col11",
    "mockupTableCellText10",
    "text59",
    "mockupTableCellText11",
    "text60",
    "mockupTableCellText12",
    "text70",
    "mockupTableCellText13",
    "text71",
    "mockupButton7",
    "link10",
    "certificate",
    "top5",
    "mockupCertificateIcon",
    "bg4",
    "group1",
    "paper1",
    "paper2",
    "cert",
    "award491",
    "overlay",
    "title29",
    "mockupTextPlaceholder",
    "mockupTextPlaceholderParagraph",
    "mockupTextPlaceholderLine",
    "mockupTextPlaceholderContent37",
    "placeholder38",
    "mockupTextPlaceholderLine2",
    "mockupTextPlaceholderContent38",
    "placeholder39",
    "mockupTextPlaceholderLine3",
    "mockupTextPlaceholderContent39",
    "placeholder40",
    "mockupTextPlaceholderLine4",
    "mockupTextPlaceholderContent40",
    "placeholder41",
    "mockupTextPlaceholderLine5",
    "mockupTextPlaceholderContent41",
    "placeholder42",
    "mockupTextPlaceholderParagraph2",
    "mockupTextPlaceholderLine6",
    "mockupTextPlaceholderContent42",
    "placeholder43",
    "mockupTextPlaceholderLine7",
    "mockupTextPlaceholderContent43",
    "placeholder44",
    "mockupTextPlaceholderLine8",
    "mockupTextPlaceholderContent44",
    "placeholder45",
    "mockupTextPlaceholderLine9",
    "mockupTextPlaceholderContent45",
    "placeholder46",
    "mockupTextPlaceholderLine10",
    "mockupTextPlaceholderContent46",
    "placeholder47",
    "mockupTextPlaceholderLine11",
    "mockupTextPlaceholderContent47",
    "placeholder48",
    "mockupTextPlaceholderLine12",
    "mockupTextPlaceholderContent48",
    "placeholder49",
    "mockupTextPlaceholderLine13",
    "mockupTextPlaceholderContent49",
    "placeholder50",
    "mockupTextPlaceholderParagraph3",
    "mockupTextPlaceholderLine14",
    "mockupTextPlaceholderContent50",
    "placeholder51",
    "mockupTextPlaceholderLine15",
    "mockupTextPlaceholderContent15",
    "placeholder52",
    "mockupTextPlaceholderLine16",
    "mockupTextPlaceholderContent16",
    "placeholder53",
    "mockupTextPlaceholderLine17",
    "mockupTextPlaceholderContent17",
    "placeholder54",
    "mockupTextPlaceholderLine18",
    "mockupTextPlaceholderContent18",
    "placeholder55",
    "mockupTextPlaceholderParagraph4",
    "mockupTextPlaceholderLine19",
    "mockupTextPlaceholderContent19",
    "placeholder19",
    "mockupTextPlaceholderLine20",
    "mockupTextPlaceholderContent20",
    "placeholder20",
    "mockupTextPlaceholderLine21",
    "mockupTextPlaceholderContent21",
    "placeholder21",
    "mockupTextPlaceholderLine22",
    "mockupTextPlaceholderContent22",
    "placeholder22",
    "mockupTextPlaceholderLine23",
    "mockupTextPlaceholderContent23",
    "placeholder23",
    "mockupTextPlaceholderLine24",
    "mockupTextPlaceholderContent24",
    "placeholder24",
    "mockupTextPlaceholderLine25",
    "mockupTextPlaceholderContent25",
    "placeholder25",
    "mockupTextPlaceholderLine26",
    "mockupTextPlaceholderContent26",
    "placeholder26",
    "mockupButton8",
    "link11",
    "alert2",
    "icon22",
    "check2",
    "content4",
    "report",
    "bill",
    "header21",
    "subtitle9",
    "title30",
    "main7",
    "placeholder27",
    "header22",
    "title31",
    "date",
    "section",
    "head",
    "mockupTextPlaceholderParagraph5",
    "mockupTextPlaceholderLine27",
    "mockupTextPlaceholderContent27",
    "placeholder28",
    "mockupTextPlaceholderLine28",
    "mockupTextPlaceholderContent28",
    "placeholder29",
    "mockupTextPlaceholderLine29",
    "mockupTextPlaceholderContent29",
    "placeholder30",
    "mockupTextPlaceholderLine30",
    "mockupTextPlaceholderContent30",
    "placeholder31",
    "mockupTextPlaceholderLine31",
    "mockupTextPlaceholderContent31",
    "placeholder32",
    "total",
    "title32",
    "val6",
    "section2",
    "head2",
    "mockupTextPlaceholderParagraph6",
    "mockupTextPlaceholderLine32",
    "mockupTextPlaceholderContent32",
    "placeholder33",
    "mockupTextPlaceholderLine33",
    "mockupTextPlaceholderContent33",
    "placeholder34",
    "mockupTextPlaceholderLine34",
    "mockupTextPlaceholderContent34",
    "placeholder35",
    "mockupTextPlaceholderLine35",
    "mockupTextPlaceholderContent35",
    "placeholder36",
    "mockupTextPlaceholderLine36",
    "mockupTextPlaceholderContent36",
    "placeholder37",
    "total2",
    "title34",
    "val7",
    "edge",
    "tri",
    "rect",
    "tri2",
    "rect2",
    "tri3",
    "rect3",
    "tri4",
    "rect4",
    "tri5",
    "rect5",
    "tri6",
    "rect6",
    "tri7",
    "rect7",
    "tri8",
    "rect8",
    "tri9",
    "rect9",
    "tri10",
    "rect10",
    "tri11",
    "rect11",
    "tri12",
    "rect12",
    "tri13",
    "rect13",
    "tri14",
    "rect14",
    "tri15",
    "rect15",
    "tri16",
    "rect16",
    "tri17",
    "rect17",
    "tri18",
    "rect18",
    "tri19",
    "rect19",
    "tri20",
    "rect20",
    "tri21",
    "rect21",
    "tri22",
    "rect22",
    "tri23",
    "rect23",
    "tri24",
    "rect24",
    "tri25",
    "rect25",
    "tri26",
    "rect26",
    "tri27",
    "rect27",
    "tri28",
    "rect28",
    "tri29",
    "rect29",
    "tri30",
    "rect30",
    "tri31",
    "rect31",
    "tri32",
    "rect32",
    "shade3",
    "features3",
    "title33",
    "figmaPaste2",
    "contentsItem10",
    "icon23",
    "text61",
    "contentsItem11",
    "icon24",
    "text62",
    "contentsItem12",
    "icon25",
    "text63",
    "contentsItem13",
    "icon26",
    "text64",
    "contentsItem14",
    "icon27",
    "text65",
    "contentsItem15",
    "icon28",
    "text66",
    "contentsItem16",
    "icon29",
    "text67",
    "contentsItem17",
    "icon30",
    "text68",
    "bodyWrapper5",
    "intro3",
    "col5",
    "logo8",
    "text",
    "title18",
    "desc8",
    "img3",
    "bg2",
    "reimbursement",
    "header11",
    "subtitle4",
    "title19",
    "main4",
    "placeholder16",
    "row",
    "prop",
    "label10",
    "val",
    "prop2",
    "label11",
    "val2",
    "mockupProgressBarWithTitle",
    "header12",
    "title20",
    "val3",
    "bar",
    "value",
    "demographics",
    "demographics2",
    "header13",
    "subtitle7",
    "title4",
    "main5",
    "placeholder17",
    "row2",
    "header14",
    "name6",
    "error",
    "tip",
    "label3",
    "link6",
    "row6",
    "header15",
    "name7",
    "error2",
    "tip2",
    "label4",
    "link7",
    "row7",
    "header16",
    "name8",
    "error3",
    "tip3",
    "label5",
    "link8",
    "shade2",
    "cap",
    "header17",
    "subtitle8",
    "title21",
    "main3",
    "placeholder18",
    "field",
    "label6",
    "select",
    "input",
    "leftIcon",
    "text25",
    "rightIcon",
    "row5",
    "prop3",
    "label7",
    "val4",
    "prop4",
    "label8",
    "val5",
    "profile3",
    "av3",
    "col6",
    "top4",
    "header18",
    "name9",
    "status3",
    "label9",
    "body8",
    "year3",
    "name5",
    "actions3",
    "mockupButton5",
    "link9",
    "mockupButton6",
    "link5",
    "menu2",
    "header19",
    "title22",
    "icon8",
    "list",
    "item23",
    "text26",
    "item24",
    "text4",
    "item25",
    "text27",
    "item26",
    "text28",
    "item27",
    "text29",
    "item28",
    "text30",
    "item29",
    "text31",
    "item30",
    "text32",
    "item31",
    "text33",
    "item32",
    "text34",
    "alert",
    "icon9",
    "content2",
    "text35",
    "icon10",
    "features",
    "title5",
    "figmaPaste",
    "contentsItem",
    "icon11",
    "text36",
    "contentsItem2",
    "icon12",
    "text37",
    "contentsItem3",
    "icon13",
    "text38",
    "contentsItem4",
    "icon14",
    "text39",
    "contentsItem5",
    "icon15",
    "text5",
    "contentsItem6",
    "icon16",
    "text40",
    "contentsItem7",
    "icon17",
    "text41",
    "contentsItem8",
    "icon18",
    "text42",
    "contentsItem9",
    "icon19",
    "text43",
    "mobileWrapper",
    "header",
    "top",
    "subtitle2",
    "title2",
    "body",
    "tabs",
    "content8",
    "placeholder83",
    "intro5",
    "img5",
    "bg",
    "compWrap",
    "perf",
    "header6",
    "subtitle3",
    "title24",
    "main",
    "mockupCompetencies",
    "graph",
    "labels",
    "series2",
    "rectangle1",
    "rectangle2",
    "rectangle3",
    "rectangle4",
    "rectangle5",
    "rectangle6",
    "series3",
    "rectangle7",
    "rectangle8",
    "rectangle9",
    "rectangle10",
    "rectangle11",
    "rectangle12",
    "scores",
    "graphScore",
    "num",
    "graphScore2",
    "num2",
    "graphScore3",
    "num3",
    "smallerGraph",
    "inner",
    "labels2",
    "series22",
    "rectangle13",
    "rectangle14",
    "rectangle15",
    "rectangle16",
    "rectangle17",
    "rectangle18",
    "series32",
    "rectangle19",
    "rectangle20",
    "rectangle21",
    "rectangle22",
    "rectangle23",
    "rectangle24",
    "scores2",
    "graphScore4",
    "num4",
    "graphScore5",
    "num5",
    "graphScore6",
    "num6",
    "list6",
    "item",
    "icon",
    "abbr",
    "title25",
    "item2",
    "icon2",
    "abbr2",
    "title3",
    "item3",
    "icon3",
    "abbr3",
    "title41",
    "item4",
    "icon4",
    "abbr4",
    "title43",
    "item5",
    "icon5",
    "abbr5",
    "title6",
    "item6",
    "icon6",
    "abbr6",
    "title7",
    "shade",
    "nav2",
    "btn",
    "text55",
    "btn2",
    "text2",
    "btn3",
    "text3",
    "btn4",
    "text56",
    "mockupButtonBarItem",
    "text69",
    "btn5",
    "text6",
    "btn6",
    "text7",
    "btn7",
    "text8",
    "btn8",
    "text9",
    "btn9",
    "text10",
    "profile",
    "av",
    "col12",
    "top2",
    "header2",
    "name",
    "status",
    "label",
    "line",
    "mockupTextPlaceholderContent",
    "placeholder2",
    "body3",
    "year",
    "name2",
    "line2",
    "mockupTextPlaceholderContent2",
    "placeholder3",
    "actions",
    "mockupButton",
    "link",
    "mockupButton2",
    "link2",
    "text11",
    "title8",
    "desc13",
    "areas2",
    "header3",
    "title49",
    "body2",
    "frame23",
    "item7",
    "title50",
    "desc17",
    "item8",
    "title51",
    "desc18",
    "item9",
    "title52",
    "desc19",
    "item10",
    "title53",
    "desc20",
    "item11",
    "title54",
    "desc21",
    "item12",
    "title55",
    "desc10",
    "footnote2",
    "content5",
    "placeholder56",
    "intro6",
    "img6",
    "bg5",
    "xmlid74572",
    "xmlid67762",
    "xmlid74332",
    "xmlid73392",
    "certificate2",
    "top6",
    "mockupCertificateIcon2",
    "bg6",
    "group2",
    "paper3",
    "paper4",
    "cert2",
    "award492",
    "overlay2",
    "title26",
    "mockupTextPlaceholder2",
    "mockupTextPlaceholderParagraph7",
    "mockupTextPlaceholderLine37",
    "mockupTextPlaceholderContent51",
    "placeholder57",
    "mockupTextPlaceholderLine38",
    "mockupTextPlaceholderContent52",
    "placeholder58",
    "mockupTextPlaceholderLine39",
    "mockupTextPlaceholderContent3",
    "placeholder4",
    "mockupTextPlaceholderLine40",
    "mockupTextPlaceholderContent4",
    "placeholder5",
    "mockupTextPlaceholderLine41",
    "mockupTextPlaceholderContent5",
    "placeholder6",
    "mockupTextPlaceholderParagraph8",
    "mockupTextPlaceholderLine42",
    "mockupTextPlaceholderContent6",
    "placeholder7",
    "mockupTextPlaceholderLine43",
    "mockupTextPlaceholderContent7",
    "placeholder8",
    "mockupTextPlaceholderLine44",
    "mockupTextPlaceholderContent8",
    "placeholder9",
    "mockupTextPlaceholderLine45",
    "mockupTextPlaceholderContent9",
    "placeholder10",
    "mockupTextPlaceholderLine46",
    "mockupTextPlaceholderContent10",
    "placeholder11",
    "mockupTextPlaceholderLine47",
    "mockupTextPlaceholderContent11",
    "placeholder12",
    "mockupTextPlaceholderLine48",
    "mockupTextPlaceholderContent12",
    "placeholder13",
    "mockupTextPlaceholderLine49",
    "mockupTextPlaceholderContent13",
    "placeholder14",
    "mockupTextPlaceholderParagraph9",
    "mockupTextPlaceholderLine50",
    "mockupTextPlaceholderContent14",
    "placeholder15",
    "mockupTextPlaceholderLine51",
    "mockupTextPlaceholderContent53",
    "placeholder59",
    "mockupTextPlaceholderLine52",
    "mockupTextPlaceholderContent54",
    "placeholder60",
    "mockupTextPlaceholderLine53",
    "mockupTextPlaceholderContent55",
    "placeholder61",
    "mockupTextPlaceholderLine54",
    "mockupTextPlaceholderContent56",
    "placeholder62",
    "mockupTextPlaceholderParagraph10",
    "mockupTextPlaceholderLine55",
    "mockupTextPlaceholderContent57",
    "placeholder63",
    "mockupTextPlaceholderLine56",
    "mockupTextPlaceholderContent58",
    "placeholder64",
    "mockupTextPlaceholderLine57",
    "mockupTextPlaceholderContent59",
    "placeholder65",
    "mockupTextPlaceholderLine58",
    "mockupTextPlaceholderContent60",
    "placeholder66",
    "mockupTextPlaceholderLine59",
    "mockupTextPlaceholderContent61",
    "placeholder67",
    "mockupTextPlaceholderLine60",
    "mockupTextPlaceholderContent62",
    "placeholder68",
    "mockupTextPlaceholderLine61",
    "mockupTextPlaceholderContent63",
    "placeholder69",
    "mockupTextPlaceholderLine62",
    "mockupTextPlaceholderContent64",
    "placeholder70",
    "mockupButton3",
    "link3",
    "bill3",
    "bill2",
    "header4",
    "subtitle6",
    "title35",
    "main2",
    "placeholder71",
    "header5",
    "title36",
    "date2",
    "section3",
    "head3",
    "mockupTextPlaceholderParagraph11",
    "mockupTextPlaceholderLine63",
    "mockupTextPlaceholderContent65",
    "placeholder72",
    "mockupTextPlaceholderLine64",
    "mockupTextPlaceholderContent66",
    "placeholder73",
    "mockupTextPlaceholderLine65",
    "mockupTextPlaceholderContent67",
    "placeholder74",
    "mockupTextPlaceholderLine66",
    "mockupTextPlaceholderContent68",
    "placeholder75",
    "mockupTextPlaceholderLine67",
    "mockupTextPlaceholderContent69",
    "placeholder76",
    "total3",
    "title37",
    "val8",
    "section4",
    "head4",
    "mockupTextPlaceholderParagraph12",
    "mockupTextPlaceholderLine68",
    "mockupTextPlaceholderContent70",
    "placeholder77",
    "mockupTextPlaceholderLine69",
    "mockupTextPlaceholderContent71",
    "placeholder78",
    "mockupTextPlaceholderLine70",
    "mockupTextPlaceholderContent72",
    "placeholder79",
    "mockupTextPlaceholderLine71",
    "mockupTextPlaceholderContent73",
    "placeholder80",
    "mockupTextPlaceholderLine72",
    "mockupTextPlaceholderContent74",
    "placeholder81",
    "total4",
    "title38",
    "val9",
    "edge2",
    "tri33",
    "rect33",
    "tri34",
    "rect34",
    "tri35",
    "rect35",
    "tri36",
    "rect36",
    "tri37",
    "rect37",
    "tri38",
    "rect38",
    "tri39",
    "rect39",
    "tri40",
    "rect40",
    "tri41",
    "rect41",
    "tri42",
    "rect42",
    "tri43",
    "rect43",
    "tri44",
    "rect44",
    "tri45",
    "rect45",
    "tri46",
    "rect46",
    "tri47",
    "rect47",
    "tri48",
    "rect48",
    "tri49",
    "rect49",
    "tri50",
    "rect50",
    "tri51",
    "rect51",
    "tri52",
    "rect52",
    "tri53",
    "rect53",
    "tri54",
    "rect54",
    "tri55",
    "rect55",
    "tri56",
    "rect56",
    "tri57",
    "rect57",
    "tri58",
    "rect58",
    "tri59",
    "rect59",
    "tri60",
    "rect60",
    "tri61",
    "rect61",
    "tri62",
    "rect62",
    "tri63",
    "rect63",
    "tri64",
    "rect64",
    "shade4",
    "alert4",
    "icon31",
    "content6",
    "text15",
    "icon32",
    "text16",
    "title39",
    "desc11",
    "features2",
    "title40",
    "contents",
    "contentsItem18",
    "icon33",
    "text17",
    "contentsItem19",
    "icon34",
    "text18",
    "contentsItem20",
    "icon35",
    "text19",
    "contentsItem21",
    "icon36",
    "text20",
    "contentsItem22",
    "icon7",
    "text21",
    "contentsItem23",
    "icon37",
    "text22",
    "contentsItem24",
    "icon38",
    "text23",
    "contentsItem25",
    "icon39",
    "text24",
    "content7",
    "placeholder82",
    "intro7",
    "img7",
    "cap2",
    "header27",
    "subtitle11",
    "title42",
    "main9",
    "placeholder84",
    "field2",
    "label14",
    "select2",
    "input2",
    "leftIcon2",
    "text54",
    "rightIcon2",
    "row4",
    "prop5",
    "label15",
    "val10",
    "prop6",
    "label16",
    "val11",
    "text79",
    "title46",
    "desc12",
    "features4",
    "title47",
    "grid",
    "contentsItem26",
    "icon41",
    "text80",
    "contentsItem27",
    "icon42",
    "text81",
    "contentsItem28",
    "icon43",
    "text82",
    "contentsItem29",
    "icon44",
    "text83",
    "contentsItem30",
    "icon45",
    "text84",
    "contentsItem31",
    "icon46",
    "text85",
    "contentsItem32",
    "icon47",
    "text86",
    "contentsItem33",
    "icon48",
    "text87",
    "contentsItem34",
    "icon49",
    "text88"
  ],
  desktopWrapper: [
    "desktopWrapper",
    "intro2",
    "header9",
    "top3",
    "subtitle",
    "title",
    "body6",
    "col4",
    "nav",
    "img2",
    "logoIcon",
    "logo7",
    "logo2",
    "logo3",
    "productTabs",
    "content",
    "placeholder",
    "intro",
    "col",
    "logo",
    "text53",
    "title23",
    "desc",
    "img",
    "areas",
    "header10",
    "title11",
    "body7",
    "frame22",
    "item17",
    "title12",
    "desc7",
    "item18",
    "title13",
    "desc2",
    "item19",
    "title14",
    "desc3",
    "item20",
    "title15",
    "desc4",
    "item21",
    "title16",
    "desc5",
    "item22",
    "title17",
    "desc6",
    "footnote",
    "bodyWrapper6",
    "intro4",
    "col7",
    "logo9",
    "text44",
    "title27",
    "desc9",
    "img4",
    "bg3",
    "xmlid7457",
    "xmlid6776",
    "xmlid7433",
    "xmlid7339",
    "alert3",
    "icon20",
    "content3",
    "text45",
    "icon21",
    "credits",
    "header20",
    "subtitle5",
    "title28",
    "main6",
    "mockupCmeCredits",
    "table",
    "col8",
    "mockupTableCellText",
    "text46",
    "mockupTableCellAvatar",
    "mockupTableCellAvatar2",
    "mockupTableCellAvatar3",
    "col9",
    "mockupTableCellText2",
    "text47",
    "mockupTableCellText3",
    "text48",
    "mockupTableCellText4",
    "text49",
    "mockupTableCellText5",
    "text50",
    "col10",
    "mockupTableCellText6",
    "text51",
    "mockupTableCellText7",
    "text52",
    "mockupTableCellText8",
    "text57",
    "mockupTableCellText9",
    "text58",
    "col11",
    "mockupTableCellText10",
    "text59",
    "mockupTableCellText11",
    "text60",
    "mockupTableCellText12",
    "text70",
    "mockupTableCellText13",
    "text71",
    "mockupButton7",
    "link10",
    "certificate",
    "top5",
    "mockupCertificateIcon",
    "bg4",
    "group1",
    "paper1",
    "paper2",
    "cert",
    "award491",
    "overlay",
    "title29",
    "mockupTextPlaceholder",
    "mockupTextPlaceholderParagraph",
    "mockupTextPlaceholderLine",
    "mockupTextPlaceholderContent37",
    "placeholder38",
    "mockupTextPlaceholderLine2",
    "mockupTextPlaceholderContent38",
    "placeholder39",
    "mockupTextPlaceholderLine3",
    "mockupTextPlaceholderContent39",
    "placeholder40",
    "mockupTextPlaceholderLine4",
    "mockupTextPlaceholderContent40",
    "placeholder41",
    "mockupTextPlaceholderLine5",
    "mockupTextPlaceholderContent41",
    "placeholder42",
    "mockupTextPlaceholderParagraph2",
    "mockupTextPlaceholderLine6",
    "mockupTextPlaceholderContent42",
    "placeholder43",
    "mockupTextPlaceholderLine7",
    "mockupTextPlaceholderContent43",
    "placeholder44",
    "mockupTextPlaceholderLine8",
    "mockupTextPlaceholderContent44",
    "placeholder45",
    "mockupTextPlaceholderLine9",
    "mockupTextPlaceholderContent45",
    "placeholder46",
    "mockupTextPlaceholderLine10",
    "mockupTextPlaceholderContent46",
    "placeholder47",
    "mockupTextPlaceholderLine11",
    "mockupTextPlaceholderContent47",
    "placeholder48",
    "mockupTextPlaceholderLine12",
    "mockupTextPlaceholderContent48",
    "placeholder49",
    "mockupTextPlaceholderLine13",
    "mockupTextPlaceholderContent49",
    "placeholder50",
    "mockupTextPlaceholderParagraph3",
    "mockupTextPlaceholderLine14",
    "mockupTextPlaceholderContent50",
    "placeholder51",
    "mockupTextPlaceholderLine15",
    "mockupTextPlaceholderContent15",
    "placeholder52",
    "mockupTextPlaceholderLine16",
    "mockupTextPlaceholderContent16",
    "placeholder53",
    "mockupTextPlaceholderLine17",
    "mockupTextPlaceholderContent17",
    "placeholder54",
    "mockupTextPlaceholderLine18",
    "mockupTextPlaceholderContent18",
    "placeholder55",
    "mockupTextPlaceholderParagraph4",
    "mockupTextPlaceholderLine19",
    "mockupTextPlaceholderContent19",
    "placeholder19",
    "mockupTextPlaceholderLine20",
    "mockupTextPlaceholderContent20",
    "placeholder20",
    "mockupTextPlaceholderLine21",
    "mockupTextPlaceholderContent21",
    "placeholder21",
    "mockupTextPlaceholderLine22",
    "mockupTextPlaceholderContent22",
    "placeholder22",
    "mockupTextPlaceholderLine23",
    "mockupTextPlaceholderContent23",
    "placeholder23",
    "mockupTextPlaceholderLine24",
    "mockupTextPlaceholderContent24",
    "placeholder24",
    "mockupTextPlaceholderLine25",
    "mockupTextPlaceholderContent25",
    "placeholder25",
    "mockupTextPlaceholderLine26",
    "mockupTextPlaceholderContent26",
    "placeholder26",
    "mockupButton8",
    "link11",
    "alert2",
    "icon22",
    "check2",
    "content4",
    "report",
    "bill",
    "header21",
    "subtitle9",
    "title30",
    "main7",
    "placeholder27",
    "header22",
    "title31",
    "date",
    "section",
    "head",
    "mockupTextPlaceholderParagraph5",
    "mockupTextPlaceholderLine27",
    "mockupTextPlaceholderContent27",
    "placeholder28",
    "mockupTextPlaceholderLine28",
    "mockupTextPlaceholderContent28",
    "placeholder29",
    "mockupTextPlaceholderLine29",
    "mockupTextPlaceholderContent29",
    "placeholder30",
    "mockupTextPlaceholderLine30",
    "mockupTextPlaceholderContent30",
    "placeholder31",
    "mockupTextPlaceholderLine31",
    "mockupTextPlaceholderContent31",
    "placeholder32",
    "total",
    "title32",
    "val6",
    "section2",
    "head2",
    "mockupTextPlaceholderParagraph6",
    "mockupTextPlaceholderLine32",
    "mockupTextPlaceholderContent32",
    "placeholder33",
    "mockupTextPlaceholderLine33",
    "mockupTextPlaceholderContent33",
    "placeholder34",
    "mockupTextPlaceholderLine34",
    "mockupTextPlaceholderContent34",
    "placeholder35",
    "mockupTextPlaceholderLine35",
    "mockupTextPlaceholderContent35",
    "placeholder36",
    "mockupTextPlaceholderLine36",
    "mockupTextPlaceholderContent36",
    "placeholder37",
    "total2",
    "title34",
    "val7",
    "edge",
    "tri",
    "rect",
    "tri2",
    "rect2",
    "tri3",
    "rect3",
    "tri4",
    "rect4",
    "tri5",
    "rect5",
    "tri6",
    "rect6",
    "tri7",
    "rect7",
    "tri8",
    "rect8",
    "tri9",
    "rect9",
    "tri10",
    "rect10",
    "tri11",
    "rect11",
    "tri12",
    "rect12",
    "tri13",
    "rect13",
    "tri14",
    "rect14",
    "tri15",
    "rect15",
    "tri16",
    "rect16",
    "tri17",
    "rect17",
    "tri18",
    "rect18",
    "tri19",
    "rect19",
    "tri20",
    "rect20",
    "tri21",
    "rect21",
    "tri22",
    "rect22",
    "tri23",
    "rect23",
    "tri24",
    "rect24",
    "tri25",
    "rect25",
    "tri26",
    "rect26",
    "tri27",
    "rect27",
    "tri28",
    "rect28",
    "tri29",
    "rect29",
    "tri30",
    "rect30",
    "tri31",
    "rect31",
    "tri32",
    "rect32",
    "shade3",
    "features3",
    "title33",
    "figmaPaste2",
    "contentsItem10",
    "icon23",
    "text61",
    "contentsItem11",
    "icon24",
    "text62",
    "contentsItem12",
    "icon25",
    "text63",
    "contentsItem13",
    "icon26",
    "text64",
    "contentsItem14",
    "icon27",
    "text65",
    "contentsItem15",
    "icon28",
    "text66",
    "contentsItem16",
    "icon29",
    "text67",
    "contentsItem17",
    "icon30",
    "text68",
    "bodyWrapper5",
    "intro3",
    "col5",
    "logo8",
    "text",
    "title18",
    "desc8",
    "img3",
    "bg2",
    "reimbursement",
    "header11",
    "subtitle4",
    "title19",
    "main4",
    "placeholder16",
    "row",
    "prop",
    "label10",
    "val",
    "prop2",
    "label11",
    "val2",
    "mockupProgressBarWithTitle",
    "header12",
    "title20",
    "val3",
    "bar",
    "value",
    "demographics",
    "demographics2",
    "header13",
    "subtitle7",
    "title4",
    "main5",
    "placeholder17",
    "row2",
    "header14",
    "name6",
    "error",
    "tip",
    "label3",
    "link6",
    "row6",
    "header15",
    "name7",
    "error2",
    "tip2",
    "label4",
    "link7",
    "row7",
    "header16",
    "name8",
    "error3",
    "tip3",
    "label5",
    "link8",
    "shade2",
    "cap",
    "header17",
    "subtitle8",
    "title21",
    "main3",
    "placeholder18",
    "field",
    "label6",
    "select",
    "input",
    "leftIcon",
    "text25",
    "rightIcon",
    "row5",
    "prop3",
    "label7",
    "val4",
    "prop4",
    "label8",
    "val5",
    "profile3",
    "av3",
    "col6",
    "top4",
    "header18",
    "name9",
    "status3",
    "label9",
    "body8",
    "year3",
    "name5",
    "actions3",
    "mockupButton5",
    "link9",
    "mockupButton6",
    "link5",
    "menu2",
    "header19",
    "title22",
    "icon8",
    "list",
    "item23",
    "text26",
    "item24",
    "text4",
    "item25",
    "text27",
    "item26",
    "text28",
    "item27",
    "text29",
    "item28",
    "text30",
    "item29",
    "text31",
    "item30",
    "text32",
    "item31",
    "text33",
    "item32",
    "text34",
    "alert",
    "icon9",
    "content2",
    "text35",
    "icon10",
    "features",
    "title5",
    "figmaPaste",
    "contentsItem",
    "icon11",
    "text36",
    "contentsItem2",
    "icon12",
    "text37",
    "contentsItem3",
    "icon13",
    "text38",
    "contentsItem4",
    "icon14",
    "text39",
    "contentsItem5",
    "icon15",
    "text5",
    "contentsItem6",
    "icon16",
    "text40",
    "contentsItem7",
    "icon17",
    "text41",
    "contentsItem8",
    "icon18",
    "text42",
    "contentsItem9",
    "icon19",
    "text43"
  ],
  intro2: [
    "intro2",
    "header9",
    "top3",
    "subtitle",
    "title",
    "body6",
    "col4",
    "nav",
    "img2",
    "logoIcon",
    "logo7",
    "logo2",
    "logo3"
  ],
  header9: ["header9", "top3", "subtitle", "title", "body6"],
  top3: ["top3", "subtitle", "title"],
  subtitle: ["subtitle"],
  title: ["title"],
  body6: ["body6"],
  col4: ["col4", "nav", "img2", "logoIcon", "logo7", "logo2", "logo3"],
  nav: ["nav", "img2", "logoIcon", "logo7", "logo2", "logo3"],
  img2: ["img2", "logoIcon", "logo7", "logo2", "logo3"],
  logoIcon: ["logoIcon"],
  logo7: ["logo7"],
  logo2: ["logo2"],
  logo3: ["logo3"],
  productTabs: [
    "productTabs",
    "content",
    "placeholder",
    "intro",
    "col",
    "logo",
    "text53",
    "title23",
    "desc",
    "img",
    "areas",
    "header10",
    "title11",
    "body7",
    "frame22",
    "item17",
    "title12",
    "desc7",
    "item18",
    "title13",
    "desc2",
    "item19",
    "title14",
    "desc3",
    "item20",
    "title15",
    "desc4",
    "item21",
    "title16",
    "desc5",
    "item22",
    "title17",
    "desc6",
    "footnote",
    "bodyWrapper6",
    "intro4",
    "col7",
    "logo9",
    "text44",
    "title27",
    "desc9",
    "img4",
    "bg3",
    "xmlid7457",
    "xmlid6776",
    "xmlid7433",
    "xmlid7339",
    "alert3",
    "icon20",
    "content3",
    "text45",
    "icon21",
    "credits",
    "header20",
    "subtitle5",
    "title28",
    "main6",
    "mockupCmeCredits",
    "table",
    "col8",
    "mockupTableCellText",
    "text46",
    "mockupTableCellAvatar",
    "mockupTableCellAvatar2",
    "mockupTableCellAvatar3",
    "col9",
    "mockupTableCellText2",
    "text47",
    "mockupTableCellText3",
    "text48",
    "mockupTableCellText4",
    "text49",
    "mockupTableCellText5",
    "text50",
    "col10",
    "mockupTableCellText6",
    "text51",
    "mockupTableCellText7",
    "text52",
    "mockupTableCellText8",
    "text57",
    "mockupTableCellText9",
    "text58",
    "col11",
    "mockupTableCellText10",
    "text59",
    "mockupTableCellText11",
    "text60",
    "mockupTableCellText12",
    "text70",
    "mockupTableCellText13",
    "text71",
    "mockupButton7",
    "link10",
    "certificate",
    "top5",
    "mockupCertificateIcon",
    "bg4",
    "group1",
    "paper1",
    "paper2",
    "cert",
    "award491",
    "overlay",
    "title29",
    "mockupTextPlaceholder",
    "mockupTextPlaceholderParagraph",
    "mockupTextPlaceholderLine",
    "mockupTextPlaceholderContent37",
    "placeholder38",
    "mockupTextPlaceholderLine2",
    "mockupTextPlaceholderContent38",
    "placeholder39",
    "mockupTextPlaceholderLine3",
    "mockupTextPlaceholderContent39",
    "placeholder40",
    "mockupTextPlaceholderLine4",
    "mockupTextPlaceholderContent40",
    "placeholder41",
    "mockupTextPlaceholderLine5",
    "mockupTextPlaceholderContent41",
    "placeholder42",
    "mockupTextPlaceholderParagraph2",
    "mockupTextPlaceholderLine6",
    "mockupTextPlaceholderContent42",
    "placeholder43",
    "mockupTextPlaceholderLine7",
    "mockupTextPlaceholderContent43",
    "placeholder44",
    "mockupTextPlaceholderLine8",
    "mockupTextPlaceholderContent44",
    "placeholder45",
    "mockupTextPlaceholderLine9",
    "mockupTextPlaceholderContent45",
    "placeholder46",
    "mockupTextPlaceholderLine10",
    "mockupTextPlaceholderContent46",
    "placeholder47",
    "mockupTextPlaceholderLine11",
    "mockupTextPlaceholderContent47",
    "placeholder48",
    "mockupTextPlaceholderLine12",
    "mockupTextPlaceholderContent48",
    "placeholder49",
    "mockupTextPlaceholderLine13",
    "mockupTextPlaceholderContent49",
    "placeholder50",
    "mockupTextPlaceholderParagraph3",
    "mockupTextPlaceholderLine14",
    "mockupTextPlaceholderContent50",
    "placeholder51",
    "mockupTextPlaceholderLine15",
    "mockupTextPlaceholderContent15",
    "placeholder52",
    "mockupTextPlaceholderLine16",
    "mockupTextPlaceholderContent16",
    "placeholder53",
    "mockupTextPlaceholderLine17",
    "mockupTextPlaceholderContent17",
    "placeholder54",
    "mockupTextPlaceholderLine18",
    "mockupTextPlaceholderContent18",
    "placeholder55",
    "mockupTextPlaceholderParagraph4",
    "mockupTextPlaceholderLine19",
    "mockupTextPlaceholderContent19",
    "placeholder19",
    "mockupTextPlaceholderLine20",
    "mockupTextPlaceholderContent20",
    "placeholder20",
    "mockupTextPlaceholderLine21",
    "mockupTextPlaceholderContent21",
    "placeholder21",
    "mockupTextPlaceholderLine22",
    "mockupTextPlaceholderContent22",
    "placeholder22",
    "mockupTextPlaceholderLine23",
    "mockupTextPlaceholderContent23",
    "placeholder23",
    "mockupTextPlaceholderLine24",
    "mockupTextPlaceholderContent24",
    "placeholder24",
    "mockupTextPlaceholderLine25",
    "mockupTextPlaceholderContent25",
    "placeholder25",
    "mockupTextPlaceholderLine26",
    "mockupTextPlaceholderContent26",
    "placeholder26",
    "mockupButton8",
    "link11",
    "alert2",
    "icon22",
    "check2",
    "content4",
    "report",
    "bill",
    "header21",
    "subtitle9",
    "title30",
    "main7",
    "placeholder27",
    "header22",
    "title31",
    "date",
    "section",
    "head",
    "mockupTextPlaceholderParagraph5",
    "mockupTextPlaceholderLine27",
    "mockupTextPlaceholderContent27",
    "placeholder28",
    "mockupTextPlaceholderLine28",
    "mockupTextPlaceholderContent28",
    "placeholder29",
    "mockupTextPlaceholderLine29",
    "mockupTextPlaceholderContent29",
    "placeholder30",
    "mockupTextPlaceholderLine30",
    "mockupTextPlaceholderContent30",
    "placeholder31",
    "mockupTextPlaceholderLine31",
    "mockupTextPlaceholderContent31",
    "placeholder32",
    "total",
    "title32",
    "val6",
    "section2",
    "head2",
    "mockupTextPlaceholderParagraph6",
    "mockupTextPlaceholderLine32",
    "mockupTextPlaceholderContent32",
    "placeholder33",
    "mockupTextPlaceholderLine33",
    "mockupTextPlaceholderContent33",
    "placeholder34",
    "mockupTextPlaceholderLine34",
    "mockupTextPlaceholderContent34",
    "placeholder35",
    "mockupTextPlaceholderLine35",
    "mockupTextPlaceholderContent35",
    "placeholder36",
    "mockupTextPlaceholderLine36",
    "mockupTextPlaceholderContent36",
    "placeholder37",
    "total2",
    "title34",
    "val7",
    "edge",
    "tri",
    "rect",
    "tri2",
    "rect2",
    "tri3",
    "rect3",
    "tri4",
    "rect4",
    "tri5",
    "rect5",
    "tri6",
    "rect6",
    "tri7",
    "rect7",
    "tri8",
    "rect8",
    "tri9",
    "rect9",
    "tri10",
    "rect10",
    "tri11",
    "rect11",
    "tri12",
    "rect12",
    "tri13",
    "rect13",
    "tri14",
    "rect14",
    "tri15",
    "rect15",
    "tri16",
    "rect16",
    "tri17",
    "rect17",
    "tri18",
    "rect18",
    "tri19",
    "rect19",
    "tri20",
    "rect20",
    "tri21",
    "rect21",
    "tri22",
    "rect22",
    "tri23",
    "rect23",
    "tri24",
    "rect24",
    "tri25",
    "rect25",
    "tri26",
    "rect26",
    "tri27",
    "rect27",
    "tri28",
    "rect28",
    "tri29",
    "rect29",
    "tri30",
    "rect30",
    "tri31",
    "rect31",
    "tri32",
    "rect32",
    "shade3",
    "features3",
    "title33",
    "figmaPaste2",
    "contentsItem10",
    "icon23",
    "text61",
    "contentsItem11",
    "icon24",
    "text62",
    "contentsItem12",
    "icon25",
    "text63",
    "contentsItem13",
    "icon26",
    "text64",
    "contentsItem14",
    "icon27",
    "text65",
    "contentsItem15",
    "icon28",
    "text66",
    "contentsItem16",
    "icon29",
    "text67",
    "contentsItem17",
    "icon30",
    "text68",
    "bodyWrapper5",
    "intro3",
    "col5",
    "logo8",
    "text",
    "title18",
    "desc8",
    "img3",
    "bg2",
    "reimbursement",
    "header11",
    "subtitle4",
    "title19",
    "main4",
    "placeholder16",
    "row",
    "prop",
    "label10",
    "val",
    "prop2",
    "label11",
    "val2",
    "mockupProgressBarWithTitle",
    "header12",
    "title20",
    "val3",
    "bar",
    "value",
    "demographics",
    "demographics2",
    "header13",
    "subtitle7",
    "title4",
    "main5",
    "placeholder17",
    "row2",
    "header14",
    "name6",
    "error",
    "tip",
    "label3",
    "link6",
    "row6",
    "header15",
    "name7",
    "error2",
    "tip2",
    "label4",
    "link7",
    "row7",
    "header16",
    "name8",
    "error3",
    "tip3",
    "label5",
    "link8",
    "shade2",
    "cap",
    "header17",
    "subtitle8",
    "title21",
    "main3",
    "placeholder18",
    "field",
    "label6",
    "select",
    "input",
    "leftIcon",
    "text25",
    "rightIcon",
    "row5",
    "prop3",
    "label7",
    "val4",
    "prop4",
    "label8",
    "val5",
    "profile3",
    "av3",
    "col6",
    "top4",
    "header18",
    "name9",
    "status3",
    "label9",
    "body8",
    "year3",
    "name5",
    "actions3",
    "mockupButton5",
    "link9",
    "mockupButton6",
    "link5",
    "menu2",
    "header19",
    "title22",
    "icon8",
    "list",
    "item23",
    "text26",
    "item24",
    "text4",
    "item25",
    "text27",
    "item26",
    "text28",
    "item27",
    "text29",
    "item28",
    "text30",
    "item29",
    "text31",
    "item30",
    "text32",
    "item31",
    "text33",
    "item32",
    "text34",
    "alert",
    "icon9",
    "content2",
    "text35",
    "icon10",
    "features",
    "title5",
    "figmaPaste",
    "contentsItem",
    "icon11",
    "text36",
    "contentsItem2",
    "icon12",
    "text37",
    "contentsItem3",
    "icon13",
    "text38",
    "contentsItem4",
    "icon14",
    "text39",
    "contentsItem5",
    "icon15",
    "text5",
    "contentsItem6",
    "icon16",
    "text40",
    "contentsItem7",
    "icon17",
    "text41",
    "contentsItem8",
    "icon18",
    "text42",
    "contentsItem9",
    "icon19",
    "text43"
  ],
  content: [
    "content",
    "placeholder",
    "intro",
    "col",
    "logo",
    "text53",
    "title23",
    "desc",
    "img",
    "areas",
    "header10",
    "title11",
    "body7",
    "frame22",
    "item17",
    "title12",
    "desc7",
    "item18",
    "title13",
    "desc2",
    "item19",
    "title14",
    "desc3",
    "item20",
    "title15",
    "desc4",
    "item21",
    "title16",
    "desc5",
    "item22",
    "title17",
    "desc6",
    "footnote"
  ],
  placeholder: [
    "placeholder",
    "intro",
    "col",
    "logo",
    "text53",
    "title23",
    "desc",
    "img",
    "areas",
    "header10",
    "title11",
    "body7",
    "frame22",
    "item17",
    "title12",
    "desc7",
    "item18",
    "title13",
    "desc2",
    "item19",
    "title14",
    "desc3",
    "item20",
    "title15",
    "desc4",
    "item21",
    "title16",
    "desc5",
    "item22",
    "title17",
    "desc6",
    "footnote"
  ],
  intro: ["intro", "col", "logo", "text53", "title23", "desc", "img"],
  col: ["col", "logo", "text53", "title23", "desc"],
  logo: ["logo"],
  text53: ["text53", "title23", "desc"],
  title23: ["title23"],
  desc: ["desc"],
  img: ["img"],
  areas: [
    "areas",
    "header10",
    "title11",
    "body7",
    "frame22",
    "item17",
    "title12",
    "desc7",
    "item18",
    "title13",
    "desc2",
    "item19",
    "title14",
    "desc3",
    "item20",
    "title15",
    "desc4",
    "item21",
    "title16",
    "desc5",
    "item22",
    "title17",
    "desc6",
    "footnote"
  ],
  header10: ["header10", "title11", "body7"],
  title11: ["title11"],
  body7: ["body7"],
  frame22: [
    "frame22",
    "item17",
    "title12",
    "desc7",
    "item18",
    "title13",
    "desc2",
    "item19",
    "title14",
    "desc3",
    "item20",
    "title15",
    "desc4",
    "item21",
    "title16",
    "desc5",
    "item22",
    "title17",
    "desc6"
  ],
  item17: ["item17", "title12", "desc7"],
  title12: ["title12"],
  desc7: ["desc7"],
  item18: ["item18", "title13", "desc2"],
  title13: ["title13"],
  desc2: ["desc2"],
  item19: ["item19", "title14", "desc3"],
  title14: ["title14"],
  desc3: ["desc3"],
  item20: ["item20", "title15", "desc4"],
  title15: ["title15"],
  desc4: ["desc4"],
  item21: ["item21", "title16", "desc5"],
  title16: ["title16"],
  desc5: ["desc5"],
  item22: ["item22", "title17", "desc6"],
  title17: ["title17"],
  desc6: ["desc6"],
  footnote: ["footnote"],
  bodyWrapper6: [
    "bodyWrapper6",
    "intro4",
    "col7",
    "logo9",
    "text44",
    "title27",
    "desc9",
    "img4",
    "bg3",
    "xmlid7457",
    "xmlid6776",
    "xmlid7433",
    "xmlid7339",
    "alert3",
    "icon20",
    "content3",
    "text45",
    "icon21",
    "credits",
    "header20",
    "subtitle5",
    "title28",
    "main6",
    "mockupCmeCredits",
    "table",
    "col8",
    "mockupTableCellText",
    "text46",
    "mockupTableCellAvatar",
    "mockupTableCellAvatar2",
    "mockupTableCellAvatar3",
    "col9",
    "mockupTableCellText2",
    "text47",
    "mockupTableCellText3",
    "text48",
    "mockupTableCellText4",
    "text49",
    "mockupTableCellText5",
    "text50",
    "col10",
    "mockupTableCellText6",
    "text51",
    "mockupTableCellText7",
    "text52",
    "mockupTableCellText8",
    "text57",
    "mockupTableCellText9",
    "text58",
    "col11",
    "mockupTableCellText10",
    "text59",
    "mockupTableCellText11",
    "text60",
    "mockupTableCellText12",
    "text70",
    "mockupTableCellText13",
    "text71",
    "mockupButton7",
    "link10",
    "certificate",
    "top5",
    "mockupCertificateIcon",
    "bg4",
    "group1",
    "paper1",
    "paper2",
    "cert",
    "award491",
    "overlay",
    "title29",
    "mockupTextPlaceholder",
    "mockupTextPlaceholderParagraph",
    "mockupTextPlaceholderLine",
    "mockupTextPlaceholderContent37",
    "placeholder38",
    "mockupTextPlaceholderLine2",
    "mockupTextPlaceholderContent38",
    "placeholder39",
    "mockupTextPlaceholderLine3",
    "mockupTextPlaceholderContent39",
    "placeholder40",
    "mockupTextPlaceholderLine4",
    "mockupTextPlaceholderContent40",
    "placeholder41",
    "mockupTextPlaceholderLine5",
    "mockupTextPlaceholderContent41",
    "placeholder42",
    "mockupTextPlaceholderParagraph2",
    "mockupTextPlaceholderLine6",
    "mockupTextPlaceholderContent42",
    "placeholder43",
    "mockupTextPlaceholderLine7",
    "mockupTextPlaceholderContent43",
    "placeholder44",
    "mockupTextPlaceholderLine8",
    "mockupTextPlaceholderContent44",
    "placeholder45",
    "mockupTextPlaceholderLine9",
    "mockupTextPlaceholderContent45",
    "placeholder46",
    "mockupTextPlaceholderLine10",
    "mockupTextPlaceholderContent46",
    "placeholder47",
    "mockupTextPlaceholderLine11",
    "mockupTextPlaceholderContent47",
    "placeholder48",
    "mockupTextPlaceholderLine12",
    "mockupTextPlaceholderContent48",
    "placeholder49",
    "mockupTextPlaceholderLine13",
    "mockupTextPlaceholderContent49",
    "placeholder50",
    "mockupTextPlaceholderParagraph3",
    "mockupTextPlaceholderLine14",
    "mockupTextPlaceholderContent50",
    "placeholder51",
    "mockupTextPlaceholderLine15",
    "mockupTextPlaceholderContent15",
    "placeholder52",
    "mockupTextPlaceholderLine16",
    "mockupTextPlaceholderContent16",
    "placeholder53",
    "mockupTextPlaceholderLine17",
    "mockupTextPlaceholderContent17",
    "placeholder54",
    "mockupTextPlaceholderLine18",
    "mockupTextPlaceholderContent18",
    "placeholder55",
    "mockupTextPlaceholderParagraph4",
    "mockupTextPlaceholderLine19",
    "mockupTextPlaceholderContent19",
    "placeholder19",
    "mockupTextPlaceholderLine20",
    "mockupTextPlaceholderContent20",
    "placeholder20",
    "mockupTextPlaceholderLine21",
    "mockupTextPlaceholderContent21",
    "placeholder21",
    "mockupTextPlaceholderLine22",
    "mockupTextPlaceholderContent22",
    "placeholder22",
    "mockupTextPlaceholderLine23",
    "mockupTextPlaceholderContent23",
    "placeholder23",
    "mockupTextPlaceholderLine24",
    "mockupTextPlaceholderContent24",
    "placeholder24",
    "mockupTextPlaceholderLine25",
    "mockupTextPlaceholderContent25",
    "placeholder25",
    "mockupTextPlaceholderLine26",
    "mockupTextPlaceholderContent26",
    "placeholder26",
    "mockupButton8",
    "link11",
    "alert2",
    "icon22",
    "check2",
    "content4",
    "report",
    "bill",
    "header21",
    "subtitle9",
    "title30",
    "main7",
    "placeholder27",
    "header22",
    "title31",
    "date",
    "section",
    "head",
    "mockupTextPlaceholderParagraph5",
    "mockupTextPlaceholderLine27",
    "mockupTextPlaceholderContent27",
    "placeholder28",
    "mockupTextPlaceholderLine28",
    "mockupTextPlaceholderContent28",
    "placeholder29",
    "mockupTextPlaceholderLine29",
    "mockupTextPlaceholderContent29",
    "placeholder30",
    "mockupTextPlaceholderLine30",
    "mockupTextPlaceholderContent30",
    "placeholder31",
    "mockupTextPlaceholderLine31",
    "mockupTextPlaceholderContent31",
    "placeholder32",
    "total",
    "title32",
    "val6",
    "section2",
    "head2",
    "mockupTextPlaceholderParagraph6",
    "mockupTextPlaceholderLine32",
    "mockupTextPlaceholderContent32",
    "placeholder33",
    "mockupTextPlaceholderLine33",
    "mockupTextPlaceholderContent33",
    "placeholder34",
    "mockupTextPlaceholderLine34",
    "mockupTextPlaceholderContent34",
    "placeholder35",
    "mockupTextPlaceholderLine35",
    "mockupTextPlaceholderContent35",
    "placeholder36",
    "mockupTextPlaceholderLine36",
    "mockupTextPlaceholderContent36",
    "placeholder37",
    "total2",
    "title34",
    "val7",
    "edge",
    "tri",
    "rect",
    "tri2",
    "rect2",
    "tri3",
    "rect3",
    "tri4",
    "rect4",
    "tri5",
    "rect5",
    "tri6",
    "rect6",
    "tri7",
    "rect7",
    "tri8",
    "rect8",
    "tri9",
    "rect9",
    "tri10",
    "rect10",
    "tri11",
    "rect11",
    "tri12",
    "rect12",
    "tri13",
    "rect13",
    "tri14",
    "rect14",
    "tri15",
    "rect15",
    "tri16",
    "rect16",
    "tri17",
    "rect17",
    "tri18",
    "rect18",
    "tri19",
    "rect19",
    "tri20",
    "rect20",
    "tri21",
    "rect21",
    "tri22",
    "rect22",
    "tri23",
    "rect23",
    "tri24",
    "rect24",
    "tri25",
    "rect25",
    "tri26",
    "rect26",
    "tri27",
    "rect27",
    "tri28",
    "rect28",
    "tri29",
    "rect29",
    "tri30",
    "rect30",
    "tri31",
    "rect31",
    "tri32",
    "rect32",
    "shade3",
    "features3",
    "title33",
    "figmaPaste2",
    "contentsItem10",
    "icon23",
    "text61",
    "contentsItem11",
    "icon24",
    "text62",
    "contentsItem12",
    "icon25",
    "text63",
    "contentsItem13",
    "icon26",
    "text64",
    "contentsItem14",
    "icon27",
    "text65",
    "contentsItem15",
    "icon28",
    "text66",
    "contentsItem16",
    "icon29",
    "text67",
    "contentsItem17",
    "icon30",
    "text68"
  ],
  intro4: [
    "intro4",
    "col7",
    "logo9",
    "text44",
    "title27",
    "desc9",
    "img4",
    "bg3",
    "xmlid7457",
    "xmlid6776",
    "xmlid7433",
    "xmlid7339",
    "alert3",
    "icon20",
    "content3",
    "text45",
    "icon21",
    "credits",
    "header20",
    "subtitle5",
    "title28",
    "main6",
    "mockupCmeCredits",
    "table",
    "col8",
    "mockupTableCellText",
    "text46",
    "mockupTableCellAvatar",
    "mockupTableCellAvatar2",
    "mockupTableCellAvatar3",
    "col9",
    "mockupTableCellText2",
    "text47",
    "mockupTableCellText3",
    "text48",
    "mockupTableCellText4",
    "text49",
    "mockupTableCellText5",
    "text50",
    "col10",
    "mockupTableCellText6",
    "text51",
    "mockupTableCellText7",
    "text52",
    "mockupTableCellText8",
    "text57",
    "mockupTableCellText9",
    "text58",
    "col11",
    "mockupTableCellText10",
    "text59",
    "mockupTableCellText11",
    "text60",
    "mockupTableCellText12",
    "text70",
    "mockupTableCellText13",
    "text71",
    "mockupButton7",
    "link10",
    "certificate",
    "top5",
    "mockupCertificateIcon",
    "bg4",
    "group1",
    "paper1",
    "paper2",
    "cert",
    "award491",
    "overlay",
    "title29",
    "mockupTextPlaceholder",
    "mockupTextPlaceholderParagraph",
    "mockupTextPlaceholderLine",
    "mockupTextPlaceholderContent37",
    "placeholder38",
    "mockupTextPlaceholderLine2",
    "mockupTextPlaceholderContent38",
    "placeholder39",
    "mockupTextPlaceholderLine3",
    "mockupTextPlaceholderContent39",
    "placeholder40",
    "mockupTextPlaceholderLine4",
    "mockupTextPlaceholderContent40",
    "placeholder41",
    "mockupTextPlaceholderLine5",
    "mockupTextPlaceholderContent41",
    "placeholder42",
    "mockupTextPlaceholderParagraph2",
    "mockupTextPlaceholderLine6",
    "mockupTextPlaceholderContent42",
    "placeholder43",
    "mockupTextPlaceholderLine7",
    "mockupTextPlaceholderContent43",
    "placeholder44",
    "mockupTextPlaceholderLine8",
    "mockupTextPlaceholderContent44",
    "placeholder45",
    "mockupTextPlaceholderLine9",
    "mockupTextPlaceholderContent45",
    "placeholder46",
    "mockupTextPlaceholderLine10",
    "mockupTextPlaceholderContent46",
    "placeholder47",
    "mockupTextPlaceholderLine11",
    "mockupTextPlaceholderContent47",
    "placeholder48",
    "mockupTextPlaceholderLine12",
    "mockupTextPlaceholderContent48",
    "placeholder49",
    "mockupTextPlaceholderLine13",
    "mockupTextPlaceholderContent49",
    "placeholder50",
    "mockupTextPlaceholderParagraph3",
    "mockupTextPlaceholderLine14",
    "mockupTextPlaceholderContent50",
    "placeholder51",
    "mockupTextPlaceholderLine15",
    "mockupTextPlaceholderContent15",
    "placeholder52",
    "mockupTextPlaceholderLine16",
    "mockupTextPlaceholderContent16",
    "placeholder53",
    "mockupTextPlaceholderLine17",
    "mockupTextPlaceholderContent17",
    "placeholder54",
    "mockupTextPlaceholderLine18",
    "mockupTextPlaceholderContent18",
    "placeholder55",
    "mockupTextPlaceholderParagraph4",
    "mockupTextPlaceholderLine19",
    "mockupTextPlaceholderContent19",
    "placeholder19",
    "mockupTextPlaceholderLine20",
    "mockupTextPlaceholderContent20",
    "placeholder20",
    "mockupTextPlaceholderLine21",
    "mockupTextPlaceholderContent21",
    "placeholder21",
    "mockupTextPlaceholderLine22",
    "mockupTextPlaceholderContent22",
    "placeholder22",
    "mockupTextPlaceholderLine23",
    "mockupTextPlaceholderContent23",
    "placeholder23",
    "mockupTextPlaceholderLine24",
    "mockupTextPlaceholderContent24",
    "placeholder24",
    "mockupTextPlaceholderLine25",
    "mockupTextPlaceholderContent25",
    "placeholder25",
    "mockupTextPlaceholderLine26",
    "mockupTextPlaceholderContent26",
    "placeholder26",
    "mockupButton8",
    "link11",
    "alert2",
    "icon22",
    "check2",
    "content4",
    "report",
    "bill",
    "header21",
    "subtitle9",
    "title30",
    "main7",
    "placeholder27",
    "header22",
    "title31",
    "date",
    "section",
    "head",
    "mockupTextPlaceholderParagraph5",
    "mockupTextPlaceholderLine27",
    "mockupTextPlaceholderContent27",
    "placeholder28",
    "mockupTextPlaceholderLine28",
    "mockupTextPlaceholderContent28",
    "placeholder29",
    "mockupTextPlaceholderLine29",
    "mockupTextPlaceholderContent29",
    "placeholder30",
    "mockupTextPlaceholderLine30",
    "mockupTextPlaceholderContent30",
    "placeholder31",
    "mockupTextPlaceholderLine31",
    "mockupTextPlaceholderContent31",
    "placeholder32",
    "total",
    "title32",
    "val6",
    "section2",
    "head2",
    "mockupTextPlaceholderParagraph6",
    "mockupTextPlaceholderLine32",
    "mockupTextPlaceholderContent32",
    "placeholder33",
    "mockupTextPlaceholderLine33",
    "mockupTextPlaceholderContent33",
    "placeholder34",
    "mockupTextPlaceholderLine34",
    "mockupTextPlaceholderContent34",
    "placeholder35",
    "mockupTextPlaceholderLine35",
    "mockupTextPlaceholderContent35",
    "placeholder36",
    "mockupTextPlaceholderLine36",
    "mockupTextPlaceholderContent36",
    "placeholder37",
    "total2",
    "title34",
    "val7",
    "edge",
    "tri",
    "rect",
    "tri2",
    "rect2",
    "tri3",
    "rect3",
    "tri4",
    "rect4",
    "tri5",
    "rect5",
    "tri6",
    "rect6",
    "tri7",
    "rect7",
    "tri8",
    "rect8",
    "tri9",
    "rect9",
    "tri10",
    "rect10",
    "tri11",
    "rect11",
    "tri12",
    "rect12",
    "tri13",
    "rect13",
    "tri14",
    "rect14",
    "tri15",
    "rect15",
    "tri16",
    "rect16",
    "tri17",
    "rect17",
    "tri18",
    "rect18",
    "tri19",
    "rect19",
    "tri20",
    "rect20",
    "tri21",
    "rect21",
    "tri22",
    "rect22",
    "tri23",
    "rect23",
    "tri24",
    "rect24",
    "tri25",
    "rect25",
    "tri26",
    "rect26",
    "tri27",
    "rect27",
    "tri28",
    "rect28",
    "tri29",
    "rect29",
    "tri30",
    "rect30",
    "tri31",
    "rect31",
    "tri32",
    "rect32",
    "shade3"
  ],
  col7: ["col7", "logo9", "text44", "title27", "desc9"],
  logo9: ["logo9"],
  text44: ["text44", "title27", "desc9"],
  title27: ["title27"],
  desc9: ["desc9"],
  img4: [
    "img4",
    "bg3",
    "xmlid7457",
    "xmlid6776",
    "xmlid7433",
    "xmlid7339",
    "alert3",
    "icon20",
    "content3",
    "text45",
    "icon21",
    "credits",
    "header20",
    "subtitle5",
    "title28",
    "main6",
    "mockupCmeCredits",
    "table",
    "col8",
    "mockupTableCellText",
    "text46",
    "mockupTableCellAvatar",
    "mockupTableCellAvatar2",
    "mockupTableCellAvatar3",
    "col9",
    "mockupTableCellText2",
    "text47",
    "mockupTableCellText3",
    "text48",
    "mockupTableCellText4",
    "text49",
    "mockupTableCellText5",
    "text50",
    "col10",
    "mockupTableCellText6",
    "text51",
    "mockupTableCellText7",
    "text52",
    "mockupTableCellText8",
    "text57",
    "mockupTableCellText9",
    "text58",
    "col11",
    "mockupTableCellText10",
    "text59",
    "mockupTableCellText11",
    "text60",
    "mockupTableCellText12",
    "text70",
    "mockupTableCellText13",
    "text71",
    "mockupButton7",
    "link10",
    "certificate",
    "top5",
    "mockupCertificateIcon",
    "bg4",
    "group1",
    "paper1",
    "paper2",
    "cert",
    "award491",
    "overlay",
    "title29",
    "mockupTextPlaceholder",
    "mockupTextPlaceholderParagraph",
    "mockupTextPlaceholderLine",
    "mockupTextPlaceholderContent37",
    "placeholder38",
    "mockupTextPlaceholderLine2",
    "mockupTextPlaceholderContent38",
    "placeholder39",
    "mockupTextPlaceholderLine3",
    "mockupTextPlaceholderContent39",
    "placeholder40",
    "mockupTextPlaceholderLine4",
    "mockupTextPlaceholderContent40",
    "placeholder41",
    "mockupTextPlaceholderLine5",
    "mockupTextPlaceholderContent41",
    "placeholder42",
    "mockupTextPlaceholderParagraph2",
    "mockupTextPlaceholderLine6",
    "mockupTextPlaceholderContent42",
    "placeholder43",
    "mockupTextPlaceholderLine7",
    "mockupTextPlaceholderContent43",
    "placeholder44",
    "mockupTextPlaceholderLine8",
    "mockupTextPlaceholderContent44",
    "placeholder45",
    "mockupTextPlaceholderLine9",
    "mockupTextPlaceholderContent45",
    "placeholder46",
    "mockupTextPlaceholderLine10",
    "mockupTextPlaceholderContent46",
    "placeholder47",
    "mockupTextPlaceholderLine11",
    "mockupTextPlaceholderContent47",
    "placeholder48",
    "mockupTextPlaceholderLine12",
    "mockupTextPlaceholderContent48",
    "placeholder49",
    "mockupTextPlaceholderLine13",
    "mockupTextPlaceholderContent49",
    "placeholder50",
    "mockupTextPlaceholderParagraph3",
    "mockupTextPlaceholderLine14",
    "mockupTextPlaceholderContent50",
    "placeholder51",
    "mockupTextPlaceholderLine15",
    "mockupTextPlaceholderContent15",
    "placeholder52",
    "mockupTextPlaceholderLine16",
    "mockupTextPlaceholderContent16",
    "placeholder53",
    "mockupTextPlaceholderLine17",
    "mockupTextPlaceholderContent17",
    "placeholder54",
    "mockupTextPlaceholderLine18",
    "mockupTextPlaceholderContent18",
    "placeholder55",
    "mockupTextPlaceholderParagraph4",
    "mockupTextPlaceholderLine19",
    "mockupTextPlaceholderContent19",
    "placeholder19",
    "mockupTextPlaceholderLine20",
    "mockupTextPlaceholderContent20",
    "placeholder20",
    "mockupTextPlaceholderLine21",
    "mockupTextPlaceholderContent21",
    "placeholder21",
    "mockupTextPlaceholderLine22",
    "mockupTextPlaceholderContent22",
    "placeholder22",
    "mockupTextPlaceholderLine23",
    "mockupTextPlaceholderContent23",
    "placeholder23",
    "mockupTextPlaceholderLine24",
    "mockupTextPlaceholderContent24",
    "placeholder24",
    "mockupTextPlaceholderLine25",
    "mockupTextPlaceholderContent25",
    "placeholder25",
    "mockupTextPlaceholderLine26",
    "mockupTextPlaceholderContent26",
    "placeholder26",
    "mockupButton8",
    "link11",
    "alert2",
    "icon22",
    "check2",
    "content4",
    "report",
    "bill",
    "header21",
    "subtitle9",
    "title30",
    "main7",
    "placeholder27",
    "header22",
    "title31",
    "date",
    "section",
    "head",
    "mockupTextPlaceholderParagraph5",
    "mockupTextPlaceholderLine27",
    "mockupTextPlaceholderContent27",
    "placeholder28",
    "mockupTextPlaceholderLine28",
    "mockupTextPlaceholderContent28",
    "placeholder29",
    "mockupTextPlaceholderLine29",
    "mockupTextPlaceholderContent29",
    "placeholder30",
    "mockupTextPlaceholderLine30",
    "mockupTextPlaceholderContent30",
    "placeholder31",
    "mockupTextPlaceholderLine31",
    "mockupTextPlaceholderContent31",
    "placeholder32",
    "total",
    "title32",
    "val6",
    "section2",
    "head2",
    "mockupTextPlaceholderParagraph6",
    "mockupTextPlaceholderLine32",
    "mockupTextPlaceholderContent32",
    "placeholder33",
    "mockupTextPlaceholderLine33",
    "mockupTextPlaceholderContent33",
    "placeholder34",
    "mockupTextPlaceholderLine34",
    "mockupTextPlaceholderContent34",
    "placeholder35",
    "mockupTextPlaceholderLine35",
    "mockupTextPlaceholderContent35",
    "placeholder36",
    "mockupTextPlaceholderLine36",
    "mockupTextPlaceholderContent36",
    "placeholder37",
    "total2",
    "title34",
    "val7",
    "edge",
    "tri",
    "rect",
    "tri2",
    "rect2",
    "tri3",
    "rect3",
    "tri4",
    "rect4",
    "tri5",
    "rect5",
    "tri6",
    "rect6",
    "tri7",
    "rect7",
    "tri8",
    "rect8",
    "tri9",
    "rect9",
    "tri10",
    "rect10",
    "tri11",
    "rect11",
    "tri12",
    "rect12",
    "tri13",
    "rect13",
    "tri14",
    "rect14",
    "tri15",
    "rect15",
    "tri16",
    "rect16",
    "tri17",
    "rect17",
    "tri18",
    "rect18",
    "tri19",
    "rect19",
    "tri20",
    "rect20",
    "tri21",
    "rect21",
    "tri22",
    "rect22",
    "tri23",
    "rect23",
    "tri24",
    "rect24",
    "tri25",
    "rect25",
    "tri26",
    "rect26",
    "tri27",
    "rect27",
    "tri28",
    "rect28",
    "tri29",
    "rect29",
    "tri30",
    "rect30",
    "tri31",
    "rect31",
    "tri32",
    "rect32",
    "shade3"
  ],
  bg3: ["bg3", "xmlid7457", "xmlid6776", "xmlid7433", "xmlid7339"],
  xmlid7457: ["xmlid7457", "xmlid6776", "xmlid7433", "xmlid7339"],
  xmlid6776: ["xmlid6776"],
  xmlid7433: ["xmlid7433"],
  xmlid7339: ["xmlid7339"],
  alert3: ["alert3", "icon20", "content3", "text45", "icon21"],
  icon20: ["icon20"],
  content3: ["content3", "text45"],
  text45: ["text45"],
  icon21: ["icon21"],
  credits: [
    "credits",
    "header20",
    "subtitle5",
    "title28",
    "main6",
    "mockupCmeCredits",
    "table",
    "col8",
    "mockupTableCellText",
    "text46",
    "mockupTableCellAvatar",
    "mockupTableCellAvatar2",
    "mockupTableCellAvatar3",
    "col9",
    "mockupTableCellText2",
    "text47",
    "mockupTableCellText3",
    "text48",
    "mockupTableCellText4",
    "text49",
    "mockupTableCellText5",
    "text50",
    "col10",
    "mockupTableCellText6",
    "text51",
    "mockupTableCellText7",
    "text52",
    "mockupTableCellText8",
    "text57",
    "mockupTableCellText9",
    "text58",
    "col11",
    "mockupTableCellText10",
    "text59",
    "mockupTableCellText11",
    "text60",
    "mockupTableCellText12",
    "text70",
    "mockupTableCellText13",
    "text71",
    "mockupButton7",
    "link10"
  ],
  header20: ["header20", "subtitle5", "title28"],
  subtitle5: ["subtitle5"],
  title28: ["title28"],
  main6: [
    "main6",
    "mockupCmeCredits",
    "table",
    "col8",
    "mockupTableCellText",
    "text46",
    "mockupTableCellAvatar",
    "mockupTableCellAvatar2",
    "mockupTableCellAvatar3",
    "col9",
    "mockupTableCellText2",
    "text47",
    "mockupTableCellText3",
    "text48",
    "mockupTableCellText4",
    "text49",
    "mockupTableCellText5",
    "text50",
    "col10",
    "mockupTableCellText6",
    "text51",
    "mockupTableCellText7",
    "text52",
    "mockupTableCellText8",
    "text57",
    "mockupTableCellText9",
    "text58",
    "col11",
    "mockupTableCellText10",
    "text59",
    "mockupTableCellText11",
    "text60",
    "mockupTableCellText12",
    "text70",
    "mockupTableCellText13",
    "text71",
    "mockupButton7",
    "link10"
  ],
  mockupCmeCredits: [
    "mockupCmeCredits",
    "table",
    "col8",
    "mockupTableCellText",
    "text46",
    "mockupTableCellAvatar",
    "mockupTableCellAvatar2",
    "mockupTableCellAvatar3",
    "col9",
    "mockupTableCellText2",
    "text47",
    "mockupTableCellText3",
    "text48",
    "mockupTableCellText4",
    "text49",
    "mockupTableCellText5",
    "text50",
    "col10",
    "mockupTableCellText6",
    "text51",
    "mockupTableCellText7",
    "text52",
    "mockupTableCellText8",
    "text57",
    "mockupTableCellText9",
    "text58",
    "col11",
    "mockupTableCellText10",
    "text59",
    "mockupTableCellText11",
    "text60",
    "mockupTableCellText12",
    "text70",
    "mockupTableCellText13",
    "text71",
    "mockupButton7",
    "link10"
  ],
  table: [
    "table",
    "col8",
    "mockupTableCellText",
    "text46",
    "mockupTableCellAvatar",
    "mockupTableCellAvatar2",
    "mockupTableCellAvatar3",
    "col9",
    "mockupTableCellText2",
    "text47",
    "mockupTableCellText3",
    "text48",
    "mockupTableCellText4",
    "text49",
    "mockupTableCellText5",
    "text50",
    "col10",
    "mockupTableCellText6",
    "text51",
    "mockupTableCellText7",
    "text52",
    "mockupTableCellText8",
    "text57",
    "mockupTableCellText9",
    "text58",
    "col11",
    "mockupTableCellText10",
    "text59",
    "mockupTableCellText11",
    "text60",
    "mockupTableCellText12",
    "text70",
    "mockupTableCellText13",
    "text71"
  ],
  col8: [
    "col8",
    "mockupTableCellText",
    "text46",
    "mockupTableCellAvatar",
    "mockupTableCellAvatar2",
    "mockupTableCellAvatar3"
  ],
  mockupTableCellText: ["mockupTableCellText", "text46"],
  text46: ["text46"],
  mockupTableCellAvatar: ["mockupTableCellAvatar"],
  mockupTableCellAvatar2: ["mockupTableCellAvatar2"],
  mockupTableCellAvatar3: ["mockupTableCellAvatar3"],
  col9: [
    "col9",
    "mockupTableCellText2",
    "text47",
    "mockupTableCellText3",
    "text48",
    "mockupTableCellText4",
    "text49",
    "mockupTableCellText5",
    "text50"
  ],
  mockupTableCellText2: ["mockupTableCellText2", "text47"],
  text47: ["text47"],
  mockupTableCellText3: ["mockupTableCellText3", "text48"],
  text48: ["text48"],
  mockupTableCellText4: ["mockupTableCellText4", "text49"],
  text49: ["text49"],
  mockupTableCellText5: ["mockupTableCellText5", "text50"],
  text50: ["text50"],
  col10: [
    "col10",
    "mockupTableCellText6",
    "text51",
    "mockupTableCellText7",
    "text52",
    "mockupTableCellText8",
    "text57",
    "mockupTableCellText9",
    "text58"
  ],
  mockupTableCellText6: ["mockupTableCellText6", "text51"],
  text51: ["text51"],
  mockupTableCellText7: ["mockupTableCellText7", "text52"],
  text52: ["text52"],
  mockupTableCellText8: ["mockupTableCellText8", "text57"],
  text57: ["text57"],
  mockupTableCellText9: ["mockupTableCellText9", "text58"],
  text58: ["text58"],
  col11: [
    "col11",
    "mockupTableCellText10",
    "text59",
    "mockupTableCellText11",
    "text60",
    "mockupTableCellText12",
    "text70",
    "mockupTableCellText13",
    "text71"
  ],
  mockupTableCellText10: ["mockupTableCellText10", "text59"],
  text59: ["text59"],
  mockupTableCellText11: ["mockupTableCellText11", "text60"],
  text60: ["text60"],
  mockupTableCellText12: ["mockupTableCellText12", "text70"],
  text70: ["text70"],
  mockupTableCellText13: ["mockupTableCellText13", "text71"],
  text71: ["text71"],
  mockupButton7: ["mockupButton7", "link10"],
  link10: ["link10"],
  certificate: [
    "certificate",
    "top5",
    "mockupCertificateIcon",
    "bg4",
    "group1",
    "paper1",
    "paper2",
    "cert",
    "award491",
    "overlay",
    "title29",
    "mockupTextPlaceholder",
    "mockupTextPlaceholderParagraph",
    "mockupTextPlaceholderLine",
    "mockupTextPlaceholderContent37",
    "placeholder38",
    "mockupTextPlaceholderLine2",
    "mockupTextPlaceholderContent38",
    "placeholder39",
    "mockupTextPlaceholderLine3",
    "mockupTextPlaceholderContent39",
    "placeholder40",
    "mockupTextPlaceholderLine4",
    "mockupTextPlaceholderContent40",
    "placeholder41",
    "mockupTextPlaceholderLine5",
    "mockupTextPlaceholderContent41",
    "placeholder42",
    "mockupTextPlaceholderParagraph2",
    "mockupTextPlaceholderLine6",
    "mockupTextPlaceholderContent42",
    "placeholder43",
    "mockupTextPlaceholderLine7",
    "mockupTextPlaceholderContent43",
    "placeholder44",
    "mockupTextPlaceholderLine8",
    "mockupTextPlaceholderContent44",
    "placeholder45",
    "mockupTextPlaceholderLine9",
    "mockupTextPlaceholderContent45",
    "placeholder46",
    "mockupTextPlaceholderLine10",
    "mockupTextPlaceholderContent46",
    "placeholder47",
    "mockupTextPlaceholderLine11",
    "mockupTextPlaceholderContent47",
    "placeholder48",
    "mockupTextPlaceholderLine12",
    "mockupTextPlaceholderContent48",
    "placeholder49",
    "mockupTextPlaceholderLine13",
    "mockupTextPlaceholderContent49",
    "placeholder50",
    "mockupTextPlaceholderParagraph3",
    "mockupTextPlaceholderLine14",
    "mockupTextPlaceholderContent50",
    "placeholder51",
    "mockupTextPlaceholderLine15",
    "mockupTextPlaceholderContent15",
    "placeholder52",
    "mockupTextPlaceholderLine16",
    "mockupTextPlaceholderContent16",
    "placeholder53",
    "mockupTextPlaceholderLine17",
    "mockupTextPlaceholderContent17",
    "placeholder54",
    "mockupTextPlaceholderLine18",
    "mockupTextPlaceholderContent18",
    "placeholder55",
    "mockupTextPlaceholderParagraph4",
    "mockupTextPlaceholderLine19",
    "mockupTextPlaceholderContent19",
    "placeholder19",
    "mockupTextPlaceholderLine20",
    "mockupTextPlaceholderContent20",
    "placeholder20",
    "mockupTextPlaceholderLine21",
    "mockupTextPlaceholderContent21",
    "placeholder21",
    "mockupTextPlaceholderLine22",
    "mockupTextPlaceholderContent22",
    "placeholder22",
    "mockupTextPlaceholderLine23",
    "mockupTextPlaceholderContent23",
    "placeholder23",
    "mockupTextPlaceholderLine24",
    "mockupTextPlaceholderContent24",
    "placeholder24",
    "mockupTextPlaceholderLine25",
    "mockupTextPlaceholderContent25",
    "placeholder25",
    "mockupTextPlaceholderLine26",
    "mockupTextPlaceholderContent26",
    "placeholder26",
    "mockupButton8",
    "link11"
  ],
  top5: [
    "top5",
    "mockupCertificateIcon",
    "bg4",
    "group1",
    "paper1",
    "paper2",
    "cert",
    "award491",
    "overlay",
    "title29",
    "mockupTextPlaceholder",
    "mockupTextPlaceholderParagraph",
    "mockupTextPlaceholderLine",
    "mockupTextPlaceholderContent37",
    "placeholder38",
    "mockupTextPlaceholderLine2",
    "mockupTextPlaceholderContent38",
    "placeholder39",
    "mockupTextPlaceholderLine3",
    "mockupTextPlaceholderContent39",
    "placeholder40",
    "mockupTextPlaceholderLine4",
    "mockupTextPlaceholderContent40",
    "placeholder41",
    "mockupTextPlaceholderLine5",
    "mockupTextPlaceholderContent41",
    "placeholder42",
    "mockupTextPlaceholderParagraph2",
    "mockupTextPlaceholderLine6",
    "mockupTextPlaceholderContent42",
    "placeholder43",
    "mockupTextPlaceholderLine7",
    "mockupTextPlaceholderContent43",
    "placeholder44",
    "mockupTextPlaceholderLine8",
    "mockupTextPlaceholderContent44",
    "placeholder45",
    "mockupTextPlaceholderLine9",
    "mockupTextPlaceholderContent45",
    "placeholder46",
    "mockupTextPlaceholderLine10",
    "mockupTextPlaceholderContent46",
    "placeholder47",
    "mockupTextPlaceholderLine11",
    "mockupTextPlaceholderContent47",
    "placeholder48",
    "mockupTextPlaceholderLine12",
    "mockupTextPlaceholderContent48",
    "placeholder49",
    "mockupTextPlaceholderLine13",
    "mockupTextPlaceholderContent49",
    "placeholder50",
    "mockupTextPlaceholderParagraph3",
    "mockupTextPlaceholderLine14",
    "mockupTextPlaceholderContent50",
    "placeholder51",
    "mockupTextPlaceholderLine15",
    "mockupTextPlaceholderContent15",
    "placeholder52",
    "mockupTextPlaceholderLine16",
    "mockupTextPlaceholderContent16",
    "placeholder53",
    "mockupTextPlaceholderLine17",
    "mockupTextPlaceholderContent17",
    "placeholder54",
    "mockupTextPlaceholderLine18",
    "mockupTextPlaceholderContent18",
    "placeholder55",
    "mockupTextPlaceholderParagraph4",
    "mockupTextPlaceholderLine19",
    "mockupTextPlaceholderContent19",
    "placeholder19",
    "mockupTextPlaceholderLine20",
    "mockupTextPlaceholderContent20",
    "placeholder20",
    "mockupTextPlaceholderLine21",
    "mockupTextPlaceholderContent21",
    "placeholder21",
    "mockupTextPlaceholderLine22",
    "mockupTextPlaceholderContent22",
    "placeholder22",
    "mockupTextPlaceholderLine23",
    "mockupTextPlaceholderContent23",
    "placeholder23",
    "mockupTextPlaceholderLine24",
    "mockupTextPlaceholderContent24",
    "placeholder24",
    "mockupTextPlaceholderLine25",
    "mockupTextPlaceholderContent25",
    "placeholder25",
    "mockupTextPlaceholderLine26",
    "mockupTextPlaceholderContent26",
    "placeholder26"
  ],
  mockupCertificateIcon: [
    "mockupCertificateIcon",
    "bg4",
    "group1",
    "paper1",
    "paper2",
    "cert",
    "award491",
    "overlay"
  ],
  bg4: ["bg4"],
  group1: ["group1", "paper1", "paper2", "cert", "award491"],
  paper1: ["paper1"],
  paper2: ["paper2"],
  cert: ["cert", "award491"],
  award491: ["award491"],
  overlay: ["overlay"],
  title29: ["title29"],
  mockupTextPlaceholder: [
    "mockupTextPlaceholder",
    "mockupTextPlaceholderParagraph",
    "mockupTextPlaceholderLine",
    "mockupTextPlaceholderContent37",
    "placeholder38",
    "mockupTextPlaceholderLine2",
    "mockupTextPlaceholderContent38",
    "placeholder39",
    "mockupTextPlaceholderLine3",
    "mockupTextPlaceholderContent39",
    "placeholder40",
    "mockupTextPlaceholderLine4",
    "mockupTextPlaceholderContent40",
    "placeholder41",
    "mockupTextPlaceholderLine5",
    "mockupTextPlaceholderContent41",
    "placeholder42",
    "mockupTextPlaceholderParagraph2",
    "mockupTextPlaceholderLine6",
    "mockupTextPlaceholderContent42",
    "placeholder43",
    "mockupTextPlaceholderLine7",
    "mockupTextPlaceholderContent43",
    "placeholder44",
    "mockupTextPlaceholderLine8",
    "mockupTextPlaceholderContent44",
    "placeholder45",
    "mockupTextPlaceholderLine9",
    "mockupTextPlaceholderContent45",
    "placeholder46",
    "mockupTextPlaceholderLine10",
    "mockupTextPlaceholderContent46",
    "placeholder47",
    "mockupTextPlaceholderLine11",
    "mockupTextPlaceholderContent47",
    "placeholder48",
    "mockupTextPlaceholderLine12",
    "mockupTextPlaceholderContent48",
    "placeholder49",
    "mockupTextPlaceholderLine13",
    "mockupTextPlaceholderContent49",
    "placeholder50",
    "mockupTextPlaceholderParagraph3",
    "mockupTextPlaceholderLine14",
    "mockupTextPlaceholderContent50",
    "placeholder51",
    "mockupTextPlaceholderLine15",
    "mockupTextPlaceholderContent15",
    "placeholder52",
    "mockupTextPlaceholderLine16",
    "mockupTextPlaceholderContent16",
    "placeholder53",
    "mockupTextPlaceholderLine17",
    "mockupTextPlaceholderContent17",
    "placeholder54",
    "mockupTextPlaceholderLine18",
    "mockupTextPlaceholderContent18",
    "placeholder55",
    "mockupTextPlaceholderParagraph4",
    "mockupTextPlaceholderLine19",
    "mockupTextPlaceholderContent19",
    "placeholder19",
    "mockupTextPlaceholderLine20",
    "mockupTextPlaceholderContent20",
    "placeholder20",
    "mockupTextPlaceholderLine21",
    "mockupTextPlaceholderContent21",
    "placeholder21",
    "mockupTextPlaceholderLine22",
    "mockupTextPlaceholderContent22",
    "placeholder22",
    "mockupTextPlaceholderLine23",
    "mockupTextPlaceholderContent23",
    "placeholder23",
    "mockupTextPlaceholderLine24",
    "mockupTextPlaceholderContent24",
    "placeholder24",
    "mockupTextPlaceholderLine25",
    "mockupTextPlaceholderContent25",
    "placeholder25",
    "mockupTextPlaceholderLine26",
    "mockupTextPlaceholderContent26",
    "placeholder26"
  ],
  mockupTextPlaceholderParagraph: [
    "mockupTextPlaceholderParagraph",
    "mockupTextPlaceholderLine",
    "mockupTextPlaceholderContent37",
    "placeholder38",
    "mockupTextPlaceholderLine2",
    "mockupTextPlaceholderContent38",
    "placeholder39",
    "mockupTextPlaceholderLine3",
    "mockupTextPlaceholderContent39",
    "placeholder40",
    "mockupTextPlaceholderLine4",
    "mockupTextPlaceholderContent40",
    "placeholder41",
    "mockupTextPlaceholderLine5",
    "mockupTextPlaceholderContent41",
    "placeholder42"
  ],
  mockupTextPlaceholderLine: [
    "mockupTextPlaceholderLine",
    "mockupTextPlaceholderContent37",
    "placeholder38"
  ],
  mockupTextPlaceholderContent37: [
    "mockupTextPlaceholderContent37",
    "placeholder38"
  ],
  placeholder38: ["placeholder38"],
  mockupTextPlaceholderLine2: [
    "mockupTextPlaceholderLine2",
    "mockupTextPlaceholderContent38",
    "placeholder39"
  ],
  mockupTextPlaceholderContent38: [
    "mockupTextPlaceholderContent38",
    "placeholder39"
  ],
  placeholder39: ["placeholder39"],
  mockupTextPlaceholderLine3: [
    "mockupTextPlaceholderLine3",
    "mockupTextPlaceholderContent39",
    "placeholder40"
  ],
  mockupTextPlaceholderContent39: [
    "mockupTextPlaceholderContent39",
    "placeholder40"
  ],
  placeholder40: ["placeholder40"],
  mockupTextPlaceholderLine4: [
    "mockupTextPlaceholderLine4",
    "mockupTextPlaceholderContent40",
    "placeholder41"
  ],
  mockupTextPlaceholderContent40: [
    "mockupTextPlaceholderContent40",
    "placeholder41"
  ],
  placeholder41: ["placeholder41"],
  mockupTextPlaceholderLine5: [
    "mockupTextPlaceholderLine5",
    "mockupTextPlaceholderContent41",
    "placeholder42"
  ],
  mockupTextPlaceholderContent41: [
    "mockupTextPlaceholderContent41",
    "placeholder42"
  ],
  placeholder42: ["placeholder42"],
  mockupTextPlaceholderParagraph2: [
    "mockupTextPlaceholderParagraph2",
    "mockupTextPlaceholderLine6",
    "mockupTextPlaceholderContent42",
    "placeholder43",
    "mockupTextPlaceholderLine7",
    "mockupTextPlaceholderContent43",
    "placeholder44",
    "mockupTextPlaceholderLine8",
    "mockupTextPlaceholderContent44",
    "placeholder45",
    "mockupTextPlaceholderLine9",
    "mockupTextPlaceholderContent45",
    "placeholder46",
    "mockupTextPlaceholderLine10",
    "mockupTextPlaceholderContent46",
    "placeholder47",
    "mockupTextPlaceholderLine11",
    "mockupTextPlaceholderContent47",
    "placeholder48",
    "mockupTextPlaceholderLine12",
    "mockupTextPlaceholderContent48",
    "placeholder49",
    "mockupTextPlaceholderLine13",
    "mockupTextPlaceholderContent49",
    "placeholder50"
  ],
  mockupTextPlaceholderLine6: [
    "mockupTextPlaceholderLine6",
    "mockupTextPlaceholderContent42",
    "placeholder43"
  ],
  mockupTextPlaceholderContent42: [
    "mockupTextPlaceholderContent42",
    "placeholder43"
  ],
  placeholder43: ["placeholder43"],
  mockupTextPlaceholderLine7: [
    "mockupTextPlaceholderLine7",
    "mockupTextPlaceholderContent43",
    "placeholder44"
  ],
  mockupTextPlaceholderContent43: [
    "mockupTextPlaceholderContent43",
    "placeholder44"
  ],
  placeholder44: ["placeholder44"],
  mockupTextPlaceholderLine8: [
    "mockupTextPlaceholderLine8",
    "mockupTextPlaceholderContent44",
    "placeholder45"
  ],
  mockupTextPlaceholderContent44: [
    "mockupTextPlaceholderContent44",
    "placeholder45"
  ],
  placeholder45: ["placeholder45"],
  mockupTextPlaceholderLine9: [
    "mockupTextPlaceholderLine9",
    "mockupTextPlaceholderContent45",
    "placeholder46"
  ],
  mockupTextPlaceholderContent45: [
    "mockupTextPlaceholderContent45",
    "placeholder46"
  ],
  placeholder46: ["placeholder46"],
  mockupTextPlaceholderLine10: [
    "mockupTextPlaceholderLine10",
    "mockupTextPlaceholderContent46",
    "placeholder47"
  ],
  mockupTextPlaceholderContent46: [
    "mockupTextPlaceholderContent46",
    "placeholder47"
  ],
  placeholder47: ["placeholder47"],
  mockupTextPlaceholderLine11: [
    "mockupTextPlaceholderLine11",
    "mockupTextPlaceholderContent47",
    "placeholder48"
  ],
  mockupTextPlaceholderContent47: [
    "mockupTextPlaceholderContent47",
    "placeholder48"
  ],
  placeholder48: ["placeholder48"],
  mockupTextPlaceholderLine12: [
    "mockupTextPlaceholderLine12",
    "mockupTextPlaceholderContent48",
    "placeholder49"
  ],
  mockupTextPlaceholderContent48: [
    "mockupTextPlaceholderContent48",
    "placeholder49"
  ],
  placeholder49: ["placeholder49"],
  mockupTextPlaceholderLine13: [
    "mockupTextPlaceholderLine13",
    "mockupTextPlaceholderContent49",
    "placeholder50"
  ],
  mockupTextPlaceholderContent49: [
    "mockupTextPlaceholderContent49",
    "placeholder50"
  ],
  placeholder50: ["placeholder50"],
  mockupTextPlaceholderParagraph3: [
    "mockupTextPlaceholderParagraph3",
    "mockupTextPlaceholderLine14",
    "mockupTextPlaceholderContent50",
    "placeholder51",
    "mockupTextPlaceholderLine15",
    "mockupTextPlaceholderContent15",
    "placeholder52",
    "mockupTextPlaceholderLine16",
    "mockupTextPlaceholderContent16",
    "placeholder53",
    "mockupTextPlaceholderLine17",
    "mockupTextPlaceholderContent17",
    "placeholder54",
    "mockupTextPlaceholderLine18",
    "mockupTextPlaceholderContent18",
    "placeholder55"
  ],
  mockupTextPlaceholderLine14: [
    "mockupTextPlaceholderLine14",
    "mockupTextPlaceholderContent50",
    "placeholder51"
  ],
  mockupTextPlaceholderContent50: [
    "mockupTextPlaceholderContent50",
    "placeholder51"
  ],
  placeholder51: ["placeholder51"],
  mockupTextPlaceholderLine15: [
    "mockupTextPlaceholderLine15",
    "mockupTextPlaceholderContent15",
    "placeholder52"
  ],
  mockupTextPlaceholderContent15: [
    "mockupTextPlaceholderContent15",
    "placeholder52"
  ],
  placeholder52: ["placeholder52"],
  mockupTextPlaceholderLine16: [
    "mockupTextPlaceholderLine16",
    "mockupTextPlaceholderContent16",
    "placeholder53"
  ],
  mockupTextPlaceholderContent16: [
    "mockupTextPlaceholderContent16",
    "placeholder53"
  ],
  placeholder53: ["placeholder53"],
  mockupTextPlaceholderLine17: [
    "mockupTextPlaceholderLine17",
    "mockupTextPlaceholderContent17",
    "placeholder54"
  ],
  mockupTextPlaceholderContent17: [
    "mockupTextPlaceholderContent17",
    "placeholder54"
  ],
  placeholder54: ["placeholder54"],
  mockupTextPlaceholderLine18: [
    "mockupTextPlaceholderLine18",
    "mockupTextPlaceholderContent18",
    "placeholder55"
  ],
  mockupTextPlaceholderContent18: [
    "mockupTextPlaceholderContent18",
    "placeholder55"
  ],
  placeholder55: ["placeholder55"],
  mockupTextPlaceholderParagraph4: [
    "mockupTextPlaceholderParagraph4",
    "mockupTextPlaceholderLine19",
    "mockupTextPlaceholderContent19",
    "placeholder19",
    "mockupTextPlaceholderLine20",
    "mockupTextPlaceholderContent20",
    "placeholder20",
    "mockupTextPlaceholderLine21",
    "mockupTextPlaceholderContent21",
    "placeholder21",
    "mockupTextPlaceholderLine22",
    "mockupTextPlaceholderContent22",
    "placeholder22",
    "mockupTextPlaceholderLine23",
    "mockupTextPlaceholderContent23",
    "placeholder23",
    "mockupTextPlaceholderLine24",
    "mockupTextPlaceholderContent24",
    "placeholder24",
    "mockupTextPlaceholderLine25",
    "mockupTextPlaceholderContent25",
    "placeholder25",
    "mockupTextPlaceholderLine26",
    "mockupTextPlaceholderContent26",
    "placeholder26"
  ],
  mockupTextPlaceholderLine19: [
    "mockupTextPlaceholderLine19",
    "mockupTextPlaceholderContent19",
    "placeholder19"
  ],
  mockupTextPlaceholderContent19: [
    "mockupTextPlaceholderContent19",
    "placeholder19"
  ],
  placeholder19: ["placeholder19"],
  mockupTextPlaceholderLine20: [
    "mockupTextPlaceholderLine20",
    "mockupTextPlaceholderContent20",
    "placeholder20"
  ],
  mockupTextPlaceholderContent20: [
    "mockupTextPlaceholderContent20",
    "placeholder20"
  ],
  placeholder20: ["placeholder20"],
  mockupTextPlaceholderLine21: [
    "mockupTextPlaceholderLine21",
    "mockupTextPlaceholderContent21",
    "placeholder21"
  ],
  mockupTextPlaceholderContent21: [
    "mockupTextPlaceholderContent21",
    "placeholder21"
  ],
  placeholder21: ["placeholder21"],
  mockupTextPlaceholderLine22: [
    "mockupTextPlaceholderLine22",
    "mockupTextPlaceholderContent22",
    "placeholder22"
  ],
  mockupTextPlaceholderContent22: [
    "mockupTextPlaceholderContent22",
    "placeholder22"
  ],
  placeholder22: ["placeholder22"],
  mockupTextPlaceholderLine23: [
    "mockupTextPlaceholderLine23",
    "mockupTextPlaceholderContent23",
    "placeholder23"
  ],
  mockupTextPlaceholderContent23: [
    "mockupTextPlaceholderContent23",
    "placeholder23"
  ],
  placeholder23: ["placeholder23"],
  mockupTextPlaceholderLine24: [
    "mockupTextPlaceholderLine24",
    "mockupTextPlaceholderContent24",
    "placeholder24"
  ],
  mockupTextPlaceholderContent24: [
    "mockupTextPlaceholderContent24",
    "placeholder24"
  ],
  placeholder24: ["placeholder24"],
  mockupTextPlaceholderLine25: [
    "mockupTextPlaceholderLine25",
    "mockupTextPlaceholderContent25",
    "placeholder25"
  ],
  mockupTextPlaceholderContent25: [
    "mockupTextPlaceholderContent25",
    "placeholder25"
  ],
  placeholder25: ["placeholder25"],
  mockupTextPlaceholderLine26: [
    "mockupTextPlaceholderLine26",
    "mockupTextPlaceholderContent26",
    "placeholder26"
  ],
  mockupTextPlaceholderContent26: [
    "mockupTextPlaceholderContent26",
    "placeholder26"
  ],
  placeholder26: ["placeholder26"],
  mockupButton8: ["mockupButton8", "link11"],
  link11: ["link11"],
  alert2: ["alert2", "icon22", "check2", "content4"],
  icon22: ["icon22", "check2"],
  check2: ["check2"],
  content4: ["content4"],
  report: [
    "report",
    "bill",
    "header21",
    "subtitle9",
    "title30",
    "main7",
    "placeholder27",
    "header22",
    "title31",
    "date",
    "section",
    "head",
    "mockupTextPlaceholderParagraph5",
    "mockupTextPlaceholderLine27",
    "mockupTextPlaceholderContent27",
    "placeholder28",
    "mockupTextPlaceholderLine28",
    "mockupTextPlaceholderContent28",
    "placeholder29",
    "mockupTextPlaceholderLine29",
    "mockupTextPlaceholderContent29",
    "placeholder30",
    "mockupTextPlaceholderLine30",
    "mockupTextPlaceholderContent30",
    "placeholder31",
    "mockupTextPlaceholderLine31",
    "mockupTextPlaceholderContent31",
    "placeholder32",
    "total",
    "title32",
    "val6",
    "section2",
    "head2",
    "mockupTextPlaceholderParagraph6",
    "mockupTextPlaceholderLine32",
    "mockupTextPlaceholderContent32",
    "placeholder33",
    "mockupTextPlaceholderLine33",
    "mockupTextPlaceholderContent33",
    "placeholder34",
    "mockupTextPlaceholderLine34",
    "mockupTextPlaceholderContent34",
    "placeholder35",
    "mockupTextPlaceholderLine35",
    "mockupTextPlaceholderContent35",
    "placeholder36",
    "mockupTextPlaceholderLine36",
    "mockupTextPlaceholderContent36",
    "placeholder37",
    "total2",
    "title34",
    "val7",
    "edge",
    "tri",
    "rect",
    "tri2",
    "rect2",
    "tri3",
    "rect3",
    "tri4",
    "rect4",
    "tri5",
    "rect5",
    "tri6",
    "rect6",
    "tri7",
    "rect7",
    "tri8",
    "rect8",
    "tri9",
    "rect9",
    "tri10",
    "rect10",
    "tri11",
    "rect11",
    "tri12",
    "rect12",
    "tri13",
    "rect13",
    "tri14",
    "rect14",
    "tri15",
    "rect15",
    "tri16",
    "rect16",
    "tri17",
    "rect17",
    "tri18",
    "rect18",
    "tri19",
    "rect19",
    "tri20",
    "rect20",
    "tri21",
    "rect21",
    "tri22",
    "rect22",
    "tri23",
    "rect23",
    "tri24",
    "rect24",
    "tri25",
    "rect25",
    "tri26",
    "rect26",
    "tri27",
    "rect27",
    "tri28",
    "rect28",
    "tri29",
    "rect29",
    "tri30",
    "rect30",
    "tri31",
    "rect31",
    "tri32",
    "rect32",
    "shade3"
  ],
  bill: [
    "bill",
    "header21",
    "subtitle9",
    "title30",
    "main7",
    "placeholder27",
    "header22",
    "title31",
    "date",
    "section",
    "head",
    "mockupTextPlaceholderParagraph5",
    "mockupTextPlaceholderLine27",
    "mockupTextPlaceholderContent27",
    "placeholder28",
    "mockupTextPlaceholderLine28",
    "mockupTextPlaceholderContent28",
    "placeholder29",
    "mockupTextPlaceholderLine29",
    "mockupTextPlaceholderContent29",
    "placeholder30",
    "mockupTextPlaceholderLine30",
    "mockupTextPlaceholderContent30",
    "placeholder31",
    "mockupTextPlaceholderLine31",
    "mockupTextPlaceholderContent31",
    "placeholder32",
    "total",
    "title32",
    "val6",
    "section2",
    "head2",
    "mockupTextPlaceholderParagraph6",
    "mockupTextPlaceholderLine32",
    "mockupTextPlaceholderContent32",
    "placeholder33",
    "mockupTextPlaceholderLine33",
    "mockupTextPlaceholderContent33",
    "placeholder34",
    "mockupTextPlaceholderLine34",
    "mockupTextPlaceholderContent34",
    "placeholder35",
    "mockupTextPlaceholderLine35",
    "mockupTextPlaceholderContent35",
    "placeholder36",
    "mockupTextPlaceholderLine36",
    "mockupTextPlaceholderContent36",
    "placeholder37",
    "total2",
    "title34",
    "val7",
    "edge",
    "tri",
    "rect",
    "tri2",
    "rect2",
    "tri3",
    "rect3",
    "tri4",
    "rect4",
    "tri5",
    "rect5",
    "tri6",
    "rect6",
    "tri7",
    "rect7",
    "tri8",
    "rect8",
    "tri9",
    "rect9",
    "tri10",
    "rect10",
    "tri11",
    "rect11",
    "tri12",
    "rect12",
    "tri13",
    "rect13",
    "tri14",
    "rect14",
    "tri15",
    "rect15",
    "tri16",
    "rect16",
    "tri17",
    "rect17",
    "tri18",
    "rect18",
    "tri19",
    "rect19",
    "tri20",
    "rect20",
    "tri21",
    "rect21",
    "tri22",
    "rect22",
    "tri23",
    "rect23",
    "tri24",
    "rect24",
    "tri25",
    "rect25",
    "tri26",
    "rect26",
    "tri27",
    "rect27",
    "tri28",
    "rect28",
    "tri29",
    "rect29",
    "tri30",
    "rect30",
    "tri31",
    "rect31",
    "tri32",
    "rect32"
  ],
  header21: ["header21", "subtitle9", "title30"],
  subtitle9: ["subtitle9"],
  title30: ["title30"],
  main7: [
    "main7",
    "placeholder27",
    "header22",
    "title31",
    "date",
    "section",
    "head",
    "mockupTextPlaceholderParagraph5",
    "mockupTextPlaceholderLine27",
    "mockupTextPlaceholderContent27",
    "placeholder28",
    "mockupTextPlaceholderLine28",
    "mockupTextPlaceholderContent28",
    "placeholder29",
    "mockupTextPlaceholderLine29",
    "mockupTextPlaceholderContent29",
    "placeholder30",
    "mockupTextPlaceholderLine30",
    "mockupTextPlaceholderContent30",
    "placeholder31",
    "mockupTextPlaceholderLine31",
    "mockupTextPlaceholderContent31",
    "placeholder32",
    "total",
    "title32",
    "val6",
    "section2",
    "head2",
    "mockupTextPlaceholderParagraph6",
    "mockupTextPlaceholderLine32",
    "mockupTextPlaceholderContent32",
    "placeholder33",
    "mockupTextPlaceholderLine33",
    "mockupTextPlaceholderContent33",
    "placeholder34",
    "mockupTextPlaceholderLine34",
    "mockupTextPlaceholderContent34",
    "placeholder35",
    "mockupTextPlaceholderLine35",
    "mockupTextPlaceholderContent35",
    "placeholder36",
    "mockupTextPlaceholderLine36",
    "mockupTextPlaceholderContent36",
    "placeholder37",
    "total2",
    "title34",
    "val7"
  ],
  placeholder27: [
    "placeholder27",
    "header22",
    "title31",
    "date",
    "section",
    "head",
    "mockupTextPlaceholderParagraph5",
    "mockupTextPlaceholderLine27",
    "mockupTextPlaceholderContent27",
    "placeholder28",
    "mockupTextPlaceholderLine28",
    "mockupTextPlaceholderContent28",
    "placeholder29",
    "mockupTextPlaceholderLine29",
    "mockupTextPlaceholderContent29",
    "placeholder30",
    "mockupTextPlaceholderLine30",
    "mockupTextPlaceholderContent30",
    "placeholder31",
    "mockupTextPlaceholderLine31",
    "mockupTextPlaceholderContent31",
    "placeholder32",
    "total",
    "title32",
    "val6",
    "section2",
    "head2",
    "mockupTextPlaceholderParagraph6",
    "mockupTextPlaceholderLine32",
    "mockupTextPlaceholderContent32",
    "placeholder33",
    "mockupTextPlaceholderLine33",
    "mockupTextPlaceholderContent33",
    "placeholder34",
    "mockupTextPlaceholderLine34",
    "mockupTextPlaceholderContent34",
    "placeholder35",
    "mockupTextPlaceholderLine35",
    "mockupTextPlaceholderContent35",
    "placeholder36",
    "mockupTextPlaceholderLine36",
    "mockupTextPlaceholderContent36",
    "placeholder37",
    "total2",
    "title34",
    "val7"
  ],
  header22: ["header22", "title31", "date"],
  title31: ["title31"],
  date: ["date"],
  section: [
    "section",
    "head",
    "mockupTextPlaceholderParagraph5",
    "mockupTextPlaceholderLine27",
    "mockupTextPlaceholderContent27",
    "placeholder28",
    "mockupTextPlaceholderLine28",
    "mockupTextPlaceholderContent28",
    "placeholder29",
    "mockupTextPlaceholderLine29",
    "mockupTextPlaceholderContent29",
    "placeholder30",
    "mockupTextPlaceholderLine30",
    "mockupTextPlaceholderContent30",
    "placeholder31",
    "mockupTextPlaceholderLine31",
    "mockupTextPlaceholderContent31",
    "placeholder32",
    "total",
    "title32",
    "val6"
  ],
  head: ["head"],
  mockupTextPlaceholderParagraph5: [
    "mockupTextPlaceholderParagraph5",
    "mockupTextPlaceholderLine27",
    "mockupTextPlaceholderContent27",
    "placeholder28",
    "mockupTextPlaceholderLine28",
    "mockupTextPlaceholderContent28",
    "placeholder29",
    "mockupTextPlaceholderLine29",
    "mockupTextPlaceholderContent29",
    "placeholder30",
    "mockupTextPlaceholderLine30",
    "mockupTextPlaceholderContent30",
    "placeholder31",
    "mockupTextPlaceholderLine31",
    "mockupTextPlaceholderContent31",
    "placeholder32"
  ],
  mockupTextPlaceholderLine27: [
    "mockupTextPlaceholderLine27",
    "mockupTextPlaceholderContent27",
    "placeholder28"
  ],
  mockupTextPlaceholderContent27: [
    "mockupTextPlaceholderContent27",
    "placeholder28"
  ],
  placeholder28: ["placeholder28"],
  mockupTextPlaceholderLine28: [
    "mockupTextPlaceholderLine28",
    "mockupTextPlaceholderContent28",
    "placeholder29"
  ],
  mockupTextPlaceholderContent28: [
    "mockupTextPlaceholderContent28",
    "placeholder29"
  ],
  placeholder29: ["placeholder29"],
  mockupTextPlaceholderLine29: [
    "mockupTextPlaceholderLine29",
    "mockupTextPlaceholderContent29",
    "placeholder30"
  ],
  mockupTextPlaceholderContent29: [
    "mockupTextPlaceholderContent29",
    "placeholder30"
  ],
  placeholder30: ["placeholder30"],
  mockupTextPlaceholderLine30: [
    "mockupTextPlaceholderLine30",
    "mockupTextPlaceholderContent30",
    "placeholder31"
  ],
  mockupTextPlaceholderContent30: [
    "mockupTextPlaceholderContent30",
    "placeholder31"
  ],
  placeholder31: ["placeholder31"],
  mockupTextPlaceholderLine31: [
    "mockupTextPlaceholderLine31",
    "mockupTextPlaceholderContent31",
    "placeholder32"
  ],
  mockupTextPlaceholderContent31: [
    "mockupTextPlaceholderContent31",
    "placeholder32"
  ],
  placeholder32: ["placeholder32"],
  total: ["total", "title32", "val6"],
  title32: ["title32"],
  val6: ["val6"],
  section2: [
    "section2",
    "head2",
    "mockupTextPlaceholderParagraph6",
    "mockupTextPlaceholderLine32",
    "mockupTextPlaceholderContent32",
    "placeholder33",
    "mockupTextPlaceholderLine33",
    "mockupTextPlaceholderContent33",
    "placeholder34",
    "mockupTextPlaceholderLine34",
    "mockupTextPlaceholderContent34",
    "placeholder35",
    "mockupTextPlaceholderLine35",
    "mockupTextPlaceholderContent35",
    "placeholder36",
    "mockupTextPlaceholderLine36",
    "mockupTextPlaceholderContent36",
    "placeholder37",
    "total2",
    "title34",
    "val7"
  ],
  head2: ["head2"],
  mockupTextPlaceholderParagraph6: [
    "mockupTextPlaceholderParagraph6",
    "mockupTextPlaceholderLine32",
    "mockupTextPlaceholderContent32",
    "placeholder33",
    "mockupTextPlaceholderLine33",
    "mockupTextPlaceholderContent33",
    "placeholder34",
    "mockupTextPlaceholderLine34",
    "mockupTextPlaceholderContent34",
    "placeholder35",
    "mockupTextPlaceholderLine35",
    "mockupTextPlaceholderContent35",
    "placeholder36",
    "mockupTextPlaceholderLine36",
    "mockupTextPlaceholderContent36",
    "placeholder37"
  ],
  mockupTextPlaceholderLine32: [
    "mockupTextPlaceholderLine32",
    "mockupTextPlaceholderContent32",
    "placeholder33"
  ],
  mockupTextPlaceholderContent32: [
    "mockupTextPlaceholderContent32",
    "placeholder33"
  ],
  placeholder33: ["placeholder33"],
  mockupTextPlaceholderLine33: [
    "mockupTextPlaceholderLine33",
    "mockupTextPlaceholderContent33",
    "placeholder34"
  ],
  mockupTextPlaceholderContent33: [
    "mockupTextPlaceholderContent33",
    "placeholder34"
  ],
  placeholder34: ["placeholder34"],
  mockupTextPlaceholderLine34: [
    "mockupTextPlaceholderLine34",
    "mockupTextPlaceholderContent34",
    "placeholder35"
  ],
  mockupTextPlaceholderContent34: [
    "mockupTextPlaceholderContent34",
    "placeholder35"
  ],
  placeholder35: ["placeholder35"],
  mockupTextPlaceholderLine35: [
    "mockupTextPlaceholderLine35",
    "mockupTextPlaceholderContent35",
    "placeholder36"
  ],
  mockupTextPlaceholderContent35: [
    "mockupTextPlaceholderContent35",
    "placeholder36"
  ],
  placeholder36: ["placeholder36"],
  mockupTextPlaceholderLine36: [
    "mockupTextPlaceholderLine36",
    "mockupTextPlaceholderContent36",
    "placeholder37"
  ],
  mockupTextPlaceholderContent36: [
    "mockupTextPlaceholderContent36",
    "placeholder37"
  ],
  placeholder37: ["placeholder37"],
  total2: ["total2", "title34", "val7"],
  title34: ["title34"],
  val7: ["val7"],
  edge: [
    "edge",
    "tri",
    "rect",
    "tri2",
    "rect2",
    "tri3",
    "rect3",
    "tri4",
    "rect4",
    "tri5",
    "rect5",
    "tri6",
    "rect6",
    "tri7",
    "rect7",
    "tri8",
    "rect8",
    "tri9",
    "rect9",
    "tri10",
    "rect10",
    "tri11",
    "rect11",
    "tri12",
    "rect12",
    "tri13",
    "rect13",
    "tri14",
    "rect14",
    "tri15",
    "rect15",
    "tri16",
    "rect16",
    "tri17",
    "rect17",
    "tri18",
    "rect18",
    "tri19",
    "rect19",
    "tri20",
    "rect20",
    "tri21",
    "rect21",
    "tri22",
    "rect22",
    "tri23",
    "rect23",
    "tri24",
    "rect24",
    "tri25",
    "rect25",
    "tri26",
    "rect26",
    "tri27",
    "rect27",
    "tri28",
    "rect28",
    "tri29",
    "rect29",
    "tri30",
    "rect30",
    "tri31",
    "rect31",
    "tri32",
    "rect32"
  ],
  tri: ["tri", "rect"],
  rect: ["rect"],
  tri2: ["tri2", "rect2"],
  rect2: ["rect2"],
  tri3: ["tri3", "rect3"],
  rect3: ["rect3"],
  tri4: ["tri4", "rect4"],
  rect4: ["rect4"],
  tri5: ["tri5", "rect5"],
  rect5: ["rect5"],
  tri6: ["tri6", "rect6"],
  rect6: ["rect6"],
  tri7: ["tri7", "rect7"],
  rect7: ["rect7"],
  tri8: ["tri8", "rect8"],
  rect8: ["rect8"],
  tri9: ["tri9", "rect9"],
  rect9: ["rect9"],
  tri10: ["tri10", "rect10"],
  rect10: ["rect10"],
  tri11: ["tri11", "rect11"],
  rect11: ["rect11"],
  tri12: ["tri12", "rect12"],
  rect12: ["rect12"],
  tri13: ["tri13", "rect13"],
  rect13: ["rect13"],
  tri14: ["tri14", "rect14"],
  rect14: ["rect14"],
  tri15: ["tri15", "rect15"],
  rect15: ["rect15"],
  tri16: ["tri16", "rect16"],
  rect16: ["rect16"],
  tri17: ["tri17", "rect17"],
  rect17: ["rect17"],
  tri18: ["tri18", "rect18"],
  rect18: ["rect18"],
  tri19: ["tri19", "rect19"],
  rect19: ["rect19"],
  tri20: ["tri20", "rect20"],
  rect20: ["rect20"],
  tri21: ["tri21", "rect21"],
  rect21: ["rect21"],
  tri22: ["tri22", "rect22"],
  rect22: ["rect22"],
  tri23: ["tri23", "rect23"],
  rect23: ["rect23"],
  tri24: ["tri24", "rect24"],
  rect24: ["rect24"],
  tri25: ["tri25", "rect25"],
  rect25: ["rect25"],
  tri26: ["tri26", "rect26"],
  rect26: ["rect26"],
  tri27: ["tri27", "rect27"],
  rect27: ["rect27"],
  tri28: ["tri28", "rect28"],
  rect28: ["rect28"],
  tri29: ["tri29", "rect29"],
  rect29: ["rect29"],
  tri30: ["tri30", "rect30"],
  rect30: ["rect30"],
  tri31: ["tri31", "rect31"],
  rect31: ["rect31"],
  tri32: ["tri32", "rect32"],
  rect32: ["rect32"],
  shade3: ["shade3"],
  features3: [
    "features3",
    "title33",
    "figmaPaste2",
    "contentsItem10",
    "icon23",
    "text61",
    "contentsItem11",
    "icon24",
    "text62",
    "contentsItem12",
    "icon25",
    "text63",
    "contentsItem13",
    "icon26",
    "text64",
    "contentsItem14",
    "icon27",
    "text65",
    "contentsItem15",
    "icon28",
    "text66",
    "contentsItem16",
    "icon29",
    "text67",
    "contentsItem17",
    "icon30",
    "text68"
  ],
  title33: ["title33"],
  figmaPaste2: [
    "figmaPaste2",
    "contentsItem10",
    "icon23",
    "text61",
    "contentsItem11",
    "icon24",
    "text62",
    "contentsItem12",
    "icon25",
    "text63",
    "contentsItem13",
    "icon26",
    "text64",
    "contentsItem14",
    "icon27",
    "text65",
    "contentsItem15",
    "icon28",
    "text66",
    "contentsItem16",
    "icon29",
    "text67",
    "contentsItem17",
    "icon30",
    "text68"
  ],
  contentsItem10: ["contentsItem10", "icon23", "text61"],
  icon23: ["icon23"],
  text61: ["text61"],
  contentsItem11: ["contentsItem11", "icon24", "text62"],
  icon24: ["icon24"],
  text62: ["text62"],
  contentsItem12: ["contentsItem12", "icon25", "text63"],
  icon25: ["icon25"],
  text63: ["text63"],
  contentsItem13: ["contentsItem13", "icon26", "text64"],
  icon26: ["icon26"],
  text64: ["text64"],
  contentsItem14: ["contentsItem14", "icon27", "text65"],
  icon27: ["icon27"],
  text65: ["text65"],
  contentsItem15: ["contentsItem15", "icon28", "text66"],
  icon28: ["icon28"],
  text66: ["text66"],
  contentsItem16: ["contentsItem16", "icon29", "text67"],
  icon29: ["icon29"],
  text67: ["text67"],
  contentsItem17: ["contentsItem17", "icon30", "text68"],
  icon30: ["icon30"],
  text68: ["text68"],
  bodyWrapper5: [
    "bodyWrapper5",
    "intro3",
    "col5",
    "logo8",
    "text",
    "title18",
    "desc8",
    "img3",
    "bg2",
    "reimbursement",
    "header11",
    "subtitle4",
    "title19",
    "main4",
    "placeholder16",
    "row",
    "prop",
    "label10",
    "val",
    "prop2",
    "label11",
    "val2",
    "mockupProgressBarWithTitle",
    "header12",
    "title20",
    "val3",
    "bar",
    "value",
    "demographics",
    "demographics2",
    "header13",
    "subtitle7",
    "title4",
    "main5",
    "placeholder17",
    "row2",
    "header14",
    "name6",
    "error",
    "tip",
    "label3",
    "link6",
    "row6",
    "header15",
    "name7",
    "error2",
    "tip2",
    "label4",
    "link7",
    "row7",
    "header16",
    "name8",
    "error3",
    "tip3",
    "label5",
    "link8",
    "shade2",
    "cap",
    "header17",
    "subtitle8",
    "title21",
    "main3",
    "placeholder18",
    "field",
    "label6",
    "select",
    "input",
    "leftIcon",
    "text25",
    "rightIcon",
    "row5",
    "prop3",
    "label7",
    "val4",
    "prop4",
    "label8",
    "val5",
    "profile3",
    "av3",
    "col6",
    "top4",
    "header18",
    "name9",
    "status3",
    "label9",
    "body8",
    "year3",
    "name5",
    "actions3",
    "mockupButton5",
    "link9",
    "mockupButton6",
    "link5",
    "menu2",
    "header19",
    "title22",
    "icon8",
    "list",
    "item23",
    "text26",
    "item24",
    "text4",
    "item25",
    "text27",
    "item26",
    "text28",
    "item27",
    "text29",
    "item28",
    "text30",
    "item29",
    "text31",
    "item30",
    "text32",
    "item31",
    "text33",
    "item32",
    "text34",
    "alert",
    "icon9",
    "content2",
    "text35",
    "icon10",
    "features",
    "title5",
    "figmaPaste",
    "contentsItem",
    "icon11",
    "text36",
    "contentsItem2",
    "icon12",
    "text37",
    "contentsItem3",
    "icon13",
    "text38",
    "contentsItem4",
    "icon14",
    "text39",
    "contentsItem5",
    "icon15",
    "text5",
    "contentsItem6",
    "icon16",
    "text40",
    "contentsItem7",
    "icon17",
    "text41",
    "contentsItem8",
    "icon18",
    "text42",
    "contentsItem9",
    "icon19",
    "text43"
  ],
  intro3: [
    "intro3",
    "col5",
    "logo8",
    "text",
    "title18",
    "desc8",
    "img3",
    "bg2",
    "reimbursement",
    "header11",
    "subtitle4",
    "title19",
    "main4",
    "placeholder16",
    "row",
    "prop",
    "label10",
    "val",
    "prop2",
    "label11",
    "val2",
    "mockupProgressBarWithTitle",
    "header12",
    "title20",
    "val3",
    "bar",
    "value",
    "demographics",
    "demographics2",
    "header13",
    "subtitle7",
    "title4",
    "main5",
    "placeholder17",
    "row2",
    "header14",
    "name6",
    "error",
    "tip",
    "label3",
    "link6",
    "row6",
    "header15",
    "name7",
    "error2",
    "tip2",
    "label4",
    "link7",
    "row7",
    "header16",
    "name8",
    "error3",
    "tip3",
    "label5",
    "link8",
    "shade2",
    "cap",
    "header17",
    "subtitle8",
    "title21",
    "main3",
    "placeholder18",
    "field",
    "label6",
    "select",
    "input",
    "leftIcon",
    "text25",
    "rightIcon",
    "row5",
    "prop3",
    "label7",
    "val4",
    "prop4",
    "label8",
    "val5",
    "profile3",
    "av3",
    "col6",
    "top4",
    "header18",
    "name9",
    "status3",
    "label9",
    "body8",
    "year3",
    "name5",
    "actions3",
    "mockupButton5",
    "link9",
    "mockupButton6",
    "link5",
    "menu2",
    "header19",
    "title22",
    "icon8",
    "list",
    "item23",
    "text26",
    "item24",
    "text4",
    "item25",
    "text27",
    "item26",
    "text28",
    "item27",
    "text29",
    "item28",
    "text30",
    "item29",
    "text31",
    "item30",
    "text32",
    "item31",
    "text33",
    "item32",
    "text34",
    "alert",
    "icon9",
    "content2",
    "text35",
    "icon10"
  ],
  col5: ["col5", "logo8", "text", "title18", "desc8"],
  logo8: ["logo8"],
  text: ["text", "title18", "desc8"],
  title18: ["title18"],
  desc8: ["desc8"],
  img3: [
    "img3",
    "bg2",
    "reimbursement",
    "header11",
    "subtitle4",
    "title19",
    "main4",
    "placeholder16",
    "row",
    "prop",
    "label10",
    "val",
    "prop2",
    "label11",
    "val2",
    "mockupProgressBarWithTitle",
    "header12",
    "title20",
    "val3",
    "bar",
    "value",
    "demographics",
    "demographics2",
    "header13",
    "subtitle7",
    "title4",
    "main5",
    "placeholder17",
    "row2",
    "header14",
    "name6",
    "error",
    "tip",
    "label3",
    "link6",
    "row6",
    "header15",
    "name7",
    "error2",
    "tip2",
    "label4",
    "link7",
    "row7",
    "header16",
    "name8",
    "error3",
    "tip3",
    "label5",
    "link8",
    "shade2",
    "cap",
    "header17",
    "subtitle8",
    "title21",
    "main3",
    "placeholder18",
    "field",
    "label6",
    "select",
    "input",
    "leftIcon",
    "text25",
    "rightIcon",
    "row5",
    "prop3",
    "label7",
    "val4",
    "prop4",
    "label8",
    "val5",
    "profile3",
    "av3",
    "col6",
    "top4",
    "header18",
    "name9",
    "status3",
    "label9",
    "body8",
    "year3",
    "name5",
    "actions3",
    "mockupButton5",
    "link9",
    "mockupButton6",
    "link5",
    "menu2",
    "header19",
    "title22",
    "icon8",
    "list",
    "item23",
    "text26",
    "item24",
    "text4",
    "item25",
    "text27",
    "item26",
    "text28",
    "item27",
    "text29",
    "item28",
    "text30",
    "item29",
    "text31",
    "item30",
    "text32",
    "item31",
    "text33",
    "item32",
    "text34",
    "alert",
    "icon9",
    "content2",
    "text35",
    "icon10"
  ],
  bg2: ["bg2"],
  reimbursement: [
    "reimbursement",
    "header11",
    "subtitle4",
    "title19",
    "main4",
    "placeholder16",
    "row",
    "prop",
    "label10",
    "val",
    "prop2",
    "label11",
    "val2",
    "mockupProgressBarWithTitle",
    "header12",
    "title20",
    "val3",
    "bar",
    "value"
  ],
  header11: ["header11", "subtitle4", "title19"],
  subtitle4: ["subtitle4"],
  title19: ["title19"],
  main4: [
    "main4",
    "placeholder16",
    "row",
    "prop",
    "label10",
    "val",
    "prop2",
    "label11",
    "val2",
    "mockupProgressBarWithTitle",
    "header12",
    "title20",
    "val3",
    "bar",
    "value"
  ],
  placeholder16: [
    "placeholder16",
    "row",
    "prop",
    "label10",
    "val",
    "prop2",
    "label11",
    "val2",
    "mockupProgressBarWithTitle",
    "header12",
    "title20",
    "val3",
    "bar",
    "value"
  ],
  row: ["row", "prop", "label10", "val", "prop2", "label11", "val2"],
  prop: ["prop", "label10", "val"],
  label10: ["label10"],
  val: ["val"],
  prop2: ["prop2", "label11", "val2"],
  label11: ["label11"],
  val2: ["val2"],
  mockupProgressBarWithTitle: [
    "mockupProgressBarWithTitle",
    "header12",
    "title20",
    "val3",
    "bar",
    "value"
  ],
  header12: ["header12", "title20", "val3"],
  title20: ["title20"],
  val3: ["val3"],
  bar: ["bar", "value"],
  value: ["value"],
  demographics: [
    "demographics",
    "demographics2",
    "header13",
    "subtitle7",
    "title4",
    "main5",
    "placeholder17",
    "row2",
    "header14",
    "name6",
    "error",
    "tip",
    "label3",
    "link6",
    "row6",
    "header15",
    "name7",
    "error2",
    "tip2",
    "label4",
    "link7",
    "row7",
    "header16",
    "name8",
    "error3",
    "tip3",
    "label5",
    "link8",
    "shade2"
  ],
  demographics2: [
    "demographics2",
    "header13",
    "subtitle7",
    "title4",
    "main5",
    "placeholder17",
    "row2",
    "header14",
    "name6",
    "error",
    "tip",
    "label3",
    "link6",
    "row6",
    "header15",
    "name7",
    "error2",
    "tip2",
    "label4",
    "link7",
    "row7",
    "header16",
    "name8",
    "error3",
    "tip3",
    "label5",
    "link8"
  ],
  header13: ["header13", "subtitle7", "title4"],
  subtitle7: ["subtitle7"],
  title4: ["title4"],
  main5: [
    "main5",
    "placeholder17",
    "row2",
    "header14",
    "name6",
    "error",
    "tip",
    "label3",
    "link6",
    "row6",
    "header15",
    "name7",
    "error2",
    "tip2",
    "label4",
    "link7",
    "row7",
    "header16",
    "name8",
    "error3",
    "tip3",
    "label5",
    "link8"
  ],
  placeholder17: [
    "placeholder17",
    "row2",
    "header14",
    "name6",
    "error",
    "tip",
    "label3",
    "link6",
    "row6",
    "header15",
    "name7",
    "error2",
    "tip2",
    "label4",
    "link7",
    "row7",
    "header16",
    "name8",
    "error3",
    "tip3",
    "label5",
    "link8"
  ],
  row2: ["row2", "header14", "name6", "error", "tip", "label3", "link6"],
  header14: ["header14", "name6"],
  name6: ["name6"],
  error: ["error", "tip", "label3", "link6"],
  tip: ["tip"],
  label3: ["label3"],
  link6: ["link6"],
  row6: ["row6", "header15", "name7", "error2", "tip2", "label4", "link7"],
  header15: ["header15", "name7"],
  name7: ["name7"],
  error2: ["error2", "tip2", "label4", "link7"],
  tip2: ["tip2"],
  label4: ["label4"],
  link7: ["link7"],
  row7: ["row7", "header16", "name8", "error3", "tip3", "label5", "link8"],
  header16: ["header16", "name8"],
  name8: ["name8"],
  error3: ["error3", "tip3", "label5", "link8"],
  tip3: ["tip3"],
  label5: ["label5"],
  link8: ["link8"],
  shade2: ["shade2"],
  cap: [
    "cap",
    "header17",
    "subtitle8",
    "title21",
    "main3",
    "placeholder18",
    "field",
    "label6",
    "select",
    "input",
    "leftIcon",
    "text25",
    "rightIcon",
    "row5",
    "prop3",
    "label7",
    "val4",
    "prop4",
    "label8",
    "val5"
  ],
  header17: ["header17", "subtitle8", "title21"],
  subtitle8: ["subtitle8"],
  title21: ["title21"],
  main3: [
    "main3",
    "placeholder18",
    "field",
    "label6",
    "select",
    "input",
    "leftIcon",
    "text25",
    "rightIcon",
    "row5",
    "prop3",
    "label7",
    "val4",
    "prop4",
    "label8",
    "val5"
  ],
  placeholder18: [
    "placeholder18",
    "field",
    "label6",
    "select",
    "input",
    "leftIcon",
    "text25",
    "rightIcon",
    "row5",
    "prop3",
    "label7",
    "val4",
    "prop4",
    "label8",
    "val5"
  ],
  field: [
    "field",
    "label6",
    "select",
    "input",
    "leftIcon",
    "text25",
    "rightIcon"
  ],
  label6: ["label6"],
  select: ["select", "input", "leftIcon", "text25", "rightIcon"],
  input: ["input", "leftIcon", "text25", "rightIcon"],
  leftIcon: ["leftIcon"],
  text25: ["text25"],
  rightIcon: ["rightIcon"],
  row5: ["row5", "prop3", "label7", "val4", "prop4", "label8", "val5"],
  prop3: ["prop3", "label7", "val4"],
  label7: ["label7"],
  val4: ["val4"],
  prop4: ["prop4", "label8", "val5"],
  label8: ["label8"],
  val5: ["val5"],
  profile3: [
    "profile3",
    "av3",
    "col6",
    "top4",
    "header18",
    "name9",
    "status3",
    "label9",
    "body8",
    "year3",
    "name5",
    "actions3",
    "mockupButton5",
    "link9",
    "mockupButton6",
    "link5"
  ],
  av3: ["av3"],
  col6: [
    "col6",
    "top4",
    "header18",
    "name9",
    "status3",
    "label9",
    "body8",
    "year3",
    "name5",
    "actions3",
    "mockupButton5",
    "link9",
    "mockupButton6",
    "link5"
  ],
  top4: [
    "top4",
    "header18",
    "name9",
    "status3",
    "label9",
    "body8",
    "year3",
    "name5"
  ],
  header18: ["header18", "name9", "status3", "label9"],
  name9: ["name9"],
  status3: ["status3", "label9"],
  label9: ["label9"],
  body8: ["body8", "year3", "name5"],
  year3: ["year3"],
  name5: ["name5"],
  actions3: ["actions3", "mockupButton5", "link9", "mockupButton6", "link5"],
  mockupButton5: ["mockupButton5", "link9"],
  link9: ["link9"],
  mockupButton6: ["mockupButton6", "link5"],
  link5: ["link5"],
  menu2: [
    "menu2",
    "header19",
    "title22",
    "icon8",
    "list",
    "item23",
    "text26",
    "item24",
    "text4",
    "item25",
    "text27",
    "item26",
    "text28",
    "item27",
    "text29",
    "item28",
    "text30",
    "item29",
    "text31",
    "item30",
    "text32",
    "item31",
    "text33",
    "item32",
    "text34"
  ],
  header19: ["header19", "title22", "icon8"],
  title22: ["title22"],
  icon8: ["icon8"],
  list: [
    "list",
    "item23",
    "text26",
    "item24",
    "text4",
    "item25",
    "text27",
    "item26",
    "text28",
    "item27",
    "text29",
    "item28",
    "text30",
    "item29",
    "text31",
    "item30",
    "text32",
    "item31",
    "text33",
    "item32",
    "text34"
  ],
  item23: ["item23", "text26"],
  text26: ["text26"],
  item24: ["item24", "text4"],
  text4: ["text4"],
  item25: ["item25", "text27"],
  text27: ["text27"],
  item26: ["item26", "text28"],
  text28: ["text28"],
  item27: ["item27", "text29"],
  text29: ["text29"],
  item28: ["item28", "text30"],
  text30: ["text30"],
  item29: ["item29", "text31"],
  text31: ["text31"],
  item30: ["item30", "text32"],
  text32: ["text32"],
  item31: ["item31", "text33"],
  text33: ["text33"],
  item32: ["item32", "text34"],
  text34: ["text34"],
  alert: ["alert", "icon9", "content2", "text35", "icon10"],
  icon9: ["icon9"],
  content2: ["content2", "text35"],
  text35: ["text35"],
  icon10: ["icon10"],
  features: [
    "features",
    "title5",
    "figmaPaste",
    "contentsItem",
    "icon11",
    "text36",
    "contentsItem2",
    "icon12",
    "text37",
    "contentsItem3",
    "icon13",
    "text38",
    "contentsItem4",
    "icon14",
    "text39",
    "contentsItem5",
    "icon15",
    "text5",
    "contentsItem6",
    "icon16",
    "text40",
    "contentsItem7",
    "icon17",
    "text41",
    "contentsItem8",
    "icon18",
    "text42",
    "contentsItem9",
    "icon19",
    "text43"
  ],
  title5: ["title5"],
  figmaPaste: [
    "figmaPaste",
    "contentsItem",
    "icon11",
    "text36",
    "contentsItem2",
    "icon12",
    "text37",
    "contentsItem3",
    "icon13",
    "text38",
    "contentsItem4",
    "icon14",
    "text39",
    "contentsItem5",
    "icon15",
    "text5",
    "contentsItem6",
    "icon16",
    "text40",
    "contentsItem7",
    "icon17",
    "text41",
    "contentsItem8",
    "icon18",
    "text42",
    "contentsItem9",
    "icon19",
    "text43"
  ],
  contentsItem: ["contentsItem", "icon11", "text36"],
  icon11: ["icon11"],
  text36: ["text36"],
  contentsItem2: ["contentsItem2", "icon12", "text37"],
  icon12: ["icon12"],
  text37: ["text37"],
  contentsItem3: ["contentsItem3", "icon13", "text38"],
  icon13: ["icon13"],
  text38: ["text38"],
  contentsItem4: ["contentsItem4", "icon14", "text39"],
  icon14: ["icon14"],
  text39: ["text39"],
  contentsItem5: ["contentsItem5", "icon15", "text5"],
  icon15: ["icon15"],
  text5: ["text5"],
  contentsItem6: ["contentsItem6", "icon16", "text40"],
  icon16: ["icon16"],
  text40: ["text40"],
  contentsItem7: ["contentsItem7", "icon17", "text41"],
  icon17: ["icon17"],
  text41: ["text41"],
  contentsItem8: ["contentsItem8", "icon18", "text42"],
  icon18: ["icon18"],
  text42: ["text42"],
  contentsItem9: ["contentsItem9", "icon19", "text43"],
  icon19: ["icon19"],
  text43: ["text43"],
  mobileWrapper: [
    "mobileWrapper",
    "header",
    "top",
    "subtitle2",
    "title2",
    "body",
    "tabs",
    "content8",
    "placeholder83",
    "intro5",
    "img5",
    "bg",
    "compWrap",
    "perf",
    "header6",
    "subtitle3",
    "title24",
    "main",
    "mockupCompetencies",
    "graph",
    "labels",
    "series2",
    "rectangle1",
    "rectangle2",
    "rectangle3",
    "rectangle4",
    "rectangle5",
    "rectangle6",
    "series3",
    "rectangle7",
    "rectangle8",
    "rectangle9",
    "rectangle10",
    "rectangle11",
    "rectangle12",
    "scores",
    "graphScore",
    "num",
    "graphScore2",
    "num2",
    "graphScore3",
    "num3",
    "smallerGraph",
    "inner",
    "labels2",
    "series22",
    "rectangle13",
    "rectangle14",
    "rectangle15",
    "rectangle16",
    "rectangle17",
    "rectangle18",
    "series32",
    "rectangle19",
    "rectangle20",
    "rectangle21",
    "rectangle22",
    "rectangle23",
    "rectangle24",
    "scores2",
    "graphScore4",
    "num4",
    "graphScore5",
    "num5",
    "graphScore6",
    "num6",
    "list6",
    "item",
    "icon",
    "abbr",
    "title25",
    "item2",
    "icon2",
    "abbr2",
    "title3",
    "item3",
    "icon3",
    "abbr3",
    "title41",
    "item4",
    "icon4",
    "abbr4",
    "title43",
    "item5",
    "icon5",
    "abbr5",
    "title6",
    "item6",
    "icon6",
    "abbr6",
    "title7",
    "shade",
    "nav2",
    "btn",
    "text55",
    "btn2",
    "text2",
    "btn3",
    "text3",
    "btn4",
    "text56",
    "mockupButtonBarItem",
    "text69",
    "btn5",
    "text6",
    "btn6",
    "text7",
    "btn7",
    "text8",
    "btn8",
    "text9",
    "btn9",
    "text10",
    "profile",
    "av",
    "col12",
    "top2",
    "header2",
    "name",
    "status",
    "label",
    "line",
    "mockupTextPlaceholderContent",
    "placeholder2",
    "body3",
    "year",
    "name2",
    "line2",
    "mockupTextPlaceholderContent2",
    "placeholder3",
    "actions",
    "mockupButton",
    "link",
    "mockupButton2",
    "link2",
    "text11",
    "title8",
    "desc13",
    "areas2",
    "header3",
    "title49",
    "body2",
    "frame23",
    "item7",
    "title50",
    "desc17",
    "item8",
    "title51",
    "desc18",
    "item9",
    "title52",
    "desc19",
    "item10",
    "title53",
    "desc20",
    "item11",
    "title54",
    "desc21",
    "item12",
    "title55",
    "desc10",
    "footnote2",
    "content5",
    "placeholder56",
    "intro6",
    "img6",
    "bg5",
    "xmlid74572",
    "xmlid67762",
    "xmlid74332",
    "xmlid73392",
    "certificate2",
    "top6",
    "mockupCertificateIcon2",
    "bg6",
    "group2",
    "paper3",
    "paper4",
    "cert2",
    "award492",
    "overlay2",
    "title26",
    "mockupTextPlaceholder2",
    "mockupTextPlaceholderParagraph7",
    "mockupTextPlaceholderLine37",
    "mockupTextPlaceholderContent51",
    "placeholder57",
    "mockupTextPlaceholderLine38",
    "mockupTextPlaceholderContent52",
    "placeholder58",
    "mockupTextPlaceholderLine39",
    "mockupTextPlaceholderContent3",
    "placeholder4",
    "mockupTextPlaceholderLine40",
    "mockupTextPlaceholderContent4",
    "placeholder5",
    "mockupTextPlaceholderLine41",
    "mockupTextPlaceholderContent5",
    "placeholder6",
    "mockupTextPlaceholderParagraph8",
    "mockupTextPlaceholderLine42",
    "mockupTextPlaceholderContent6",
    "placeholder7",
    "mockupTextPlaceholderLine43",
    "mockupTextPlaceholderContent7",
    "placeholder8",
    "mockupTextPlaceholderLine44",
    "mockupTextPlaceholderContent8",
    "placeholder9",
    "mockupTextPlaceholderLine45",
    "mockupTextPlaceholderContent9",
    "placeholder10",
    "mockupTextPlaceholderLine46",
    "mockupTextPlaceholderContent10",
    "placeholder11",
    "mockupTextPlaceholderLine47",
    "mockupTextPlaceholderContent11",
    "placeholder12",
    "mockupTextPlaceholderLine48",
    "mockupTextPlaceholderContent12",
    "placeholder13",
    "mockupTextPlaceholderLine49",
    "mockupTextPlaceholderContent13",
    "placeholder14",
    "mockupTextPlaceholderParagraph9",
    "mockupTextPlaceholderLine50",
    "mockupTextPlaceholderContent14",
    "placeholder15",
    "mockupTextPlaceholderLine51",
    "mockupTextPlaceholderContent53",
    "placeholder59",
    "mockupTextPlaceholderLine52",
    "mockupTextPlaceholderContent54",
    "placeholder60",
    "mockupTextPlaceholderLine53",
    "mockupTextPlaceholderContent55",
    "placeholder61",
    "mockupTextPlaceholderLine54",
    "mockupTextPlaceholderContent56",
    "placeholder62",
    "mockupTextPlaceholderParagraph10",
    "mockupTextPlaceholderLine55",
    "mockupTextPlaceholderContent57",
    "placeholder63",
    "mockupTextPlaceholderLine56",
    "mockupTextPlaceholderContent58",
    "placeholder64",
    "mockupTextPlaceholderLine57",
    "mockupTextPlaceholderContent59",
    "placeholder65",
    "mockupTextPlaceholderLine58",
    "mockupTextPlaceholderContent60",
    "placeholder66",
    "mockupTextPlaceholderLine59",
    "mockupTextPlaceholderContent61",
    "placeholder67",
    "mockupTextPlaceholderLine60",
    "mockupTextPlaceholderContent62",
    "placeholder68",
    "mockupTextPlaceholderLine61",
    "mockupTextPlaceholderContent63",
    "placeholder69",
    "mockupTextPlaceholderLine62",
    "mockupTextPlaceholderContent64",
    "placeholder70",
    "mockupButton3",
    "link3",
    "bill3",
    "bill2",
    "header4",
    "subtitle6",
    "title35",
    "main2",
    "placeholder71",
    "header5",
    "title36",
    "date2",
    "section3",
    "head3",
    "mockupTextPlaceholderParagraph11",
    "mockupTextPlaceholderLine63",
    "mockupTextPlaceholderContent65",
    "placeholder72",
    "mockupTextPlaceholderLine64",
    "mockupTextPlaceholderContent66",
    "placeholder73",
    "mockupTextPlaceholderLine65",
    "mockupTextPlaceholderContent67",
    "placeholder74",
    "mockupTextPlaceholderLine66",
    "mockupTextPlaceholderContent68",
    "placeholder75",
    "mockupTextPlaceholderLine67",
    "mockupTextPlaceholderContent69",
    "placeholder76",
    "total3",
    "title37",
    "val8",
    "section4",
    "head4",
    "mockupTextPlaceholderParagraph12",
    "mockupTextPlaceholderLine68",
    "mockupTextPlaceholderContent70",
    "placeholder77",
    "mockupTextPlaceholderLine69",
    "mockupTextPlaceholderContent71",
    "placeholder78",
    "mockupTextPlaceholderLine70",
    "mockupTextPlaceholderContent72",
    "placeholder79",
    "mockupTextPlaceholderLine71",
    "mockupTextPlaceholderContent73",
    "placeholder80",
    "mockupTextPlaceholderLine72",
    "mockupTextPlaceholderContent74",
    "placeholder81",
    "total4",
    "title38",
    "val9",
    "edge2",
    "tri33",
    "rect33",
    "tri34",
    "rect34",
    "tri35",
    "rect35",
    "tri36",
    "rect36",
    "tri37",
    "rect37",
    "tri38",
    "rect38",
    "tri39",
    "rect39",
    "tri40",
    "rect40",
    "tri41",
    "rect41",
    "tri42",
    "rect42",
    "tri43",
    "rect43",
    "tri44",
    "rect44",
    "tri45",
    "rect45",
    "tri46",
    "rect46",
    "tri47",
    "rect47",
    "tri48",
    "rect48",
    "tri49",
    "rect49",
    "tri50",
    "rect50",
    "tri51",
    "rect51",
    "tri52",
    "rect52",
    "tri53",
    "rect53",
    "tri54",
    "rect54",
    "tri55",
    "rect55",
    "tri56",
    "rect56",
    "tri57",
    "rect57",
    "tri58",
    "rect58",
    "tri59",
    "rect59",
    "tri60",
    "rect60",
    "tri61",
    "rect61",
    "tri62",
    "rect62",
    "tri63",
    "rect63",
    "tri64",
    "rect64",
    "shade4",
    "alert4",
    "icon31",
    "content6",
    "text15",
    "icon32",
    "text16",
    "title39",
    "desc11",
    "features2",
    "title40",
    "contents",
    "contentsItem18",
    "icon33",
    "text17",
    "contentsItem19",
    "icon34",
    "text18",
    "contentsItem20",
    "icon35",
    "text19",
    "contentsItem21",
    "icon36",
    "text20",
    "contentsItem22",
    "icon7",
    "text21",
    "contentsItem23",
    "icon37",
    "text22",
    "contentsItem24",
    "icon38",
    "text23",
    "contentsItem25",
    "icon39",
    "text24",
    "content7",
    "placeholder82",
    "intro7",
    "img7",
    "cap2",
    "header27",
    "subtitle11",
    "title42",
    "main9",
    "placeholder84",
    "field2",
    "label14",
    "select2",
    "input2",
    "leftIcon2",
    "text54",
    "rightIcon2",
    "row4",
    "prop5",
    "label15",
    "val10",
    "prop6",
    "label16",
    "val11",
    "text79",
    "title46",
    "desc12",
    "features4",
    "title47",
    "grid",
    "contentsItem26",
    "icon41",
    "text80",
    "contentsItem27",
    "icon42",
    "text81",
    "contentsItem28",
    "icon43",
    "text82",
    "contentsItem29",
    "icon44",
    "text83",
    "contentsItem30",
    "icon45",
    "text84",
    "contentsItem31",
    "icon46",
    "text85",
    "contentsItem32",
    "icon47",
    "text86",
    "contentsItem33",
    "icon48",
    "text87",
    "contentsItem34",
    "icon49",
    "text88"
  ],
  header: ["header", "top", "subtitle2", "title2", "body"],
  top: ["top", "subtitle2", "title2"],
  subtitle2: ["subtitle2"],
  title2: ["title2"],
  body: ["body"],
  tabs: [
    "tabs",
    "content8",
    "placeholder83",
    "intro5",
    "img5",
    "bg",
    "compWrap",
    "perf",
    "header6",
    "subtitle3",
    "title24",
    "main",
    "mockupCompetencies",
    "graph",
    "labels",
    "series2",
    "rectangle1",
    "rectangle2",
    "rectangle3",
    "rectangle4",
    "rectangle5",
    "rectangle6",
    "series3",
    "rectangle7",
    "rectangle8",
    "rectangle9",
    "rectangle10",
    "rectangle11",
    "rectangle12",
    "scores",
    "graphScore",
    "num",
    "graphScore2",
    "num2",
    "graphScore3",
    "num3",
    "smallerGraph",
    "inner",
    "labels2",
    "series22",
    "rectangle13",
    "rectangle14",
    "rectangle15",
    "rectangle16",
    "rectangle17",
    "rectangle18",
    "series32",
    "rectangle19",
    "rectangle20",
    "rectangle21",
    "rectangle22",
    "rectangle23",
    "rectangle24",
    "scores2",
    "graphScore4",
    "num4",
    "graphScore5",
    "num5",
    "graphScore6",
    "num6",
    "list6",
    "item",
    "icon",
    "abbr",
    "title25",
    "item2",
    "icon2",
    "abbr2",
    "title3",
    "item3",
    "icon3",
    "abbr3",
    "title41",
    "item4",
    "icon4",
    "abbr4",
    "title43",
    "item5",
    "icon5",
    "abbr5",
    "title6",
    "item6",
    "icon6",
    "abbr6",
    "title7",
    "shade",
    "nav2",
    "btn",
    "text55",
    "btn2",
    "text2",
    "btn3",
    "text3",
    "btn4",
    "text56",
    "mockupButtonBarItem",
    "text69",
    "btn5",
    "text6",
    "btn6",
    "text7",
    "btn7",
    "text8",
    "btn8",
    "text9",
    "btn9",
    "text10",
    "profile",
    "av",
    "col12",
    "top2",
    "header2",
    "name",
    "status",
    "label",
    "line",
    "mockupTextPlaceholderContent",
    "placeholder2",
    "body3",
    "year",
    "name2",
    "line2",
    "mockupTextPlaceholderContent2",
    "placeholder3",
    "actions",
    "mockupButton",
    "link",
    "mockupButton2",
    "link2",
    "text11",
    "title8",
    "desc13",
    "areas2",
    "header3",
    "title49",
    "body2",
    "frame23",
    "item7",
    "title50",
    "desc17",
    "item8",
    "title51",
    "desc18",
    "item9",
    "title52",
    "desc19",
    "item10",
    "title53",
    "desc20",
    "item11",
    "title54",
    "desc21",
    "item12",
    "title55",
    "desc10",
    "footnote2",
    "content5",
    "placeholder56",
    "intro6",
    "img6",
    "bg5",
    "xmlid74572",
    "xmlid67762",
    "xmlid74332",
    "xmlid73392",
    "certificate2",
    "top6",
    "mockupCertificateIcon2",
    "bg6",
    "group2",
    "paper3",
    "paper4",
    "cert2",
    "award492",
    "overlay2",
    "title26",
    "mockupTextPlaceholder2",
    "mockupTextPlaceholderParagraph7",
    "mockupTextPlaceholderLine37",
    "mockupTextPlaceholderContent51",
    "placeholder57",
    "mockupTextPlaceholderLine38",
    "mockupTextPlaceholderContent52",
    "placeholder58",
    "mockupTextPlaceholderLine39",
    "mockupTextPlaceholderContent3",
    "placeholder4",
    "mockupTextPlaceholderLine40",
    "mockupTextPlaceholderContent4",
    "placeholder5",
    "mockupTextPlaceholderLine41",
    "mockupTextPlaceholderContent5",
    "placeholder6",
    "mockupTextPlaceholderParagraph8",
    "mockupTextPlaceholderLine42",
    "mockupTextPlaceholderContent6",
    "placeholder7",
    "mockupTextPlaceholderLine43",
    "mockupTextPlaceholderContent7",
    "placeholder8",
    "mockupTextPlaceholderLine44",
    "mockupTextPlaceholderContent8",
    "placeholder9",
    "mockupTextPlaceholderLine45",
    "mockupTextPlaceholderContent9",
    "placeholder10",
    "mockupTextPlaceholderLine46",
    "mockupTextPlaceholderContent10",
    "placeholder11",
    "mockupTextPlaceholderLine47",
    "mockupTextPlaceholderContent11",
    "placeholder12",
    "mockupTextPlaceholderLine48",
    "mockupTextPlaceholderContent12",
    "placeholder13",
    "mockupTextPlaceholderLine49",
    "mockupTextPlaceholderContent13",
    "placeholder14",
    "mockupTextPlaceholderParagraph9",
    "mockupTextPlaceholderLine50",
    "mockupTextPlaceholderContent14",
    "placeholder15",
    "mockupTextPlaceholderLine51",
    "mockupTextPlaceholderContent53",
    "placeholder59",
    "mockupTextPlaceholderLine52",
    "mockupTextPlaceholderContent54",
    "placeholder60",
    "mockupTextPlaceholderLine53",
    "mockupTextPlaceholderContent55",
    "placeholder61",
    "mockupTextPlaceholderLine54",
    "mockupTextPlaceholderContent56",
    "placeholder62",
    "mockupTextPlaceholderParagraph10",
    "mockupTextPlaceholderLine55",
    "mockupTextPlaceholderContent57",
    "placeholder63",
    "mockupTextPlaceholderLine56",
    "mockupTextPlaceholderContent58",
    "placeholder64",
    "mockupTextPlaceholderLine57",
    "mockupTextPlaceholderContent59",
    "placeholder65",
    "mockupTextPlaceholderLine58",
    "mockupTextPlaceholderContent60",
    "placeholder66",
    "mockupTextPlaceholderLine59",
    "mockupTextPlaceholderContent61",
    "placeholder67",
    "mockupTextPlaceholderLine60",
    "mockupTextPlaceholderContent62",
    "placeholder68",
    "mockupTextPlaceholderLine61",
    "mockupTextPlaceholderContent63",
    "placeholder69",
    "mockupTextPlaceholderLine62",
    "mockupTextPlaceholderContent64",
    "placeholder70",
    "mockupButton3",
    "link3",
    "bill3",
    "bill2",
    "header4",
    "subtitle6",
    "title35",
    "main2",
    "placeholder71",
    "header5",
    "title36",
    "date2",
    "section3",
    "head3",
    "mockupTextPlaceholderParagraph11",
    "mockupTextPlaceholderLine63",
    "mockupTextPlaceholderContent65",
    "placeholder72",
    "mockupTextPlaceholderLine64",
    "mockupTextPlaceholderContent66",
    "placeholder73",
    "mockupTextPlaceholderLine65",
    "mockupTextPlaceholderContent67",
    "placeholder74",
    "mockupTextPlaceholderLine66",
    "mockupTextPlaceholderContent68",
    "placeholder75",
    "mockupTextPlaceholderLine67",
    "mockupTextPlaceholderContent69",
    "placeholder76",
    "total3",
    "title37",
    "val8",
    "section4",
    "head4",
    "mockupTextPlaceholderParagraph12",
    "mockupTextPlaceholderLine68",
    "mockupTextPlaceholderContent70",
    "placeholder77",
    "mockupTextPlaceholderLine69",
    "mockupTextPlaceholderContent71",
    "placeholder78",
    "mockupTextPlaceholderLine70",
    "mockupTextPlaceholderContent72",
    "placeholder79",
    "mockupTextPlaceholderLine71",
    "mockupTextPlaceholderContent73",
    "placeholder80",
    "mockupTextPlaceholderLine72",
    "mockupTextPlaceholderContent74",
    "placeholder81",
    "total4",
    "title38",
    "val9",
    "edge2",
    "tri33",
    "rect33",
    "tri34",
    "rect34",
    "tri35",
    "rect35",
    "tri36",
    "rect36",
    "tri37",
    "rect37",
    "tri38",
    "rect38",
    "tri39",
    "rect39",
    "tri40",
    "rect40",
    "tri41",
    "rect41",
    "tri42",
    "rect42",
    "tri43",
    "rect43",
    "tri44",
    "rect44",
    "tri45",
    "rect45",
    "tri46",
    "rect46",
    "tri47",
    "rect47",
    "tri48",
    "rect48",
    "tri49",
    "rect49",
    "tri50",
    "rect50",
    "tri51",
    "rect51",
    "tri52",
    "rect52",
    "tri53",
    "rect53",
    "tri54",
    "rect54",
    "tri55",
    "rect55",
    "tri56",
    "rect56",
    "tri57",
    "rect57",
    "tri58",
    "rect58",
    "tri59",
    "rect59",
    "tri60",
    "rect60",
    "tri61",
    "rect61",
    "tri62",
    "rect62",
    "tri63",
    "rect63",
    "tri64",
    "rect64",
    "shade4",
    "alert4",
    "icon31",
    "content6",
    "text15",
    "icon32",
    "text16",
    "title39",
    "desc11",
    "features2",
    "title40",
    "contents",
    "contentsItem18",
    "icon33",
    "text17",
    "contentsItem19",
    "icon34",
    "text18",
    "contentsItem20",
    "icon35",
    "text19",
    "contentsItem21",
    "icon36",
    "text20",
    "contentsItem22",
    "icon7",
    "text21",
    "contentsItem23",
    "icon37",
    "text22",
    "contentsItem24",
    "icon38",
    "text23",
    "contentsItem25",
    "icon39",
    "text24",
    "content7",
    "placeholder82",
    "intro7",
    "img7",
    "cap2",
    "header27",
    "subtitle11",
    "title42",
    "main9",
    "placeholder84",
    "field2",
    "label14",
    "select2",
    "input2",
    "leftIcon2",
    "text54",
    "rightIcon2",
    "row4",
    "prop5",
    "label15",
    "val10",
    "prop6",
    "label16",
    "val11",
    "text79",
    "title46",
    "desc12",
    "features4",
    "title47",
    "grid",
    "contentsItem26",
    "icon41",
    "text80",
    "contentsItem27",
    "icon42",
    "text81",
    "contentsItem28",
    "icon43",
    "text82",
    "contentsItem29",
    "icon44",
    "text83",
    "contentsItem30",
    "icon45",
    "text84",
    "contentsItem31",
    "icon46",
    "text85",
    "contentsItem32",
    "icon47",
    "text86",
    "contentsItem33",
    "icon48",
    "text87",
    "contentsItem34",
    "icon49",
    "text88"
  ],
  content8: [
    "content8",
    "placeholder83",
    "intro5",
    "img5",
    "bg",
    "compWrap",
    "perf",
    "header6",
    "subtitle3",
    "title24",
    "main",
    "mockupCompetencies",
    "graph",
    "labels",
    "series2",
    "rectangle1",
    "rectangle2",
    "rectangle3",
    "rectangle4",
    "rectangle5",
    "rectangle6",
    "series3",
    "rectangle7",
    "rectangle8",
    "rectangle9",
    "rectangle10",
    "rectangle11",
    "rectangle12",
    "scores",
    "graphScore",
    "num",
    "graphScore2",
    "num2",
    "graphScore3",
    "num3",
    "smallerGraph",
    "inner",
    "labels2",
    "series22",
    "rectangle13",
    "rectangle14",
    "rectangle15",
    "rectangle16",
    "rectangle17",
    "rectangle18",
    "series32",
    "rectangle19",
    "rectangle20",
    "rectangle21",
    "rectangle22",
    "rectangle23",
    "rectangle24",
    "scores2",
    "graphScore4",
    "num4",
    "graphScore5",
    "num5",
    "graphScore6",
    "num6",
    "list6",
    "item",
    "icon",
    "abbr",
    "title25",
    "item2",
    "icon2",
    "abbr2",
    "title3",
    "item3",
    "icon3",
    "abbr3",
    "title41",
    "item4",
    "icon4",
    "abbr4",
    "title43",
    "item5",
    "icon5",
    "abbr5",
    "title6",
    "item6",
    "icon6",
    "abbr6",
    "title7",
    "shade",
    "nav2",
    "btn",
    "text55",
    "btn2",
    "text2",
    "btn3",
    "text3",
    "btn4",
    "text56",
    "mockupButtonBarItem",
    "text69",
    "btn5",
    "text6",
    "btn6",
    "text7",
    "btn7",
    "text8",
    "btn8",
    "text9",
    "btn9",
    "text10",
    "profile",
    "av",
    "col12",
    "top2",
    "header2",
    "name",
    "status",
    "label",
    "line",
    "mockupTextPlaceholderContent",
    "placeholder2",
    "body3",
    "year",
    "name2",
    "line2",
    "mockupTextPlaceholderContent2",
    "placeholder3",
    "actions",
    "mockupButton",
    "link",
    "mockupButton2",
    "link2",
    "text11",
    "title8",
    "desc13",
    "areas2",
    "header3",
    "title49",
    "body2",
    "frame23",
    "item7",
    "title50",
    "desc17",
    "item8",
    "title51",
    "desc18",
    "item9",
    "title52",
    "desc19",
    "item10",
    "title53",
    "desc20",
    "item11",
    "title54",
    "desc21",
    "item12",
    "title55",
    "desc10",
    "footnote2"
  ],
  placeholder83: [
    "placeholder83",
    "intro5",
    "img5",
    "bg",
    "compWrap",
    "perf",
    "header6",
    "subtitle3",
    "title24",
    "main",
    "mockupCompetencies",
    "graph",
    "labels",
    "series2",
    "rectangle1",
    "rectangle2",
    "rectangle3",
    "rectangle4",
    "rectangle5",
    "rectangle6",
    "series3",
    "rectangle7",
    "rectangle8",
    "rectangle9",
    "rectangle10",
    "rectangle11",
    "rectangle12",
    "scores",
    "graphScore",
    "num",
    "graphScore2",
    "num2",
    "graphScore3",
    "num3",
    "smallerGraph",
    "inner",
    "labels2",
    "series22",
    "rectangle13",
    "rectangle14",
    "rectangle15",
    "rectangle16",
    "rectangle17",
    "rectangle18",
    "series32",
    "rectangle19",
    "rectangle20",
    "rectangle21",
    "rectangle22",
    "rectangle23",
    "rectangle24",
    "scores2",
    "graphScore4",
    "num4",
    "graphScore5",
    "num5",
    "graphScore6",
    "num6",
    "list6",
    "item",
    "icon",
    "abbr",
    "title25",
    "item2",
    "icon2",
    "abbr2",
    "title3",
    "item3",
    "icon3",
    "abbr3",
    "title41",
    "item4",
    "icon4",
    "abbr4",
    "title43",
    "item5",
    "icon5",
    "abbr5",
    "title6",
    "item6",
    "icon6",
    "abbr6",
    "title7",
    "shade",
    "nav2",
    "btn",
    "text55",
    "btn2",
    "text2",
    "btn3",
    "text3",
    "btn4",
    "text56",
    "mockupButtonBarItem",
    "text69",
    "btn5",
    "text6",
    "btn6",
    "text7",
    "btn7",
    "text8",
    "btn8",
    "text9",
    "btn9",
    "text10",
    "profile",
    "av",
    "col12",
    "top2",
    "header2",
    "name",
    "status",
    "label",
    "line",
    "mockupTextPlaceholderContent",
    "placeholder2",
    "body3",
    "year",
    "name2",
    "line2",
    "mockupTextPlaceholderContent2",
    "placeholder3",
    "actions",
    "mockupButton",
    "link",
    "mockupButton2",
    "link2",
    "text11",
    "title8",
    "desc13",
    "areas2",
    "header3",
    "title49",
    "body2",
    "frame23",
    "item7",
    "title50",
    "desc17",
    "item8",
    "title51",
    "desc18",
    "item9",
    "title52",
    "desc19",
    "item10",
    "title53",
    "desc20",
    "item11",
    "title54",
    "desc21",
    "item12",
    "title55",
    "desc10",
    "footnote2"
  ],
  intro5: [
    "intro5",
    "img5",
    "bg",
    "compWrap",
    "perf",
    "header6",
    "subtitle3",
    "title24",
    "main",
    "mockupCompetencies",
    "graph",
    "labels",
    "series2",
    "rectangle1",
    "rectangle2",
    "rectangle3",
    "rectangle4",
    "rectangle5",
    "rectangle6",
    "series3",
    "rectangle7",
    "rectangle8",
    "rectangle9",
    "rectangle10",
    "rectangle11",
    "rectangle12",
    "scores",
    "graphScore",
    "num",
    "graphScore2",
    "num2",
    "graphScore3",
    "num3",
    "smallerGraph",
    "inner",
    "labels2",
    "series22",
    "rectangle13",
    "rectangle14",
    "rectangle15",
    "rectangle16",
    "rectangle17",
    "rectangle18",
    "series32",
    "rectangle19",
    "rectangle20",
    "rectangle21",
    "rectangle22",
    "rectangle23",
    "rectangle24",
    "scores2",
    "graphScore4",
    "num4",
    "graphScore5",
    "num5",
    "graphScore6",
    "num6",
    "list6",
    "item",
    "icon",
    "abbr",
    "title25",
    "item2",
    "icon2",
    "abbr2",
    "title3",
    "item3",
    "icon3",
    "abbr3",
    "title41",
    "item4",
    "icon4",
    "abbr4",
    "title43",
    "item5",
    "icon5",
    "abbr5",
    "title6",
    "item6",
    "icon6",
    "abbr6",
    "title7",
    "shade",
    "nav2",
    "btn",
    "text55",
    "btn2",
    "text2",
    "btn3",
    "text3",
    "btn4",
    "text56",
    "mockupButtonBarItem",
    "text69",
    "btn5",
    "text6",
    "btn6",
    "text7",
    "btn7",
    "text8",
    "btn8",
    "text9",
    "btn9",
    "text10",
    "profile",
    "av",
    "col12",
    "top2",
    "header2",
    "name",
    "status",
    "label",
    "line",
    "mockupTextPlaceholderContent",
    "placeholder2",
    "body3",
    "year",
    "name2",
    "line2",
    "mockupTextPlaceholderContent2",
    "placeholder3",
    "actions",
    "mockupButton",
    "link",
    "mockupButton2",
    "link2",
    "text11",
    "title8",
    "desc13"
  ],
  img5: [
    "img5",
    "bg",
    "compWrap",
    "perf",
    "header6",
    "subtitle3",
    "title24",
    "main",
    "mockupCompetencies",
    "graph",
    "labels",
    "series2",
    "rectangle1",
    "rectangle2",
    "rectangle3",
    "rectangle4",
    "rectangle5",
    "rectangle6",
    "series3",
    "rectangle7",
    "rectangle8",
    "rectangle9",
    "rectangle10",
    "rectangle11",
    "rectangle12",
    "scores",
    "graphScore",
    "num",
    "graphScore2",
    "num2",
    "graphScore3",
    "num3",
    "smallerGraph",
    "inner",
    "labels2",
    "series22",
    "rectangle13",
    "rectangle14",
    "rectangle15",
    "rectangle16",
    "rectangle17",
    "rectangle18",
    "series32",
    "rectangle19",
    "rectangle20",
    "rectangle21",
    "rectangle22",
    "rectangle23",
    "rectangle24",
    "scores2",
    "graphScore4",
    "num4",
    "graphScore5",
    "num5",
    "graphScore6",
    "num6",
    "list6",
    "item",
    "icon",
    "abbr",
    "title25",
    "item2",
    "icon2",
    "abbr2",
    "title3",
    "item3",
    "icon3",
    "abbr3",
    "title41",
    "item4",
    "icon4",
    "abbr4",
    "title43",
    "item5",
    "icon5",
    "abbr5",
    "title6",
    "item6",
    "icon6",
    "abbr6",
    "title7",
    "shade",
    "nav2",
    "btn",
    "text55",
    "btn2",
    "text2",
    "btn3",
    "text3",
    "btn4",
    "text56",
    "mockupButtonBarItem",
    "text69",
    "btn5",
    "text6",
    "btn6",
    "text7",
    "btn7",
    "text8",
    "btn8",
    "text9",
    "btn9",
    "text10",
    "profile",
    "av",
    "col12",
    "top2",
    "header2",
    "name",
    "status",
    "label",
    "line",
    "mockupTextPlaceholderContent",
    "placeholder2",
    "body3",
    "year",
    "name2",
    "line2",
    "mockupTextPlaceholderContent2",
    "placeholder3",
    "actions",
    "mockupButton",
    "link",
    "mockupButton2",
    "link2"
  ],
  bg: ["bg"],
  compWrap: [
    "compWrap",
    "perf",
    "header6",
    "subtitle3",
    "title24",
    "main",
    "mockupCompetencies",
    "graph",
    "labels",
    "series2",
    "rectangle1",
    "rectangle2",
    "rectangle3",
    "rectangle4",
    "rectangle5",
    "rectangle6",
    "series3",
    "rectangle7",
    "rectangle8",
    "rectangle9",
    "rectangle10",
    "rectangle11",
    "rectangle12",
    "scores",
    "graphScore",
    "num",
    "graphScore2",
    "num2",
    "graphScore3",
    "num3",
    "smallerGraph",
    "inner",
    "labels2",
    "series22",
    "rectangle13",
    "rectangle14",
    "rectangle15",
    "rectangle16",
    "rectangle17",
    "rectangle18",
    "series32",
    "rectangle19",
    "rectangle20",
    "rectangle21",
    "rectangle22",
    "rectangle23",
    "rectangle24",
    "scores2",
    "graphScore4",
    "num4",
    "graphScore5",
    "num5",
    "graphScore6",
    "num6",
    "list6",
    "item",
    "icon",
    "abbr",
    "title25",
    "item2",
    "icon2",
    "abbr2",
    "title3",
    "item3",
    "icon3",
    "abbr3",
    "title41",
    "item4",
    "icon4",
    "abbr4",
    "title43",
    "item5",
    "icon5",
    "abbr5",
    "title6",
    "item6",
    "icon6",
    "abbr6",
    "title7",
    "shade"
  ],
  perf: [
    "perf",
    "header6",
    "subtitle3",
    "title24",
    "main",
    "mockupCompetencies",
    "graph",
    "labels",
    "series2",
    "rectangle1",
    "rectangle2",
    "rectangle3",
    "rectangle4",
    "rectangle5",
    "rectangle6",
    "series3",
    "rectangle7",
    "rectangle8",
    "rectangle9",
    "rectangle10",
    "rectangle11",
    "rectangle12",
    "scores",
    "graphScore",
    "num",
    "graphScore2",
    "num2",
    "graphScore3",
    "num3",
    "smallerGraph",
    "inner",
    "labels2",
    "series22",
    "rectangle13",
    "rectangle14",
    "rectangle15",
    "rectangle16",
    "rectangle17",
    "rectangle18",
    "series32",
    "rectangle19",
    "rectangle20",
    "rectangle21",
    "rectangle22",
    "rectangle23",
    "rectangle24",
    "scores2",
    "graphScore4",
    "num4",
    "graphScore5",
    "num5",
    "graphScore6",
    "num6",
    "list6",
    "item",
    "icon",
    "abbr",
    "title25",
    "item2",
    "icon2",
    "abbr2",
    "title3",
    "item3",
    "icon3",
    "abbr3",
    "title41",
    "item4",
    "icon4",
    "abbr4",
    "title43",
    "item5",
    "icon5",
    "abbr5",
    "title6",
    "item6",
    "icon6",
    "abbr6",
    "title7"
  ],
  header6: ["header6", "subtitle3", "title24"],
  subtitle3: ["subtitle3"],
  title24: ["title24"],
  main: [
    "main",
    "mockupCompetencies",
    "graph",
    "labels",
    "series2",
    "rectangle1",
    "rectangle2",
    "rectangle3",
    "rectangle4",
    "rectangle5",
    "rectangle6",
    "series3",
    "rectangle7",
    "rectangle8",
    "rectangle9",
    "rectangle10",
    "rectangle11",
    "rectangle12",
    "scores",
    "graphScore",
    "num",
    "graphScore2",
    "num2",
    "graphScore3",
    "num3",
    "smallerGraph",
    "inner",
    "labels2",
    "series22",
    "rectangle13",
    "rectangle14",
    "rectangle15",
    "rectangle16",
    "rectangle17",
    "rectangle18",
    "series32",
    "rectangle19",
    "rectangle20",
    "rectangle21",
    "rectangle22",
    "rectangle23",
    "rectangle24",
    "scores2",
    "graphScore4",
    "num4",
    "graphScore5",
    "num5",
    "graphScore6",
    "num6",
    "list6",
    "item",
    "icon",
    "abbr",
    "title25",
    "item2",
    "icon2",
    "abbr2",
    "title3",
    "item3",
    "icon3",
    "abbr3",
    "title41",
    "item4",
    "icon4",
    "abbr4",
    "title43",
    "item5",
    "icon5",
    "abbr5",
    "title6",
    "item6",
    "icon6",
    "abbr6",
    "title7"
  ],
  mockupCompetencies: [
    "mockupCompetencies",
    "graph",
    "labels",
    "series2",
    "rectangle1",
    "rectangle2",
    "rectangle3",
    "rectangle4",
    "rectangle5",
    "rectangle6",
    "series3",
    "rectangle7",
    "rectangle8",
    "rectangle9",
    "rectangle10",
    "rectangle11",
    "rectangle12",
    "scores",
    "graphScore",
    "num",
    "graphScore2",
    "num2",
    "graphScore3",
    "num3",
    "smallerGraph",
    "inner",
    "labels2",
    "series22",
    "rectangle13",
    "rectangle14",
    "rectangle15",
    "rectangle16",
    "rectangle17",
    "rectangle18",
    "series32",
    "rectangle19",
    "rectangle20",
    "rectangle21",
    "rectangle22",
    "rectangle23",
    "rectangle24",
    "scores2",
    "graphScore4",
    "num4",
    "graphScore5",
    "num5",
    "graphScore6",
    "num6",
    "list6",
    "item",
    "icon",
    "abbr",
    "title25",
    "item2",
    "icon2",
    "abbr2",
    "title3",
    "item3",
    "icon3",
    "abbr3",
    "title41",
    "item4",
    "icon4",
    "abbr4",
    "title43",
    "item5",
    "icon5",
    "abbr5",
    "title6",
    "item6",
    "icon6",
    "abbr6",
    "title7"
  ],
  graph: [
    "graph",
    "labels",
    "series2",
    "rectangle1",
    "rectangle2",
    "rectangle3",
    "rectangle4",
    "rectangle5",
    "rectangle6",
    "series3",
    "rectangle7",
    "rectangle8",
    "rectangle9",
    "rectangle10",
    "rectangle11",
    "rectangle12",
    "scores",
    "graphScore",
    "num",
    "graphScore2",
    "num2",
    "graphScore3",
    "num3"
  ],
  labels: ["labels"],
  series2: [
    "series2",
    "rectangle1",
    "rectangle2",
    "rectangle3",
    "rectangle4",
    "rectangle5",
    "rectangle6"
  ],
  rectangle1: ["rectangle1"],
  rectangle2: ["rectangle2"],
  rectangle3: ["rectangle3"],
  rectangle4: ["rectangle4"],
  rectangle5: ["rectangle5"],
  rectangle6: ["rectangle6"],
  series3: [
    "series3",
    "rectangle7",
    "rectangle8",
    "rectangle9",
    "rectangle10",
    "rectangle11",
    "rectangle12"
  ],
  rectangle7: ["rectangle7"],
  rectangle8: ["rectangle8"],
  rectangle9: ["rectangle9"],
  rectangle10: ["rectangle10"],
  rectangle11: ["rectangle11"],
  rectangle12: ["rectangle12"],
  scores: [
    "scores",
    "graphScore",
    "num",
    "graphScore2",
    "num2",
    "graphScore3",
    "num3"
  ],
  graphScore: ["graphScore", "num"],
  num: ["num"],
  graphScore2: ["graphScore2", "num2"],
  num2: ["num2"],
  graphScore3: ["graphScore3", "num3"],
  num3: ["num3"],
  smallerGraph: [
    "smallerGraph",
    "inner",
    "labels2",
    "series22",
    "rectangle13",
    "rectangle14",
    "rectangle15",
    "rectangle16",
    "rectangle17",
    "rectangle18",
    "series32",
    "rectangle19",
    "rectangle20",
    "rectangle21",
    "rectangle22",
    "rectangle23",
    "rectangle24",
    "scores2",
    "graphScore4",
    "num4",
    "graphScore5",
    "num5",
    "graphScore6",
    "num6"
  ],
  inner: [
    "inner",
    "labels2",
    "series22",
    "rectangle13",
    "rectangle14",
    "rectangle15",
    "rectangle16",
    "rectangle17",
    "rectangle18",
    "series32",
    "rectangle19",
    "rectangle20",
    "rectangle21",
    "rectangle22",
    "rectangle23",
    "rectangle24",
    "scores2",
    "graphScore4",
    "num4",
    "graphScore5",
    "num5",
    "graphScore6",
    "num6"
  ],
  labels2: ["labels2"],
  series22: [
    "series22",
    "rectangle13",
    "rectangle14",
    "rectangle15",
    "rectangle16",
    "rectangle17",
    "rectangle18"
  ],
  rectangle13: ["rectangle13"],
  rectangle14: ["rectangle14"],
  rectangle15: ["rectangle15"],
  rectangle16: ["rectangle16"],
  rectangle17: ["rectangle17"],
  rectangle18: ["rectangle18"],
  series32: [
    "series32",
    "rectangle19",
    "rectangle20",
    "rectangle21",
    "rectangle22",
    "rectangle23",
    "rectangle24"
  ],
  rectangle19: ["rectangle19"],
  rectangle20: ["rectangle20"],
  rectangle21: ["rectangle21"],
  rectangle22: ["rectangle22"],
  rectangle23: ["rectangle23"],
  rectangle24: ["rectangle24"],
  scores2: [
    "scores2",
    "graphScore4",
    "num4",
    "graphScore5",
    "num5",
    "graphScore6",
    "num6"
  ],
  graphScore4: ["graphScore4", "num4"],
  num4: ["num4"],
  graphScore5: ["graphScore5", "num5"],
  num5: ["num5"],
  graphScore6: ["graphScore6", "num6"],
  num6: ["num6"],
  list6: [
    "list6",
    "item",
    "icon",
    "abbr",
    "title25",
    "item2",
    "icon2",
    "abbr2",
    "title3",
    "item3",
    "icon3",
    "abbr3",
    "title41",
    "item4",
    "icon4",
    "abbr4",
    "title43",
    "item5",
    "icon5",
    "abbr5",
    "title6",
    "item6",
    "icon6",
    "abbr6",
    "title7"
  ],
  item: ["item", "icon", "abbr", "title25"],
  icon: ["icon", "abbr"],
  abbr: ["abbr"],
  title25: ["title25"],
  item2: ["item2", "icon2", "abbr2", "title3"],
  icon2: ["icon2", "abbr2"],
  abbr2: ["abbr2"],
  title3: ["title3"],
  item3: ["item3", "icon3", "abbr3", "title41"],
  icon3: ["icon3", "abbr3"],
  abbr3: ["abbr3"],
  title41: ["title41"],
  item4: ["item4", "icon4", "abbr4", "title43"],
  icon4: ["icon4", "abbr4"],
  abbr4: ["abbr4"],
  title43: ["title43"],
  item5: ["item5", "icon5", "abbr5", "title6"],
  icon5: ["icon5", "abbr5"],
  abbr5: ["abbr5"],
  title6: ["title6"],
  item6: ["item6", "icon6", "abbr6", "title7"],
  icon6: ["icon6", "abbr6"],
  abbr6: ["abbr6"],
  title7: ["title7"],
  shade: ["shade"],
  nav2: [
    "nav2",
    "btn",
    "text55",
    "btn2",
    "text2",
    "btn3",
    "text3",
    "btn4",
    "text56",
    "mockupButtonBarItem",
    "text69",
    "btn5",
    "text6",
    "btn6",
    "text7",
    "btn7",
    "text8",
    "btn8",
    "text9",
    "btn9",
    "text10"
  ],
  btn: ["btn", "text55"],
  text55: ["text55"],
  btn2: ["btn2", "text2"],
  text2: ["text2"],
  btn3: ["btn3", "text3"],
  text3: ["text3"],
  btn4: ["btn4", "text56"],
  text56: ["text56"],
  mockupButtonBarItem: ["mockupButtonBarItem", "text69"],
  text69: ["text69"],
  btn5: ["btn5", "text6"],
  text6: ["text6"],
  btn6: ["btn6", "text7"],
  text7: ["text7"],
  btn7: ["btn7", "text8"],
  text8: ["text8"],
  btn8: ["btn8", "text9"],
  text9: ["text9"],
  btn9: ["btn9", "text10"],
  text10: ["text10"],
  profile: [
    "profile",
    "av",
    "col12",
    "top2",
    "header2",
    "name",
    "status",
    "label",
    "line",
    "mockupTextPlaceholderContent",
    "placeholder2",
    "body3",
    "year",
    "name2",
    "line2",
    "mockupTextPlaceholderContent2",
    "placeholder3",
    "actions",
    "mockupButton",
    "link",
    "mockupButton2",
    "link2"
  ],
  av: ["av"],
  col12: [
    "col12",
    "top2",
    "header2",
    "name",
    "status",
    "label",
    "line",
    "mockupTextPlaceholderContent",
    "placeholder2",
    "body3",
    "year",
    "name2",
    "line2",
    "mockupTextPlaceholderContent2",
    "placeholder3",
    "actions",
    "mockupButton",
    "link",
    "mockupButton2",
    "link2"
  ],
  top2: [
    "top2",
    "header2",
    "name",
    "status",
    "label",
    "line",
    "mockupTextPlaceholderContent",
    "placeholder2",
    "body3",
    "year",
    "name2",
    "line2",
    "mockupTextPlaceholderContent2",
    "placeholder3"
  ],
  header2: [
    "header2",
    "name",
    "status",
    "label",
    "line",
    "mockupTextPlaceholderContent",
    "placeholder2"
  ],
  name: ["name"],
  status: [
    "status",
    "label",
    "line",
    "mockupTextPlaceholderContent",
    "placeholder2"
  ],
  label: ["label"],
  line: ["line", "mockupTextPlaceholderContent", "placeholder2"],
  mockupTextPlaceholderContent: [
    "mockupTextPlaceholderContent",
    "placeholder2"
  ],
  placeholder2: ["placeholder2"],
  body3: [
    "body3",
    "year",
    "name2",
    "line2",
    "mockupTextPlaceholderContent2",
    "placeholder3"
  ],
  year: ["year"],
  name2: ["name2"],
  line2: ["line2", "mockupTextPlaceholderContent2", "placeholder3"],
  mockupTextPlaceholderContent2: [
    "mockupTextPlaceholderContent2",
    "placeholder3"
  ],
  placeholder3: ["placeholder3"],
  actions: ["actions", "mockupButton", "link", "mockupButton2", "link2"],
  mockupButton: ["mockupButton", "link"],
  link: ["link"],
  mockupButton2: ["mockupButton2", "link2"],
  link2: ["link2"],
  text11: ["text11", "title8", "desc13"],
  title8: ["title8"],
  desc13: ["desc13"],
  areas2: [
    "areas2",
    "header3",
    "title49",
    "body2",
    "frame23",
    "item7",
    "title50",
    "desc17",
    "item8",
    "title51",
    "desc18",
    "item9",
    "title52",
    "desc19",
    "item10",
    "title53",
    "desc20",
    "item11",
    "title54",
    "desc21",
    "item12",
    "title55",
    "desc10",
    "footnote2"
  ],
  header3: ["header3", "title49", "body2"],
  title49: ["title49"],
  body2: ["body2"],
  frame23: [
    "frame23",
    "item7",
    "title50",
    "desc17",
    "item8",
    "title51",
    "desc18",
    "item9",
    "title52",
    "desc19",
    "item10",
    "title53",
    "desc20",
    "item11",
    "title54",
    "desc21",
    "item12",
    "title55",
    "desc10"
  ],
  item7: ["item7", "title50", "desc17"],
  title50: ["title50"],
  desc17: ["desc17"],
  item8: ["item8", "title51", "desc18"],
  title51: ["title51"],
  desc18: ["desc18"],
  item9: ["item9", "title52", "desc19"],
  title52: ["title52"],
  desc19: ["desc19"],
  item10: ["item10", "title53", "desc20"],
  title53: ["title53"],
  desc20: ["desc20"],
  item11: ["item11", "title54", "desc21"],
  title54: ["title54"],
  desc21: ["desc21"],
  item12: ["item12", "title55", "desc10"],
  title55: ["title55"],
  desc10: ["desc10"],
  footnote2: ["footnote2"],
  content5: [
    "content5",
    "placeholder56",
    "intro6",
    "img6",
    "bg5",
    "xmlid74572",
    "xmlid67762",
    "xmlid74332",
    "xmlid73392",
    "certificate2",
    "top6",
    "mockupCertificateIcon2",
    "bg6",
    "group2",
    "paper3",
    "paper4",
    "cert2",
    "award492",
    "overlay2",
    "title26",
    "mockupTextPlaceholder2",
    "mockupTextPlaceholderParagraph7",
    "mockupTextPlaceholderLine37",
    "mockupTextPlaceholderContent51",
    "placeholder57",
    "mockupTextPlaceholderLine38",
    "mockupTextPlaceholderContent52",
    "placeholder58",
    "mockupTextPlaceholderLine39",
    "mockupTextPlaceholderContent3",
    "placeholder4",
    "mockupTextPlaceholderLine40",
    "mockupTextPlaceholderContent4",
    "placeholder5",
    "mockupTextPlaceholderLine41",
    "mockupTextPlaceholderContent5",
    "placeholder6",
    "mockupTextPlaceholderParagraph8",
    "mockupTextPlaceholderLine42",
    "mockupTextPlaceholderContent6",
    "placeholder7",
    "mockupTextPlaceholderLine43",
    "mockupTextPlaceholderContent7",
    "placeholder8",
    "mockupTextPlaceholderLine44",
    "mockupTextPlaceholderContent8",
    "placeholder9",
    "mockupTextPlaceholderLine45",
    "mockupTextPlaceholderContent9",
    "placeholder10",
    "mockupTextPlaceholderLine46",
    "mockupTextPlaceholderContent10",
    "placeholder11",
    "mockupTextPlaceholderLine47",
    "mockupTextPlaceholderContent11",
    "placeholder12",
    "mockupTextPlaceholderLine48",
    "mockupTextPlaceholderContent12",
    "placeholder13",
    "mockupTextPlaceholderLine49",
    "mockupTextPlaceholderContent13",
    "placeholder14",
    "mockupTextPlaceholderParagraph9",
    "mockupTextPlaceholderLine50",
    "mockupTextPlaceholderContent14",
    "placeholder15",
    "mockupTextPlaceholderLine51",
    "mockupTextPlaceholderContent53",
    "placeholder59",
    "mockupTextPlaceholderLine52",
    "mockupTextPlaceholderContent54",
    "placeholder60",
    "mockupTextPlaceholderLine53",
    "mockupTextPlaceholderContent55",
    "placeholder61",
    "mockupTextPlaceholderLine54",
    "mockupTextPlaceholderContent56",
    "placeholder62",
    "mockupTextPlaceholderParagraph10",
    "mockupTextPlaceholderLine55",
    "mockupTextPlaceholderContent57",
    "placeholder63",
    "mockupTextPlaceholderLine56",
    "mockupTextPlaceholderContent58",
    "placeholder64",
    "mockupTextPlaceholderLine57",
    "mockupTextPlaceholderContent59",
    "placeholder65",
    "mockupTextPlaceholderLine58",
    "mockupTextPlaceholderContent60",
    "placeholder66",
    "mockupTextPlaceholderLine59",
    "mockupTextPlaceholderContent61",
    "placeholder67",
    "mockupTextPlaceholderLine60",
    "mockupTextPlaceholderContent62",
    "placeholder68",
    "mockupTextPlaceholderLine61",
    "mockupTextPlaceholderContent63",
    "placeholder69",
    "mockupTextPlaceholderLine62",
    "mockupTextPlaceholderContent64",
    "placeholder70",
    "mockupButton3",
    "link3",
    "bill3",
    "bill2",
    "header4",
    "subtitle6",
    "title35",
    "main2",
    "placeholder71",
    "header5",
    "title36",
    "date2",
    "section3",
    "head3",
    "mockupTextPlaceholderParagraph11",
    "mockupTextPlaceholderLine63",
    "mockupTextPlaceholderContent65",
    "placeholder72",
    "mockupTextPlaceholderLine64",
    "mockupTextPlaceholderContent66",
    "placeholder73",
    "mockupTextPlaceholderLine65",
    "mockupTextPlaceholderContent67",
    "placeholder74",
    "mockupTextPlaceholderLine66",
    "mockupTextPlaceholderContent68",
    "placeholder75",
    "mockupTextPlaceholderLine67",
    "mockupTextPlaceholderContent69",
    "placeholder76",
    "total3",
    "title37",
    "val8",
    "section4",
    "head4",
    "mockupTextPlaceholderParagraph12",
    "mockupTextPlaceholderLine68",
    "mockupTextPlaceholderContent70",
    "placeholder77",
    "mockupTextPlaceholderLine69",
    "mockupTextPlaceholderContent71",
    "placeholder78",
    "mockupTextPlaceholderLine70",
    "mockupTextPlaceholderContent72",
    "placeholder79",
    "mockupTextPlaceholderLine71",
    "mockupTextPlaceholderContent73",
    "placeholder80",
    "mockupTextPlaceholderLine72",
    "mockupTextPlaceholderContent74",
    "placeholder81",
    "total4",
    "title38",
    "val9",
    "edge2",
    "tri33",
    "rect33",
    "tri34",
    "rect34",
    "tri35",
    "rect35",
    "tri36",
    "rect36",
    "tri37",
    "rect37",
    "tri38",
    "rect38",
    "tri39",
    "rect39",
    "tri40",
    "rect40",
    "tri41",
    "rect41",
    "tri42",
    "rect42",
    "tri43",
    "rect43",
    "tri44",
    "rect44",
    "tri45",
    "rect45",
    "tri46",
    "rect46",
    "tri47",
    "rect47",
    "tri48",
    "rect48",
    "tri49",
    "rect49",
    "tri50",
    "rect50",
    "tri51",
    "rect51",
    "tri52",
    "rect52",
    "tri53",
    "rect53",
    "tri54",
    "rect54",
    "tri55",
    "rect55",
    "tri56",
    "rect56",
    "tri57",
    "rect57",
    "tri58",
    "rect58",
    "tri59",
    "rect59",
    "tri60",
    "rect60",
    "tri61",
    "rect61",
    "tri62",
    "rect62",
    "tri63",
    "rect63",
    "tri64",
    "rect64",
    "shade4",
    "alert4",
    "icon31",
    "content6",
    "text15",
    "icon32",
    "text16",
    "title39",
    "desc11",
    "features2",
    "title40",
    "contents",
    "contentsItem18",
    "icon33",
    "text17",
    "contentsItem19",
    "icon34",
    "text18",
    "contentsItem20",
    "icon35",
    "text19",
    "contentsItem21",
    "icon36",
    "text20",
    "contentsItem22",
    "icon7",
    "text21",
    "contentsItem23",
    "icon37",
    "text22",
    "contentsItem24",
    "icon38",
    "text23",
    "contentsItem25",
    "icon39",
    "text24"
  ],
  placeholder56: [
    "placeholder56",
    "intro6",
    "img6",
    "bg5",
    "xmlid74572",
    "xmlid67762",
    "xmlid74332",
    "xmlid73392",
    "certificate2",
    "top6",
    "mockupCertificateIcon2",
    "bg6",
    "group2",
    "paper3",
    "paper4",
    "cert2",
    "award492",
    "overlay2",
    "title26",
    "mockupTextPlaceholder2",
    "mockupTextPlaceholderParagraph7",
    "mockupTextPlaceholderLine37",
    "mockupTextPlaceholderContent51",
    "placeholder57",
    "mockupTextPlaceholderLine38",
    "mockupTextPlaceholderContent52",
    "placeholder58",
    "mockupTextPlaceholderLine39",
    "mockupTextPlaceholderContent3",
    "placeholder4",
    "mockupTextPlaceholderLine40",
    "mockupTextPlaceholderContent4",
    "placeholder5",
    "mockupTextPlaceholderLine41",
    "mockupTextPlaceholderContent5",
    "placeholder6",
    "mockupTextPlaceholderParagraph8",
    "mockupTextPlaceholderLine42",
    "mockupTextPlaceholderContent6",
    "placeholder7",
    "mockupTextPlaceholderLine43",
    "mockupTextPlaceholderContent7",
    "placeholder8",
    "mockupTextPlaceholderLine44",
    "mockupTextPlaceholderContent8",
    "placeholder9",
    "mockupTextPlaceholderLine45",
    "mockupTextPlaceholderContent9",
    "placeholder10",
    "mockupTextPlaceholderLine46",
    "mockupTextPlaceholderContent10",
    "placeholder11",
    "mockupTextPlaceholderLine47",
    "mockupTextPlaceholderContent11",
    "placeholder12",
    "mockupTextPlaceholderLine48",
    "mockupTextPlaceholderContent12",
    "placeholder13",
    "mockupTextPlaceholderLine49",
    "mockupTextPlaceholderContent13",
    "placeholder14",
    "mockupTextPlaceholderParagraph9",
    "mockupTextPlaceholderLine50",
    "mockupTextPlaceholderContent14",
    "placeholder15",
    "mockupTextPlaceholderLine51",
    "mockupTextPlaceholderContent53",
    "placeholder59",
    "mockupTextPlaceholderLine52",
    "mockupTextPlaceholderContent54",
    "placeholder60",
    "mockupTextPlaceholderLine53",
    "mockupTextPlaceholderContent55",
    "placeholder61",
    "mockupTextPlaceholderLine54",
    "mockupTextPlaceholderContent56",
    "placeholder62",
    "mockupTextPlaceholderParagraph10",
    "mockupTextPlaceholderLine55",
    "mockupTextPlaceholderContent57",
    "placeholder63",
    "mockupTextPlaceholderLine56",
    "mockupTextPlaceholderContent58",
    "placeholder64",
    "mockupTextPlaceholderLine57",
    "mockupTextPlaceholderContent59",
    "placeholder65",
    "mockupTextPlaceholderLine58",
    "mockupTextPlaceholderContent60",
    "placeholder66",
    "mockupTextPlaceholderLine59",
    "mockupTextPlaceholderContent61",
    "placeholder67",
    "mockupTextPlaceholderLine60",
    "mockupTextPlaceholderContent62",
    "placeholder68",
    "mockupTextPlaceholderLine61",
    "mockupTextPlaceholderContent63",
    "placeholder69",
    "mockupTextPlaceholderLine62",
    "mockupTextPlaceholderContent64",
    "placeholder70",
    "mockupButton3",
    "link3",
    "bill3",
    "bill2",
    "header4",
    "subtitle6",
    "title35",
    "main2",
    "placeholder71",
    "header5",
    "title36",
    "date2",
    "section3",
    "head3",
    "mockupTextPlaceholderParagraph11",
    "mockupTextPlaceholderLine63",
    "mockupTextPlaceholderContent65",
    "placeholder72",
    "mockupTextPlaceholderLine64",
    "mockupTextPlaceholderContent66",
    "placeholder73",
    "mockupTextPlaceholderLine65",
    "mockupTextPlaceholderContent67",
    "placeholder74",
    "mockupTextPlaceholderLine66",
    "mockupTextPlaceholderContent68",
    "placeholder75",
    "mockupTextPlaceholderLine67",
    "mockupTextPlaceholderContent69",
    "placeholder76",
    "total3",
    "title37",
    "val8",
    "section4",
    "head4",
    "mockupTextPlaceholderParagraph12",
    "mockupTextPlaceholderLine68",
    "mockupTextPlaceholderContent70",
    "placeholder77",
    "mockupTextPlaceholderLine69",
    "mockupTextPlaceholderContent71",
    "placeholder78",
    "mockupTextPlaceholderLine70",
    "mockupTextPlaceholderContent72",
    "placeholder79",
    "mockupTextPlaceholderLine71",
    "mockupTextPlaceholderContent73",
    "placeholder80",
    "mockupTextPlaceholderLine72",
    "mockupTextPlaceholderContent74",
    "placeholder81",
    "total4",
    "title38",
    "val9",
    "edge2",
    "tri33",
    "rect33",
    "tri34",
    "rect34",
    "tri35",
    "rect35",
    "tri36",
    "rect36",
    "tri37",
    "rect37",
    "tri38",
    "rect38",
    "tri39",
    "rect39",
    "tri40",
    "rect40",
    "tri41",
    "rect41",
    "tri42",
    "rect42",
    "tri43",
    "rect43",
    "tri44",
    "rect44",
    "tri45",
    "rect45",
    "tri46",
    "rect46",
    "tri47",
    "rect47",
    "tri48",
    "rect48",
    "tri49",
    "rect49",
    "tri50",
    "rect50",
    "tri51",
    "rect51",
    "tri52",
    "rect52",
    "tri53",
    "rect53",
    "tri54",
    "rect54",
    "tri55",
    "rect55",
    "tri56",
    "rect56",
    "tri57",
    "rect57",
    "tri58",
    "rect58",
    "tri59",
    "rect59",
    "tri60",
    "rect60",
    "tri61",
    "rect61",
    "tri62",
    "rect62",
    "tri63",
    "rect63",
    "tri64",
    "rect64",
    "shade4",
    "alert4",
    "icon31",
    "content6",
    "text15",
    "icon32",
    "text16",
    "title39",
    "desc11",
    "features2",
    "title40",
    "contents",
    "contentsItem18",
    "icon33",
    "text17",
    "contentsItem19",
    "icon34",
    "text18",
    "contentsItem20",
    "icon35",
    "text19",
    "contentsItem21",
    "icon36",
    "text20",
    "contentsItem22",
    "icon7",
    "text21",
    "contentsItem23",
    "icon37",
    "text22",
    "contentsItem24",
    "icon38",
    "text23",
    "contentsItem25",
    "icon39",
    "text24"
  ],
  intro6: [
    "intro6",
    "img6",
    "bg5",
    "xmlid74572",
    "xmlid67762",
    "xmlid74332",
    "xmlid73392",
    "certificate2",
    "top6",
    "mockupCertificateIcon2",
    "bg6",
    "group2",
    "paper3",
    "paper4",
    "cert2",
    "award492",
    "overlay2",
    "title26",
    "mockupTextPlaceholder2",
    "mockupTextPlaceholderParagraph7",
    "mockupTextPlaceholderLine37",
    "mockupTextPlaceholderContent51",
    "placeholder57",
    "mockupTextPlaceholderLine38",
    "mockupTextPlaceholderContent52",
    "placeholder58",
    "mockupTextPlaceholderLine39",
    "mockupTextPlaceholderContent3",
    "placeholder4",
    "mockupTextPlaceholderLine40",
    "mockupTextPlaceholderContent4",
    "placeholder5",
    "mockupTextPlaceholderLine41",
    "mockupTextPlaceholderContent5",
    "placeholder6",
    "mockupTextPlaceholderParagraph8",
    "mockupTextPlaceholderLine42",
    "mockupTextPlaceholderContent6",
    "placeholder7",
    "mockupTextPlaceholderLine43",
    "mockupTextPlaceholderContent7",
    "placeholder8",
    "mockupTextPlaceholderLine44",
    "mockupTextPlaceholderContent8",
    "placeholder9",
    "mockupTextPlaceholderLine45",
    "mockupTextPlaceholderContent9",
    "placeholder10",
    "mockupTextPlaceholderLine46",
    "mockupTextPlaceholderContent10",
    "placeholder11",
    "mockupTextPlaceholderLine47",
    "mockupTextPlaceholderContent11",
    "placeholder12",
    "mockupTextPlaceholderLine48",
    "mockupTextPlaceholderContent12",
    "placeholder13",
    "mockupTextPlaceholderLine49",
    "mockupTextPlaceholderContent13",
    "placeholder14",
    "mockupTextPlaceholderParagraph9",
    "mockupTextPlaceholderLine50",
    "mockupTextPlaceholderContent14",
    "placeholder15",
    "mockupTextPlaceholderLine51",
    "mockupTextPlaceholderContent53",
    "placeholder59",
    "mockupTextPlaceholderLine52",
    "mockupTextPlaceholderContent54",
    "placeholder60",
    "mockupTextPlaceholderLine53",
    "mockupTextPlaceholderContent55",
    "placeholder61",
    "mockupTextPlaceholderLine54",
    "mockupTextPlaceholderContent56",
    "placeholder62",
    "mockupTextPlaceholderParagraph10",
    "mockupTextPlaceholderLine55",
    "mockupTextPlaceholderContent57",
    "placeholder63",
    "mockupTextPlaceholderLine56",
    "mockupTextPlaceholderContent58",
    "placeholder64",
    "mockupTextPlaceholderLine57",
    "mockupTextPlaceholderContent59",
    "placeholder65",
    "mockupTextPlaceholderLine58",
    "mockupTextPlaceholderContent60",
    "placeholder66",
    "mockupTextPlaceholderLine59",
    "mockupTextPlaceholderContent61",
    "placeholder67",
    "mockupTextPlaceholderLine60",
    "mockupTextPlaceholderContent62",
    "placeholder68",
    "mockupTextPlaceholderLine61",
    "mockupTextPlaceholderContent63",
    "placeholder69",
    "mockupTextPlaceholderLine62",
    "mockupTextPlaceholderContent64",
    "placeholder70",
    "mockupButton3",
    "link3",
    "bill3",
    "bill2",
    "header4",
    "subtitle6",
    "title35",
    "main2",
    "placeholder71",
    "header5",
    "title36",
    "date2",
    "section3",
    "head3",
    "mockupTextPlaceholderParagraph11",
    "mockupTextPlaceholderLine63",
    "mockupTextPlaceholderContent65",
    "placeholder72",
    "mockupTextPlaceholderLine64",
    "mockupTextPlaceholderContent66",
    "placeholder73",
    "mockupTextPlaceholderLine65",
    "mockupTextPlaceholderContent67",
    "placeholder74",
    "mockupTextPlaceholderLine66",
    "mockupTextPlaceholderContent68",
    "placeholder75",
    "mockupTextPlaceholderLine67",
    "mockupTextPlaceholderContent69",
    "placeholder76",
    "total3",
    "title37",
    "val8",
    "section4",
    "head4",
    "mockupTextPlaceholderParagraph12",
    "mockupTextPlaceholderLine68",
    "mockupTextPlaceholderContent70",
    "placeholder77",
    "mockupTextPlaceholderLine69",
    "mockupTextPlaceholderContent71",
    "placeholder78",
    "mockupTextPlaceholderLine70",
    "mockupTextPlaceholderContent72",
    "placeholder79",
    "mockupTextPlaceholderLine71",
    "mockupTextPlaceholderContent73",
    "placeholder80",
    "mockupTextPlaceholderLine72",
    "mockupTextPlaceholderContent74",
    "placeholder81",
    "total4",
    "title38",
    "val9",
    "edge2",
    "tri33",
    "rect33",
    "tri34",
    "rect34",
    "tri35",
    "rect35",
    "tri36",
    "rect36",
    "tri37",
    "rect37",
    "tri38",
    "rect38",
    "tri39",
    "rect39",
    "tri40",
    "rect40",
    "tri41",
    "rect41",
    "tri42",
    "rect42",
    "tri43",
    "rect43",
    "tri44",
    "rect44",
    "tri45",
    "rect45",
    "tri46",
    "rect46",
    "tri47",
    "rect47",
    "tri48",
    "rect48",
    "tri49",
    "rect49",
    "tri50",
    "rect50",
    "tri51",
    "rect51",
    "tri52",
    "rect52",
    "tri53",
    "rect53",
    "tri54",
    "rect54",
    "tri55",
    "rect55",
    "tri56",
    "rect56",
    "tri57",
    "rect57",
    "tri58",
    "rect58",
    "tri59",
    "rect59",
    "tri60",
    "rect60",
    "tri61",
    "rect61",
    "tri62",
    "rect62",
    "tri63",
    "rect63",
    "tri64",
    "rect64",
    "shade4",
    "alert4",
    "icon31",
    "content6",
    "text15",
    "icon32",
    "text16",
    "title39",
    "desc11"
  ],
  img6: [
    "img6",
    "bg5",
    "xmlid74572",
    "xmlid67762",
    "xmlid74332",
    "xmlid73392",
    "certificate2",
    "top6",
    "mockupCertificateIcon2",
    "bg6",
    "group2",
    "paper3",
    "paper4",
    "cert2",
    "award492",
    "overlay2",
    "title26",
    "mockupTextPlaceholder2",
    "mockupTextPlaceholderParagraph7",
    "mockupTextPlaceholderLine37",
    "mockupTextPlaceholderContent51",
    "placeholder57",
    "mockupTextPlaceholderLine38",
    "mockupTextPlaceholderContent52",
    "placeholder58",
    "mockupTextPlaceholderLine39",
    "mockupTextPlaceholderContent3",
    "placeholder4",
    "mockupTextPlaceholderLine40",
    "mockupTextPlaceholderContent4",
    "placeholder5",
    "mockupTextPlaceholderLine41",
    "mockupTextPlaceholderContent5",
    "placeholder6",
    "mockupTextPlaceholderParagraph8",
    "mockupTextPlaceholderLine42",
    "mockupTextPlaceholderContent6",
    "placeholder7",
    "mockupTextPlaceholderLine43",
    "mockupTextPlaceholderContent7",
    "placeholder8",
    "mockupTextPlaceholderLine44",
    "mockupTextPlaceholderContent8",
    "placeholder9",
    "mockupTextPlaceholderLine45",
    "mockupTextPlaceholderContent9",
    "placeholder10",
    "mockupTextPlaceholderLine46",
    "mockupTextPlaceholderContent10",
    "placeholder11",
    "mockupTextPlaceholderLine47",
    "mockupTextPlaceholderContent11",
    "placeholder12",
    "mockupTextPlaceholderLine48",
    "mockupTextPlaceholderContent12",
    "placeholder13",
    "mockupTextPlaceholderLine49",
    "mockupTextPlaceholderContent13",
    "placeholder14",
    "mockupTextPlaceholderParagraph9",
    "mockupTextPlaceholderLine50",
    "mockupTextPlaceholderContent14",
    "placeholder15",
    "mockupTextPlaceholderLine51",
    "mockupTextPlaceholderContent53",
    "placeholder59",
    "mockupTextPlaceholderLine52",
    "mockupTextPlaceholderContent54",
    "placeholder60",
    "mockupTextPlaceholderLine53",
    "mockupTextPlaceholderContent55",
    "placeholder61",
    "mockupTextPlaceholderLine54",
    "mockupTextPlaceholderContent56",
    "placeholder62",
    "mockupTextPlaceholderParagraph10",
    "mockupTextPlaceholderLine55",
    "mockupTextPlaceholderContent57",
    "placeholder63",
    "mockupTextPlaceholderLine56",
    "mockupTextPlaceholderContent58",
    "placeholder64",
    "mockupTextPlaceholderLine57",
    "mockupTextPlaceholderContent59",
    "placeholder65",
    "mockupTextPlaceholderLine58",
    "mockupTextPlaceholderContent60",
    "placeholder66",
    "mockupTextPlaceholderLine59",
    "mockupTextPlaceholderContent61",
    "placeholder67",
    "mockupTextPlaceholderLine60",
    "mockupTextPlaceholderContent62",
    "placeholder68",
    "mockupTextPlaceholderLine61",
    "mockupTextPlaceholderContent63",
    "placeholder69",
    "mockupTextPlaceholderLine62",
    "mockupTextPlaceholderContent64",
    "placeholder70",
    "mockupButton3",
    "link3",
    "bill3",
    "bill2",
    "header4",
    "subtitle6",
    "title35",
    "main2",
    "placeholder71",
    "header5",
    "title36",
    "date2",
    "section3",
    "head3",
    "mockupTextPlaceholderParagraph11",
    "mockupTextPlaceholderLine63",
    "mockupTextPlaceholderContent65",
    "placeholder72",
    "mockupTextPlaceholderLine64",
    "mockupTextPlaceholderContent66",
    "placeholder73",
    "mockupTextPlaceholderLine65",
    "mockupTextPlaceholderContent67",
    "placeholder74",
    "mockupTextPlaceholderLine66",
    "mockupTextPlaceholderContent68",
    "placeholder75",
    "mockupTextPlaceholderLine67",
    "mockupTextPlaceholderContent69",
    "placeholder76",
    "total3",
    "title37",
    "val8",
    "section4",
    "head4",
    "mockupTextPlaceholderParagraph12",
    "mockupTextPlaceholderLine68",
    "mockupTextPlaceholderContent70",
    "placeholder77",
    "mockupTextPlaceholderLine69",
    "mockupTextPlaceholderContent71",
    "placeholder78",
    "mockupTextPlaceholderLine70",
    "mockupTextPlaceholderContent72",
    "placeholder79",
    "mockupTextPlaceholderLine71",
    "mockupTextPlaceholderContent73",
    "placeholder80",
    "mockupTextPlaceholderLine72",
    "mockupTextPlaceholderContent74",
    "placeholder81",
    "total4",
    "title38",
    "val9",
    "edge2",
    "tri33",
    "rect33",
    "tri34",
    "rect34",
    "tri35",
    "rect35",
    "tri36",
    "rect36",
    "tri37",
    "rect37",
    "tri38",
    "rect38",
    "tri39",
    "rect39",
    "tri40",
    "rect40",
    "tri41",
    "rect41",
    "tri42",
    "rect42",
    "tri43",
    "rect43",
    "tri44",
    "rect44",
    "tri45",
    "rect45",
    "tri46",
    "rect46",
    "tri47",
    "rect47",
    "tri48",
    "rect48",
    "tri49",
    "rect49",
    "tri50",
    "rect50",
    "tri51",
    "rect51",
    "tri52",
    "rect52",
    "tri53",
    "rect53",
    "tri54",
    "rect54",
    "tri55",
    "rect55",
    "tri56",
    "rect56",
    "tri57",
    "rect57",
    "tri58",
    "rect58",
    "tri59",
    "rect59",
    "tri60",
    "rect60",
    "tri61",
    "rect61",
    "tri62",
    "rect62",
    "tri63",
    "rect63",
    "tri64",
    "rect64",
    "shade4",
    "alert4",
    "icon31",
    "content6",
    "text15",
    "icon32"
  ],
  bg5: ["bg5", "xmlid74572", "xmlid67762", "xmlid74332", "xmlid73392"],
  xmlid74572: ["xmlid74572", "xmlid67762", "xmlid74332", "xmlid73392"],
  xmlid67762: ["xmlid67762"],
  xmlid74332: ["xmlid74332"],
  xmlid73392: ["xmlid73392"],
  certificate2: [
    "certificate2",
    "top6",
    "mockupCertificateIcon2",
    "bg6",
    "group2",
    "paper3",
    "paper4",
    "cert2",
    "award492",
    "overlay2",
    "title26",
    "mockupTextPlaceholder2",
    "mockupTextPlaceholderParagraph7",
    "mockupTextPlaceholderLine37",
    "mockupTextPlaceholderContent51",
    "placeholder57",
    "mockupTextPlaceholderLine38",
    "mockupTextPlaceholderContent52",
    "placeholder58",
    "mockupTextPlaceholderLine39",
    "mockupTextPlaceholderContent3",
    "placeholder4",
    "mockupTextPlaceholderLine40",
    "mockupTextPlaceholderContent4",
    "placeholder5",
    "mockupTextPlaceholderLine41",
    "mockupTextPlaceholderContent5",
    "placeholder6",
    "mockupTextPlaceholderParagraph8",
    "mockupTextPlaceholderLine42",
    "mockupTextPlaceholderContent6",
    "placeholder7",
    "mockupTextPlaceholderLine43",
    "mockupTextPlaceholderContent7",
    "placeholder8",
    "mockupTextPlaceholderLine44",
    "mockupTextPlaceholderContent8",
    "placeholder9",
    "mockupTextPlaceholderLine45",
    "mockupTextPlaceholderContent9",
    "placeholder10",
    "mockupTextPlaceholderLine46",
    "mockupTextPlaceholderContent10",
    "placeholder11",
    "mockupTextPlaceholderLine47",
    "mockupTextPlaceholderContent11",
    "placeholder12",
    "mockupTextPlaceholderLine48",
    "mockupTextPlaceholderContent12",
    "placeholder13",
    "mockupTextPlaceholderLine49",
    "mockupTextPlaceholderContent13",
    "placeholder14",
    "mockupTextPlaceholderParagraph9",
    "mockupTextPlaceholderLine50",
    "mockupTextPlaceholderContent14",
    "placeholder15",
    "mockupTextPlaceholderLine51",
    "mockupTextPlaceholderContent53",
    "placeholder59",
    "mockupTextPlaceholderLine52",
    "mockupTextPlaceholderContent54",
    "placeholder60",
    "mockupTextPlaceholderLine53",
    "mockupTextPlaceholderContent55",
    "placeholder61",
    "mockupTextPlaceholderLine54",
    "mockupTextPlaceholderContent56",
    "placeholder62",
    "mockupTextPlaceholderParagraph10",
    "mockupTextPlaceholderLine55",
    "mockupTextPlaceholderContent57",
    "placeholder63",
    "mockupTextPlaceholderLine56",
    "mockupTextPlaceholderContent58",
    "placeholder64",
    "mockupTextPlaceholderLine57",
    "mockupTextPlaceholderContent59",
    "placeholder65",
    "mockupTextPlaceholderLine58",
    "mockupTextPlaceholderContent60",
    "placeholder66",
    "mockupTextPlaceholderLine59",
    "mockupTextPlaceholderContent61",
    "placeholder67",
    "mockupTextPlaceholderLine60",
    "mockupTextPlaceholderContent62",
    "placeholder68",
    "mockupTextPlaceholderLine61",
    "mockupTextPlaceholderContent63",
    "placeholder69",
    "mockupTextPlaceholderLine62",
    "mockupTextPlaceholderContent64",
    "placeholder70",
    "mockupButton3",
    "link3"
  ],
  top6: [
    "top6",
    "mockupCertificateIcon2",
    "bg6",
    "group2",
    "paper3",
    "paper4",
    "cert2",
    "award492",
    "overlay2",
    "title26",
    "mockupTextPlaceholder2",
    "mockupTextPlaceholderParagraph7",
    "mockupTextPlaceholderLine37",
    "mockupTextPlaceholderContent51",
    "placeholder57",
    "mockupTextPlaceholderLine38",
    "mockupTextPlaceholderContent52",
    "placeholder58",
    "mockupTextPlaceholderLine39",
    "mockupTextPlaceholderContent3",
    "placeholder4",
    "mockupTextPlaceholderLine40",
    "mockupTextPlaceholderContent4",
    "placeholder5",
    "mockupTextPlaceholderLine41",
    "mockupTextPlaceholderContent5",
    "placeholder6",
    "mockupTextPlaceholderParagraph8",
    "mockupTextPlaceholderLine42",
    "mockupTextPlaceholderContent6",
    "placeholder7",
    "mockupTextPlaceholderLine43",
    "mockupTextPlaceholderContent7",
    "placeholder8",
    "mockupTextPlaceholderLine44",
    "mockupTextPlaceholderContent8",
    "placeholder9",
    "mockupTextPlaceholderLine45",
    "mockupTextPlaceholderContent9",
    "placeholder10",
    "mockupTextPlaceholderLine46",
    "mockupTextPlaceholderContent10",
    "placeholder11",
    "mockupTextPlaceholderLine47",
    "mockupTextPlaceholderContent11",
    "placeholder12",
    "mockupTextPlaceholderLine48",
    "mockupTextPlaceholderContent12",
    "placeholder13",
    "mockupTextPlaceholderLine49",
    "mockupTextPlaceholderContent13",
    "placeholder14",
    "mockupTextPlaceholderParagraph9",
    "mockupTextPlaceholderLine50",
    "mockupTextPlaceholderContent14",
    "placeholder15",
    "mockupTextPlaceholderLine51",
    "mockupTextPlaceholderContent53",
    "placeholder59",
    "mockupTextPlaceholderLine52",
    "mockupTextPlaceholderContent54",
    "placeholder60",
    "mockupTextPlaceholderLine53",
    "mockupTextPlaceholderContent55",
    "placeholder61",
    "mockupTextPlaceholderLine54",
    "mockupTextPlaceholderContent56",
    "placeholder62",
    "mockupTextPlaceholderParagraph10",
    "mockupTextPlaceholderLine55",
    "mockupTextPlaceholderContent57",
    "placeholder63",
    "mockupTextPlaceholderLine56",
    "mockupTextPlaceholderContent58",
    "placeholder64",
    "mockupTextPlaceholderLine57",
    "mockupTextPlaceholderContent59",
    "placeholder65",
    "mockupTextPlaceholderLine58",
    "mockupTextPlaceholderContent60",
    "placeholder66",
    "mockupTextPlaceholderLine59",
    "mockupTextPlaceholderContent61",
    "placeholder67",
    "mockupTextPlaceholderLine60",
    "mockupTextPlaceholderContent62",
    "placeholder68",
    "mockupTextPlaceholderLine61",
    "mockupTextPlaceholderContent63",
    "placeholder69",
    "mockupTextPlaceholderLine62",
    "mockupTextPlaceholderContent64",
    "placeholder70"
  ],
  mockupCertificateIcon2: [
    "mockupCertificateIcon2",
    "bg6",
    "group2",
    "paper3",
    "paper4",
    "cert2",
    "award492",
    "overlay2"
  ],
  bg6: ["bg6"],
  group2: ["group2", "paper3", "paper4", "cert2", "award492"],
  paper3: ["paper3"],
  paper4: ["paper4"],
  cert2: ["cert2", "award492"],
  award492: ["award492"],
  overlay2: ["overlay2"],
  title26: ["title26"],
  mockupTextPlaceholder2: [
    "mockupTextPlaceholder2",
    "mockupTextPlaceholderParagraph7",
    "mockupTextPlaceholderLine37",
    "mockupTextPlaceholderContent51",
    "placeholder57",
    "mockupTextPlaceholderLine38",
    "mockupTextPlaceholderContent52",
    "placeholder58",
    "mockupTextPlaceholderLine39",
    "mockupTextPlaceholderContent3",
    "placeholder4",
    "mockupTextPlaceholderLine40",
    "mockupTextPlaceholderContent4",
    "placeholder5",
    "mockupTextPlaceholderLine41",
    "mockupTextPlaceholderContent5",
    "placeholder6",
    "mockupTextPlaceholderParagraph8",
    "mockupTextPlaceholderLine42",
    "mockupTextPlaceholderContent6",
    "placeholder7",
    "mockupTextPlaceholderLine43",
    "mockupTextPlaceholderContent7",
    "placeholder8",
    "mockupTextPlaceholderLine44",
    "mockupTextPlaceholderContent8",
    "placeholder9",
    "mockupTextPlaceholderLine45",
    "mockupTextPlaceholderContent9",
    "placeholder10",
    "mockupTextPlaceholderLine46",
    "mockupTextPlaceholderContent10",
    "placeholder11",
    "mockupTextPlaceholderLine47",
    "mockupTextPlaceholderContent11",
    "placeholder12",
    "mockupTextPlaceholderLine48",
    "mockupTextPlaceholderContent12",
    "placeholder13",
    "mockupTextPlaceholderLine49",
    "mockupTextPlaceholderContent13",
    "placeholder14",
    "mockupTextPlaceholderParagraph9",
    "mockupTextPlaceholderLine50",
    "mockupTextPlaceholderContent14",
    "placeholder15",
    "mockupTextPlaceholderLine51",
    "mockupTextPlaceholderContent53",
    "placeholder59",
    "mockupTextPlaceholderLine52",
    "mockupTextPlaceholderContent54",
    "placeholder60",
    "mockupTextPlaceholderLine53",
    "mockupTextPlaceholderContent55",
    "placeholder61",
    "mockupTextPlaceholderLine54",
    "mockupTextPlaceholderContent56",
    "placeholder62",
    "mockupTextPlaceholderParagraph10",
    "mockupTextPlaceholderLine55",
    "mockupTextPlaceholderContent57",
    "placeholder63",
    "mockupTextPlaceholderLine56",
    "mockupTextPlaceholderContent58",
    "placeholder64",
    "mockupTextPlaceholderLine57",
    "mockupTextPlaceholderContent59",
    "placeholder65",
    "mockupTextPlaceholderLine58",
    "mockupTextPlaceholderContent60",
    "placeholder66",
    "mockupTextPlaceholderLine59",
    "mockupTextPlaceholderContent61",
    "placeholder67",
    "mockupTextPlaceholderLine60",
    "mockupTextPlaceholderContent62",
    "placeholder68",
    "mockupTextPlaceholderLine61",
    "mockupTextPlaceholderContent63",
    "placeholder69",
    "mockupTextPlaceholderLine62",
    "mockupTextPlaceholderContent64",
    "placeholder70"
  ],
  mockupTextPlaceholderParagraph7: [
    "mockupTextPlaceholderParagraph7",
    "mockupTextPlaceholderLine37",
    "mockupTextPlaceholderContent51",
    "placeholder57",
    "mockupTextPlaceholderLine38",
    "mockupTextPlaceholderContent52",
    "placeholder58",
    "mockupTextPlaceholderLine39",
    "mockupTextPlaceholderContent3",
    "placeholder4",
    "mockupTextPlaceholderLine40",
    "mockupTextPlaceholderContent4",
    "placeholder5",
    "mockupTextPlaceholderLine41",
    "mockupTextPlaceholderContent5",
    "placeholder6"
  ],
  mockupTextPlaceholderLine37: [
    "mockupTextPlaceholderLine37",
    "mockupTextPlaceholderContent51",
    "placeholder57"
  ],
  mockupTextPlaceholderContent51: [
    "mockupTextPlaceholderContent51",
    "placeholder57"
  ],
  placeholder57: ["placeholder57"],
  mockupTextPlaceholderLine38: [
    "mockupTextPlaceholderLine38",
    "mockupTextPlaceholderContent52",
    "placeholder58"
  ],
  mockupTextPlaceholderContent52: [
    "mockupTextPlaceholderContent52",
    "placeholder58"
  ],
  placeholder58: ["placeholder58"],
  mockupTextPlaceholderLine39: [
    "mockupTextPlaceholderLine39",
    "mockupTextPlaceholderContent3",
    "placeholder4"
  ],
  mockupTextPlaceholderContent3: [
    "mockupTextPlaceholderContent3",
    "placeholder4"
  ],
  placeholder4: ["placeholder4"],
  mockupTextPlaceholderLine40: [
    "mockupTextPlaceholderLine40",
    "mockupTextPlaceholderContent4",
    "placeholder5"
  ],
  mockupTextPlaceholderContent4: [
    "mockupTextPlaceholderContent4",
    "placeholder5"
  ],
  placeholder5: ["placeholder5"],
  mockupTextPlaceholderLine41: [
    "mockupTextPlaceholderLine41",
    "mockupTextPlaceholderContent5",
    "placeholder6"
  ],
  mockupTextPlaceholderContent5: [
    "mockupTextPlaceholderContent5",
    "placeholder6"
  ],
  placeholder6: ["placeholder6"],
  mockupTextPlaceholderParagraph8: [
    "mockupTextPlaceholderParagraph8",
    "mockupTextPlaceholderLine42",
    "mockupTextPlaceholderContent6",
    "placeholder7",
    "mockupTextPlaceholderLine43",
    "mockupTextPlaceholderContent7",
    "placeholder8",
    "mockupTextPlaceholderLine44",
    "mockupTextPlaceholderContent8",
    "placeholder9",
    "mockupTextPlaceholderLine45",
    "mockupTextPlaceholderContent9",
    "placeholder10",
    "mockupTextPlaceholderLine46",
    "mockupTextPlaceholderContent10",
    "placeholder11",
    "mockupTextPlaceholderLine47",
    "mockupTextPlaceholderContent11",
    "placeholder12",
    "mockupTextPlaceholderLine48",
    "mockupTextPlaceholderContent12",
    "placeholder13",
    "mockupTextPlaceholderLine49",
    "mockupTextPlaceholderContent13",
    "placeholder14"
  ],
  mockupTextPlaceholderLine42: [
    "mockupTextPlaceholderLine42",
    "mockupTextPlaceholderContent6",
    "placeholder7"
  ],
  mockupTextPlaceholderContent6: [
    "mockupTextPlaceholderContent6",
    "placeholder7"
  ],
  placeholder7: ["placeholder7"],
  mockupTextPlaceholderLine43: [
    "mockupTextPlaceholderLine43",
    "mockupTextPlaceholderContent7",
    "placeholder8"
  ],
  mockupTextPlaceholderContent7: [
    "mockupTextPlaceholderContent7",
    "placeholder8"
  ],
  placeholder8: ["placeholder8"],
  mockupTextPlaceholderLine44: [
    "mockupTextPlaceholderLine44",
    "mockupTextPlaceholderContent8",
    "placeholder9"
  ],
  mockupTextPlaceholderContent8: [
    "mockupTextPlaceholderContent8",
    "placeholder9"
  ],
  placeholder9: ["placeholder9"],
  mockupTextPlaceholderLine45: [
    "mockupTextPlaceholderLine45",
    "mockupTextPlaceholderContent9",
    "placeholder10"
  ],
  mockupTextPlaceholderContent9: [
    "mockupTextPlaceholderContent9",
    "placeholder10"
  ],
  placeholder10: ["placeholder10"],
  mockupTextPlaceholderLine46: [
    "mockupTextPlaceholderLine46",
    "mockupTextPlaceholderContent10",
    "placeholder11"
  ],
  mockupTextPlaceholderContent10: [
    "mockupTextPlaceholderContent10",
    "placeholder11"
  ],
  placeholder11: ["placeholder11"],
  mockupTextPlaceholderLine47: [
    "mockupTextPlaceholderLine47",
    "mockupTextPlaceholderContent11",
    "placeholder12"
  ],
  mockupTextPlaceholderContent11: [
    "mockupTextPlaceholderContent11",
    "placeholder12"
  ],
  placeholder12: ["placeholder12"],
  mockupTextPlaceholderLine48: [
    "mockupTextPlaceholderLine48",
    "mockupTextPlaceholderContent12",
    "placeholder13"
  ],
  mockupTextPlaceholderContent12: [
    "mockupTextPlaceholderContent12",
    "placeholder13"
  ],
  placeholder13: ["placeholder13"],
  mockupTextPlaceholderLine49: [
    "mockupTextPlaceholderLine49",
    "mockupTextPlaceholderContent13",
    "placeholder14"
  ],
  mockupTextPlaceholderContent13: [
    "mockupTextPlaceholderContent13",
    "placeholder14"
  ],
  placeholder14: ["placeholder14"],
  mockupTextPlaceholderParagraph9: [
    "mockupTextPlaceholderParagraph9",
    "mockupTextPlaceholderLine50",
    "mockupTextPlaceholderContent14",
    "placeholder15",
    "mockupTextPlaceholderLine51",
    "mockupTextPlaceholderContent53",
    "placeholder59",
    "mockupTextPlaceholderLine52",
    "mockupTextPlaceholderContent54",
    "placeholder60",
    "mockupTextPlaceholderLine53",
    "mockupTextPlaceholderContent55",
    "placeholder61",
    "mockupTextPlaceholderLine54",
    "mockupTextPlaceholderContent56",
    "placeholder62"
  ],
  mockupTextPlaceholderLine50: [
    "mockupTextPlaceholderLine50",
    "mockupTextPlaceholderContent14",
    "placeholder15"
  ],
  mockupTextPlaceholderContent14: [
    "mockupTextPlaceholderContent14",
    "placeholder15"
  ],
  placeholder15: ["placeholder15"],
  mockupTextPlaceholderLine51: [
    "mockupTextPlaceholderLine51",
    "mockupTextPlaceholderContent53",
    "placeholder59"
  ],
  mockupTextPlaceholderContent53: [
    "mockupTextPlaceholderContent53",
    "placeholder59"
  ],
  placeholder59: ["placeholder59"],
  mockupTextPlaceholderLine52: [
    "mockupTextPlaceholderLine52",
    "mockupTextPlaceholderContent54",
    "placeholder60"
  ],
  mockupTextPlaceholderContent54: [
    "mockupTextPlaceholderContent54",
    "placeholder60"
  ],
  placeholder60: ["placeholder60"],
  mockupTextPlaceholderLine53: [
    "mockupTextPlaceholderLine53",
    "mockupTextPlaceholderContent55",
    "placeholder61"
  ],
  mockupTextPlaceholderContent55: [
    "mockupTextPlaceholderContent55",
    "placeholder61"
  ],
  placeholder61: ["placeholder61"],
  mockupTextPlaceholderLine54: [
    "mockupTextPlaceholderLine54",
    "mockupTextPlaceholderContent56",
    "placeholder62"
  ],
  mockupTextPlaceholderContent56: [
    "mockupTextPlaceholderContent56",
    "placeholder62"
  ],
  placeholder62: ["placeholder62"],
  mockupTextPlaceholderParagraph10: [
    "mockupTextPlaceholderParagraph10",
    "mockupTextPlaceholderLine55",
    "mockupTextPlaceholderContent57",
    "placeholder63",
    "mockupTextPlaceholderLine56",
    "mockupTextPlaceholderContent58",
    "placeholder64",
    "mockupTextPlaceholderLine57",
    "mockupTextPlaceholderContent59",
    "placeholder65",
    "mockupTextPlaceholderLine58",
    "mockupTextPlaceholderContent60",
    "placeholder66",
    "mockupTextPlaceholderLine59",
    "mockupTextPlaceholderContent61",
    "placeholder67",
    "mockupTextPlaceholderLine60",
    "mockupTextPlaceholderContent62",
    "placeholder68",
    "mockupTextPlaceholderLine61",
    "mockupTextPlaceholderContent63",
    "placeholder69",
    "mockupTextPlaceholderLine62",
    "mockupTextPlaceholderContent64",
    "placeholder70"
  ],
  mockupTextPlaceholderLine55: [
    "mockupTextPlaceholderLine55",
    "mockupTextPlaceholderContent57",
    "placeholder63"
  ],
  mockupTextPlaceholderContent57: [
    "mockupTextPlaceholderContent57",
    "placeholder63"
  ],
  placeholder63: ["placeholder63"],
  mockupTextPlaceholderLine56: [
    "mockupTextPlaceholderLine56",
    "mockupTextPlaceholderContent58",
    "placeholder64"
  ],
  mockupTextPlaceholderContent58: [
    "mockupTextPlaceholderContent58",
    "placeholder64"
  ],
  placeholder64: ["placeholder64"],
  mockupTextPlaceholderLine57: [
    "mockupTextPlaceholderLine57",
    "mockupTextPlaceholderContent59",
    "placeholder65"
  ],
  mockupTextPlaceholderContent59: [
    "mockupTextPlaceholderContent59",
    "placeholder65"
  ],
  placeholder65: ["placeholder65"],
  mockupTextPlaceholderLine58: [
    "mockupTextPlaceholderLine58",
    "mockupTextPlaceholderContent60",
    "placeholder66"
  ],
  mockupTextPlaceholderContent60: [
    "mockupTextPlaceholderContent60",
    "placeholder66"
  ],
  placeholder66: ["placeholder66"],
  mockupTextPlaceholderLine59: [
    "mockupTextPlaceholderLine59",
    "mockupTextPlaceholderContent61",
    "placeholder67"
  ],
  mockupTextPlaceholderContent61: [
    "mockupTextPlaceholderContent61",
    "placeholder67"
  ],
  placeholder67: ["placeholder67"],
  mockupTextPlaceholderLine60: [
    "mockupTextPlaceholderLine60",
    "mockupTextPlaceholderContent62",
    "placeholder68"
  ],
  mockupTextPlaceholderContent62: [
    "mockupTextPlaceholderContent62",
    "placeholder68"
  ],
  placeholder68: ["placeholder68"],
  mockupTextPlaceholderLine61: [
    "mockupTextPlaceholderLine61",
    "mockupTextPlaceholderContent63",
    "placeholder69"
  ],
  mockupTextPlaceholderContent63: [
    "mockupTextPlaceholderContent63",
    "placeholder69"
  ],
  placeholder69: ["placeholder69"],
  mockupTextPlaceholderLine62: [
    "mockupTextPlaceholderLine62",
    "mockupTextPlaceholderContent64",
    "placeholder70"
  ],
  mockupTextPlaceholderContent64: [
    "mockupTextPlaceholderContent64",
    "placeholder70"
  ],
  placeholder70: ["placeholder70"],
  mockupButton3: ["mockupButton3", "link3"],
  link3: ["link3"],
  bill3: [
    "bill3",
    "bill2",
    "header4",
    "subtitle6",
    "title35",
    "main2",
    "placeholder71",
    "header5",
    "title36",
    "date2",
    "section3",
    "head3",
    "mockupTextPlaceholderParagraph11",
    "mockupTextPlaceholderLine63",
    "mockupTextPlaceholderContent65",
    "placeholder72",
    "mockupTextPlaceholderLine64",
    "mockupTextPlaceholderContent66",
    "placeholder73",
    "mockupTextPlaceholderLine65",
    "mockupTextPlaceholderContent67",
    "placeholder74",
    "mockupTextPlaceholderLine66",
    "mockupTextPlaceholderContent68",
    "placeholder75",
    "mockupTextPlaceholderLine67",
    "mockupTextPlaceholderContent69",
    "placeholder76",
    "total3",
    "title37",
    "val8",
    "section4",
    "head4",
    "mockupTextPlaceholderParagraph12",
    "mockupTextPlaceholderLine68",
    "mockupTextPlaceholderContent70",
    "placeholder77",
    "mockupTextPlaceholderLine69",
    "mockupTextPlaceholderContent71",
    "placeholder78",
    "mockupTextPlaceholderLine70",
    "mockupTextPlaceholderContent72",
    "placeholder79",
    "mockupTextPlaceholderLine71",
    "mockupTextPlaceholderContent73",
    "placeholder80",
    "mockupTextPlaceholderLine72",
    "mockupTextPlaceholderContent74",
    "placeholder81",
    "total4",
    "title38",
    "val9",
    "edge2",
    "tri33",
    "rect33",
    "tri34",
    "rect34",
    "tri35",
    "rect35",
    "tri36",
    "rect36",
    "tri37",
    "rect37",
    "tri38",
    "rect38",
    "tri39",
    "rect39",
    "tri40",
    "rect40",
    "tri41",
    "rect41",
    "tri42",
    "rect42",
    "tri43",
    "rect43",
    "tri44",
    "rect44",
    "tri45",
    "rect45",
    "tri46",
    "rect46",
    "tri47",
    "rect47",
    "tri48",
    "rect48",
    "tri49",
    "rect49",
    "tri50",
    "rect50",
    "tri51",
    "rect51",
    "tri52",
    "rect52",
    "tri53",
    "rect53",
    "tri54",
    "rect54",
    "tri55",
    "rect55",
    "tri56",
    "rect56",
    "tri57",
    "rect57",
    "tri58",
    "rect58",
    "tri59",
    "rect59",
    "tri60",
    "rect60",
    "tri61",
    "rect61",
    "tri62",
    "rect62",
    "tri63",
    "rect63",
    "tri64",
    "rect64",
    "shade4"
  ],
  bill2: [
    "bill2",
    "header4",
    "subtitle6",
    "title35",
    "main2",
    "placeholder71",
    "header5",
    "title36",
    "date2",
    "section3",
    "head3",
    "mockupTextPlaceholderParagraph11",
    "mockupTextPlaceholderLine63",
    "mockupTextPlaceholderContent65",
    "placeholder72",
    "mockupTextPlaceholderLine64",
    "mockupTextPlaceholderContent66",
    "placeholder73",
    "mockupTextPlaceholderLine65",
    "mockupTextPlaceholderContent67",
    "placeholder74",
    "mockupTextPlaceholderLine66",
    "mockupTextPlaceholderContent68",
    "placeholder75",
    "mockupTextPlaceholderLine67",
    "mockupTextPlaceholderContent69",
    "placeholder76",
    "total3",
    "title37",
    "val8",
    "section4",
    "head4",
    "mockupTextPlaceholderParagraph12",
    "mockupTextPlaceholderLine68",
    "mockupTextPlaceholderContent70",
    "placeholder77",
    "mockupTextPlaceholderLine69",
    "mockupTextPlaceholderContent71",
    "placeholder78",
    "mockupTextPlaceholderLine70",
    "mockupTextPlaceholderContent72",
    "placeholder79",
    "mockupTextPlaceholderLine71",
    "mockupTextPlaceholderContent73",
    "placeholder80",
    "mockupTextPlaceholderLine72",
    "mockupTextPlaceholderContent74",
    "placeholder81",
    "total4",
    "title38",
    "val9",
    "edge2",
    "tri33",
    "rect33",
    "tri34",
    "rect34",
    "tri35",
    "rect35",
    "tri36",
    "rect36",
    "tri37",
    "rect37",
    "tri38",
    "rect38",
    "tri39",
    "rect39",
    "tri40",
    "rect40",
    "tri41",
    "rect41",
    "tri42",
    "rect42",
    "tri43",
    "rect43",
    "tri44",
    "rect44",
    "tri45",
    "rect45",
    "tri46",
    "rect46",
    "tri47",
    "rect47",
    "tri48",
    "rect48",
    "tri49",
    "rect49",
    "tri50",
    "rect50",
    "tri51",
    "rect51",
    "tri52",
    "rect52",
    "tri53",
    "rect53",
    "tri54",
    "rect54",
    "tri55",
    "rect55",
    "tri56",
    "rect56",
    "tri57",
    "rect57",
    "tri58",
    "rect58",
    "tri59",
    "rect59",
    "tri60",
    "rect60",
    "tri61",
    "rect61",
    "tri62",
    "rect62",
    "tri63",
    "rect63",
    "tri64",
    "rect64"
  ],
  header4: ["header4", "subtitle6", "title35"],
  subtitle6: ["subtitle6"],
  title35: ["title35"],
  main2: [
    "main2",
    "placeholder71",
    "header5",
    "title36",
    "date2",
    "section3",
    "head3",
    "mockupTextPlaceholderParagraph11",
    "mockupTextPlaceholderLine63",
    "mockupTextPlaceholderContent65",
    "placeholder72",
    "mockupTextPlaceholderLine64",
    "mockupTextPlaceholderContent66",
    "placeholder73",
    "mockupTextPlaceholderLine65",
    "mockupTextPlaceholderContent67",
    "placeholder74",
    "mockupTextPlaceholderLine66",
    "mockupTextPlaceholderContent68",
    "placeholder75",
    "mockupTextPlaceholderLine67",
    "mockupTextPlaceholderContent69",
    "placeholder76",
    "total3",
    "title37",
    "val8",
    "section4",
    "head4",
    "mockupTextPlaceholderParagraph12",
    "mockupTextPlaceholderLine68",
    "mockupTextPlaceholderContent70",
    "placeholder77",
    "mockupTextPlaceholderLine69",
    "mockupTextPlaceholderContent71",
    "placeholder78",
    "mockupTextPlaceholderLine70",
    "mockupTextPlaceholderContent72",
    "placeholder79",
    "mockupTextPlaceholderLine71",
    "mockupTextPlaceholderContent73",
    "placeholder80",
    "mockupTextPlaceholderLine72",
    "mockupTextPlaceholderContent74",
    "placeholder81",
    "total4",
    "title38",
    "val9"
  ],
  placeholder71: [
    "placeholder71",
    "header5",
    "title36",
    "date2",
    "section3",
    "head3",
    "mockupTextPlaceholderParagraph11",
    "mockupTextPlaceholderLine63",
    "mockupTextPlaceholderContent65",
    "placeholder72",
    "mockupTextPlaceholderLine64",
    "mockupTextPlaceholderContent66",
    "placeholder73",
    "mockupTextPlaceholderLine65",
    "mockupTextPlaceholderContent67",
    "placeholder74",
    "mockupTextPlaceholderLine66",
    "mockupTextPlaceholderContent68",
    "placeholder75",
    "mockupTextPlaceholderLine67",
    "mockupTextPlaceholderContent69",
    "placeholder76",
    "total3",
    "title37",
    "val8",
    "section4",
    "head4",
    "mockupTextPlaceholderParagraph12",
    "mockupTextPlaceholderLine68",
    "mockupTextPlaceholderContent70",
    "placeholder77",
    "mockupTextPlaceholderLine69",
    "mockupTextPlaceholderContent71",
    "placeholder78",
    "mockupTextPlaceholderLine70",
    "mockupTextPlaceholderContent72",
    "placeholder79",
    "mockupTextPlaceholderLine71",
    "mockupTextPlaceholderContent73",
    "placeholder80",
    "mockupTextPlaceholderLine72",
    "mockupTextPlaceholderContent74",
    "placeholder81",
    "total4",
    "title38",
    "val9"
  ],
  header5: ["header5", "title36", "date2"],
  title36: ["title36"],
  date2: ["date2"],
  section3: [
    "section3",
    "head3",
    "mockupTextPlaceholderParagraph11",
    "mockupTextPlaceholderLine63",
    "mockupTextPlaceholderContent65",
    "placeholder72",
    "mockupTextPlaceholderLine64",
    "mockupTextPlaceholderContent66",
    "placeholder73",
    "mockupTextPlaceholderLine65",
    "mockupTextPlaceholderContent67",
    "placeholder74",
    "mockupTextPlaceholderLine66",
    "mockupTextPlaceholderContent68",
    "placeholder75",
    "mockupTextPlaceholderLine67",
    "mockupTextPlaceholderContent69",
    "placeholder76",
    "total3",
    "title37",
    "val8"
  ],
  head3: ["head3"],
  mockupTextPlaceholderParagraph11: [
    "mockupTextPlaceholderParagraph11",
    "mockupTextPlaceholderLine63",
    "mockupTextPlaceholderContent65",
    "placeholder72",
    "mockupTextPlaceholderLine64",
    "mockupTextPlaceholderContent66",
    "placeholder73",
    "mockupTextPlaceholderLine65",
    "mockupTextPlaceholderContent67",
    "placeholder74",
    "mockupTextPlaceholderLine66",
    "mockupTextPlaceholderContent68",
    "placeholder75",
    "mockupTextPlaceholderLine67",
    "mockupTextPlaceholderContent69",
    "placeholder76"
  ],
  mockupTextPlaceholderLine63: [
    "mockupTextPlaceholderLine63",
    "mockupTextPlaceholderContent65",
    "placeholder72"
  ],
  mockupTextPlaceholderContent65: [
    "mockupTextPlaceholderContent65",
    "placeholder72"
  ],
  placeholder72: ["placeholder72"],
  mockupTextPlaceholderLine64: [
    "mockupTextPlaceholderLine64",
    "mockupTextPlaceholderContent66",
    "placeholder73"
  ],
  mockupTextPlaceholderContent66: [
    "mockupTextPlaceholderContent66",
    "placeholder73"
  ],
  placeholder73: ["placeholder73"],
  mockupTextPlaceholderLine65: [
    "mockupTextPlaceholderLine65",
    "mockupTextPlaceholderContent67",
    "placeholder74"
  ],
  mockupTextPlaceholderContent67: [
    "mockupTextPlaceholderContent67",
    "placeholder74"
  ],
  placeholder74: ["placeholder74"],
  mockupTextPlaceholderLine66: [
    "mockupTextPlaceholderLine66",
    "mockupTextPlaceholderContent68",
    "placeholder75"
  ],
  mockupTextPlaceholderContent68: [
    "mockupTextPlaceholderContent68",
    "placeholder75"
  ],
  placeholder75: ["placeholder75"],
  mockupTextPlaceholderLine67: [
    "mockupTextPlaceholderLine67",
    "mockupTextPlaceholderContent69",
    "placeholder76"
  ],
  mockupTextPlaceholderContent69: [
    "mockupTextPlaceholderContent69",
    "placeholder76"
  ],
  placeholder76: ["placeholder76"],
  total3: ["total3", "title37", "val8"],
  title37: ["title37"],
  val8: ["val8"],
  section4: [
    "section4",
    "head4",
    "mockupTextPlaceholderParagraph12",
    "mockupTextPlaceholderLine68",
    "mockupTextPlaceholderContent70",
    "placeholder77",
    "mockupTextPlaceholderLine69",
    "mockupTextPlaceholderContent71",
    "placeholder78",
    "mockupTextPlaceholderLine70",
    "mockupTextPlaceholderContent72",
    "placeholder79",
    "mockupTextPlaceholderLine71",
    "mockupTextPlaceholderContent73",
    "placeholder80",
    "mockupTextPlaceholderLine72",
    "mockupTextPlaceholderContent74",
    "placeholder81",
    "total4",
    "title38",
    "val9"
  ],
  head4: ["head4"],
  mockupTextPlaceholderParagraph12: [
    "mockupTextPlaceholderParagraph12",
    "mockupTextPlaceholderLine68",
    "mockupTextPlaceholderContent70",
    "placeholder77",
    "mockupTextPlaceholderLine69",
    "mockupTextPlaceholderContent71",
    "placeholder78",
    "mockupTextPlaceholderLine70",
    "mockupTextPlaceholderContent72",
    "placeholder79",
    "mockupTextPlaceholderLine71",
    "mockupTextPlaceholderContent73",
    "placeholder80",
    "mockupTextPlaceholderLine72",
    "mockupTextPlaceholderContent74",
    "placeholder81"
  ],
  mockupTextPlaceholderLine68: [
    "mockupTextPlaceholderLine68",
    "mockupTextPlaceholderContent70",
    "placeholder77"
  ],
  mockupTextPlaceholderContent70: [
    "mockupTextPlaceholderContent70",
    "placeholder77"
  ],
  placeholder77: ["placeholder77"],
  mockupTextPlaceholderLine69: [
    "mockupTextPlaceholderLine69",
    "mockupTextPlaceholderContent71",
    "placeholder78"
  ],
  mockupTextPlaceholderContent71: [
    "mockupTextPlaceholderContent71",
    "placeholder78"
  ],
  placeholder78: ["placeholder78"],
  mockupTextPlaceholderLine70: [
    "mockupTextPlaceholderLine70",
    "mockupTextPlaceholderContent72",
    "placeholder79"
  ],
  mockupTextPlaceholderContent72: [
    "mockupTextPlaceholderContent72",
    "placeholder79"
  ],
  placeholder79: ["placeholder79"],
  mockupTextPlaceholderLine71: [
    "mockupTextPlaceholderLine71",
    "mockupTextPlaceholderContent73",
    "placeholder80"
  ],
  mockupTextPlaceholderContent73: [
    "mockupTextPlaceholderContent73",
    "placeholder80"
  ],
  placeholder80: ["placeholder80"],
  mockupTextPlaceholderLine72: [
    "mockupTextPlaceholderLine72",
    "mockupTextPlaceholderContent74",
    "placeholder81"
  ],
  mockupTextPlaceholderContent74: [
    "mockupTextPlaceholderContent74",
    "placeholder81"
  ],
  placeholder81: ["placeholder81"],
  total4: ["total4", "title38", "val9"],
  title38: ["title38"],
  val9: ["val9"],
  edge2: [
    "edge2",
    "tri33",
    "rect33",
    "tri34",
    "rect34",
    "tri35",
    "rect35",
    "tri36",
    "rect36",
    "tri37",
    "rect37",
    "tri38",
    "rect38",
    "tri39",
    "rect39",
    "tri40",
    "rect40",
    "tri41",
    "rect41",
    "tri42",
    "rect42",
    "tri43",
    "rect43",
    "tri44",
    "rect44",
    "tri45",
    "rect45",
    "tri46",
    "rect46",
    "tri47",
    "rect47",
    "tri48",
    "rect48",
    "tri49",
    "rect49",
    "tri50",
    "rect50",
    "tri51",
    "rect51",
    "tri52",
    "rect52",
    "tri53",
    "rect53",
    "tri54",
    "rect54",
    "tri55",
    "rect55",
    "tri56",
    "rect56",
    "tri57",
    "rect57",
    "tri58",
    "rect58",
    "tri59",
    "rect59",
    "tri60",
    "rect60",
    "tri61",
    "rect61",
    "tri62",
    "rect62",
    "tri63",
    "rect63",
    "tri64",
    "rect64"
  ],
  tri33: ["tri33", "rect33"],
  rect33: ["rect33"],
  tri34: ["tri34", "rect34"],
  rect34: ["rect34"],
  tri35: ["tri35", "rect35"],
  rect35: ["rect35"],
  tri36: ["tri36", "rect36"],
  rect36: ["rect36"],
  tri37: ["tri37", "rect37"],
  rect37: ["rect37"],
  tri38: ["tri38", "rect38"],
  rect38: ["rect38"],
  tri39: ["tri39", "rect39"],
  rect39: ["rect39"],
  tri40: ["tri40", "rect40"],
  rect40: ["rect40"],
  tri41: ["tri41", "rect41"],
  rect41: ["rect41"],
  tri42: ["tri42", "rect42"],
  rect42: ["rect42"],
  tri43: ["tri43", "rect43"],
  rect43: ["rect43"],
  tri44: ["tri44", "rect44"],
  rect44: ["rect44"],
  tri45: ["tri45", "rect45"],
  rect45: ["rect45"],
  tri46: ["tri46", "rect46"],
  rect46: ["rect46"],
  tri47: ["tri47", "rect47"],
  rect47: ["rect47"],
  tri48: ["tri48", "rect48"],
  rect48: ["rect48"],
  tri49: ["tri49", "rect49"],
  rect49: ["rect49"],
  tri50: ["tri50", "rect50"],
  rect50: ["rect50"],
  tri51: ["tri51", "rect51"],
  rect51: ["rect51"],
  tri52: ["tri52", "rect52"],
  rect52: ["rect52"],
  tri53: ["tri53", "rect53"],
  rect53: ["rect53"],
  tri54: ["tri54", "rect54"],
  rect54: ["rect54"],
  tri55: ["tri55", "rect55"],
  rect55: ["rect55"],
  tri56: ["tri56", "rect56"],
  rect56: ["rect56"],
  tri57: ["tri57", "rect57"],
  rect57: ["rect57"],
  tri58: ["tri58", "rect58"],
  rect58: ["rect58"],
  tri59: ["tri59", "rect59"],
  rect59: ["rect59"],
  tri60: ["tri60", "rect60"],
  rect60: ["rect60"],
  tri61: ["tri61", "rect61"],
  rect61: ["rect61"],
  tri62: ["tri62", "rect62"],
  rect62: ["rect62"],
  tri63: ["tri63", "rect63"],
  rect63: ["rect63"],
  tri64: ["tri64", "rect64"],
  rect64: ["rect64"],
  shade4: ["shade4"],
  alert4: ["alert4", "icon31", "content6", "text15", "icon32"],
  icon31: ["icon31"],
  content6: ["content6", "text15"],
  text15: ["text15"],
  icon32: ["icon32"],
  text16: ["text16", "title39", "desc11"],
  title39: ["title39"],
  desc11: ["desc11"],
  features2: [
    "features2",
    "title40",
    "contents",
    "contentsItem18",
    "icon33",
    "text17",
    "contentsItem19",
    "icon34",
    "text18",
    "contentsItem20",
    "icon35",
    "text19",
    "contentsItem21",
    "icon36",
    "text20",
    "contentsItem22",
    "icon7",
    "text21",
    "contentsItem23",
    "icon37",
    "text22",
    "contentsItem24",
    "icon38",
    "text23",
    "contentsItem25",
    "icon39",
    "text24"
  ],
  title40: ["title40"],
  contents: [
    "contents",
    "contentsItem18",
    "icon33",
    "text17",
    "contentsItem19",
    "icon34",
    "text18",
    "contentsItem20",
    "icon35",
    "text19",
    "contentsItem21",
    "icon36",
    "text20",
    "contentsItem22",
    "icon7",
    "text21",
    "contentsItem23",
    "icon37",
    "text22",
    "contentsItem24",
    "icon38",
    "text23",
    "contentsItem25",
    "icon39",
    "text24"
  ],
  contentsItem18: ["contentsItem18", "icon33", "text17"],
  icon33: ["icon33"],
  text17: ["text17"],
  contentsItem19: ["contentsItem19", "icon34", "text18"],
  icon34: ["icon34"],
  text18: ["text18"],
  contentsItem20: ["contentsItem20", "icon35", "text19"],
  icon35: ["icon35"],
  text19: ["text19"],
  contentsItem21: ["contentsItem21", "icon36", "text20"],
  icon36: ["icon36"],
  text20: ["text20"],
  contentsItem22: ["contentsItem22", "icon7", "text21"],
  icon7: ["icon7"],
  text21: ["text21"],
  contentsItem23: ["contentsItem23", "icon37", "text22"],
  icon37: ["icon37"],
  text22: ["text22"],
  contentsItem24: ["contentsItem24", "icon38", "text23"],
  icon38: ["icon38"],
  text23: ["text23"],
  contentsItem25: ["contentsItem25", "icon39", "text24"],
  icon39: ["icon39"],
  text24: ["text24"],
  content7: [
    "content7",
    "placeholder82",
    "intro7",
    "img7",
    "cap2",
    "header27",
    "subtitle11",
    "title42",
    "main9",
    "placeholder84",
    "field2",
    "label14",
    "select2",
    "input2",
    "leftIcon2",
    "text54",
    "rightIcon2",
    "row4",
    "prop5",
    "label15",
    "val10",
    "prop6",
    "label16",
    "val11",
    "text79",
    "title46",
    "desc12",
    "features4",
    "title47",
    "grid",
    "contentsItem26",
    "icon41",
    "text80",
    "contentsItem27",
    "icon42",
    "text81",
    "contentsItem28",
    "icon43",
    "text82",
    "contentsItem29",
    "icon44",
    "text83",
    "contentsItem30",
    "icon45",
    "text84",
    "contentsItem31",
    "icon46",
    "text85",
    "contentsItem32",
    "icon47",
    "text86",
    "contentsItem33",
    "icon48",
    "text87",
    "contentsItem34",
    "icon49",
    "text88"
  ],
  placeholder82: [
    "placeholder82",
    "intro7",
    "img7",
    "cap2",
    "header27",
    "subtitle11",
    "title42",
    "main9",
    "placeholder84",
    "field2",
    "label14",
    "select2",
    "input2",
    "leftIcon2",
    "text54",
    "rightIcon2",
    "row4",
    "prop5",
    "label15",
    "val10",
    "prop6",
    "label16",
    "val11",
    "text79",
    "title46",
    "desc12",
    "features4",
    "title47",
    "grid",
    "contentsItem26",
    "icon41",
    "text80",
    "contentsItem27",
    "icon42",
    "text81",
    "contentsItem28",
    "icon43",
    "text82",
    "contentsItem29",
    "icon44",
    "text83",
    "contentsItem30",
    "icon45",
    "text84",
    "contentsItem31",
    "icon46",
    "text85",
    "contentsItem32",
    "icon47",
    "text86",
    "contentsItem33",
    "icon48",
    "text87",
    "contentsItem34",
    "icon49",
    "text88"
  ],
  intro7: [
    "intro7",
    "img7",
    "cap2",
    "header27",
    "subtitle11",
    "title42",
    "main9",
    "placeholder84",
    "field2",
    "label14",
    "select2",
    "input2",
    "leftIcon2",
    "text54",
    "rightIcon2",
    "row4",
    "prop5",
    "label15",
    "val10",
    "prop6",
    "label16",
    "val11",
    "text79",
    "title46",
    "desc12"
  ],
  img7: [
    "img7",
    "cap2",
    "header27",
    "subtitle11",
    "title42",
    "main9",
    "placeholder84",
    "field2",
    "label14",
    "select2",
    "input2",
    "leftIcon2",
    "text54",
    "rightIcon2",
    "row4",
    "prop5",
    "label15",
    "val10",
    "prop6",
    "label16",
    "val11"
  ],
  cap2: [
    "cap2",
    "header27",
    "subtitle11",
    "title42",
    "main9",
    "placeholder84",
    "field2",
    "label14",
    "select2",
    "input2",
    "leftIcon2",
    "text54",
    "rightIcon2",
    "row4",
    "prop5",
    "label15",
    "val10",
    "prop6",
    "label16",
    "val11"
  ],
  header27: ["header27", "subtitle11", "title42"],
  subtitle11: ["subtitle11"],
  title42: ["title42"],
  main9: [
    "main9",
    "placeholder84",
    "field2",
    "label14",
    "select2",
    "input2",
    "leftIcon2",
    "text54",
    "rightIcon2",
    "row4",
    "prop5",
    "label15",
    "val10",
    "prop6",
    "label16",
    "val11"
  ],
  placeholder84: [
    "placeholder84",
    "field2",
    "label14",
    "select2",
    "input2",
    "leftIcon2",
    "text54",
    "rightIcon2",
    "row4",
    "prop5",
    "label15",
    "val10",
    "prop6",
    "label16",
    "val11"
  ],
  field2: [
    "field2",
    "label14",
    "select2",
    "input2",
    "leftIcon2",
    "text54",
    "rightIcon2"
  ],
  label14: ["label14"],
  select2: ["select2", "input2", "leftIcon2", "text54", "rightIcon2"],
  input2: ["input2", "leftIcon2", "text54", "rightIcon2"],
  leftIcon2: ["leftIcon2"],
  text54: ["text54"],
  rightIcon2: ["rightIcon2"],
  row4: ["row4", "prop5", "label15", "val10", "prop6", "label16", "val11"],
  prop5: ["prop5", "label15", "val10"],
  label15: ["label15"],
  val10: ["val10"],
  prop6: ["prop6", "label16", "val11"],
  label16: ["label16"],
  val11: ["val11"],
  text79: ["text79", "title46", "desc12"],
  title46: ["title46"],
  desc12: ["desc12"],
  features4: [
    "features4",
    "title47",
    "grid",
    "contentsItem26",
    "icon41",
    "text80",
    "contentsItem27",
    "icon42",
    "text81",
    "contentsItem28",
    "icon43",
    "text82",
    "contentsItem29",
    "icon44",
    "text83",
    "contentsItem30",
    "icon45",
    "text84",
    "contentsItem31",
    "icon46",
    "text85",
    "contentsItem32",
    "icon47",
    "text86",
    "contentsItem33",
    "icon48",
    "text87",
    "contentsItem34",
    "icon49",
    "text88"
  ],
  title47: ["title47"],
  grid: [
    "grid",
    "contentsItem26",
    "icon41",
    "text80",
    "contentsItem27",
    "icon42",
    "text81",
    "contentsItem28",
    "icon43",
    "text82",
    "contentsItem29",
    "icon44",
    "text83",
    "contentsItem30",
    "icon45",
    "text84",
    "contentsItem31",
    "icon46",
    "text85",
    "contentsItem32",
    "icon47",
    "text86",
    "contentsItem33",
    "icon48",
    "text87",
    "contentsItem34",
    "icon49",
    "text88"
  ],
  contentsItem26: ["contentsItem26", "icon41", "text80"],
  icon41: ["icon41"],
  text80: ["text80"],
  contentsItem27: ["contentsItem27", "icon42", "text81"],
  icon42: ["icon42"],
  text81: ["text81"],
  contentsItem28: ["contentsItem28", "icon43", "text82"],
  icon43: ["icon43"],
  text82: ["text82"],
  contentsItem29: ["contentsItem29", "icon44", "text83"],
  icon44: ["icon44"],
  text83: ["text83"],
  contentsItem30: ["contentsItem30", "icon45", "text84"],
  icon45: ["icon45"],
  text84: ["text84"],
  contentsItem31: ["contentsItem31", "icon46", "text85"],
  icon46: ["icon46"],
  text85: ["text85"],
  contentsItem32: ["contentsItem32", "icon47", "text86"],
  icon47: ["icon47"],
  text86: ["text86"],
  contentsItem33: ["contentsItem33", "icon48", "text87"],
  icon48: ["icon48"],
  text87: ["text87"],
  contentsItem34: ["contentsItem34", "icon49", "text88"],
  icon49: ["icon49"],
  text88: ["text88"]
} as const;
type NodeNameType = keyof typeof PlasmicDescendants;
type DescendantsType<T extends NodeNameType> =
  (typeof PlasmicDescendants)[T][number];
type NodeDefaultElementType = {
  productsSection: "section";
  productsProvider: typeof DataProvider;
  desktopWrapper: "div";
  intro2: "div";
  header9: "div";
  top3: "div";
  subtitle: "div";
  title: "div";
  body6: "div";
  col4: "div";
  nav: "div";
  img2: "div";
  logoIcon: "div";
  logo7: typeof Logo;
  logo2: typeof Logo;
  logo3: typeof Logo;
  productTabs: typeof AntdTabs;
  content: "div";
  placeholder: "div";
  intro: "div";
  col: "div";
  logo: typeof Logo;
  text53: "div";
  title23: "div";
  desc: "div";
  img: "div";
  areas: "div";
  header10: "div";
  title11: "div";
  body7: "div";
  frame22: "div";
  item17: "div";
  title12: "div";
  desc7: "div";
  item18: "div";
  title13: "div";
  desc2: "div";
  item19: "div";
  title14: "div";
  desc3: "div";
  item20: "div";
  title15: "div";
  desc4: "div";
  item21: "div";
  title16: "div";
  desc5: "div";
  item22: "div";
  title17: "div";
  desc6: "div";
  footnote: "div";
  bodyWrapper6: "div";
  intro4: "div";
  col7: "div";
  logo9: typeof Logo;
  text44: "div";
  title27: "div";
  desc9: "div";
  img4: "div";
  bg3: "div";
  xmlid7457: "div";
  xmlid6776: "div";
  xmlid7433: "div";
  xmlid7339: "div";
  alert3: "div";
  icon20: "div";
  content3: "div";
  text45: "div";
  icon21: "div";
  credits: "div";
  header20: "div";
  subtitle5: "div";
  title28: "div";
  main6: "div";
  mockupCmeCredits: "div";
  table: "div";
  col8: "div";
  mockupTableCellText: "div";
  text46: "div";
  mockupTableCellAvatar: "div";
  mockupTableCellAvatar2: "div";
  mockupTableCellAvatar3: "div";
  col9: "div";
  mockupTableCellText2: "div";
  text47: "div";
  mockupTableCellText3: "div";
  text48: "div";
  mockupTableCellText4: "div";
  text49: "div";
  mockupTableCellText5: "div";
  text50: "div";
  col10: "div";
  mockupTableCellText6: "div";
  text51: "div";
  mockupTableCellText7: "div";
  text52: "div";
  mockupTableCellText8: "div";
  text57: "div";
  mockupTableCellText9: "div";
  text58: "div";
  col11: "div";
  mockupTableCellText10: "div";
  text59: "div";
  mockupTableCellText11: "div";
  text60: "div";
  mockupTableCellText12: "div";
  text70: "div";
  mockupTableCellText13: "div";
  text71: "div";
  mockupButton7: "div";
  link10: "div";
  certificate: "div";
  top5: "div";
  mockupCertificateIcon: "div";
  bg4: "div";
  group1: "div";
  paper1: "div";
  paper2: "div";
  cert: "div";
  award491: "div";
  overlay: "div";
  title29: "div";
  mockupTextPlaceholder: "div";
  mockupTextPlaceholderParagraph: "div";
  mockupTextPlaceholderLine: "div";
  mockupTextPlaceholderContent37: "div";
  placeholder38: "div";
  mockupTextPlaceholderLine2: "div";
  mockupTextPlaceholderContent38: "div";
  placeholder39: "div";
  mockupTextPlaceholderLine3: "div";
  mockupTextPlaceholderContent39: "div";
  placeholder40: "div";
  mockupTextPlaceholderLine4: "div";
  mockupTextPlaceholderContent40: "div";
  placeholder41: "div";
  mockupTextPlaceholderLine5: "div";
  mockupTextPlaceholderContent41: "div";
  placeholder42: "div";
  mockupTextPlaceholderParagraph2: "div";
  mockupTextPlaceholderLine6: "div";
  mockupTextPlaceholderContent42: "div";
  placeholder43: "div";
  mockupTextPlaceholderLine7: "div";
  mockupTextPlaceholderContent43: "div";
  placeholder44: "div";
  mockupTextPlaceholderLine8: "div";
  mockupTextPlaceholderContent44: "div";
  placeholder45: "div";
  mockupTextPlaceholderLine9: "div";
  mockupTextPlaceholderContent45: "div";
  placeholder46: "div";
  mockupTextPlaceholderLine10: "div";
  mockupTextPlaceholderContent46: "div";
  placeholder47: "div";
  mockupTextPlaceholderLine11: "div";
  mockupTextPlaceholderContent47: "div";
  placeholder48: "div";
  mockupTextPlaceholderLine12: "div";
  mockupTextPlaceholderContent48: "div";
  placeholder49: "div";
  mockupTextPlaceholderLine13: "div";
  mockupTextPlaceholderContent49: "div";
  placeholder50: "div";
  mockupTextPlaceholderParagraph3: "div";
  mockupTextPlaceholderLine14: "div";
  mockupTextPlaceholderContent50: "div";
  placeholder51: "div";
  mockupTextPlaceholderLine15: "div";
  mockupTextPlaceholderContent15: "div";
  placeholder52: "div";
  mockupTextPlaceholderLine16: "div";
  mockupTextPlaceholderContent16: "div";
  placeholder53: "div";
  mockupTextPlaceholderLine17: "div";
  mockupTextPlaceholderContent17: "div";
  placeholder54: "div";
  mockupTextPlaceholderLine18: "div";
  mockupTextPlaceholderContent18: "div";
  placeholder55: "div";
  mockupTextPlaceholderParagraph4: "div";
  mockupTextPlaceholderLine19: "div";
  mockupTextPlaceholderContent19: "div";
  placeholder19: "div";
  mockupTextPlaceholderLine20: "div";
  mockupTextPlaceholderContent20: "div";
  placeholder20: "div";
  mockupTextPlaceholderLine21: "div";
  mockupTextPlaceholderContent21: "div";
  placeholder21: "div";
  mockupTextPlaceholderLine22: "div";
  mockupTextPlaceholderContent22: "div";
  placeholder22: "div";
  mockupTextPlaceholderLine23: "div";
  mockupTextPlaceholderContent23: "div";
  placeholder23: "div";
  mockupTextPlaceholderLine24: "div";
  mockupTextPlaceholderContent24: "div";
  placeholder24: "div";
  mockupTextPlaceholderLine25: "div";
  mockupTextPlaceholderContent25: "div";
  placeholder25: "div";
  mockupTextPlaceholderLine26: "div";
  mockupTextPlaceholderContent26: "div";
  placeholder26: "div";
  mockupButton8: "div";
  link11: "div";
  alert2: "div";
  icon22: "div";
  check2: "div";
  content4: "div";
  report: "div";
  bill: "div";
  header21: "div";
  subtitle9: "div";
  title30: "div";
  main7: "div";
  placeholder27: "div";
  header22: "div";
  title31: "div";
  date: "div";
  section: "div";
  head: "div";
  mockupTextPlaceholderParagraph5: "div";
  mockupTextPlaceholderLine27: "div";
  mockupTextPlaceholderContent27: "div";
  placeholder28: "div";
  mockupTextPlaceholderLine28: "div";
  mockupTextPlaceholderContent28: "div";
  placeholder29: "div";
  mockupTextPlaceholderLine29: "div";
  mockupTextPlaceholderContent29: "div";
  placeholder30: "div";
  mockupTextPlaceholderLine30: "div";
  mockupTextPlaceholderContent30: "div";
  placeholder31: "div";
  mockupTextPlaceholderLine31: "div";
  mockupTextPlaceholderContent31: "div";
  placeholder32: "div";
  total: "div";
  title32: "div";
  val6: "div";
  section2: "div";
  head2: "div";
  mockupTextPlaceholderParagraph6: "div";
  mockupTextPlaceholderLine32: "div";
  mockupTextPlaceholderContent32: "div";
  placeholder33: "div";
  mockupTextPlaceholderLine33: "div";
  mockupTextPlaceholderContent33: "div";
  placeholder34: "div";
  mockupTextPlaceholderLine34: "div";
  mockupTextPlaceholderContent34: "div";
  placeholder35: "div";
  mockupTextPlaceholderLine35: "div";
  mockupTextPlaceholderContent35: "div";
  placeholder36: "div";
  mockupTextPlaceholderLine36: "div";
  mockupTextPlaceholderContent36: "div";
  placeholder37: "div";
  total2: "div";
  title34: "div";
  val7: "div";
  edge: "div";
  tri: "div";
  rect: "div";
  tri2: "div";
  rect2: "div";
  tri3: "div";
  rect3: "div";
  tri4: "div";
  rect4: "div";
  tri5: "div";
  rect5: "div";
  tri6: "div";
  rect6: "div";
  tri7: "div";
  rect7: "div";
  tri8: "div";
  rect8: "div";
  tri9: "div";
  rect9: "div";
  tri10: "div";
  rect10: "div";
  tri11: "div";
  rect11: "div";
  tri12: "div";
  rect12: "div";
  tri13: "div";
  rect13: "div";
  tri14: "div";
  rect14: "div";
  tri15: "div";
  rect15: "div";
  tri16: "div";
  rect16: "div";
  tri17: "div";
  rect17: "div";
  tri18: "div";
  rect18: "div";
  tri19: "div";
  rect19: "div";
  tri20: "div";
  rect20: "div";
  tri21: "div";
  rect21: "div";
  tri22: "div";
  rect22: "div";
  tri23: "div";
  rect23: "div";
  tri24: "div";
  rect24: "div";
  tri25: "div";
  rect25: "div";
  tri26: "div";
  rect26: "div";
  tri27: "div";
  rect27: "div";
  tri28: "div";
  rect28: "div";
  tri29: "div";
  rect29: "div";
  tri30: "div";
  rect30: "div";
  tri31: "div";
  rect31: "div";
  tri32: "div";
  rect32: "div";
  shade3: "div";
  features3: "div";
  title33: "div";
  figmaPaste2: "div";
  contentsItem10: "div";
  icon23: "div";
  text61: "div";
  contentsItem11: "div";
  icon24: "div";
  text62: "div";
  contentsItem12: "div";
  icon25: "div";
  text63: "div";
  contentsItem13: "div";
  icon26: "div";
  text64: "div";
  contentsItem14: "div";
  icon27: "div";
  text65: "div";
  contentsItem15: "div";
  icon28: "div";
  text66: "div";
  contentsItem16: "div";
  icon29: "div";
  text67: "div";
  contentsItem17: "div";
  icon30: "div";
  text68: "div";
  bodyWrapper5: "div";
  intro3: "div";
  col5: "div";
  logo8: typeof Logo;
  text: "div";
  title18: "div";
  desc8: "div";
  img3: "div";
  bg2: "div";
  reimbursement: "div";
  header11: "div";
  subtitle4: "div";
  title19: "div";
  main4: "div";
  placeholder16: "div";
  row: "div";
  prop: "div";
  label10: "div";
  val: "div";
  prop2: "div";
  label11: "div";
  val2: "div";
  mockupProgressBarWithTitle: "div";
  header12: "div";
  title20: "div";
  val3: "div";
  bar: "div";
  value: "div";
  demographics: "div";
  demographics2: "div";
  header13: "div";
  subtitle7: "div";
  title4: "div";
  main5: "div";
  placeholder17: "div";
  row2: "div";
  header14: "div";
  name6: "div";
  error: "div";
  tip: "div";
  label3: "div";
  link6: "div";
  row6: "div";
  header15: "div";
  name7: "div";
  error2: "div";
  tip2: "div";
  label4: "div";
  link7: "div";
  row7: "div";
  header16: "div";
  name8: "div";
  error3: "div";
  tip3: "div";
  label5: "div";
  link8: "div";
  shade2: "div";
  cap: "div";
  header17: "div";
  subtitle8: "div";
  title21: "div";
  main3: "div";
  placeholder18: "div";
  field: "div";
  label6: "div";
  select: "div";
  input: "div";
  leftIcon: "div";
  text25: "div";
  rightIcon: "div";
  row5: "div";
  prop3: "div";
  label7: "div";
  val4: "div";
  prop4: "div";
  label8: "div";
  val5: "div";
  profile3: "div";
  av3: "div";
  col6: "div";
  top4: "div";
  header18: "div";
  name9: "div";
  status3: "div";
  label9: "div";
  body8: "div";
  year3: "div";
  name5: "div";
  actions3: "div";
  mockupButton5: "div";
  link9: "div";
  mockupButton6: "div";
  link5: "div";
  menu2: "div";
  header19: "div";
  title22: "div";
  icon8: "div";
  list: "div";
  item23: "div";
  text26: "div";
  item24: "div";
  text4: "div";
  item25: "div";
  text27: "div";
  item26: "div";
  text28: "div";
  item27: "div";
  text29: "div";
  item28: "div";
  text30: "div";
  item29: "div";
  text31: "div";
  item30: "div";
  text32: "div";
  item31: "div";
  text33: "div";
  item32: "div";
  text34: "div";
  alert: "div";
  icon9: "div";
  content2: "div";
  text35: "div";
  icon10: "div";
  features: "div";
  title5: "div";
  figmaPaste: "div";
  contentsItem: "div";
  icon11: "div";
  text36: "div";
  contentsItem2: "div";
  icon12: "div";
  text37: "div";
  contentsItem3: "div";
  icon13: "div";
  text38: "div";
  contentsItem4: "div";
  icon14: "div";
  text39: "div";
  contentsItem5: "div";
  icon15: "div";
  text5: "div";
  contentsItem6: "div";
  icon16: "div";
  text40: "div";
  contentsItem7: "div";
  icon17: "div";
  text41: "div";
  contentsItem8: "div";
  icon18: "div";
  text42: "div";
  contentsItem9: "div";
  icon19: "div";
  text43: "div";
  mobileWrapper: "div";
  header: "div";
  top: "div";
  subtitle2: "div";
  title2: "div";
  body: "div";
  tabs: typeof AntdTabs;
  content8: "div";
  placeholder83: "div";
  intro5: "div";
  img5: "div";
  bg: "div";
  compWrap: "div";
  perf: "div";
  header6: "div";
  subtitle3: "div";
  title24: "div";
  main: "div";
  mockupCompetencies: "div";
  graph: "div";
  labels: "div";
  series2: "div";
  rectangle1: "div";
  rectangle2: "div";
  rectangle3: "div";
  rectangle4: "div";
  rectangle5: "div";
  rectangle6: "div";
  series3: "div";
  rectangle7: "div";
  rectangle8: "div";
  rectangle9: "div";
  rectangle10: "div";
  rectangle11: "div";
  rectangle12: "div";
  scores: "div";
  graphScore: "div";
  num: "div";
  graphScore2: "div";
  num2: "div";
  graphScore3: "div";
  num3: "div";
  smallerGraph: "div";
  inner: "div";
  labels2: "div";
  series22: "div";
  rectangle13: "div";
  rectangle14: "div";
  rectangle15: "div";
  rectangle16: "div";
  rectangle17: "div";
  rectangle18: "div";
  series32: "div";
  rectangle19: "div";
  rectangle20: "div";
  rectangle21: "div";
  rectangle22: "div";
  rectangle23: "div";
  rectangle24: "div";
  scores2: "div";
  graphScore4: "div";
  num4: "div";
  graphScore5: "div";
  num5: "div";
  graphScore6: "div";
  num6: "div";
  list6: "div";
  item: "div";
  icon: "div";
  abbr: "div";
  title25: "div";
  item2: "div";
  icon2: "div";
  abbr2: "div";
  title3: "div";
  item3: "div";
  icon3: "div";
  abbr3: "div";
  title41: "div";
  item4: "div";
  icon4: "div";
  abbr4: "div";
  title43: "div";
  item5: "div";
  icon5: "div";
  abbr5: "div";
  title6: "div";
  item6: "div";
  icon6: "div";
  abbr6: "div";
  title7: "div";
  shade: "div";
  nav2: "div";
  btn: "div";
  text55: "div";
  btn2: "div";
  text2: "div";
  btn3: "div";
  text3: "div";
  btn4: "div";
  text56: "div";
  mockupButtonBarItem: "div";
  text69: "div";
  btn5: "div";
  text6: "div";
  btn6: "div";
  text7: "div";
  btn7: "div";
  text8: "div";
  btn8: "div";
  text9: "div";
  btn9: "div";
  text10: "div";
  profile: "div";
  av: "div";
  col12: "div";
  top2: "div";
  header2: "div";
  name: "div";
  status: "div";
  label: "div";
  line: "div";
  mockupTextPlaceholderContent: "div";
  placeholder2: "div";
  body3: "div";
  year: "div";
  name2: "div";
  line2: "div";
  mockupTextPlaceholderContent2: "div";
  placeholder3: "div";
  actions: "div";
  mockupButton: "div";
  link: "div";
  mockupButton2: "div";
  link2: "div";
  text11: "div";
  title8: "div";
  desc13: "div";
  areas2: "div";
  header3: "div";
  title49: "div";
  body2: "div";
  frame23: "div";
  item7: "div";
  title50: "div";
  desc17: "div";
  item8: "div";
  title51: "div";
  desc18: "div";
  item9: "div";
  title52: "div";
  desc19: "div";
  item10: "div";
  title53: "div";
  desc20: "div";
  item11: "div";
  title54: "div";
  desc21: "div";
  item12: "div";
  title55: "div";
  desc10: "div";
  footnote2: "div";
  content5: "div";
  placeholder56: "div";
  intro6: "div";
  img6: "div";
  bg5: "div";
  xmlid74572: "div";
  xmlid67762: "div";
  xmlid74332: "div";
  xmlid73392: "div";
  certificate2: "div";
  top6: "div";
  mockupCertificateIcon2: "div";
  bg6: "div";
  group2: "div";
  paper3: "div";
  paper4: "div";
  cert2: "div";
  award492: "div";
  overlay2: "div";
  title26: "div";
  mockupTextPlaceholder2: "div";
  mockupTextPlaceholderParagraph7: "div";
  mockupTextPlaceholderLine37: "div";
  mockupTextPlaceholderContent51: "div";
  placeholder57: "div";
  mockupTextPlaceholderLine38: "div";
  mockupTextPlaceholderContent52: "div";
  placeholder58: "div";
  mockupTextPlaceholderLine39: "div";
  mockupTextPlaceholderContent3: "div";
  placeholder4: "div";
  mockupTextPlaceholderLine40: "div";
  mockupTextPlaceholderContent4: "div";
  placeholder5: "div";
  mockupTextPlaceholderLine41: "div";
  mockupTextPlaceholderContent5: "div";
  placeholder6: "div";
  mockupTextPlaceholderParagraph8: "div";
  mockupTextPlaceholderLine42: "div";
  mockupTextPlaceholderContent6: "div";
  placeholder7: "div";
  mockupTextPlaceholderLine43: "div";
  mockupTextPlaceholderContent7: "div";
  placeholder8: "div";
  mockupTextPlaceholderLine44: "div";
  mockupTextPlaceholderContent8: "div";
  placeholder9: "div";
  mockupTextPlaceholderLine45: "div";
  mockupTextPlaceholderContent9: "div";
  placeholder10: "div";
  mockupTextPlaceholderLine46: "div";
  mockupTextPlaceholderContent10: "div";
  placeholder11: "div";
  mockupTextPlaceholderLine47: "div";
  mockupTextPlaceholderContent11: "div";
  placeholder12: "div";
  mockupTextPlaceholderLine48: "div";
  mockupTextPlaceholderContent12: "div";
  placeholder13: "div";
  mockupTextPlaceholderLine49: "div";
  mockupTextPlaceholderContent13: "div";
  placeholder14: "div";
  mockupTextPlaceholderParagraph9: "div";
  mockupTextPlaceholderLine50: "div";
  mockupTextPlaceholderContent14: "div";
  placeholder15: "div";
  mockupTextPlaceholderLine51: "div";
  mockupTextPlaceholderContent53: "div";
  placeholder59: "div";
  mockupTextPlaceholderLine52: "div";
  mockupTextPlaceholderContent54: "div";
  placeholder60: "div";
  mockupTextPlaceholderLine53: "div";
  mockupTextPlaceholderContent55: "div";
  placeholder61: "div";
  mockupTextPlaceholderLine54: "div";
  mockupTextPlaceholderContent56: "div";
  placeholder62: "div";
  mockupTextPlaceholderParagraph10: "div";
  mockupTextPlaceholderLine55: "div";
  mockupTextPlaceholderContent57: "div";
  placeholder63: "div";
  mockupTextPlaceholderLine56: "div";
  mockupTextPlaceholderContent58: "div";
  placeholder64: "div";
  mockupTextPlaceholderLine57: "div";
  mockupTextPlaceholderContent59: "div";
  placeholder65: "div";
  mockupTextPlaceholderLine58: "div";
  mockupTextPlaceholderContent60: "div";
  placeholder66: "div";
  mockupTextPlaceholderLine59: "div";
  mockupTextPlaceholderContent61: "div";
  placeholder67: "div";
  mockupTextPlaceholderLine60: "div";
  mockupTextPlaceholderContent62: "div";
  placeholder68: "div";
  mockupTextPlaceholderLine61: "div";
  mockupTextPlaceholderContent63: "div";
  placeholder69: "div";
  mockupTextPlaceholderLine62: "div";
  mockupTextPlaceholderContent64: "div";
  placeholder70: "div";
  mockupButton3: "div";
  link3: "div";
  bill3: "div";
  bill2: "div";
  header4: "div";
  subtitle6: "div";
  title35: "div";
  main2: "div";
  placeholder71: "div";
  header5: "div";
  title36: "div";
  date2: "div";
  section3: "div";
  head3: "div";
  mockupTextPlaceholderParagraph11: "div";
  mockupTextPlaceholderLine63: "div";
  mockupTextPlaceholderContent65: "div";
  placeholder72: "div";
  mockupTextPlaceholderLine64: "div";
  mockupTextPlaceholderContent66: "div";
  placeholder73: "div";
  mockupTextPlaceholderLine65: "div";
  mockupTextPlaceholderContent67: "div";
  placeholder74: "div";
  mockupTextPlaceholderLine66: "div";
  mockupTextPlaceholderContent68: "div";
  placeholder75: "div";
  mockupTextPlaceholderLine67: "div";
  mockupTextPlaceholderContent69: "div";
  placeholder76: "div";
  total3: "div";
  title37: "div";
  val8: "div";
  section4: "div";
  head4: "div";
  mockupTextPlaceholderParagraph12: "div";
  mockupTextPlaceholderLine68: "div";
  mockupTextPlaceholderContent70: "div";
  placeholder77: "div";
  mockupTextPlaceholderLine69: "div";
  mockupTextPlaceholderContent71: "div";
  placeholder78: "div";
  mockupTextPlaceholderLine70: "div";
  mockupTextPlaceholderContent72: "div";
  placeholder79: "div";
  mockupTextPlaceholderLine71: "div";
  mockupTextPlaceholderContent73: "div";
  placeholder80: "div";
  mockupTextPlaceholderLine72: "div";
  mockupTextPlaceholderContent74: "div";
  placeholder81: "div";
  total4: "div";
  title38: "div";
  val9: "div";
  edge2: "div";
  tri33: "div";
  rect33: "div";
  tri34: "div";
  rect34: "div";
  tri35: "div";
  rect35: "div";
  tri36: "div";
  rect36: "div";
  tri37: "div";
  rect37: "div";
  tri38: "div";
  rect38: "div";
  tri39: "div";
  rect39: "div";
  tri40: "div";
  rect40: "div";
  tri41: "div";
  rect41: "div";
  tri42: "div";
  rect42: "div";
  tri43: "div";
  rect43: "div";
  tri44: "div";
  rect44: "div";
  tri45: "div";
  rect45: "div";
  tri46: "div";
  rect46: "div";
  tri47: "div";
  rect47: "div";
  tri48: "div";
  rect48: "div";
  tri49: "div";
  rect49: "div";
  tri50: "div";
  rect50: "div";
  tri51: "div";
  rect51: "div";
  tri52: "div";
  rect52: "div";
  tri53: "div";
  rect53: "div";
  tri54: "div";
  rect54: "div";
  tri55: "div";
  rect55: "div";
  tri56: "div";
  rect56: "div";
  tri57: "div";
  rect57: "div";
  tri58: "div";
  rect58: "div";
  tri59: "div";
  rect59: "div";
  tri60: "div";
  rect60: "div";
  tri61: "div";
  rect61: "div";
  tri62: "div";
  rect62: "div";
  tri63: "div";
  rect63: "div";
  tri64: "div";
  rect64: "div";
  shade4: "div";
  alert4: "div";
  icon31: "div";
  content6: "div";
  text15: "div";
  icon32: "div";
  text16: "div";
  title39: "div";
  desc11: "div";
  features2: "div";
  title40: "div";
  contents: "div";
  contentsItem18: "div";
  icon33: "div";
  text17: "div";
  contentsItem19: "div";
  icon34: "div";
  text18: "div";
  contentsItem20: "div";
  icon35: "div";
  text19: "div";
  contentsItem21: "div";
  icon36: "div";
  text20: "div";
  contentsItem22: "div";
  icon7: "div";
  text21: "div";
  contentsItem23: "div";
  icon37: "div";
  text22: "div";
  contentsItem24: "div";
  icon38: "div";
  text23: "div";
  contentsItem25: "div";
  icon39: "div";
  text24: "div";
  content7: "div";
  placeholder82: "div";
  intro7: "div";
  img7: "div";
  cap2: "div";
  header27: "div";
  subtitle11: "div";
  title42: "div";
  main9: "div";
  placeholder84: "div";
  field2: "div";
  label14: "div";
  select2: "div";
  input2: "div";
  leftIcon2: "div";
  text54: "div";
  rightIcon2: "div";
  row4: "div";
  prop5: "div";
  label15: "div";
  val10: "div";
  prop6: "div";
  label16: "div";
  val11: "div";
  text79: "div";
  title46: "div";
  desc12: "div";
  features4: "div";
  title47: "div";
  grid: "div";
  contentsItem26: "div";
  icon41: "div";
  text80: "div";
  contentsItem27: "div";
  icon42: "div";
  text81: "div";
  contentsItem28: "div";
  icon43: "div";
  text82: "div";
  contentsItem29: "div";
  icon44: "div";
  text83: "div";
  contentsItem30: "div";
  icon45: "div";
  text84: "div";
  contentsItem31: "div";
  icon46: "div";
  text85: "div";
  contentsItem32: "div";
  icon47: "div";
  text86: "div";
  contentsItem33: "div";
  icon48: "div";
  text87: "div";
  contentsItem34: "div";
  icon49: "div";
  text88: "div";
};

type ReservedPropsType = "variants" | "args" | "overrides";
type NodeOverridesType<T extends NodeNameType> = Pick<
  PlasmicHomeProductsSection__OverridesType,
  DescendantsType<T>
>;
type NodeComponentProps<T extends NodeNameType> =
  // Explicitly specify variants, args, and overrides as objects
  {
    variants?: PlasmicHomeProductsSection__VariantsArgs;
    args?: PlasmicHomeProductsSection__ArgsType;
    overrides?: NodeOverridesType<T>;
  } &
    // Specify variants directly as props
    Omit<PlasmicHomeProductsSection__VariantsArgs, ReservedPropsType> &
    // Specify args directly as props
    Omit<PlasmicHomeProductsSection__ArgsType, ReservedPropsType> &
    // Specify overrides for each element directly as props
    Omit<
      NodeOverridesType<T>,
      ReservedPropsType | VariantPropType | ArgPropType
    > &
    // Specify props for the root element
    Omit<
      Partial<React.ComponentProps<NodeDefaultElementType[T]>>,
      ReservedPropsType | VariantPropType | ArgPropType | DescendantsType<T>
    >;

function makeNodeComponent<NodeName extends NodeNameType>(nodeName: NodeName) {
  type PropsType = NodeComponentProps<NodeName> & { key?: React.Key };
  const func = function <T extends PropsType>(
    props: T & StrictProps<T, PropsType>
  ) {
    const { variants, args, overrides } = React.useMemo(
      () =>
        deriveRenderOpts(props, {
          name: nodeName,
          descendantNames: PlasmicDescendants[nodeName],
          internalArgPropNames: PlasmicHomeProductsSection__ArgProps,
          internalVariantPropNames: PlasmicHomeProductsSection__VariantProps
        }),
      [props, nodeName]
    );
    return PlasmicHomeProductsSection__RenderFunc({
      variants,
      args,
      overrides,
      forNode: nodeName
    });
  };
  if (nodeName === "productsSection") {
    func.displayName = "PlasmicHomeProductsSection";
  } else {
    func.displayName = `PlasmicHomeProductsSection.${nodeName}`;
  }
  return func;
}

export const PlasmicHomeProductsSection = Object.assign(
  // Top-level PlasmicHomeProductsSection renders the root element
  makeNodeComponent("productsSection"),
  {
    // Helper components rendering sub-elements
    productsProvider: makeNodeComponent("productsProvider"),
    desktopWrapper: makeNodeComponent("desktopWrapper"),
    intro2: makeNodeComponent("intro2"),
    header9: makeNodeComponent("header9"),
    top3: makeNodeComponent("top3"),
    subtitle: makeNodeComponent("subtitle"),
    title: makeNodeComponent("title"),
    body6: makeNodeComponent("body6"),
    col4: makeNodeComponent("col4"),
    nav: makeNodeComponent("nav"),
    img2: makeNodeComponent("img2"),
    logoIcon: makeNodeComponent("logoIcon"),
    logo7: makeNodeComponent("logo7"),
    logo2: makeNodeComponent("logo2"),
    logo3: makeNodeComponent("logo3"),
    productTabs: makeNodeComponent("productTabs"),
    content: makeNodeComponent("content"),
    placeholder: makeNodeComponent("placeholder"),
    intro: makeNodeComponent("intro"),
    col: makeNodeComponent("col"),
    logo: makeNodeComponent("logo"),
    text53: makeNodeComponent("text53"),
    title23: makeNodeComponent("title23"),
    desc: makeNodeComponent("desc"),
    img: makeNodeComponent("img"),
    areas: makeNodeComponent("areas"),
    header10: makeNodeComponent("header10"),
    title11: makeNodeComponent("title11"),
    body7: makeNodeComponent("body7"),
    frame22: makeNodeComponent("frame22"),
    item17: makeNodeComponent("item17"),
    title12: makeNodeComponent("title12"),
    desc7: makeNodeComponent("desc7"),
    item18: makeNodeComponent("item18"),
    title13: makeNodeComponent("title13"),
    desc2: makeNodeComponent("desc2"),
    item19: makeNodeComponent("item19"),
    title14: makeNodeComponent("title14"),
    desc3: makeNodeComponent("desc3"),
    item20: makeNodeComponent("item20"),
    title15: makeNodeComponent("title15"),
    desc4: makeNodeComponent("desc4"),
    item21: makeNodeComponent("item21"),
    title16: makeNodeComponent("title16"),
    desc5: makeNodeComponent("desc5"),
    item22: makeNodeComponent("item22"),
    title17: makeNodeComponent("title17"),
    desc6: makeNodeComponent("desc6"),
    footnote: makeNodeComponent("footnote"),
    bodyWrapper6: makeNodeComponent("bodyWrapper6"),
    intro4: makeNodeComponent("intro4"),
    col7: makeNodeComponent("col7"),
    logo9: makeNodeComponent("logo9"),
    text44: makeNodeComponent("text44"),
    title27: makeNodeComponent("title27"),
    desc9: makeNodeComponent("desc9"),
    img4: makeNodeComponent("img4"),
    bg3: makeNodeComponent("bg3"),
    xmlid7457: makeNodeComponent("xmlid7457"),
    xmlid6776: makeNodeComponent("xmlid6776"),
    xmlid7433: makeNodeComponent("xmlid7433"),
    xmlid7339: makeNodeComponent("xmlid7339"),
    alert3: makeNodeComponent("alert3"),
    icon20: makeNodeComponent("icon20"),
    content3: makeNodeComponent("content3"),
    text45: makeNodeComponent("text45"),
    icon21: makeNodeComponent("icon21"),
    credits: makeNodeComponent("credits"),
    header20: makeNodeComponent("header20"),
    subtitle5: makeNodeComponent("subtitle5"),
    title28: makeNodeComponent("title28"),
    main6: makeNodeComponent("main6"),
    mockupCmeCredits: makeNodeComponent("mockupCmeCredits"),
    table: makeNodeComponent("table"),
    col8: makeNodeComponent("col8"),
    mockupTableCellText: makeNodeComponent("mockupTableCellText"),
    text46: makeNodeComponent("text46"),
    mockupTableCellAvatar: makeNodeComponent("mockupTableCellAvatar"),
    mockupTableCellAvatar2: makeNodeComponent("mockupTableCellAvatar2"),
    mockupTableCellAvatar3: makeNodeComponent("mockupTableCellAvatar3"),
    col9: makeNodeComponent("col9"),
    mockupTableCellText2: makeNodeComponent("mockupTableCellText2"),
    text47: makeNodeComponent("text47"),
    mockupTableCellText3: makeNodeComponent("mockupTableCellText3"),
    text48: makeNodeComponent("text48"),
    mockupTableCellText4: makeNodeComponent("mockupTableCellText4"),
    text49: makeNodeComponent("text49"),
    mockupTableCellText5: makeNodeComponent("mockupTableCellText5"),
    text50: makeNodeComponent("text50"),
    col10: makeNodeComponent("col10"),
    mockupTableCellText6: makeNodeComponent("mockupTableCellText6"),
    text51: makeNodeComponent("text51"),
    mockupTableCellText7: makeNodeComponent("mockupTableCellText7"),
    text52: makeNodeComponent("text52"),
    mockupTableCellText8: makeNodeComponent("mockupTableCellText8"),
    text57: makeNodeComponent("text57"),
    mockupTableCellText9: makeNodeComponent("mockupTableCellText9"),
    text58: makeNodeComponent("text58"),
    col11: makeNodeComponent("col11"),
    mockupTableCellText10: makeNodeComponent("mockupTableCellText10"),
    text59: makeNodeComponent("text59"),
    mockupTableCellText11: makeNodeComponent("mockupTableCellText11"),
    text60: makeNodeComponent("text60"),
    mockupTableCellText12: makeNodeComponent("mockupTableCellText12"),
    text70: makeNodeComponent("text70"),
    mockupTableCellText13: makeNodeComponent("mockupTableCellText13"),
    text71: makeNodeComponent("text71"),
    mockupButton7: makeNodeComponent("mockupButton7"),
    link10: makeNodeComponent("link10"),
    certificate: makeNodeComponent("certificate"),
    top5: makeNodeComponent("top5"),
    mockupCertificateIcon: makeNodeComponent("mockupCertificateIcon"),
    bg4: makeNodeComponent("bg4"),
    group1: makeNodeComponent("group1"),
    paper1: makeNodeComponent("paper1"),
    paper2: makeNodeComponent("paper2"),
    cert: makeNodeComponent("cert"),
    award491: makeNodeComponent("award491"),
    overlay: makeNodeComponent("overlay"),
    title29: makeNodeComponent("title29"),
    mockupTextPlaceholder: makeNodeComponent("mockupTextPlaceholder"),
    mockupTextPlaceholderParagraph: makeNodeComponent(
      "mockupTextPlaceholderParagraph"
    ),
    mockupTextPlaceholderLine: makeNodeComponent("mockupTextPlaceholderLine"),
    mockupTextPlaceholderContent37: makeNodeComponent(
      "mockupTextPlaceholderContent37"
    ),
    placeholder38: makeNodeComponent("placeholder38"),
    mockupTextPlaceholderLine2: makeNodeComponent("mockupTextPlaceholderLine2"),
    mockupTextPlaceholderContent38: makeNodeComponent(
      "mockupTextPlaceholderContent38"
    ),
    placeholder39: makeNodeComponent("placeholder39"),
    mockupTextPlaceholderLine3: makeNodeComponent("mockupTextPlaceholderLine3"),
    mockupTextPlaceholderContent39: makeNodeComponent(
      "mockupTextPlaceholderContent39"
    ),
    placeholder40: makeNodeComponent("placeholder40"),
    mockupTextPlaceholderLine4: makeNodeComponent("mockupTextPlaceholderLine4"),
    mockupTextPlaceholderContent40: makeNodeComponent(
      "mockupTextPlaceholderContent40"
    ),
    placeholder41: makeNodeComponent("placeholder41"),
    mockupTextPlaceholderLine5: makeNodeComponent("mockupTextPlaceholderLine5"),
    mockupTextPlaceholderContent41: makeNodeComponent(
      "mockupTextPlaceholderContent41"
    ),
    placeholder42: makeNodeComponent("placeholder42"),
    mockupTextPlaceholderParagraph2: makeNodeComponent(
      "mockupTextPlaceholderParagraph2"
    ),
    mockupTextPlaceholderLine6: makeNodeComponent("mockupTextPlaceholderLine6"),
    mockupTextPlaceholderContent42: makeNodeComponent(
      "mockupTextPlaceholderContent42"
    ),
    placeholder43: makeNodeComponent("placeholder43"),
    mockupTextPlaceholderLine7: makeNodeComponent("mockupTextPlaceholderLine7"),
    mockupTextPlaceholderContent43: makeNodeComponent(
      "mockupTextPlaceholderContent43"
    ),
    placeholder44: makeNodeComponent("placeholder44"),
    mockupTextPlaceholderLine8: makeNodeComponent("mockupTextPlaceholderLine8"),
    mockupTextPlaceholderContent44: makeNodeComponent(
      "mockupTextPlaceholderContent44"
    ),
    placeholder45: makeNodeComponent("placeholder45"),
    mockupTextPlaceholderLine9: makeNodeComponent("mockupTextPlaceholderLine9"),
    mockupTextPlaceholderContent45: makeNodeComponent(
      "mockupTextPlaceholderContent45"
    ),
    placeholder46: makeNodeComponent("placeholder46"),
    mockupTextPlaceholderLine10: makeNodeComponent(
      "mockupTextPlaceholderLine10"
    ),
    mockupTextPlaceholderContent46: makeNodeComponent(
      "mockupTextPlaceholderContent46"
    ),
    placeholder47: makeNodeComponent("placeholder47"),
    mockupTextPlaceholderLine11: makeNodeComponent(
      "mockupTextPlaceholderLine11"
    ),
    mockupTextPlaceholderContent47: makeNodeComponent(
      "mockupTextPlaceholderContent47"
    ),
    placeholder48: makeNodeComponent("placeholder48"),
    mockupTextPlaceholderLine12: makeNodeComponent(
      "mockupTextPlaceholderLine12"
    ),
    mockupTextPlaceholderContent48: makeNodeComponent(
      "mockupTextPlaceholderContent48"
    ),
    placeholder49: makeNodeComponent("placeholder49"),
    mockupTextPlaceholderLine13: makeNodeComponent(
      "mockupTextPlaceholderLine13"
    ),
    mockupTextPlaceholderContent49: makeNodeComponent(
      "mockupTextPlaceholderContent49"
    ),
    placeholder50: makeNodeComponent("placeholder50"),
    mockupTextPlaceholderParagraph3: makeNodeComponent(
      "mockupTextPlaceholderParagraph3"
    ),
    mockupTextPlaceholderLine14: makeNodeComponent(
      "mockupTextPlaceholderLine14"
    ),
    mockupTextPlaceholderContent50: makeNodeComponent(
      "mockupTextPlaceholderContent50"
    ),
    placeholder51: makeNodeComponent("placeholder51"),
    mockupTextPlaceholderLine15: makeNodeComponent(
      "mockupTextPlaceholderLine15"
    ),
    mockupTextPlaceholderContent15: makeNodeComponent(
      "mockupTextPlaceholderContent15"
    ),
    placeholder52: makeNodeComponent("placeholder52"),
    mockupTextPlaceholderLine16: makeNodeComponent(
      "mockupTextPlaceholderLine16"
    ),
    mockupTextPlaceholderContent16: makeNodeComponent(
      "mockupTextPlaceholderContent16"
    ),
    placeholder53: makeNodeComponent("placeholder53"),
    mockupTextPlaceholderLine17: makeNodeComponent(
      "mockupTextPlaceholderLine17"
    ),
    mockupTextPlaceholderContent17: makeNodeComponent(
      "mockupTextPlaceholderContent17"
    ),
    placeholder54: makeNodeComponent("placeholder54"),
    mockupTextPlaceholderLine18: makeNodeComponent(
      "mockupTextPlaceholderLine18"
    ),
    mockupTextPlaceholderContent18: makeNodeComponent(
      "mockupTextPlaceholderContent18"
    ),
    placeholder55: makeNodeComponent("placeholder55"),
    mockupTextPlaceholderParagraph4: makeNodeComponent(
      "mockupTextPlaceholderParagraph4"
    ),
    mockupTextPlaceholderLine19: makeNodeComponent(
      "mockupTextPlaceholderLine19"
    ),
    mockupTextPlaceholderContent19: makeNodeComponent(
      "mockupTextPlaceholderContent19"
    ),
    placeholder19: makeNodeComponent("placeholder19"),
    mockupTextPlaceholderLine20: makeNodeComponent(
      "mockupTextPlaceholderLine20"
    ),
    mockupTextPlaceholderContent20: makeNodeComponent(
      "mockupTextPlaceholderContent20"
    ),
    placeholder20: makeNodeComponent("placeholder20"),
    mockupTextPlaceholderLine21: makeNodeComponent(
      "mockupTextPlaceholderLine21"
    ),
    mockupTextPlaceholderContent21: makeNodeComponent(
      "mockupTextPlaceholderContent21"
    ),
    placeholder21: makeNodeComponent("placeholder21"),
    mockupTextPlaceholderLine22: makeNodeComponent(
      "mockupTextPlaceholderLine22"
    ),
    mockupTextPlaceholderContent22: makeNodeComponent(
      "mockupTextPlaceholderContent22"
    ),
    placeholder22: makeNodeComponent("placeholder22"),
    mockupTextPlaceholderLine23: makeNodeComponent(
      "mockupTextPlaceholderLine23"
    ),
    mockupTextPlaceholderContent23: makeNodeComponent(
      "mockupTextPlaceholderContent23"
    ),
    placeholder23: makeNodeComponent("placeholder23"),
    mockupTextPlaceholderLine24: makeNodeComponent(
      "mockupTextPlaceholderLine24"
    ),
    mockupTextPlaceholderContent24: makeNodeComponent(
      "mockupTextPlaceholderContent24"
    ),
    placeholder24: makeNodeComponent("placeholder24"),
    mockupTextPlaceholderLine25: makeNodeComponent(
      "mockupTextPlaceholderLine25"
    ),
    mockupTextPlaceholderContent25: makeNodeComponent(
      "mockupTextPlaceholderContent25"
    ),
    placeholder25: makeNodeComponent("placeholder25"),
    mockupTextPlaceholderLine26: makeNodeComponent(
      "mockupTextPlaceholderLine26"
    ),
    mockupTextPlaceholderContent26: makeNodeComponent(
      "mockupTextPlaceholderContent26"
    ),
    placeholder26: makeNodeComponent("placeholder26"),
    mockupButton8: makeNodeComponent("mockupButton8"),
    link11: makeNodeComponent("link11"),
    alert2: makeNodeComponent("alert2"),
    icon22: makeNodeComponent("icon22"),
    check2: makeNodeComponent("check2"),
    content4: makeNodeComponent("content4"),
    report: makeNodeComponent("report"),
    bill: makeNodeComponent("bill"),
    header21: makeNodeComponent("header21"),
    subtitle9: makeNodeComponent("subtitle9"),
    title30: makeNodeComponent("title30"),
    main7: makeNodeComponent("main7"),
    placeholder27: makeNodeComponent("placeholder27"),
    header22: makeNodeComponent("header22"),
    title31: makeNodeComponent("title31"),
    date: makeNodeComponent("date"),
    section: makeNodeComponent("section"),
    head: makeNodeComponent("head"),
    mockupTextPlaceholderParagraph5: makeNodeComponent(
      "mockupTextPlaceholderParagraph5"
    ),
    mockupTextPlaceholderLine27: makeNodeComponent(
      "mockupTextPlaceholderLine27"
    ),
    mockupTextPlaceholderContent27: makeNodeComponent(
      "mockupTextPlaceholderContent27"
    ),
    placeholder28: makeNodeComponent("placeholder28"),
    mockupTextPlaceholderLine28: makeNodeComponent(
      "mockupTextPlaceholderLine28"
    ),
    mockupTextPlaceholderContent28: makeNodeComponent(
      "mockupTextPlaceholderContent28"
    ),
    placeholder29: makeNodeComponent("placeholder29"),
    mockupTextPlaceholderLine29: makeNodeComponent(
      "mockupTextPlaceholderLine29"
    ),
    mockupTextPlaceholderContent29: makeNodeComponent(
      "mockupTextPlaceholderContent29"
    ),
    placeholder30: makeNodeComponent("placeholder30"),
    mockupTextPlaceholderLine30: makeNodeComponent(
      "mockupTextPlaceholderLine30"
    ),
    mockupTextPlaceholderContent30: makeNodeComponent(
      "mockupTextPlaceholderContent30"
    ),
    placeholder31: makeNodeComponent("placeholder31"),
    mockupTextPlaceholderLine31: makeNodeComponent(
      "mockupTextPlaceholderLine31"
    ),
    mockupTextPlaceholderContent31: makeNodeComponent(
      "mockupTextPlaceholderContent31"
    ),
    placeholder32: makeNodeComponent("placeholder32"),
    total: makeNodeComponent("total"),
    title32: makeNodeComponent("title32"),
    val6: makeNodeComponent("val6"),
    section2: makeNodeComponent("section2"),
    head2: makeNodeComponent("head2"),
    mockupTextPlaceholderParagraph6: makeNodeComponent(
      "mockupTextPlaceholderParagraph6"
    ),
    mockupTextPlaceholderLine32: makeNodeComponent(
      "mockupTextPlaceholderLine32"
    ),
    mockupTextPlaceholderContent32: makeNodeComponent(
      "mockupTextPlaceholderContent32"
    ),
    placeholder33: makeNodeComponent("placeholder33"),
    mockupTextPlaceholderLine33: makeNodeComponent(
      "mockupTextPlaceholderLine33"
    ),
    mockupTextPlaceholderContent33: makeNodeComponent(
      "mockupTextPlaceholderContent33"
    ),
    placeholder34: makeNodeComponent("placeholder34"),
    mockupTextPlaceholderLine34: makeNodeComponent(
      "mockupTextPlaceholderLine34"
    ),
    mockupTextPlaceholderContent34: makeNodeComponent(
      "mockupTextPlaceholderContent34"
    ),
    placeholder35: makeNodeComponent("placeholder35"),
    mockupTextPlaceholderLine35: makeNodeComponent(
      "mockupTextPlaceholderLine35"
    ),
    mockupTextPlaceholderContent35: makeNodeComponent(
      "mockupTextPlaceholderContent35"
    ),
    placeholder36: makeNodeComponent("placeholder36"),
    mockupTextPlaceholderLine36: makeNodeComponent(
      "mockupTextPlaceholderLine36"
    ),
    mockupTextPlaceholderContent36: makeNodeComponent(
      "mockupTextPlaceholderContent36"
    ),
    placeholder37: makeNodeComponent("placeholder37"),
    total2: makeNodeComponent("total2"),
    title34: makeNodeComponent("title34"),
    val7: makeNodeComponent("val7"),
    edge: makeNodeComponent("edge"),
    tri: makeNodeComponent("tri"),
    rect: makeNodeComponent("rect"),
    tri2: makeNodeComponent("tri2"),
    rect2: makeNodeComponent("rect2"),
    tri3: makeNodeComponent("tri3"),
    rect3: makeNodeComponent("rect3"),
    tri4: makeNodeComponent("tri4"),
    rect4: makeNodeComponent("rect4"),
    tri5: makeNodeComponent("tri5"),
    rect5: makeNodeComponent("rect5"),
    tri6: makeNodeComponent("tri6"),
    rect6: makeNodeComponent("rect6"),
    tri7: makeNodeComponent("tri7"),
    rect7: makeNodeComponent("rect7"),
    tri8: makeNodeComponent("tri8"),
    rect8: makeNodeComponent("rect8"),
    tri9: makeNodeComponent("tri9"),
    rect9: makeNodeComponent("rect9"),
    tri10: makeNodeComponent("tri10"),
    rect10: makeNodeComponent("rect10"),
    tri11: makeNodeComponent("tri11"),
    rect11: makeNodeComponent("rect11"),
    tri12: makeNodeComponent("tri12"),
    rect12: makeNodeComponent("rect12"),
    tri13: makeNodeComponent("tri13"),
    rect13: makeNodeComponent("rect13"),
    tri14: makeNodeComponent("tri14"),
    rect14: makeNodeComponent("rect14"),
    tri15: makeNodeComponent("tri15"),
    rect15: makeNodeComponent("rect15"),
    tri16: makeNodeComponent("tri16"),
    rect16: makeNodeComponent("rect16"),
    tri17: makeNodeComponent("tri17"),
    rect17: makeNodeComponent("rect17"),
    tri18: makeNodeComponent("tri18"),
    rect18: makeNodeComponent("rect18"),
    tri19: makeNodeComponent("tri19"),
    rect19: makeNodeComponent("rect19"),
    tri20: makeNodeComponent("tri20"),
    rect20: makeNodeComponent("rect20"),
    tri21: makeNodeComponent("tri21"),
    rect21: makeNodeComponent("rect21"),
    tri22: makeNodeComponent("tri22"),
    rect22: makeNodeComponent("rect22"),
    tri23: makeNodeComponent("tri23"),
    rect23: makeNodeComponent("rect23"),
    tri24: makeNodeComponent("tri24"),
    rect24: makeNodeComponent("rect24"),
    tri25: makeNodeComponent("tri25"),
    rect25: makeNodeComponent("rect25"),
    tri26: makeNodeComponent("tri26"),
    rect26: makeNodeComponent("rect26"),
    tri27: makeNodeComponent("tri27"),
    rect27: makeNodeComponent("rect27"),
    tri28: makeNodeComponent("tri28"),
    rect28: makeNodeComponent("rect28"),
    tri29: makeNodeComponent("tri29"),
    rect29: makeNodeComponent("rect29"),
    tri30: makeNodeComponent("tri30"),
    rect30: makeNodeComponent("rect30"),
    tri31: makeNodeComponent("tri31"),
    rect31: makeNodeComponent("rect31"),
    tri32: makeNodeComponent("tri32"),
    rect32: makeNodeComponent("rect32"),
    shade3: makeNodeComponent("shade3"),
    features3: makeNodeComponent("features3"),
    title33: makeNodeComponent("title33"),
    figmaPaste2: makeNodeComponent("figmaPaste2"),
    contentsItem10: makeNodeComponent("contentsItem10"),
    icon23: makeNodeComponent("icon23"),
    text61: makeNodeComponent("text61"),
    contentsItem11: makeNodeComponent("contentsItem11"),
    icon24: makeNodeComponent("icon24"),
    text62: makeNodeComponent("text62"),
    contentsItem12: makeNodeComponent("contentsItem12"),
    icon25: makeNodeComponent("icon25"),
    text63: makeNodeComponent("text63"),
    contentsItem13: makeNodeComponent("contentsItem13"),
    icon26: makeNodeComponent("icon26"),
    text64: makeNodeComponent("text64"),
    contentsItem14: makeNodeComponent("contentsItem14"),
    icon27: makeNodeComponent("icon27"),
    text65: makeNodeComponent("text65"),
    contentsItem15: makeNodeComponent("contentsItem15"),
    icon28: makeNodeComponent("icon28"),
    text66: makeNodeComponent("text66"),
    contentsItem16: makeNodeComponent("contentsItem16"),
    icon29: makeNodeComponent("icon29"),
    text67: makeNodeComponent("text67"),
    contentsItem17: makeNodeComponent("contentsItem17"),
    icon30: makeNodeComponent("icon30"),
    text68: makeNodeComponent("text68"),
    bodyWrapper5: makeNodeComponent("bodyWrapper5"),
    intro3: makeNodeComponent("intro3"),
    col5: makeNodeComponent("col5"),
    logo8: makeNodeComponent("logo8"),
    text: makeNodeComponent("text"),
    title18: makeNodeComponent("title18"),
    desc8: makeNodeComponent("desc8"),
    img3: makeNodeComponent("img3"),
    bg2: makeNodeComponent("bg2"),
    reimbursement: makeNodeComponent("reimbursement"),
    header11: makeNodeComponent("header11"),
    subtitle4: makeNodeComponent("subtitle4"),
    title19: makeNodeComponent("title19"),
    main4: makeNodeComponent("main4"),
    placeholder16: makeNodeComponent("placeholder16"),
    row: makeNodeComponent("row"),
    prop: makeNodeComponent("prop"),
    label10: makeNodeComponent("label10"),
    val: makeNodeComponent("val"),
    prop2: makeNodeComponent("prop2"),
    label11: makeNodeComponent("label11"),
    val2: makeNodeComponent("val2"),
    mockupProgressBarWithTitle: makeNodeComponent("mockupProgressBarWithTitle"),
    header12: makeNodeComponent("header12"),
    title20: makeNodeComponent("title20"),
    val3: makeNodeComponent("val3"),
    bar: makeNodeComponent("bar"),
    value: makeNodeComponent("value"),
    demographics: makeNodeComponent("demographics"),
    demographics2: makeNodeComponent("demographics2"),
    header13: makeNodeComponent("header13"),
    subtitle7: makeNodeComponent("subtitle7"),
    title4: makeNodeComponent("title4"),
    main5: makeNodeComponent("main5"),
    placeholder17: makeNodeComponent("placeholder17"),
    row2: makeNodeComponent("row2"),
    header14: makeNodeComponent("header14"),
    name6: makeNodeComponent("name6"),
    error: makeNodeComponent("error"),
    tip: makeNodeComponent("tip"),
    label3: makeNodeComponent("label3"),
    link6: makeNodeComponent("link6"),
    row6: makeNodeComponent("row6"),
    header15: makeNodeComponent("header15"),
    name7: makeNodeComponent("name7"),
    error2: makeNodeComponent("error2"),
    tip2: makeNodeComponent("tip2"),
    label4: makeNodeComponent("label4"),
    link7: makeNodeComponent("link7"),
    row7: makeNodeComponent("row7"),
    header16: makeNodeComponent("header16"),
    name8: makeNodeComponent("name8"),
    error3: makeNodeComponent("error3"),
    tip3: makeNodeComponent("tip3"),
    label5: makeNodeComponent("label5"),
    link8: makeNodeComponent("link8"),
    shade2: makeNodeComponent("shade2"),
    cap: makeNodeComponent("cap"),
    header17: makeNodeComponent("header17"),
    subtitle8: makeNodeComponent("subtitle8"),
    title21: makeNodeComponent("title21"),
    main3: makeNodeComponent("main3"),
    placeholder18: makeNodeComponent("placeholder18"),
    field: makeNodeComponent("field"),
    label6: makeNodeComponent("label6"),
    select: makeNodeComponent("select"),
    input: makeNodeComponent("input"),
    leftIcon: makeNodeComponent("leftIcon"),
    text25: makeNodeComponent("text25"),
    rightIcon: makeNodeComponent("rightIcon"),
    row5: makeNodeComponent("row5"),
    prop3: makeNodeComponent("prop3"),
    label7: makeNodeComponent("label7"),
    val4: makeNodeComponent("val4"),
    prop4: makeNodeComponent("prop4"),
    label8: makeNodeComponent("label8"),
    val5: makeNodeComponent("val5"),
    profile3: makeNodeComponent("profile3"),
    av3: makeNodeComponent("av3"),
    col6: makeNodeComponent("col6"),
    top4: makeNodeComponent("top4"),
    header18: makeNodeComponent("header18"),
    name9: makeNodeComponent("name9"),
    status3: makeNodeComponent("status3"),
    label9: makeNodeComponent("label9"),
    body8: makeNodeComponent("body8"),
    year3: makeNodeComponent("year3"),
    name5: makeNodeComponent("name5"),
    actions3: makeNodeComponent("actions3"),
    mockupButton5: makeNodeComponent("mockupButton5"),
    link9: makeNodeComponent("link9"),
    mockupButton6: makeNodeComponent("mockupButton6"),
    link5: makeNodeComponent("link5"),
    menu2: makeNodeComponent("menu2"),
    header19: makeNodeComponent("header19"),
    title22: makeNodeComponent("title22"),
    icon8: makeNodeComponent("icon8"),
    list: makeNodeComponent("list"),
    item23: makeNodeComponent("item23"),
    text26: makeNodeComponent("text26"),
    item24: makeNodeComponent("item24"),
    text4: makeNodeComponent("text4"),
    item25: makeNodeComponent("item25"),
    text27: makeNodeComponent("text27"),
    item26: makeNodeComponent("item26"),
    text28: makeNodeComponent("text28"),
    item27: makeNodeComponent("item27"),
    text29: makeNodeComponent("text29"),
    item28: makeNodeComponent("item28"),
    text30: makeNodeComponent("text30"),
    item29: makeNodeComponent("item29"),
    text31: makeNodeComponent("text31"),
    item30: makeNodeComponent("item30"),
    text32: makeNodeComponent("text32"),
    item31: makeNodeComponent("item31"),
    text33: makeNodeComponent("text33"),
    item32: makeNodeComponent("item32"),
    text34: makeNodeComponent("text34"),
    alert: makeNodeComponent("alert"),
    icon9: makeNodeComponent("icon9"),
    content2: makeNodeComponent("content2"),
    text35: makeNodeComponent("text35"),
    icon10: makeNodeComponent("icon10"),
    features: makeNodeComponent("features"),
    title5: makeNodeComponent("title5"),
    figmaPaste: makeNodeComponent("figmaPaste"),
    contentsItem: makeNodeComponent("contentsItem"),
    icon11: makeNodeComponent("icon11"),
    text36: makeNodeComponent("text36"),
    contentsItem2: makeNodeComponent("contentsItem2"),
    icon12: makeNodeComponent("icon12"),
    text37: makeNodeComponent("text37"),
    contentsItem3: makeNodeComponent("contentsItem3"),
    icon13: makeNodeComponent("icon13"),
    text38: makeNodeComponent("text38"),
    contentsItem4: makeNodeComponent("contentsItem4"),
    icon14: makeNodeComponent("icon14"),
    text39: makeNodeComponent("text39"),
    contentsItem5: makeNodeComponent("contentsItem5"),
    icon15: makeNodeComponent("icon15"),
    text5: makeNodeComponent("text5"),
    contentsItem6: makeNodeComponent("contentsItem6"),
    icon16: makeNodeComponent("icon16"),
    text40: makeNodeComponent("text40"),
    contentsItem7: makeNodeComponent("contentsItem7"),
    icon17: makeNodeComponent("icon17"),
    text41: makeNodeComponent("text41"),
    contentsItem8: makeNodeComponent("contentsItem8"),
    icon18: makeNodeComponent("icon18"),
    text42: makeNodeComponent("text42"),
    contentsItem9: makeNodeComponent("contentsItem9"),
    icon19: makeNodeComponent("icon19"),
    text43: makeNodeComponent("text43"),
    mobileWrapper: makeNodeComponent("mobileWrapper"),
    header: makeNodeComponent("header"),
    top: makeNodeComponent("top"),
    subtitle2: makeNodeComponent("subtitle2"),
    title2: makeNodeComponent("title2"),
    body: makeNodeComponent("body"),
    tabs: makeNodeComponent("tabs"),
    content8: makeNodeComponent("content8"),
    placeholder83: makeNodeComponent("placeholder83"),
    intro5: makeNodeComponent("intro5"),
    img5: makeNodeComponent("img5"),
    bg: makeNodeComponent("bg"),
    compWrap: makeNodeComponent("compWrap"),
    perf: makeNodeComponent("perf"),
    header6: makeNodeComponent("header6"),
    subtitle3: makeNodeComponent("subtitle3"),
    title24: makeNodeComponent("title24"),
    main: makeNodeComponent("main"),
    mockupCompetencies: makeNodeComponent("mockupCompetencies"),
    graph: makeNodeComponent("graph"),
    labels: makeNodeComponent("labels"),
    series2: makeNodeComponent("series2"),
    rectangle1: makeNodeComponent("rectangle1"),
    rectangle2: makeNodeComponent("rectangle2"),
    rectangle3: makeNodeComponent("rectangle3"),
    rectangle4: makeNodeComponent("rectangle4"),
    rectangle5: makeNodeComponent("rectangle5"),
    rectangle6: makeNodeComponent("rectangle6"),
    series3: makeNodeComponent("series3"),
    rectangle7: makeNodeComponent("rectangle7"),
    rectangle8: makeNodeComponent("rectangle8"),
    rectangle9: makeNodeComponent("rectangle9"),
    rectangle10: makeNodeComponent("rectangle10"),
    rectangle11: makeNodeComponent("rectangle11"),
    rectangle12: makeNodeComponent("rectangle12"),
    scores: makeNodeComponent("scores"),
    graphScore: makeNodeComponent("graphScore"),
    num: makeNodeComponent("num"),
    graphScore2: makeNodeComponent("graphScore2"),
    num2: makeNodeComponent("num2"),
    graphScore3: makeNodeComponent("graphScore3"),
    num3: makeNodeComponent("num3"),
    smallerGraph: makeNodeComponent("smallerGraph"),
    inner: makeNodeComponent("inner"),
    labels2: makeNodeComponent("labels2"),
    series22: makeNodeComponent("series22"),
    rectangle13: makeNodeComponent("rectangle13"),
    rectangle14: makeNodeComponent("rectangle14"),
    rectangle15: makeNodeComponent("rectangle15"),
    rectangle16: makeNodeComponent("rectangle16"),
    rectangle17: makeNodeComponent("rectangle17"),
    rectangle18: makeNodeComponent("rectangle18"),
    series32: makeNodeComponent("series32"),
    rectangle19: makeNodeComponent("rectangle19"),
    rectangle20: makeNodeComponent("rectangle20"),
    rectangle21: makeNodeComponent("rectangle21"),
    rectangle22: makeNodeComponent("rectangle22"),
    rectangle23: makeNodeComponent("rectangle23"),
    rectangle24: makeNodeComponent("rectangle24"),
    scores2: makeNodeComponent("scores2"),
    graphScore4: makeNodeComponent("graphScore4"),
    num4: makeNodeComponent("num4"),
    graphScore5: makeNodeComponent("graphScore5"),
    num5: makeNodeComponent("num5"),
    graphScore6: makeNodeComponent("graphScore6"),
    num6: makeNodeComponent("num6"),
    list6: makeNodeComponent("list6"),
    item: makeNodeComponent("item"),
    icon: makeNodeComponent("icon"),
    abbr: makeNodeComponent("abbr"),
    title25: makeNodeComponent("title25"),
    item2: makeNodeComponent("item2"),
    icon2: makeNodeComponent("icon2"),
    abbr2: makeNodeComponent("abbr2"),
    title3: makeNodeComponent("title3"),
    item3: makeNodeComponent("item3"),
    icon3: makeNodeComponent("icon3"),
    abbr3: makeNodeComponent("abbr3"),
    title41: makeNodeComponent("title41"),
    item4: makeNodeComponent("item4"),
    icon4: makeNodeComponent("icon4"),
    abbr4: makeNodeComponent("abbr4"),
    title43: makeNodeComponent("title43"),
    item5: makeNodeComponent("item5"),
    icon5: makeNodeComponent("icon5"),
    abbr5: makeNodeComponent("abbr5"),
    title6: makeNodeComponent("title6"),
    item6: makeNodeComponent("item6"),
    icon6: makeNodeComponent("icon6"),
    abbr6: makeNodeComponent("abbr6"),
    title7: makeNodeComponent("title7"),
    shade: makeNodeComponent("shade"),
    nav2: makeNodeComponent("nav2"),
    btn: makeNodeComponent("btn"),
    text55: makeNodeComponent("text55"),
    btn2: makeNodeComponent("btn2"),
    text2: makeNodeComponent("text2"),
    btn3: makeNodeComponent("btn3"),
    text3: makeNodeComponent("text3"),
    btn4: makeNodeComponent("btn4"),
    text56: makeNodeComponent("text56"),
    mockupButtonBarItem: makeNodeComponent("mockupButtonBarItem"),
    text69: makeNodeComponent("text69"),
    btn5: makeNodeComponent("btn5"),
    text6: makeNodeComponent("text6"),
    btn6: makeNodeComponent("btn6"),
    text7: makeNodeComponent("text7"),
    btn7: makeNodeComponent("btn7"),
    text8: makeNodeComponent("text8"),
    btn8: makeNodeComponent("btn8"),
    text9: makeNodeComponent("text9"),
    btn9: makeNodeComponent("btn9"),
    text10: makeNodeComponent("text10"),
    profile: makeNodeComponent("profile"),
    av: makeNodeComponent("av"),
    col12: makeNodeComponent("col12"),
    top2: makeNodeComponent("top2"),
    header2: makeNodeComponent("header2"),
    _name: makeNodeComponent("name"),
    status: makeNodeComponent("status"),
    label: makeNodeComponent("label"),
    line: makeNodeComponent("line"),
    mockupTextPlaceholderContent: makeNodeComponent(
      "mockupTextPlaceholderContent"
    ),
    placeholder2: makeNodeComponent("placeholder2"),
    body3: makeNodeComponent("body3"),
    year: makeNodeComponent("year"),
    name2: makeNodeComponent("name2"),
    line2: makeNodeComponent("line2"),
    mockupTextPlaceholderContent2: makeNodeComponent(
      "mockupTextPlaceholderContent2"
    ),
    placeholder3: makeNodeComponent("placeholder3"),
    actions: makeNodeComponent("actions"),
    mockupButton: makeNodeComponent("mockupButton"),
    link: makeNodeComponent("link"),
    mockupButton2: makeNodeComponent("mockupButton2"),
    link2: makeNodeComponent("link2"),
    text11: makeNodeComponent("text11"),
    title8: makeNodeComponent("title8"),
    desc13: makeNodeComponent("desc13"),
    areas2: makeNodeComponent("areas2"),
    header3: makeNodeComponent("header3"),
    title49: makeNodeComponent("title49"),
    body2: makeNodeComponent("body2"),
    frame23: makeNodeComponent("frame23"),
    item7: makeNodeComponent("item7"),
    title50: makeNodeComponent("title50"),
    desc17: makeNodeComponent("desc17"),
    item8: makeNodeComponent("item8"),
    title51: makeNodeComponent("title51"),
    desc18: makeNodeComponent("desc18"),
    item9: makeNodeComponent("item9"),
    title52: makeNodeComponent("title52"),
    desc19: makeNodeComponent("desc19"),
    item10: makeNodeComponent("item10"),
    title53: makeNodeComponent("title53"),
    desc20: makeNodeComponent("desc20"),
    item11: makeNodeComponent("item11"),
    title54: makeNodeComponent("title54"),
    desc21: makeNodeComponent("desc21"),
    item12: makeNodeComponent("item12"),
    title55: makeNodeComponent("title55"),
    desc10: makeNodeComponent("desc10"),
    footnote2: makeNodeComponent("footnote2"),
    content5: makeNodeComponent("content5"),
    placeholder56: makeNodeComponent("placeholder56"),
    intro6: makeNodeComponent("intro6"),
    img6: makeNodeComponent("img6"),
    bg5: makeNodeComponent("bg5"),
    xmlid74572: makeNodeComponent("xmlid74572"),
    xmlid67762: makeNodeComponent("xmlid67762"),
    xmlid74332: makeNodeComponent("xmlid74332"),
    xmlid73392: makeNodeComponent("xmlid73392"),
    certificate2: makeNodeComponent("certificate2"),
    top6: makeNodeComponent("top6"),
    mockupCertificateIcon2: makeNodeComponent("mockupCertificateIcon2"),
    bg6: makeNodeComponent("bg6"),
    group2: makeNodeComponent("group2"),
    paper3: makeNodeComponent("paper3"),
    paper4: makeNodeComponent("paper4"),
    cert2: makeNodeComponent("cert2"),
    award492: makeNodeComponent("award492"),
    overlay2: makeNodeComponent("overlay2"),
    title26: makeNodeComponent("title26"),
    mockupTextPlaceholder2: makeNodeComponent("mockupTextPlaceholder2"),
    mockupTextPlaceholderParagraph7: makeNodeComponent(
      "mockupTextPlaceholderParagraph7"
    ),
    mockupTextPlaceholderLine37: makeNodeComponent(
      "mockupTextPlaceholderLine37"
    ),
    mockupTextPlaceholderContent51: makeNodeComponent(
      "mockupTextPlaceholderContent51"
    ),
    placeholder57: makeNodeComponent("placeholder57"),
    mockupTextPlaceholderLine38: makeNodeComponent(
      "mockupTextPlaceholderLine38"
    ),
    mockupTextPlaceholderContent52: makeNodeComponent(
      "mockupTextPlaceholderContent52"
    ),
    placeholder58: makeNodeComponent("placeholder58"),
    mockupTextPlaceholderLine39: makeNodeComponent(
      "mockupTextPlaceholderLine39"
    ),
    mockupTextPlaceholderContent3: makeNodeComponent(
      "mockupTextPlaceholderContent3"
    ),
    placeholder4: makeNodeComponent("placeholder4"),
    mockupTextPlaceholderLine40: makeNodeComponent(
      "mockupTextPlaceholderLine40"
    ),
    mockupTextPlaceholderContent4: makeNodeComponent(
      "mockupTextPlaceholderContent4"
    ),
    placeholder5: makeNodeComponent("placeholder5"),
    mockupTextPlaceholderLine41: makeNodeComponent(
      "mockupTextPlaceholderLine41"
    ),
    mockupTextPlaceholderContent5: makeNodeComponent(
      "mockupTextPlaceholderContent5"
    ),
    placeholder6: makeNodeComponent("placeholder6"),
    mockupTextPlaceholderParagraph8: makeNodeComponent(
      "mockupTextPlaceholderParagraph8"
    ),
    mockupTextPlaceholderLine42: makeNodeComponent(
      "mockupTextPlaceholderLine42"
    ),
    mockupTextPlaceholderContent6: makeNodeComponent(
      "mockupTextPlaceholderContent6"
    ),
    placeholder7: makeNodeComponent("placeholder7"),
    mockupTextPlaceholderLine43: makeNodeComponent(
      "mockupTextPlaceholderLine43"
    ),
    mockupTextPlaceholderContent7: makeNodeComponent(
      "mockupTextPlaceholderContent7"
    ),
    placeholder8: makeNodeComponent("placeholder8"),
    mockupTextPlaceholderLine44: makeNodeComponent(
      "mockupTextPlaceholderLine44"
    ),
    mockupTextPlaceholderContent8: makeNodeComponent(
      "mockupTextPlaceholderContent8"
    ),
    placeholder9: makeNodeComponent("placeholder9"),
    mockupTextPlaceholderLine45: makeNodeComponent(
      "mockupTextPlaceholderLine45"
    ),
    mockupTextPlaceholderContent9: makeNodeComponent(
      "mockupTextPlaceholderContent9"
    ),
    placeholder10: makeNodeComponent("placeholder10"),
    mockupTextPlaceholderLine46: makeNodeComponent(
      "mockupTextPlaceholderLine46"
    ),
    mockupTextPlaceholderContent10: makeNodeComponent(
      "mockupTextPlaceholderContent10"
    ),
    placeholder11: makeNodeComponent("placeholder11"),
    mockupTextPlaceholderLine47: makeNodeComponent(
      "mockupTextPlaceholderLine47"
    ),
    mockupTextPlaceholderContent11: makeNodeComponent(
      "mockupTextPlaceholderContent11"
    ),
    placeholder12: makeNodeComponent("placeholder12"),
    mockupTextPlaceholderLine48: makeNodeComponent(
      "mockupTextPlaceholderLine48"
    ),
    mockupTextPlaceholderContent12: makeNodeComponent(
      "mockupTextPlaceholderContent12"
    ),
    placeholder13: makeNodeComponent("placeholder13"),
    mockupTextPlaceholderLine49: makeNodeComponent(
      "mockupTextPlaceholderLine49"
    ),
    mockupTextPlaceholderContent13: makeNodeComponent(
      "mockupTextPlaceholderContent13"
    ),
    placeholder14: makeNodeComponent("placeholder14"),
    mockupTextPlaceholderParagraph9: makeNodeComponent(
      "mockupTextPlaceholderParagraph9"
    ),
    mockupTextPlaceholderLine50: makeNodeComponent(
      "mockupTextPlaceholderLine50"
    ),
    mockupTextPlaceholderContent14: makeNodeComponent(
      "mockupTextPlaceholderContent14"
    ),
    placeholder15: makeNodeComponent("placeholder15"),
    mockupTextPlaceholderLine51: makeNodeComponent(
      "mockupTextPlaceholderLine51"
    ),
    mockupTextPlaceholderContent53: makeNodeComponent(
      "mockupTextPlaceholderContent53"
    ),
    placeholder59: makeNodeComponent("placeholder59"),
    mockupTextPlaceholderLine52: makeNodeComponent(
      "mockupTextPlaceholderLine52"
    ),
    mockupTextPlaceholderContent54: makeNodeComponent(
      "mockupTextPlaceholderContent54"
    ),
    placeholder60: makeNodeComponent("placeholder60"),
    mockupTextPlaceholderLine53: makeNodeComponent(
      "mockupTextPlaceholderLine53"
    ),
    mockupTextPlaceholderContent55: makeNodeComponent(
      "mockupTextPlaceholderContent55"
    ),
    placeholder61: makeNodeComponent("placeholder61"),
    mockupTextPlaceholderLine54: makeNodeComponent(
      "mockupTextPlaceholderLine54"
    ),
    mockupTextPlaceholderContent56: makeNodeComponent(
      "mockupTextPlaceholderContent56"
    ),
    placeholder62: makeNodeComponent("placeholder62"),
    mockupTextPlaceholderParagraph10: makeNodeComponent(
      "mockupTextPlaceholderParagraph10"
    ),
    mockupTextPlaceholderLine55: makeNodeComponent(
      "mockupTextPlaceholderLine55"
    ),
    mockupTextPlaceholderContent57: makeNodeComponent(
      "mockupTextPlaceholderContent57"
    ),
    placeholder63: makeNodeComponent("placeholder63"),
    mockupTextPlaceholderLine56: makeNodeComponent(
      "mockupTextPlaceholderLine56"
    ),
    mockupTextPlaceholderContent58: makeNodeComponent(
      "mockupTextPlaceholderContent58"
    ),
    placeholder64: makeNodeComponent("placeholder64"),
    mockupTextPlaceholderLine57: makeNodeComponent(
      "mockupTextPlaceholderLine57"
    ),
    mockupTextPlaceholderContent59: makeNodeComponent(
      "mockupTextPlaceholderContent59"
    ),
    placeholder65: makeNodeComponent("placeholder65"),
    mockupTextPlaceholderLine58: makeNodeComponent(
      "mockupTextPlaceholderLine58"
    ),
    mockupTextPlaceholderContent60: makeNodeComponent(
      "mockupTextPlaceholderContent60"
    ),
    placeholder66: makeNodeComponent("placeholder66"),
    mockupTextPlaceholderLine59: makeNodeComponent(
      "mockupTextPlaceholderLine59"
    ),
    mockupTextPlaceholderContent61: makeNodeComponent(
      "mockupTextPlaceholderContent61"
    ),
    placeholder67: makeNodeComponent("placeholder67"),
    mockupTextPlaceholderLine60: makeNodeComponent(
      "mockupTextPlaceholderLine60"
    ),
    mockupTextPlaceholderContent62: makeNodeComponent(
      "mockupTextPlaceholderContent62"
    ),
    placeholder68: makeNodeComponent("placeholder68"),
    mockupTextPlaceholderLine61: makeNodeComponent(
      "mockupTextPlaceholderLine61"
    ),
    mockupTextPlaceholderContent63: makeNodeComponent(
      "mockupTextPlaceholderContent63"
    ),
    placeholder69: makeNodeComponent("placeholder69"),
    mockupTextPlaceholderLine62: makeNodeComponent(
      "mockupTextPlaceholderLine62"
    ),
    mockupTextPlaceholderContent64: makeNodeComponent(
      "mockupTextPlaceholderContent64"
    ),
    placeholder70: makeNodeComponent("placeholder70"),
    mockupButton3: makeNodeComponent("mockupButton3"),
    link3: makeNodeComponent("link3"),
    bill3: makeNodeComponent("bill3"),
    bill2: makeNodeComponent("bill2"),
    header4: makeNodeComponent("header4"),
    subtitle6: makeNodeComponent("subtitle6"),
    title35: makeNodeComponent("title35"),
    main2: makeNodeComponent("main2"),
    placeholder71: makeNodeComponent("placeholder71"),
    header5: makeNodeComponent("header5"),
    title36: makeNodeComponent("title36"),
    date2: makeNodeComponent("date2"),
    section3: makeNodeComponent("section3"),
    head3: makeNodeComponent("head3"),
    mockupTextPlaceholderParagraph11: makeNodeComponent(
      "mockupTextPlaceholderParagraph11"
    ),
    mockupTextPlaceholderLine63: makeNodeComponent(
      "mockupTextPlaceholderLine63"
    ),
    mockupTextPlaceholderContent65: makeNodeComponent(
      "mockupTextPlaceholderContent65"
    ),
    placeholder72: makeNodeComponent("placeholder72"),
    mockupTextPlaceholderLine64: makeNodeComponent(
      "mockupTextPlaceholderLine64"
    ),
    mockupTextPlaceholderContent66: makeNodeComponent(
      "mockupTextPlaceholderContent66"
    ),
    placeholder73: makeNodeComponent("placeholder73"),
    mockupTextPlaceholderLine65: makeNodeComponent(
      "mockupTextPlaceholderLine65"
    ),
    mockupTextPlaceholderContent67: makeNodeComponent(
      "mockupTextPlaceholderContent67"
    ),
    placeholder74: makeNodeComponent("placeholder74"),
    mockupTextPlaceholderLine66: makeNodeComponent(
      "mockupTextPlaceholderLine66"
    ),
    mockupTextPlaceholderContent68: makeNodeComponent(
      "mockupTextPlaceholderContent68"
    ),
    placeholder75: makeNodeComponent("placeholder75"),
    mockupTextPlaceholderLine67: makeNodeComponent(
      "mockupTextPlaceholderLine67"
    ),
    mockupTextPlaceholderContent69: makeNodeComponent(
      "mockupTextPlaceholderContent69"
    ),
    placeholder76: makeNodeComponent("placeholder76"),
    total3: makeNodeComponent("total3"),
    title37: makeNodeComponent("title37"),
    val8: makeNodeComponent("val8"),
    section4: makeNodeComponent("section4"),
    head4: makeNodeComponent("head4"),
    mockupTextPlaceholderParagraph12: makeNodeComponent(
      "mockupTextPlaceholderParagraph12"
    ),
    mockupTextPlaceholderLine68: makeNodeComponent(
      "mockupTextPlaceholderLine68"
    ),
    mockupTextPlaceholderContent70: makeNodeComponent(
      "mockupTextPlaceholderContent70"
    ),
    placeholder77: makeNodeComponent("placeholder77"),
    mockupTextPlaceholderLine69: makeNodeComponent(
      "mockupTextPlaceholderLine69"
    ),
    mockupTextPlaceholderContent71: makeNodeComponent(
      "mockupTextPlaceholderContent71"
    ),
    placeholder78: makeNodeComponent("placeholder78"),
    mockupTextPlaceholderLine70: makeNodeComponent(
      "mockupTextPlaceholderLine70"
    ),
    mockupTextPlaceholderContent72: makeNodeComponent(
      "mockupTextPlaceholderContent72"
    ),
    placeholder79: makeNodeComponent("placeholder79"),
    mockupTextPlaceholderLine71: makeNodeComponent(
      "mockupTextPlaceholderLine71"
    ),
    mockupTextPlaceholderContent73: makeNodeComponent(
      "mockupTextPlaceholderContent73"
    ),
    placeholder80: makeNodeComponent("placeholder80"),
    mockupTextPlaceholderLine72: makeNodeComponent(
      "mockupTextPlaceholderLine72"
    ),
    mockupTextPlaceholderContent74: makeNodeComponent(
      "mockupTextPlaceholderContent74"
    ),
    placeholder81: makeNodeComponent("placeholder81"),
    total4: makeNodeComponent("total4"),
    title38: makeNodeComponent("title38"),
    val9: makeNodeComponent("val9"),
    edge2: makeNodeComponent("edge2"),
    tri33: makeNodeComponent("tri33"),
    rect33: makeNodeComponent("rect33"),
    tri34: makeNodeComponent("tri34"),
    rect34: makeNodeComponent("rect34"),
    tri35: makeNodeComponent("tri35"),
    rect35: makeNodeComponent("rect35"),
    tri36: makeNodeComponent("tri36"),
    rect36: makeNodeComponent("rect36"),
    tri37: makeNodeComponent("tri37"),
    rect37: makeNodeComponent("rect37"),
    tri38: makeNodeComponent("tri38"),
    rect38: makeNodeComponent("rect38"),
    tri39: makeNodeComponent("tri39"),
    rect39: makeNodeComponent("rect39"),
    tri40: makeNodeComponent("tri40"),
    rect40: makeNodeComponent("rect40"),
    tri41: makeNodeComponent("tri41"),
    rect41: makeNodeComponent("rect41"),
    tri42: makeNodeComponent("tri42"),
    rect42: makeNodeComponent("rect42"),
    tri43: makeNodeComponent("tri43"),
    rect43: makeNodeComponent("rect43"),
    tri44: makeNodeComponent("tri44"),
    rect44: makeNodeComponent("rect44"),
    tri45: makeNodeComponent("tri45"),
    rect45: makeNodeComponent("rect45"),
    tri46: makeNodeComponent("tri46"),
    rect46: makeNodeComponent("rect46"),
    tri47: makeNodeComponent("tri47"),
    rect47: makeNodeComponent("rect47"),
    tri48: makeNodeComponent("tri48"),
    rect48: makeNodeComponent("rect48"),
    tri49: makeNodeComponent("tri49"),
    rect49: makeNodeComponent("rect49"),
    tri50: makeNodeComponent("tri50"),
    rect50: makeNodeComponent("rect50"),
    tri51: makeNodeComponent("tri51"),
    rect51: makeNodeComponent("rect51"),
    tri52: makeNodeComponent("tri52"),
    rect52: makeNodeComponent("rect52"),
    tri53: makeNodeComponent("tri53"),
    rect53: makeNodeComponent("rect53"),
    tri54: makeNodeComponent("tri54"),
    rect54: makeNodeComponent("rect54"),
    tri55: makeNodeComponent("tri55"),
    rect55: makeNodeComponent("rect55"),
    tri56: makeNodeComponent("tri56"),
    rect56: makeNodeComponent("rect56"),
    tri57: makeNodeComponent("tri57"),
    rect57: makeNodeComponent("rect57"),
    tri58: makeNodeComponent("tri58"),
    rect58: makeNodeComponent("rect58"),
    tri59: makeNodeComponent("tri59"),
    rect59: makeNodeComponent("rect59"),
    tri60: makeNodeComponent("tri60"),
    rect60: makeNodeComponent("rect60"),
    tri61: makeNodeComponent("tri61"),
    rect61: makeNodeComponent("rect61"),
    tri62: makeNodeComponent("tri62"),
    rect62: makeNodeComponent("rect62"),
    tri63: makeNodeComponent("tri63"),
    rect63: makeNodeComponent("rect63"),
    tri64: makeNodeComponent("tri64"),
    rect64: makeNodeComponent("rect64"),
    shade4: makeNodeComponent("shade4"),
    alert4: makeNodeComponent("alert4"),
    icon31: makeNodeComponent("icon31"),
    content6: makeNodeComponent("content6"),
    text15: makeNodeComponent("text15"),
    icon32: makeNodeComponent("icon32"),
    text16: makeNodeComponent("text16"),
    title39: makeNodeComponent("title39"),
    desc11: makeNodeComponent("desc11"),
    features2: makeNodeComponent("features2"),
    title40: makeNodeComponent("title40"),
    contents: makeNodeComponent("contents"),
    contentsItem18: makeNodeComponent("contentsItem18"),
    icon33: makeNodeComponent("icon33"),
    text17: makeNodeComponent("text17"),
    contentsItem19: makeNodeComponent("contentsItem19"),
    icon34: makeNodeComponent("icon34"),
    text18: makeNodeComponent("text18"),
    contentsItem20: makeNodeComponent("contentsItem20"),
    icon35: makeNodeComponent("icon35"),
    text19: makeNodeComponent("text19"),
    contentsItem21: makeNodeComponent("contentsItem21"),
    icon36: makeNodeComponent("icon36"),
    text20: makeNodeComponent("text20"),
    contentsItem22: makeNodeComponent("contentsItem22"),
    icon7: makeNodeComponent("icon7"),
    text21: makeNodeComponent("text21"),
    contentsItem23: makeNodeComponent("contentsItem23"),
    icon37: makeNodeComponent("icon37"),
    text22: makeNodeComponent("text22"),
    contentsItem24: makeNodeComponent("contentsItem24"),
    icon38: makeNodeComponent("icon38"),
    text23: makeNodeComponent("text23"),
    contentsItem25: makeNodeComponent("contentsItem25"),
    icon39: makeNodeComponent("icon39"),
    text24: makeNodeComponent("text24"),
    content7: makeNodeComponent("content7"),
    placeholder82: makeNodeComponent("placeholder82"),
    intro7: makeNodeComponent("intro7"),
    img7: makeNodeComponent("img7"),
    cap2: makeNodeComponent("cap2"),
    header27: makeNodeComponent("header27"),
    subtitle11: makeNodeComponent("subtitle11"),
    title42: makeNodeComponent("title42"),
    main9: makeNodeComponent("main9"),
    placeholder84: makeNodeComponent("placeholder84"),
    field2: makeNodeComponent("field2"),
    label14: makeNodeComponent("label14"),
    select2: makeNodeComponent("select2"),
    input2: makeNodeComponent("input2"),
    leftIcon2: makeNodeComponent("leftIcon2"),
    text54: makeNodeComponent("text54"),
    rightIcon2: makeNodeComponent("rightIcon2"),
    row4: makeNodeComponent("row4"),
    prop5: makeNodeComponent("prop5"),
    label15: makeNodeComponent("label15"),
    val10: makeNodeComponent("val10"),
    prop6: makeNodeComponent("prop6"),
    label16: makeNodeComponent("label16"),
    val11: makeNodeComponent("val11"),
    text79: makeNodeComponent("text79"),
    title46: makeNodeComponent("title46"),
    desc12: makeNodeComponent("desc12"),
    features4: makeNodeComponent("features4"),
    title47: makeNodeComponent("title47"),
    grid: makeNodeComponent("grid"),
    contentsItem26: makeNodeComponent("contentsItem26"),
    icon41: makeNodeComponent("icon41"),
    text80: makeNodeComponent("text80"),
    contentsItem27: makeNodeComponent("contentsItem27"),
    icon42: makeNodeComponent("icon42"),
    text81: makeNodeComponent("text81"),
    contentsItem28: makeNodeComponent("contentsItem28"),
    icon43: makeNodeComponent("icon43"),
    text82: makeNodeComponent("text82"),
    contentsItem29: makeNodeComponent("contentsItem29"),
    icon44: makeNodeComponent("icon44"),
    text83: makeNodeComponent("text83"),
    contentsItem30: makeNodeComponent("contentsItem30"),
    icon45: makeNodeComponent("icon45"),
    text84: makeNodeComponent("text84"),
    contentsItem31: makeNodeComponent("contentsItem31"),
    icon46: makeNodeComponent("icon46"),
    text85: makeNodeComponent("text85"),
    contentsItem32: makeNodeComponent("contentsItem32"),
    icon47: makeNodeComponent("icon47"),
    text86: makeNodeComponent("text86"),
    contentsItem33: makeNodeComponent("contentsItem33"),
    icon48: makeNodeComponent("icon48"),
    text87: makeNodeComponent("text87"),
    contentsItem34: makeNodeComponent("contentsItem34"),
    icon49: makeNodeComponent("icon49"),
    text88: makeNodeComponent("text88"),

    // Metadata about props expected for PlasmicHomeProductsSection
    internalVariantProps: PlasmicHomeProductsSection__VariantProps,
    internalArgProps: PlasmicHomeProductsSection__ArgProps
  }
);

export default PlasmicHomeProductsSection;
/* prettier-ignore-end */
